/* Oct 25 2026: Wingman Mode rules for SoCal + Twin Cities (research handoff of Oct 25).
 *  - Curated venues come from the sheet's Wingman Spots tab (window.OB_WING_SPOTS, generated block below).
 *  - Shown: hosted singles events (speed dating, Pitch-A-Friend, singles nights), mingle-by-design social formats
 *    (bar/pub crawls, beer and wine fests, block and street parties, pool and day parties, mixers, Halloween/costume parties), and evening events at
 *    Top Pick or Strong venues on that venue's best nights. Certain Nights venues only count when tagged "Wingman".
 *  - Concerts count only at venues checked for a social crowd (WS_MUSIC below): social rooms any evening,
 *    show-dependent clubs Fri/Sat nights only. Music fests count anywhere. All-ages/family bills, seated rooms and
 *    jazz/classical-only bills stay out.
 *  - Party formats (Halloween/costume/block/street parties, mixers) need an evening start or a 21+/Nightlife tag;
 *    day-friendly formats (pool/day parties, crawls, beer and wine fests) can be daytime. Family/kids/all-ages wording excludes.
 *  - Category alone (Dance, Nightlife, Happy Hour, Concert, Games, Karaoke) never makes an event Wingman here.
 *  - Top Pick / Strong venues count from 3 PM (happy hour) on their best nights; trivia counts there too.
 *  - Sheet tags: "Wingman" adds an event (at a Certain Nights venue with listed days, only on those days);
 *    "Wingman Exclude" (or "No Wingman") always removes it, even over "Wingman".
 *  - Oct 26 2026: the same rules now run on every guide (Las Vegas, Charlotte, Denver, Honolulu, DC, Salt Lake,
 *    Portland, Phoenix/Arizona, Tokyo/Japan), each with its own Hotspots and concert venue list (WS_MUSIC_DEST).
 */
/* Wingman Spots data, generated Oct 25 2026 from the sheet's Wingman Spots tab (A1:L56); Oct 26 2026 added the
   destination rows (A92:L227: Las Vegas, Charlotte, Denver, Honolulu, DC, Salt Lake, Portland, Phoenix, Tokyo).
   Status "Needs Check" rows are hidden (verify: true) until someone confirms the venue is open.
   To change: edit the tab, then regenerate this block (gen_spots.py). */
window.OB_WING_SPOTS = [
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "NE Moose Bar & Grill",
"h": "Northeast",
"v": "nights",
"best": "Only confirmed karaoke/DJ or singles events",
"d": null,
"t": "",
"w": "Karaoke upstairs, then a basement DJ room after 9. Two easy ways into a conversation in one stop.",
"x": "Late weekends reported college-heavy; other times older regulars. Recheck karaoke/DJ event crowd before tagging.",
"m": "\\bne moose\\b|\\bmoose bar\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "331 Club",
"h": "Northeast",
"v": "top",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "Live band every night and never a cover, so the room fills with people bouncing in and out. Natural first stop on a Northeast crawl.",
"x": "Small room. Gets tight when a popular band plays.",
"m": "\\b331 club\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Up-Down Minneapolis",
"h": "Lyn-Lake",
"v": "top",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "Arcade bar full of 20- to 40-somethings. Skee-ball and Killer Queen basically force strangers to team up.",
"x": "Can skew mid-20s late on Saturdays.",
"m": "\\bup-?down\\b(?!.*(st\\.? paul|saint paul))",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Bunker's Music Bar & Grill",
"h": "North Loop",
"v": "top",
"best": "Fri, Sat, Sun",
"d": [
0,
5,
6
],
"t": "8:00 PM",
"w": "Live funk, soul and cover bands with a slightly older crowd that actually dances. The small cover keeps out the messiest drunks.",
"x": "Better for mid-30s to 40s than late 20s.",
"m": "\\bbunkers?\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Grumpy's Northeast",
"h": "Northeast",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:30 PM",
"w": "Classic Northeast bar with DJ and vinyl nights, a big patio and a friendly mixed crowd. Easy home base for a crawl.",
"x": "More neighborhood hang than pickup scene.",
"m": "\\bgrumpys\\b(?!.*(roseville|downtown))",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Brit's Pub",
"h": "Downtown",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "7:00 PM",
"w": "Big multi-room pub with a year-round rooftop bar. Lawn bowling in summer is one of the easiest icebreakers in town.",
"x": "Lawn bowling runs about mid-May to September only.",
"m": "\\bbrits pub\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Mortimer's",
"h": "Lyn-Lake",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "Longtime no-nonsense dive with a back patio and a crowd full of local musicians. Good second stop after Up-Down.",
"x": "Divey. Not the place for a dressed-up night.",
"m": "\\bmortimers\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Cuzzy's",
"h": "North Loop",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "10:00 PM",
"w": "Locally famous North Loop dive that stays packed late, which means plenty of people to talk to.",
"x": "Late and loud. Better as a nightcap than a starting point.",
"m": "\\bcuzzys\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "UNION Rooftop",
"h": "Downtown",
"v": "nights",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "10:00 PM",
"w": "Glass rooftop that turns into a late-night dance crowd Thursday through Saturday.",
"x": "Dressier, younger and bottle-service leaning. Dinner hours are mostly couples.",
"m": "\\bunion rooftop\\b|\\bunion mpls\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Stanley's Northeast Bar Room",
"h": "Northeast",
"v": "nights",
"best": "Sun",
"d": [
0
],
"t": "11:00 AM",
"w": "Vikings Sundays with a beer tent and a lively, social crowd. Speakeasy upstairs if the game gets boring.",
"x": "Skews younger. Weeknights are just a sports bar.",
"m": "\\bstanleys\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Vegas Lounge",
"h": "Northeast",
"v": "nights",
"best": "Mon, Tue, Wed",
"d": [
1,
2,
3
],
"t": "8:00 PM",
"w": "Karaoke every night, and a room full of people cheering each other on is an easy opener.",
"x": "Weekends are overrun with college kids. Weeknights only.",
"m": "\\bvegas lounge\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Psycho Suzi's Motor Lounge",
"h": "Northeast",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "",
"x": "Closed permanently August 2023.",
"m": "\\bpsycho suzis\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "The Loop / Basement Bar",
"h": "North Loop",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "",
"x": "Busy dance floors but a younger crowd and long lines.",
"m": "^the loop(?! west end)\\b|^the loop bar\\b|\\bbasement bar\\b(?!.*moose)",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Meteor",
"h": "North Minneapolis / North Loop edge",
"v": "top",
"best": "Evenings",
"d": null,
"t": "",
"w": "Specific 2026 recommendations for a 30s crowd; compact bar encourages conversations.",
"x": "Small room; not ideal for big groups.",
"m": "^meteor\\b|\\bmeteor bar\\b|\\bmeteor,",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Zhora Darling",
"h": "Northeast",
"v": "top",
"best": "Show nights / evenings",
"d": null,
"t": "",
"w": "Late food, cocktails, pool and live music make meeting people more natural.",
"x": "Separate music room; a ticketed show is not always a mixer.",
"m": "\\bzhora darling\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Nye's Bar",
"h": "Northeast",
"v": "top",
"best": "Karaoke / weekend evenings",
"d": [
5,
6
],
"t": "",
"w": "Multiple 30s singles describe this as a comfortable place for their age group.",
"x": "Karaoke attendance and crowd change by night.",
"m": "\\bnyes\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Lucky's 13 Pub",
"h": "Twin Cities metro",
"v": "strong",
"best": "Social bar nights",
"d": null,
"t": "",
"w": "Named by 30s singles as an alternative to college-heavy Northeast dives.",
"x": "Check exact location and night; chain has multiple branches.",
"m": null,
"verify": true
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Otter's Saloon",
"h": "Northeast",
"v": "nights",
"best": "Karaoke nights",
"d": null,
"t": "",
"w": "Karaoke provides a ready-made conversation opener; recommended in a 30s singles thread.",
"x": "Do not mark every ordinary bar shift as Wingman.",
"m": "\\botters? saloon\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "White Squirrel Bar",
"h": "West Seventh, Saint Paul",
"v": "nights",
"best": "Live music / social events",
"d": null,
"t": "",
"w": "Intimate live-music bar with a busy event calendar; suitable for talking between sets.",
"x": "Audience varies widely by artist; not inherently a singles bar.",
"m": "\\bwhite squirrel\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Spring Street Tavern",
"h": "Northeast",
"v": "strong",
"best": "Patio / weekends",
"d": [
5,
6
],
"t": "",
"w": "Reddit users report meeting dates through casual conversations on its patio.",
"x": "Personal anecdotes, not independently verified singles mix.",
"m": "\\bspring street tavern\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Sweeney's Saloon",
"h": "Cathedral Hill, Saint Paul",
"v": "strong",
"best": "Evenings / patio season",
"d": null,
"t": "",
"w": "Walkable neighborhood bar with an older-than-college crowd and informal hangouts.",
"x": "Area is quieter than Minneapolis clubs.",
"m": "\\bsweeneys\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Moscow on the Hill",
"h": "Cathedral Hill, Saint Paul",
"v": "strong",
"best": "Patio season / early evening",
"d": null,
"t": "",
"w": "Social patio and neighborhood bar circuit for a more grown-up evening.",
"x": "Restaurant diners and couples also common; avoid universal singles claims.",
"m": "\\bmoscow on the hill\\b",
"verify": false
},
{
"g": "Twin Cities",
"regions": [
"Twin Cities"
],
"page": "Twin Cities",
"n": "Amsterdam Bar & Hall",
"h": "Downtown Saint Paul",
"v": "nights",
"best": "Concerts / community events",
"d": null,
"t": "",
"w": "Regular live programming brings people together; good pre/post-show social opportunity.",
"x": "Downtown can be quiet on non-event nights.",
"m": "\\bamsterdam bar\\b",
"verify": false
},
{
"g": "San Diego",
"regions": [
"San Diego",
"North County"
],
"page": "San Diego",
"n": "The Waterfront Bar & Grill",
"h": "Little Italy",
"v": "top",
"best": "Early evening / happy hour",
"d": null,
"t": "Early",
"w": "Firsthand report says the crowd trends in its 30s and fills quickly.",
"x": "Crowded late; groups may be harder to approach.",
"m": "\\bwaterfront bar\\b",
"verify": false
},
{
"g": "San Diego",
"regions": [
"San Diego",
"North County"
],
"page": "San Diego",
"n": "Part Time Lover",
"h": "North Park",
"v": "top",
"best": "Weeknights / listening-bar hours",
"d": [
1,
2,
3,
4
],
"t": "",
"w": "Multiple 30s singles specifically endorse this cocktail listening bar for their age range.",
"x": "Could become a date-night/group scene when very packed.",
"m": "\\bpart time lover\\b",
"verify": false
},
{
"g": "San Diego",
"regions": [
"San Diego",
"North County"
],
"page": "San Diego",
"n": "Sunshine Company Saloon",
"h": "Ocean Beach",
"v": "strong",
"best": "Early evening / pool",
"d": null,
"t": "",
"w": "Pool tables and neighborhood-bar atmosphere make casual mingling possible.",
"x": "Firsthand report warns some nights skew younger.",
"m": "\\bsunshine co(mpany)?\\b",
"verify": false
},
{
"g": "San Diego",
"regions": [
"San Diego",
"North County"
],
"page": "San Diego",
"n": "Whistle Stop Bar",
"h": "South Park",
"v": "nights",
"best": "Booty Bassment / throwback dance nights",
"d": null,
"t": "",
"w": "Music-focused social dance events suit grown-up nightlife better than generic Dance listings.",
"x": "Normal bar nights and niche performances need separate evaluation.",
"m": "\\bwhistle stop\\b",
"verify": false
},
{
"g": "San Diego",
"regions": [
"San Diego",
"North County"
],
"page": "San Diego",
"n": "The Cordova Bar",
"h": "Bay Park",
"v": "nights",
"best": "Pitch-A-Friend / Thursday funk / Saturday DJs",
"d": [
4,
5,
6
],
"t": "",
"w": "Hosted singles presentations and mingle periods are direct Wingman matches.",
"x": "Fridays and regular cocktail shifts should not auto-qualify.",
"m": "\\bcordova\\b",
"verify": false
},
{
"g": "San Diego",
"regions": [
"San Diego",
"North County"
],
"page": "San Diego",
"n": "True North Tavern",
"h": "North Park",
"v": "nights",
"best": "Pitch-A-Friend dates / social events",
"d": [
5
],
"t": "",
"w": "Organizer lists an official Pitch-A-Friend San Diego event here.",
"x": "Ordinary sports-bar business as usual does not qualify.",
"m": "\\btrue north tavern\\b",
"verify": false
},
{
"g": "San Diego",
"regions": [
"San Diego",
"North County"
],
"page": "San Diego",
"n": "Monarch Ocean Pub",
"h": "Del Mar",
"v": "strong",
"best": "Weekend social hours",
"d": [
5,
6
],
"t": "",
"w": "An April 2026 attendee reported a late-20s to mid-30s singles crowd.",
"x": "Single anecdote; brunch and dining times differ.",
"m": "\\bmonarch ocean pub\\b|\\bmonarch\\b.*del mar",
"verify": false
},
{
"g": "San Diego",
"regions": [
"San Diego",
"North County"
],
"page": "San Diego",
"n": "Gilly's House of Cocktails",
"h": "North Park",
"v": "strong",
"best": "Evenings / busy bar hours",
"d": null,
"t": "",
"w": "Standing-room neighborhood cocktail setting, less formal than seated date spots.",
"x": "30s singles makeup not directly verified.",
"m": "\\bgillys\\b",
"verify": false
},
{
"g": "San Diego",
"regions": [
"San Diego",
"North County"
],
"page": "San Diego",
"n": "Bluefoot Bar and Lounge",
"h": "North Park",
"v": "nights",
"best": "DJ / dancing / high-energy nights",
"d": null,
"t": "",
"w": "Music and dancing can create a social scene with more mingling than dinner-only bars.",
"x": "Check crowd and genre for each event; may run younger.",
"m": "\\bbluefoot\\b",
"verify": false
},
{
"g": "Orange County",
"regions": [
"Orange County"
],
"page": "Orange County",
"n": "The Country Club",
"h": "Costa Mesa",
"v": "top",
"best": "Weekend nights",
"d": [
5,
6
],
"t": "",
"w": "March 2026 Reddit eyewitness specifically describes a strong 30s/40s going-out crowd.",
"x": "Variable night to night; can be hit-or-miss.",
"m": "\\bthe country club\\b.*costa mesa|^the country club cm\\b",
"verify": false
},
{
"g": "Orange County",
"regions": [
"Orange County"
],
"page": "Orange County",
"n": "The Wild Goose Tavern",
"h": "Costa Mesa",
"v": "strong",
"best": "Weekend nights",
"d": [
5,
6
],
"t": "",
"w": "Specifically included among Costa Mesa social nightlife choices by local Redditors.",
"x": "No verified 30s-only crowd; avoid claiming singles ratio.",
"m": "\\bwild goose\\b",
"verify": false
},
{
"g": "Orange County",
"regions": [
"Orange County"
],
"page": "Orange County",
"n": "The Bungalow Huntington Beach",
"h": "Huntington Beach",
"v": "strong",
"best": "Weekend social nights",
"d": [
5,
6
],
"t": "",
"w": "Multi-room layout and local crowd give guests opportunities to mingle.",
"x": "Age mix and event programming vary; different from Santa Monica Bungalow.",
"m": "\\bbungalow\\b.*huntington|\\bhuntington\\b.*\\bbungalow\\b",
"verify": false
},
{
"g": "Orange County",
"regions": [
"Orange County"
],
"page": "Orange County",
"n": "The Continental Room",
"h": "Downtown Fullerton",
"v": "strong",
"best": "Weekend dance nights",
"d": [
5,
6
],
"t": "",
"w": "Two dance floors and throwback 2000s music; local reports describe older crowd.",
"x": "Dancing is loud and less conversation-friendly.",
"m": "\\bcontinental room\\b",
"verify": false
},
{
"g": "Orange County",
"regions": [
"Orange County"
],
"page": "Orange County",
"n": "High Horse Saloon",
"h": "Downtown Fullerton",
"v": "nights",
"best": "Weekend dance nights",
"d": [
5,
6
],
"t": "",
"w": "Large shared dance floor and bar with substantial weekend energy.",
"x": "Can skew younger and/or country-focused.",
"m": "\\bhigh horse\\b",
"verify": false
},
{
"g": "Orange County",
"regions": [
"Orange County"
],
"page": "Orange County",
"n": "Malarky's Irish Pub",
"h": "Newport Beach Peninsula",
"v": "strong",
"best": "Weekend evenings",
"d": [
5,
6
],
"t": "",
"w": "Local Reddit contributor highlights it as a favorite Newport Peninsula bar-hopping stop.",
"x": "Mixed ages; do not infer singles demographics.",
"m": "\\bmalarkys\\b",
"verify": false
},
{
"g": "Los Angeles",
"regions": [
"Los Angeles",
"Los Angeles / Long Beach"
],
"page": "Los Angeles",
"n": "Bar Flores",
"h": "Echo Park",
"v": "top",
"best": "Wed / Thu evenings",
"d": [
3,
4
],
"t": "7-8 PM",
"w": "35-year-old local says sitting at the bar makes spontaneous conversations easy.",
"x": "No promise that everybody there is single.",
"m": "\\bbar flores\\b",
"verify": false
},
{
"g": "Los Angeles",
"regions": [
"Los Angeles",
"Los Angeles / Long Beach"
],
"page": "Los Angeles",
"n": "The Black Cat",
"h": "Silver Lake",
"v": "strong",
"best": "Wed / Thu evenings",
"d": [
3,
4
],
"t": "7-8 PM",
"w": "Specifically endorsed by 35-year-old for weeknight neighborhood mingling.",
"x": "More social restaurant/bar than dedicated singles spot.",
"m": "\\bthe black cat\\b.*(silver lake|sunset)",
"verify": false
},
{
"g": "Los Angeles",
"regions": [
"Los Angeles",
"Los Angeles / Long Beach"
],
"page": "Los Angeles",
"n": "Walt's Bar",
"h": "Highland Park",
"v": "strong",
"best": "Weekend evenings",
"d": [
5,
6
],
"t": "",
"w": "Neighborhood bar recommended for mingling in the mid-30s; game-bar social potential.",
"x": "Crowd varies; can be more about friends than singles.",
"m": "\\bwalts bar\\b",
"verify": false
},
{
"g": "Los Angeles",
"regions": [
"Los Angeles",
"Los Angeles / Long Beach"
],
"page": "Los Angeles",
"n": "Capri Club",
"h": "Eagle Rock",
"v": "strong",
"best": "Weekend evenings",
"d": [
5,
6
],
"t": "",
"w": "Recommended as a lively option for mid-30s bar-hopping, near Walt's.",
"x": "Sleek cocktail bar may attract couples too.",
"m": "\\bcapri club\\b",
"verify": false
},
{
"g": "Los Angeles",
"regions": [
"Los Angeles",
"Los Angeles / Long Beach"
],
"page": "Los Angeles",
"n": "4100 Bar",
"h": "Silver Lake",
"v": "strong",
"best": "Weekend nights",
"d": [
5,
6
],
"t": "",
"w": "Mentioned in multiple lists of social Eastside bars aimed at a mid-30s night out.",
"x": "Standing crowds may skew 20s on some nights.",
"m": "\\b4100 bar\\b",
"verify": false
},
{
"g": "Los Angeles",
"regions": [
"Los Angeles",
"Los Angeles / Long Beach"
],
"page": "Los Angeles",
"n": "R Bar",
"h": "Koreatown",
"v": "strong",
"best": "Karaoke nights",
"d": null,
"t": "",
"w": "Local singles discussion reports lots of regulars around 30-45; karaoke is an easy opener.",
"x": "Age range and energy depend on the night.",
"m": "^r bar\\b",
"verify": false
},
{
"g": "Los Angeles",
"regions": [
"Los Angeles",
"Los Angeles / Long Beach"
],
"page": "Los Angeles",
"n": "Tabula Rasa Bar",
"h": "Hollywood / Thai Town",
"v": "strong",
"best": "Casual evenings",
"d": null,
"t": "",
"w": "Regular attendee says going alone often leads to conversation.",
"x": "Unverified crowd mix, so no Top Pick yet.",
"m": "\\btabula rasa\\b",
"verify": false
},
{
"g": "Los Angeles",
"regions": [
"Los Angeles",
"Los Angeles / Long Beach"
],
"page": "Los Angeles",
"n": "The Lincoln",
"h": "Venice",
"v": "strong",
"best": "Early evening / weekend",
"d": [
5,
6
],
"t": "",
"w": "Recommended for a mid-30s Westside night; shared bar scene rather than formal dining.",
"x": "Reddit notes it can get younger and wilder on weekends.",
"m": "^the lincoln\\b.*venice",
"verify": false
},
{
"g": "Los Angeles",
"regions": [
"Los Angeles",
"Los Angeles / Long Beach"
],
"page": "Los Angeles",
"n": "Good Times at Davey Wayne's",
"h": "Hollywood",
"v": "nights",
"best": "Weekend nights / dancing",
"d": [
5,
6
],
"t": "",
"w": "Themed multi-area bar recommended to 30s nightlife seekers.",
"x": "Lines, crowd age and noise can impair real conversations.",
"m": "\\bdavey waynes\\b",
"verify": false
},
{
"g": "Ventura / Thousand Oaks",
"regions": [
"Los Angeles / Long Beach",
"Los Angeles"
],
"page": null,
"n": "The Victorian Tavern",
"h": "Ventura",
"v": "strong",
"best": "Fri / Sat evenings",
"d": [
5,
6
],
"t": "",
"w": "A woman in her 30s specifically reported liking the venue and hearing weekends are busy.",
"x": "She observed a quiet visit herself, so busy weekends not personally verified.",
"m": "\\bvictorian tavern\\b",
"verify": false
},
{
"g": "Ventura / Thousand Oaks",
"regions": [
"Los Angeles / Long Beach",
"Los Angeles"
],
"page": null,
"n": "Bright Spark Brewing",
"h": "Ventura",
"v": "nights",
"best": "Wednesday trivia",
"d": [
3
],
"t": "",
"w": "Local 30s discussion reports welcoming trivia with easy team joining.",
"x": "Ordinary taproom hours not a guaranteed singles scene.",
"m": "\\bbright spark\\b",
"verify": false
},
{
"g": "Ventura / Thousand Oaks",
"regions": [
"Los Angeles / Long Beach",
"Los Angeles"
],
"page": null,
"n": "Fluid State",
"h": "Ventura",
"v": "strong",
"best": "Bar evenings",
"d": null,
"t": "",
"w": "35-year-old newcomer received a local recommendation specifically for chatting with strangers.",
"x": "Actual demographic unknown.",
"m": "\\bfluid state\\b",
"verify": false
},
{
"g": "Ventura / Thousand Oaks",
"regions": [
"Los Angeles / Long Beach",
"Los Angeles"
],
"page": null,
"n": "The Tipsy Goat",
"h": "Thousand Oaks",
"v": "nights",
"best": "Weekend nights / karaoke",
"d": [
5,
6
],
"t": "",
"w": "Conesjo-area local recommends karaoke and crowded weekends.",
"x": "Another local calls the scene unpleasant; confidence mixed.",
"m": "\\btipsy goat\\b",
"verify": false
},
{
"g": "Inland Empire",
"regions": [
"Inland Empire",
"Inland / Desert"
],
"page": "Inland Empire",
"n": "The State",
"h": "Downtown Redlands",
"v": "strong",
"best": "Weekend bar crawl",
"d": [
5,
6
],
"t": "",
"w": "Specific Redlands singles discussion names State Street pubs as potential social options.",
"x": "Younger college nightlife can dominate some nights.",
"m": null,
"verify": true
},
{
"g": "Inland Empire",
"regions": [
"Inland Empire",
"Inland / Desert"
],
"page": "Inland Empire",
"n": "La Popular",
"h": "Downtown Redlands",
"v": "nights",
"best": "Social evenings",
"d": null,
"t": "",
"w": "Redlands local singled it out when recommending organic dating venues.",
"x": "No direct testimony of 30s singles crowd.",
"m": "\\bla popular\\b.*redlands",
"verify": false
},
{
"g": "Palm Springs / Joshua Tree",
"regions": [
"Palm Springs + Joshua Tree",
"Inland / Desert"
],
"page": "Palm Springs + Joshua Tree",
"n": "The Nest",
"h": "Indian Wells",
"v": "strong",
"best": "Later evening / social nights",
"d": null,
"t": "",
"w": "Repeatedly identified by Coachella Valley locals as a straight singles pickup bar.",
"x": "Very wide age range; often older than target 28-40.",
"m": "^the nest\\b.*indian wells",
"verify": false
},
{
"g": "Palm Springs / Joshua Tree",
"regions": [
"Palm Springs + Joshua Tree",
"Inland / Desert"
],
"page": "Palm Springs + Joshua Tree",
"n": "Bart's Bar",
"h": "Palm Springs",
"v": "nights",
"best": "Music / social evenings",
"d": null,
"t": "",
"w": "Listed by a local as a 20s/30s social hangout.",
"x": "Only one relevant recommendation; verify music schedule and current crowd.",
"m": "\\bbarts bar\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Commonwealth",
"h": "Fremont East",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "10:00 PM",
"w": "A big Victorian-style bar downstairs with a rooftop dance floor over Fremont East, so you can talk at the bar early and move up when the DJ gets going.",
"x": "There's usually a $10 to $20 cover on weekends and it gets crowded after 11, so get on the guest list or show up early.",
"m": "^commonwealth\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Atomic Liquors",
"h": "Fremont East",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "9:00 PM",
"w": "The oldest freestanding bar in town, with a mix of locals and visitors and a patio where it's easy to fall into conversation with whoever's next to you.",
"x": "It gets busy before and after shows on Fremont East, so the patio fills fast on weekends.",
"m": "\\batomic liquors\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Velveteen Rabbit",
"h": "Arts District",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "One of the original Arts District cocktail bars, with couches, a patio and a photo booth, and it's an easy first stop before walking to the other bars on Main Street.",
"x": "It's closed Wednesdays and gets tight inside on weekends, so grab a spot on the patio.",
"m": "\\bvelveteen rabbit\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "ReBAR and Davy's Locker",
"h": "Arts District",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:30 PM",
"w": "A thrift-store dive with board games, cheap drinks and a big shared patio with its nautical neighbor, which makes it easy to join a game or a table.",
"x": "It's a true dive with mismatched furniture, so don't expect cocktails or polish.",
"m": "\\brebar\\b|\\bdavys locker\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "The Chandelier",
"h": "The Strip (Cosmopolitan)",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "Three levels of bar inside a giant chandelier, with people stopping in on their way to dinner or Marquee, so there's always a crowd standing around between plans.",
"x": "Drinks are Strip-priced and slow to make, and it's mostly visitors rather than locals.",
"m": "\\bchandelier\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Frankie's Tiki Room",
"h": "Westside (W Charleston)",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "10:00 PM",
"w": "A dark, kitschy tiki bar open around the clock with strong drinks and a small room, so you end up chatting with the people crammed in next to you.",
"x": "The drinks are stronger than they look, and the room is small enough that weekends get shoulder to shoulder.",
"m": "\\bfrankies tiki\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "The Sand Dollar Lounge",
"h": "Chinatown (Spring Mountain)",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:30 PM",
"w": "A no-frills blues bar with a live band every night and a pool table, and groups mix between sets.",
"x": "It's a small room, so a popular band can make it hard to move around.",
"m": "\\bsand dollar\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Dino's Lounge",
"h": "Near the Strip (Las Vegas Blvd S)",
"v": "nights",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "9:30 PM",
"w": "A classic family-run dive where karaoke nights pull in a mix of locals and visitors, and everyone cheers for everyone.",
"x": "Off-karaoke nights are quiet and mostly regulars.",
"m": "^dinos\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Double Down Saloon",
"h": "Paradise (near UNLV)",
"v": "nights",
"best": "Live band nights",
"d": null,
"t": "10:00 PM",
"w": "A loud punk dive with murals everywhere, and on band nights the crowd is friendly and easy to talk to between sets.",
"x": "It's grungy and loud, and the jukebox crowd on off nights can be hit or miss.",
"m": "\\bdouble down saloon\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Huntridge Tavern",
"h": "Huntridge (E Charleston)",
"v": "nights",
"best": "Game days",
"d": null,
"t": "",
"w": "A cheap, rowdy neighborhood dive with plenty of TVs, and it's at its friendliest when a big game is on.",
"x": "Most nights it's regulars at the bar, so it's more hangout than scene.",
"m": "\\bhuntridge tavern\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Audio Bar",
"h": "Arts District",
"v": "nights",
"best": "Weekend DJ nights",
"d": null,
"t": "",
"w": "Part bar, part club, with a DJ booth and a desert-festival feel, so weekend DJ nights turn into a social dance party.",
"x": "Weekend daytime brunch is family-friendly, so go after dark for the bar crowd.",
"m": "^audio bar\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Omnia Nightclub",
"h": "The Strip (Caesars Palace)",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "A huge Strip megaclub built around big-name DJs and bottle service.",
"x": "Groups of guys without a table face long lines and covers that climb as the night goes on.",
"m": "^omnia\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "XS Nightclub",
"h": "The Strip (Wynn/Encore)",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "A high-end Strip megaclub where the pool deck and floor are mostly reserved tables.",
"x": "Expect a pricey cover, a strict dress code and long waits without a table.",
"m": "^xs\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "LIV Las Vegas",
"h": "The Strip (Fontainebleau)",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "The Fontainebleau's Miami-import megaclub, priced and set up for bottle service.",
"x": "The guest list closes early and general admission is among the priciest on the Strip.",
"m": "^liv\\b",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Downtown Cocktail Room",
"h": "Fremont East",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "This longtime Fremont East cocktail lounge has closed.",
"x": "It still shows up on older best-of lists, but it's gone.",
"m": "",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Don't Tell Mama",
"h": "Downtown (Neonopolis)",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "The downtown piano bar closed in February 2026.",
"x": "It still appears on singles-bar lists, but it's closed.",
"m": "",
"verify": false
},
{
"g": "Las Vegas",
"regions": [
"Las Vegas"
],
"page": "Las Vegas",
"n": "Beauty Bar",
"h": "Fremont East",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "This Fremont East salon-themed bar closed years ago.",
"x": "Some listing sites still show it, but it's gone.",
"m": "",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Super Abari Game Bar",
"h": "Belmont",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "9:00 PM",
"w": "A big arcade bar full of old and new games, so there's always an easy reason to start talking to whoever's at the next machine. Open until 2am every night.",
"x": "Weekend nights get crowded around the popular games, so go a little earlier if you want to actually play.",
"m": "\\bsuper abari\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "The Workman's Friend",
"h": "Plaza Midwood",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:30 PM",
"w": "A roomy Irish pub where the crowd skews a bit older than South End, and the long bar makes it easy to fall into conversation. Good first stop before wandering Central Ave.",
"x": "It's more of a pub than a party, so pair it with another Plaza Midwood stop if you want energy late.",
"m": "\\bworkmans friend\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Petra's",
"h": "Plaza Midwood",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:30 PM",
"w": "A small, friendly bar with a mixed crowd, vinyl DJ nights and a little stage, so people end up dancing and chatting with strangers. Very welcoming to LGBTQ folks and everyone else.",
"x": "It's a small room, so on DJ nights it fills up fast and gets loud.",
"m": "^petras\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Thirsty Beaver Saloon",
"h": "Plaza Midwood",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "A tiny, beloved country dive with a jukebox and a patio, where everyone's squeezed together and talking to strangers is basically unavoidable.",
"x": "It's closed Mondays and Tuesdays, and it's cramped inside on weekends.",
"m": "\\bthirsty beaver\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Two Buck Saloon",
"h": "Plaza Midwood",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "Cheap beer, pool tables, darts and bands on the patio keep it lively, and a pool game is an easy way to meet people.",
"x": "It's a true dive, so don't expect fancy drinks or much elbow room on weekends.",
"m": "\\btwo buck saloon\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Copperhead Social Club",
"h": "NoDa",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:30 PM",
"w": "Board games, video games and cards all over the place, so it's easy to join a game or start one with the table next to you. The burger is good too.",
"x": "Tables fill up with groups on weekends, so it's easier to mix in on a weeknight or at the bar.",
"m": "\\bcopperhead\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Idlewild",
"h": "NoDa",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "There's no menu, so you tell the bartender what you like and they make you something, which gets the people around you talking about what they ordered. Cozy and grown-up.",
"x": "It's small and seats go quickly, so it's better for one or two people than a big group.",
"m": "\\bidlewild\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Vinyl",
"h": "South End",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "One of the South End spots where the crowd runs a little older, with a big open room, DJs and lots of mingling.",
"x": "South End gets very young after 11 on weekends, so earlier is better.",
"m": "^vinyl\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Snug Harbor",
"h": "Plaza Midwood",
"v": "nights",
"best": "Karaoke night",
"d": null,
"t": "",
"w": "Its karaoke night is the most loved in town, and cheering on strangers makes it really easy to chat. Other nights it's a small rock club with local bands.",
"x": "Closed Mondays and Tuesdays, and the sign-up list gets long, so get your name in early.",
"m": "\\bsnug harbor\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Resident Culture Brewing (Plaza Midwood)",
"h": "Plaza Midwood",
"v": "nights",
"best": "Wed",
"d": [
3
],
"t": "7:00 PM",
"w": "Wednesday trivia here is a city favorite, and teams are friendly about letting a solo person or a pair join in.",
"x": "Get there early on Wednesdays to grab a table.",
"m": "\\bresident culture\\b(?!.*\\bsouth end\\b)",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Ed's Tavern",
"h": "Dilworth",
"v": "nights",
"best": "Game days",
"d": null,
"t": "",
"w": "A Dilworth staple with tons of TVs and a big patio, and on game days the whole place turns into one loud, friendly crowd.",
"x": "Big game days get packed, so show up well before kickoff.",
"m": "^eds tavern\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Saeed's Bar & Grill",
"h": "Cornelius",
"v": "nights",
"best": "Karaoke nights",
"d": null,
"t": "",
"w": "A Lake Norman hangout with karaoke, pool tables, bar games and sand volleyball courts, so there's plenty to do besides stand around.",
"x": "Check the schedule first, since the scene depends a lot on which night you go.",
"m": "\\bsaeeds bar & grill\\b",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Southern Strain Brewing (Plaza Midwood)",
"h": "Plaza Midwood",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "This Plaza Midwood taproom closed in February 2026.",
"x": "Closed for good. The Concord location is still open.",
"m": "",
"verify": false
},
{
"g": "Charlotte",
"regions": [
"Charlotte"
],
"page": "Charlotte",
"n": "Resident Culture Brewing (South End)",
"h": "South End",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "The South End location closed in 2025. The Plaza Midwood taproom is still open.",
"x": "Closed for good. Go to the Central Ave location instead.",
"m": "",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Number Thirty Eight",
"h": "RiNo",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "",
"w": "A huge indoor and outdoor space with fire pits, food stalls and live music, so there's always a crowd to drift into and something to talk about.",
"x": "It's big enough that a slow night feels empty, so check the music calendar first.",
"m": "\\bnumber thirty[- ]eight\\b|\\bnumber 38\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "American Bonded",
"h": "RiNo",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "",
"w": "A relaxed neighborhood bar on Larimer with a street food window and live music on weekends, the kind of place where people end up chatting at the bar.",
"x": "Weekend music nights get loud, so grab a spot early if you want to actually talk.",
"m": "\\bamerican bonded\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "PS Lounge",
"h": "East Colfax",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "",
"w": "A classic Colfax dive with cheap drinks, a CD jukebox and a pool room in back, and the bartender's famous free shots break the ice for you.",
"x": "It's tiny and gets cramped fast on weekends.",
"m": "^ps lounge\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Star Bar",
"h": "LoDo",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "",
"w": "A casual dive near Coors Field with a tiki patio out back, easy to fall into conversation over a beer.",
"x": "Rockies game days bring a very different, louder crowd.",
"m": "^star bar\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Forest Room 5",
"h": "Highlands/LoHi",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "",
"w": "The firepit patio and old Airstream make it feel like a backyard party, and sharing a fire with strangers is about the easiest opener there is.",
"x": "The patio is the whole point, so it's less fun if the weather turns.",
"m": "\\bforest room 5\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Improper City",
"h": "RiNo",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "",
"w": "A giant patio bar with a stage, food trucks and long tables right next to a climbing gym, so you end up sitting next to new people by default.",
"x": "Mostly an outdoor hangout, so it's much quieter in the cold months.",
"m": "\\bimproper city\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Punch Bowl Social",
"h": "Baker",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "",
"w": "Bowling, karaoke and arcade games give you an easy reason to join another group, and the bar is big enough to wander.",
"x": "Big groups and birthday parties can take over on Saturdays.",
"m": "\\bpunch bowl social\\b(?!.*(stapleton|central park))",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Atomic Cowboy",
"h": "East Colfax",
"v": "nights",
"best": "Tue",
"d": [
2
],
"t": "7:30 PM",
"w": "Pool, giant Connect 4 and Tuesday trivia give you lots of ways to start talking to people in a laid-back room.",
"x": "It can be pretty quiet early in the week outside of trivia.",
"m": "\\batomic cowboy\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Ace Eat Serve",
"h": "Capitol Hill",
"v": "nights",
"best": "Tue",
"d": [
2
],
"t": "6:00 PM",
"w": "A big room full of ping-pong tables, and the Tuesday tournament is a built-in way to meet people even if you show up solo.",
"x": "Tournament spots are limited, so sign up right at 6.",
"m": "\\bace eat serve\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Sobo 151",
"h": "Baker/South Broadway",
"v": "nights",
"best": "Avs game nights",
"d": null,
"t": "",
"w": "The unofficial Avs bar, so on game nights the whole room is cheering together and talking to strangers comes naturally.",
"x": "Big playoff games fill it up early.",
"m": "\\bsobo 151\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Don's Club Tavern",
"h": "Capitol Hill",
"v": "nights",
"best": "Karaoke nights",
"d": null,
"t": "",
"w": "A friendly old neighborhood bar with pool and karaoke, and karaoke nights turn the whole place into one crowd.",
"x": "Off nights it's mostly regulars, so go when there's karaoke.",
"m": "\\bdons club\\b",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Mercury Cafe",
"h": "Five Points",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Closed in 2025.",
"x": "",
"m": "",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Punch Bowl Social Stapleton",
"h": "Central Park",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Closed for good in 2020. The South Broadway location is the one to go to.",
"x": "",
"m": "",
"verify": false
},
{
"g": "Denver",
"regions": [
"Denver"
],
"page": "Denver",
"n": "Williams & Graham",
"h": "Highlands/LoHi",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "A great speakeasy, but it's reservation-only and seated, so it's a date spot rather than a place to meet people.",
"x": "",
"m": "\\bwilliams (&|and) graham\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Bar 35",
"h": "Chinatown",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "9:30 PM",
"w": "A brick-walled Hotel Street bar with a big beer list, a back patio and DJs on weekends, so it's easy to drift from your group to the patio and end up talking to strangers.",
"x": "It's only open Thursday through Saturday and gets packed after 11, so go earlier if you want to actually talk.",
"m": "\\bbar 35\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Manifest",
"h": "Chinatown",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "9:30 PM",
"w": "Coffee bar by day, cocktail bar with DJs and bands at night, with an arty local crowd that fills in as the night goes on and loosens up once the music starts.",
"x": "Wednesdays are quiet, and the music gets loud late on weekends, so do your talking before 11.",
"m": "^manifest\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Smith & Kings",
"h": "Chinatown",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "A roomy bar with a chalkboard cocktail menu and a young professional crowd, plus enough space to stand around and mingle instead of being stuck at a table.",
"x": "It also runs as an event space, so check that a private party hasn't taken over the room.",
"m": "\\bsmith & kings\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Skull & Crown Trading Co.",
"h": "Chinatown",
"v": "nights",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:30 PM",
"w": "A horror-themed tiki bar with flaming drinks and flickering lights, and on weekends the crowd gets rowdy enough that talking to the next table comes naturally.",
"x": "Weeknights are calmer and more date-night, and they take reservations, so weekend walk-ins can wait.",
"m": "\\bskull (&|and) crown\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Pint + Jigger",
"h": "Ala Moana",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "7:00 PM",
"w": "A sports bar with communal picnic tables and shuffleboard, where locals and out-of-towners end up sharing tables and games.",
"x": "Big game nights fill it with people glued to the TVs, so pick a night without a major game if you want conversation.",
"m": "\\bpint (\\+|and|&) jigger\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Arnold's Beach Bar",
"h": "Waikiki",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "A cheap, cold-beer dive tucked just off Kalakaua where locals and visitors mix at the bar and the regulars actually like to talk story.",
"x": "It's small and divey, so don't expect cocktails or much room once a band is playing.",
"m": "\\barnolds\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Hana Koa Brewing Co.",
"h": "Kakaako",
"v": "nights",
"best": "Event nights (tournaments, tastings)",
"d": null,
"t": "",
"w": "A big warehouse brewery that runs game nights like Mario Kart tournaments, which makes it easy to join in with a group you don't know.",
"x": "Early evenings can be family-heavy, so check the event calendar and aim for the adult events.",
"m": "\\bhana koa\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Off The Wall Craft Beer & Wine",
"h": "Kakaako",
"v": "nights",
"best": "Weeknight happy hour",
"d": null,
"t": "5:30 PM",
"w": "Long high-top tables and outdoor seating make it a natural after-work spot where groups spill into each other.",
"x": "It's an after-work place more than a late-night one, so it thins out early.",
"m": "^off the wall\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "8 Fat Fat 8",
"h": "Makiki",
"v": "nights",
"best": "Karaoke nights",
"d": null,
"t": "9:00 PM",
"w": "A 40-year local dive with pool, darts and karaoke, so there's always an easy excuse to start talking to someone.",
"x": "It's a true dive with a lot of regulars, so it's more fun with a friend than solo the first time.",
"m": "\\b8 fat fat 8\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Apartment 3",
"h": "Kaimuki",
"v": "nights",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:00 PM",
"w": "A small, dim cocktail bar on Waialae that fills up on weekends, which puts you shoulder to shoulder with a mostly local crowd.",
"x": "It's tiny, so groups bigger than three or four will have a hard time.",
"m": "^apartment 3\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Kelley O'Neil's",
"h": "Waikiki",
"v": "nights",
"best": "Live band nights",
"d": null,
"t": "9:00 PM",
"w": "An Irish pub on Lewers with live bands and a youngish crowd, the kind of place where people dance near the stage and chat at the bar.",
"x": "It's in the middle of tourist Waikiki, so expect plenty of visitors along with locals.",
"m": "\\bkelley oneils\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Moose McGillycuddy's",
"h": "Waikiki",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Fun if you're in your early 20s, but it's a cheap-drink college and exchange-student scene.",
"x": "Skews very young.",
"m": "\\bmoose mcgillycuddys\\b",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Smith's Union Bar",
"h": "Chinatown",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Hawaii's oldest bar closed in 2026 after 92 years on Hotel Street.",
"x": "Closed.",
"m": "",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Tchin Tchin Bar",
"h": "Chinatown",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "The Hotel Street rooftop wine bar closed in 2026, and its planned reopening was called off.",
"x": "Closed for now.",
"m": "",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Olohana Brewpub",
"h": "Chinatown",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "This Chinatown brewpub (formerly Kalihi Beer) closed in May 2026.",
"x": "Closed.",
"m": "",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Honolulu Beerworks (Kakaako)",
"h": "Kakaako",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "The old Cooke Street brewpub is gone; the brewery moved to a daytime taproom in Kalihi.",
"x": "Closed at this location.",
"m": "",
"verify": false
},
{
"g": "Honolulu",
"regions": [
"Honolulu"
],
"page": "Honolulu",
"n": "Waikiki Brewing (Kakaako)",
"h": "Kakaako",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Waikiki Brewing no longer has a Kakaako pub; its old spot went to Aloha Beer.",
"x": "Closed at this location.",
"m": "",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Dew Drop Inn",
"h": "Eckington",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "A big, laid back warehouse bar with a deck, cheap drinks and regular comedy, queer nights and free live music, so there's usually something going on to start a conversation about.",
"x": "No reservations, and the deck fills up first on nice nights.",
"m": "\\bdew drop inn\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "The Midlands Beer Garden",
"h": "Park View",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "7:00 PM",
"w": "Loud and casual with long picnic tables, board games and big screens, so sharing a table or getting pulled into a game of Jenga or trivia happens on its own.",
"x": "It's mostly outdoors, so it's quieter on cold nights.",
"m": "\\bmidlands\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "The Wonderland Ballroom",
"h": "Columbia Heights",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "7:30 PM",
"w": "A quirky neighborhood bar with a big front patio and an upstairs that turns into a dance floor on weekends, and the downstairs is easy to just stand around and chat in.",
"x": "The crowd gets younger as the night goes on, especially upstairs on weekends.",
"m": "\\bwonderland ballroom\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Little Miss Whiskey's Golden Dollar",
"h": "H Street",
"v": "nights",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:00 PM",
"w": "Weekends the upstairs turns into a free dance floor with a mixed crowd, and the two level patio makes it easy to drift between groups.",
"x": "It gets rowdier and younger late, so earlier is better if you want to actually talk.",
"m": "\\blittle miss whiskeys\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Red Derby",
"h": "Petworth",
"v": "strong",
"best": "Wed, Thu, Fri, Sat",
"d": [
3,
4,
5,
6
],
"t": "8:00 PM",
"w": "A cheap, friendly dive with a rooftop deck, board games, bingo and trivia, and it draws a real mix of ages instead of just the post-college crowd.",
"x": "Closed Sundays and Mondays, and it's cash-friendly and no frills.",
"m": "\\bred derby\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Franklin Hall",
"h": "U Street",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "A huge, busy hall with couches, fireplaces and long communal tables, so you end up sitting next to people you don't know without trying.",
"x": "It's all ages on weeknights until 8 PM and loud on weekends, so go later and grab a spot at a communal table early.",
"m": "\\bfranklin hall\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Hook Hall",
"h": "Park View",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "7:30 PM",
"w": "Half bar, half adult playground, with a turf beer garden, games, trivia and themed parties that give everyone something to do together.",
"x": "It's often booked for private events and parties, so check what's on before you go.",
"m": "\\bhook hall\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Dacha Beer Garden",
"h": "Shaw",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "6:30 PM",
"w": "Packed picnic tables under the giant Elizabeth Taylor mural, where sharing a table with strangers is just how it works.",
"x": "It's an outdoor spot, so it's at its best in warm weather and lines form on sunny weekends.",
"m": "^dacha\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Lyman's Tavern",
"h": "Columbia Heights",
"v": "nights",
"best": "Weeknights early",
"d": null,
"t": "7:00 PM",
"w": "A pinball bar with leagues and tournaments, so there's always an easy opener about whose turn it is.",
"x": "It gets loud and younger later in the night, so go early if you want to talk.",
"m": "\\blymans\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Primrose",
"h": "Brookland",
"v": "nights",
"best": "Event nights",
"d": null,
"t": "",
"w": "A French wine bar whose hosted events are set up for mixing and mingling, and the bar itself is an easy place to strike up a conversation.",
"x": "It's a restaurant first, so outside of events it's a quieter, wine-at-the-bar kind of night.",
"m": "^primrose\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Madam's Organ",
"h": "Adams Morgan",
"v": "nights",
"best": "Weeknights early",
"d": null,
"t": "8:00 PM",
"w": "Live bands every night across several floors, and an earlier weeknight set is a fun, easy-going way to mingle around the bar.",
"x": "Weekends after 11 it turns into a young, packed Adams Morgan crowd.",
"m": "\\bmadams organ\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Hush Harbor",
"h": "H Street",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "DC's phone-free bar on H Street has closed for now.",
"x": "The owner is looking for a new location, so it may come back.",
"m": "",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Dan's Cafe",
"h": "Adams Morgan",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "A legendary dive known for squeeze-bottle drinks, but the crowd is mostly early 20s.",
"x": "Fun for a last stop, but it's not where you'll meet people your age.",
"m": "^dans cafe\\b",
"verify": false
},
{
"g": "Washington DC",
"regions": [
"Washington DC"
],
"page": "Washington DC",
"n": "Sauf Haus Bier Hall",
"h": "Dupont Circle",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "A rooftop German beer hall that leans young, especially late on weekends.",
"x": "Expect a just-out-of-college crowd after 10.",
"m": "\\bsauf haus\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Gracie's",
"h": "Downtown",
"v": "strong",
"best": "Wed, Thu, Fri, Sat",
"d": [
3,
4,
5,
6
],
"t": "9:00 PM",
"w": "A big two-level patio, live music most nights and a late karaoke night make it easy to drift between groups and strike up a conversation.",
"x": "Utah bars stop serving at 1 AM, so the patio peaks earlier than you might expect.",
"m": "^gracies\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Lake Effect",
"h": "Downtown",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:30 PM",
"w": "Three floors with live music, a basement lounge and seasonal pop-up bars, so there is always a new room to wander into and something to talk about.",
"x": "Holiday pop-up nights in the Rabbit Hole are ticketed, so check before you go.",
"m": "\\blake effect\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Fisher Brewing",
"h": "Granary District",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "7:00 PM",
"w": "A lively taproom with a big patio, food trucks and plenty of dogs, which makes it one of the easier places in town to start chatting with strangers.",
"x": "It is a beer-and-patio spot, so it winds down earlier than the downtown bars.",
"m": "\\bfisher brewing\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Beer Bar",
"h": "Downtown",
"v": "nights",
"best": "Game nights, Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "A German beer hall setup with long shared tables, so you end up sitting next to new people whether you planned to or not.",
"x": "Gets loud and crowded on weekend evenings, so grab a spot at a shared table early.",
"m": "^beer bar\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Quarters Arcade Bar",
"h": "Downtown",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "9:00 PM",
"w": "Rows of vintage arcade games and pinball give you an easy excuse to challenge someone or ask whose turn it is.",
"x": "Only the downtown location on 400 South is open now, so skip the old Sugar House address.",
"m": "^quarters\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Kiitos Brewing",
"h": "Central City",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "7:30 PM",
"w": "A festive taproom with pinball and arcade games, plus a newer Sugar House bar that has drawn big neighborhood crowds since it opened.",
"x": "The Sugar House spot is a cozy corner bar, so it fills up fast on weekends.",
"m": "\\bkiitos\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "The Pearl",
"h": "Central 9th",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "A trendy cocktail bar with a patio and a dressed-up, social crowd in one of the city's most walkable little bar pockets.",
"x": "It is on the small side, so bigger groups should go early or plan to hop to Water Witch or Scion nearby.",
"m": "^(the )?pearl\\b(?! st)",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Twist Bar & Bistro",
"h": "Downtown",
"v": "nights",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "A big outdoor patio on Main Street with a busy weekend crowd and themed nights.",
"x": "The crowd can skew young on weekends, so it is better for a late stop than your whole night.",
"m": "^twist\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Mountain West Cider",
"h": "Marmalade District",
"v": "nights",
"best": "Live music nights, spring to fall",
"d": null,
"t": "",
"w": "A sunny cider garden with live bands, which is easy and relaxed for chatting when the weather is good.",
"x": "It is mostly a patio crowd, so it is much quieter in winter.",
"m": "\\bmountain west cider\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Harp & Hound",
"h": "Ogden (25th Street)",
"v": "nights",
"best": "Wed, Thu, Sun",
"d": [
0,
3,
4
],
"t": "9:00 PM",
"w": "An Ogden pub with trivia on Wednesdays and karaoke on Thursdays and Sundays, which are the nights to go if you want an easy way into a crowd.",
"x": "Schedules change, so check their social media before driving up.",
"m": "\\bharp (&|and) hound\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "No Name Saloon",
"h": "Park City (Main Street)",
"v": "nights",
"best": "Ski season après, Fri, Sat",
"d": [
5,
6
],
"t": "4:00 PM",
"w": "Park City's classic Main Street après bar, with a fireplace, shuffleboard and a packed room of skiers swapping stories, so it is mainly worth the drive in ski season.",
"x": "It is a tourist magnet on peak weekends, so expect a wait and ski-town prices.",
"m": "\\bno name saloon\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "The Spur Bar & Grill",
"h": "Park City (Main Street)",
"v": "nights",
"best": "Ski season, Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "Live music every night on Main Street makes it the best late option in Park City, mainly worth it in ski season when the town is full.",
"x": "Off season it can be pretty quiet, so save it for winter weekends.",
"m": "^(the )?spur bar\\b|^the spur\\b",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Garage on Beck",
"h": "North of Capitol Hill",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Closed for good in 2025.",
"x": "",
"m": "",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "The Tavernacle",
"h": "Downtown",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "The dueling piano and karaoke bar closed in 2021.",
"x": "",
"m": "",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Alibi Bar & Place",
"h": "Downtown",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Closed, and the space is now a coffee shop and bar called Mother.",
"x": "",
"m": "",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "Whiskey Street",
"h": "Downtown",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Closed after a 2025 fire, with no confirmed reopening date yet.",
"x": "",
"m": "",
"verify": false
},
{
"g": "Salt Lake City",
"regions": [
"Salt Lake City"
],
"page": "Salt Lake City",
"n": "The Green Pig Pub",
"h": "Downtown",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "A rooftop sports bar that mostly draws a college crowd.",
"x": "",
"m": "\\bgreen pig pub\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Prost",
"h": "Mississippi",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:00 PM",
"w": "A German beer hall with a big outdoor beer garden and shared tables, so you end up elbow to elbow with strangers whether you planned to or not. It sits in the middle of the Mississippi bar strip, easy to pair with a show or a crawl.",
"x": "The garden gets tight and loud on weekends, so grab a table early.",
"m": "^prost\\b(?!.*marketplace)",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "The Rambler",
"h": "Mississippi",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "7:30 PM",
"w": "Long picnic tables, firepits and heaters on a covered wraparound patio make it easy to share a table and start talking. Lots of people start their Mississippi night here.",
"x": "Firepit seats go fast on cold nights.",
"m": "^(the )?rambler\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Bar Bar",
"h": "Mississippi",
"v": "nights",
"best": "Fri, Sat after Mississippi Studios shows",
"d": [
5,
6
],
"t": "",
"w": "Burgers and a sprawling sidewalk patio attached to Mississippi Studios, so it fills up with people still buzzing from the show. Easy place to ask strangers what they thought of the set.",
"x": "It's quiet before shows let out and packed right after.",
"m": "^bar bar\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Wayfinder Beer",
"h": "Central Eastside",
"v": "strong",
"best": "Fri, Sat, Sun",
"d": [
0,
5,
6
],
"t": "6:00 PM",
"w": "A big wood deck with a firepit and picnic tables where groups spread out and mix. It's a daytime and early-evening hang more than a late-night one.",
"x": "Skews to day drinking, so it thins out later at night.",
"m": "\\bwayfinder beer\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Vendetta",
"h": "Williams",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "Shuffleboard, pinball and a gravel back patio give you something to do besides stare at your phone, and challenging someone to a game is normal here.",
"x": "It's a neighborhood haunt, so weeknights can be mostly regulars.",
"m": "\\bvendetta\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "The Nest",
"h": "Belmont",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:30 PM",
"w": "Ping-pong and pool tables keep things playful, and it's right on the Belmont strip so people drift in and out between bars.",
"x": "The tables get claimed early on weekends, so put your name down when you arrive.",
"m": "\\bnest\\b",
"verify": true
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Sugar Hill",
"h": "Belmont",
"v": "nights",
"best": "DJ nights and Meeting Mutuals meetups",
"d": null,
"t": "",
"w": "A 70s-styled bar on Belmont that hosts DJ sets and the Meeting Mutuals social nights, where people wear stickers showing their interests so it's easy to start a conversation.",
"x": "Regular nights are much calmer, so check the event calendar first.",
"m": "^sugar hill\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Ground Kontrol",
"h": "Old Town",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "A two-level arcade bar packed with classic games and pinball, and it goes 21+ after 5 PM. Waiting your turn on a machine or asking for a two-player game is an easy opener.",
"x": "Weekend nights can mean a cover and lines for the popular machines.",
"m": "\\bground kontrol\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "The Alibi Tiki Lounge",
"h": "North Portland",
"v": "nights",
"best": "Thu, Fri, Sat karaoke",
"d": [
4,
5,
6
],
"t": "9:00 PM",
"w": "Portland's classic karaoke bar, with tiki drinks and a room full of birthday groups and solo singers cheering each other on. Cheering for a stranger's song is the easiest icebreaker there is.",
"x": "The song list gets long late on weekends, so sign up as soon as you walk in.",
"m": "^(the )?alibi\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Baby Ketten Klub",
"h": "Southeast",
"v": "nights",
"best": "Karaoke nights (check schedule)",
"d": null,
"t": "",
"w": "A cult-favorite karaoke night with a deep, weird song catalog and an enthusiastic crowd that sings along with everyone. It's more of a party than a performance.",
"x": "Public karaoke shares space with private rooms, so check that a public night is on.",
"m": "\\bbaby ketten\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Dante's (Karaoke From Hell)",
"h": "Old Town",
"v": "nights",
"best": "Mon",
"d": [
1
],
"t": "9:00 PM",
"w": "Monday nights you sing with a live house band backing you, and the crowd treats every singer like a rock star. Easy to chat with whoever's waiting for their turn.",
"x": "The sign-up list fills fast and the room is loud, so talking happens between songs.",
"m": "^dantes\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Chopsticks Express",
"h": "Laurelhurst",
"v": "nights",
"best": "Karaoke nights",
"d": null,
"t": "",
"w": "A neighborhood karaoke bar where the mood is celebratory rather than showy, so nobody minds if you can't sing. Good spot to join a group's birthday energy.",
"x": "It's small, so a big party can take over the room.",
"m": "^chopsticks\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Holocene",
"h": "Buckman",
"v": "nights",
"best": "Fri, Sat DJ and dance nights",
"d": [
5,
6
],
"t": "10:00 PM",
"w": "A big converted warehouse with a sunken dance floor and two rooms, so you can dance in one and talk at the bar in the other. Dance nights pull a fun, mixed crowd.",
"x": "Lots of nights are themed or queer-centered, so pick the event that fits you.",
"m": "\\bholocene\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "The Goodfoot",
"h": "Southeast",
"v": "nights",
"best": "Fri, Sat dance nights",
"d": [
5,
6
],
"t": "10:00 PM",
"w": "Funk and soul dance nights in a basement that's been a local favorite for years, with a pool-table bar upstairs if you need a break.",
"x": "It's all about the dance floor, so it's tough for long conversations.",
"m": "\\bgoodfoot\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Voicebox Karaoke",
"h": "Central Eastside",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Private karaoke rooms you rent with your own group, so it's great for a party of friends but not for meeting anyone new.",
"x": "You only sing with the people you came with.",
"m": "^voicebox\\b",
"verify": false
},
{
"g": "Portland",
"regions": [
"Portland"
],
"page": "Portland",
"n": "Dig a Pony",
"h": "Central Eastside",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "This beloved Grand Avenue dance bar closed in 2022.",
"x": "Closed.",
"m": "",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Gracie's Tax Bar",
"h": "Downtown Phoenix",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "9:00 PM",
"w": "A friendly neighborhood dive with a roomy patio, board games and a great jukebox, so striking up a conversation feels normal here.",
"x": "It's small inside and fills up fast on weekends, so grab a patio spot early.",
"m": "\\bgracies\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Valley Bar",
"h": "Downtown Phoenix",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "An underground bar with pool tables, games and a small stage, and it pulls a young professional and creative crowd that's easy to chat with.",
"x": "It's in a basement off an alley and gets packed on weekends, while weeknights can be quiet.",
"m": "\\bvalley bar\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Cobra Arcade Bar",
"h": "Roosevelt Row",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:30 PM",
"w": "Rows of retro arcade games make it easy to challenge a stranger, and DJs keep things lively on weekends.",
"x": "The crowd leans mid-20s, and the game lines get long late on Saturdays.",
"m": "\\bcobra arcade\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Stardust Pinbar",
"h": "Downtown Phoenix",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:30 PM",
"w": "A hidden disco and pinball bar behind Ziggy's pizza, with a lit-up dance floor and machines that give you an easy excuse to say hi.",
"x": "You enter through the pizza shop, and the room is small, so it fills quickly after 10.",
"m": "\\bstardust pinbar\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "The Pemberton",
"h": "Roosevelt Row",
"v": "strong",
"best": "Fri, Sat, Sun",
"d": [
0,
5,
6
],
"t": "7:00 PM",
"w": "A big outdoor hangout with several bars, a pool and live events, so you can drift between groups instead of being stuck at one table.",
"x": "It's mostly outdoors, so check the weather and the event calendar before you go.",
"m": "\\bpemberton\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Crescent Ballroom",
"h": "Downtown Phoenix",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "The front lounge and street-side patio are open even when you don't have a show ticket, and the shared tables make it easy to fall into conversation.",
"x": "Show nights can draw a younger crowd depending on who's playing, so check the calendar.",
"m": "\\bcrescent ballroom\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Bikini Lounge",
"h": "Grand Avenue, Phoenix",
"v": "nights",
"best": "Tue",
"d": [
2
],
"t": "9:00 PM",
"w": "A cash-only tiki dive open since 1947, and its Tuesday vinyl DJ night is the busiest, friendliest weeknight party in town.",
"x": "Bring cash, and expect it to be tight and loud once the DJ gets going.",
"m": "\\bbikini lounge\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Pattie's First Avenue Lounge",
"h": "Old Town Scottsdale",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "9:00 PM",
"w": "A relaxed Old Town dive with three rooms, pool tables and an alley patio, where you can actually hear each other talk.",
"x": "Bachelorette groups wander in on weekends, so it can get loud after 11.",
"m": "\\bpatties\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Coach House",
"h": "Old Town Scottsdale",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:30 PM",
"w": "Scottsdale's oldest tavern feels like a real local hangout instead of a club, and the regulars are friendly with newcomers.",
"x": "It gets shoulder to shoulder once the holiday lights go up in late November.",
"m": "^coach house\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "The Grapevine",
"h": "Old Town Scottsdale",
"v": "nights",
"best": "Karaoke nightly, best Wed to Sat",
"d": [
3,
4,
5,
6
],
"t": "9:30 PM",
"w": "Two floors of karaoke where the crowd cheers for everyone, so singing along with strangers happens on its own.",
"x": "The song list gets long late, so put your name in early if you want a turn.",
"m": "^(the )?grapevine\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Casey Moore's Oyster House",
"h": "Tempe / Maple-Ash",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "8:00 PM",
"w": "A big patio around a 1910 house with lots of nooks and shared tables, and it's the Tempe spot where grads and locals mix instead of just students.",
"x": "It's near ASU, so expect students too, especially on game days.",
"m": "\\bcasey moores\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Hotel Congress",
"h": "Tucson / Downtown",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:30 PM",
"w": "The lobby bar, patio and Club Congress all share one building, so a night here means moving between rooms and running into the same people.",
"x": "University of Arizona students show up for weekend dance nights, so it skews younger after 11.",
"m": "^(?!the century room).*\\bhotel congress\\b|\\bclub congress\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Mill Avenue bars (Fat Tuesday, Zuma)",
"h": "Downtown Tempe",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "Mill Avenue is Tempe's busiest nightlife strip, but it's mostly ASU students and recent grads.",
"x": "If you're over 26 you'll likely feel like a chaperone, so head to Casey Moore's instead.",
"m": "^fat tuesday\\b|^zuma\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Cake Nightclub",
"h": "Old Town Scottsdale",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "A big, flashy Old Town club built around bottle service and long lines.",
"x": "It's hard to talk to anyone here unless you came with a table.",
"m": "^cake\\b",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Liars Club",
"h": "Downtown Phoenix",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "This downtown bar and pizzeria has closed.",
"x": "Valley Bar in the same building is still open.",
"m": "",
"verify": false
},
{
"g": "Phoenix",
"regions": [
"Phoenix",
"Arizona",
"Tempe"
],
"page": "Phoenix",
"n": "Bliss ReBAR",
"h": "Roosevelt Row",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "This Roosevelt Row bar closed after 12 years.",
"x": "",
"m": "",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Ebisu Yokocho",
"h": "Ebisu",
"v": "strong",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "7:00 PM",
"w": "A covered retro alley packed with tiny food and drink stalls where everyone shares counters, so chatting with the people next to you just happens. It pulls a mix of office workers, younger locals and visitors.",
"x": "Every stall needs its own drink order, and some are cash only, so bring 1,000 yen bills.",
"m": "\\bebisu yokocho\\b",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Shibuya Nonbei Yokocho",
"h": "Shibuya",
"v": "strong",
"best": "Wed, Thu, Fri",
"d": [
3,
4,
5
],
"t": "7:00 PM",
"w": "A lantern-lit alley of about 40 tiny bars right by Shibuya Station, where counters hold five or six people and the bartender usually pulls everyone into the same conversation.",
"x": "Many bars add a small seat charge and some favor regulars, so ask before you sit and go in pairs at most.",
"m": "\\bnonbei yokocho\\b",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Golden Gai (Albatross G, Ace's, Kenzo's Bar)",
"h": "Shinjuku",
"v": "nights",
"best": "Thu, Fri, Sat",
"d": [
4,
5,
6
],
"t": "9:00 PM",
"w": "Six alleys of shoebox bars with a handful of stools each, so you end up talking to whoever is squeezed in next to you. Albatross G, Ace's and Kenzo's are the easy first stops for visitors.",
"x": "Most bars charge a 500 to 1,000 yen cover posted on the door, a few say regulars or Japanese only (respect it), and many are closed on Sundays.",
"m": "\\bgolden gai\\b|\\balbatross\\b|\\bkenzos\\b",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Tasuichi",
"h": "Shibuya",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:00 PM",
"w": "A cheap, rowdy standing bar with sports on the TVs and shared standing tables, so English, Japanese and Spanish speakers all end up mixing.",
"x": "Smoking is allowed inside, and it gets loud and cramped late.",
"m": "\\btasuichi\\b",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "300 Bar (Ginza 8-chome / 300 Bar Next)",
"h": "Ginza / Yurakucho (3 locations)",
"v": "strong",
"best": "Thu, Fri",
"d": [
4,
5
],
"t": "7:30 PM",
"w": "Every drink is 300 yen and it's standing only with shared tables, so after-work groups of locals and expats tend to merge as the night goes on.",
"x": "Weeknight after-work rush means it's packed early and thins out once the office crowd heads home.",
"m": "\\b300 bar\\b",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Shibuya Yokocho (Miyashita Park)",
"h": "Shibuya",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "7:00 PM",
"w": "A long food hall of about 20 regional stalls under Miyashita Park with loud music and communal tables, so it's an easy, low-pressure place to start the night and mix with a younger crowd.",
"x": "It's packed and noisy on weekends, so grab a table early or be ready to stand.",
"m": "\\bshibuya yokocho\\b",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Two Dogs Taproom",
"h": "Roppongi",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:00 PM",
"w": "A friendly craft beer and pizza spot with English-speaking staff that fills up with an international crowd on weekends, a relaxed alternative to the Roppongi club strip.",
"x": "Smoking is allowed throughout, and weeknights are quieter and mostly local.",
"m": "\\btwo dogs\\b",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Trunk Hotel lounge",
"h": "Jingumae (Cat Street)",
"v": "nights",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "8:00 PM",
"w": "The open lobby bar near Cat Street draws a stylish mix of locals, creatives and visitors, and the bar and sofa layout makes it easy to strike up a chat.",
"x": "Drinks are hotel priced, and it can feel more like a scene to be seen in than a hangout.",
"m": "\\btrunk\\b",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Geronimo Shot Bar",
"h": "Roppongi",
"v": "nights",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "9:00 PM",
"w": "A loud, long-running shot bar with no cover where a mostly foreign crowd of regulars and newcomers ends up talking across the bar. It's a fun pregame before Roppongi clubs.",
"x": "Beers aren't cheap after happy hour, and ignore anyone on the street outside trying to steer you into a different bar.",
"m": "\\bgeronimo\\b",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Heartland (Roppongi Hills)",
"h": "Roppongi",
"v": "excluded",
"best": "",
"d": null,
"t": "",
"w": "The old Roppongi Hills expat bar that still turns up in older guides.",
"x": "Closed for years, so don't plan around it.",
"m": "",
"verify": false
},
{
"g": "Tokyo",
"regions": [
"Tokyo",
"Japan"
],
"page": "Tokyo",
"n": "Ura Namba standing bars",
"h": "Namba / Osaka",
"v": "strong",
"best": "Fri, Sat",
"d": [
5,
6
],
"t": "7:00 PM",
"w": "A few blocks of cheap tachinomi standing bars run by young owners, where the whole point is hopping from one to the next and chatting with staff and whoever is standing beside you.",
"x": "Expect a small seat or snack charge at many spots, and skip any tout pushing all-you-can-drink deals near Shinsaibashi.",
"m": "\\bura ?namba\\b",
"verify": false
}
];
/* Oct 25 2026: Music Fests chip inside Music + Nightlife.
 * Oct 25 2026: Night Out filters (Nightlife + Music, Wingman Mode, type + music-style drill-down, live counts, too-narrow warning).
 * OB Tie Dye event guide v3 (rebuilt from the live build on Oct 24 2026; older inline comments were not in the served file).
 * Oct 24 2026 St. Croix expansion:
 *  - Twin Cities area groups: new "St. Croix Valley + Western Wisconsin" (Somerset, New Richmond, Hudson, River Falls,
 *    Osceola, St. Croix Falls, Taylors Falls, Stillwater and nearby towns). "Stillwater + Day Trips" is now "Day Trips"
 *    (Duluth, Red Wing, Wabasha, Lake Pepin towns, Menomonie, Eau Claire, Northfield, etc). Old ?neighborhood=stillwater links still work.
 *  - TC_MILES: road miles from downtown Minneapolis (OpenStreetMap routing) shown on Twin Cities venue lines as "35 mi from Mpls".
 *  - Worth the Drive: Twin Cities pages only. Good-for flag + chip (?drive=1) that shows rows tagged "Worth the Drive" in the sheet.
 */
(function() {
 "use strict";
 var ROOT = document.getElementById("obg");
 if (!ROOT || ROOT.__obgBooted) return;
 ROOT.__obgBooted = !0;
 var TZ = window.OB_GUIDE_TZ || "America/Los_Angeles",
  PAGE = 40,
  DAY_MS = 864e5,
  REGIONS = ["San Diego", "North County", "Orange County", "Los Angeles / Long Beach", "Inland / Desert", "Santa Barbara / Central Coast", "Las Vegas", "Charlotte", "Twin Cities", "Denver", "Honolulu", "Washington DC", "Salt Lake City", "Portland", "Phoenix", "Tempe", "Tokyo", "St. Pete", "Los Angeles", "Palm Springs + Joshua Tree", "Inland Empire"],
  DEFAULT_REGION = window.OB_GUIDE_DEFAULT_REGION || "San Diego",
  ALL_LABEL = window.OB_GUIDE_ALL_LABEL || "All of SoCal",
  ALL_PLACE = window.OB_GUIDE_ALL_PLACE || "SoCal",
  GROUPS = [{
   k: "arts",
   label: "Arts + Culture",
   icon: "palette",
   subs: [{
    k: "art",
    label: "Art + Galleries"
   }, {
    k: "diy",
    label: "DIY + Workshops"
   }, {
    k: "film",
    label: "Film"
   }, {
    k: "theater",
    label: "Theater + Performance"
   }]
  }, {
   k: "comedy",
   label: "Comedy",
   icon: "mic"
  }, {
   k: "dance",
   label: "Dance + Nightlife",
   icon: "moon"
  }, {
   k: "dogevent",
   label: "Dog Events",
   icon: "paw"
  }, {
   k: "kids",
   label: "Family + Kids",
   icon: "smile"
  }, {
   k: "fest",
   label: "Festivals + Fairs",
   icon: "tent"
  }, {
   k: "foodwine",
   label: "Food + Drink",
   icon: "fork",
   subs: [{
    k: "food",
    label: "Food + Drink Events"
   }, {
    k: "happy",
    label: "Happy Hour"
   }]
  }, {
   k: "music",
   label: "Live Music",
   icon: "music"
  }, {
   k: "market",
   label: "Markets",
   icon: "bag"
  }, {
   k: "nature",
   label: "Nature + Night Sky",
   icon: "leaf"
  }, {
   k: "sports",
   label: "Sports",
   icon: "ball"
  }, {
   k: "games",
   label: "Trivia, Games + Karaoke",
   icon: "dice"
  }, {
   k: "wellness",
   label: "Wellness",
   icon: "sun"
  }];
 GROUPS.unshift({
  k: "active",
  label: "Active",
  icon: "bolt",
  subs: [{
   k: "races",
   label: "Races"
  }, {
   k: "workouts",
   label: "Run Clubs + Workouts"
  }]
 });
 GROUPS = [{k: "nightlife", label: "Music + Nightlife", icon: "music", subs: [{k: "music", label: "Live Music"}, {k: "dance", label: "Dance + DJ Nights"}, {k: "comedy", label: "Comedy"}, {k: "games", label: "Karaoke, Trivia + Games"}]}, {k: "foodwine", label: "Food + Drink", icon: "fork", subs: [{k: "happy", label: "Happy Hour"}, {k: "food", label: "Food + Drink Events"}]}, {k: "arts", label: "Arts + Culture", icon: "palette", subs: [{k: "art", label: "Art + Galleries"}, {k: "film", label: "Film"}, {k: "theater", label: "Theater + Performance"}, {k: "diy", label: "DIY + Workshops"}]}, {k: "markets", label: "Markets + Festivals", icon: "bag", subs: [{k: "market", label: "Markets"}, {k: "fest", label: "Festivals + Fairs"}]}, {k: "outdoors", label: "Outdoors + Active", icon: "leaf", subs: [{k: "nature", label: "Nature + Night Sky"}, {k: "races", label: "Races"}, {k: "workouts", label: "Run Clubs + Workouts"}, {k: "wellness", label: "Wellness"}]}, {k: "sports", label: "Sports", icon: "ball"}, {k: "kids", label: "Family + Kids", icon: "smile"}, {k: "dogevent", label: "Dog Events", icon: "paw"}];
 var CATS = [],
  GROUP_OF = {},
  CAT_ALIASES = {};
 GROUPS.forEach(function(g) {
  g.subs ? (CAT_ALIASES[g.k] = g.subs.map(function(s) {
   return s.k
  }), g.subs.forEach(function(s) {
   CATS.push({
    k: s.k,
    label: s.label
   }), GROUP_OF[s.k] = g
  })) : (CATS.push({
   k: g.k,
   label: g.label
  }), GROUP_OF[g.k] = g)
 });
 var CAT_KEYS = CATS.map(function(c) {
  return c.k
 });
 CAT_ALIASES.markets = ["market", "fest"], CAT_ALIASES.outdoors = ["races", "workouts", "nature", "wellness"], CAT_ALIASES.fitness = ["races", "workouts"], CAT_ALIASES.all = CAT_KEYS.slice(); CAT_ALIASES.active = ["races", "workouts"];

 function leavesOf(k) {
  return CAT_ALIASES[k] || [k]
 }
 var GOOD = [{
   k: "dog",
   label: "Dog Friendly",
   icon: "paw",
   param: "dog"
  }, {
   k: "free",
   label: "Free",
   icon: "tag",
   param: "free"
  }, {
   k: "outside",
   label: "Outdoors",
   icon: "leaf",
   param: "outdoor"
  }],
  TC_DRIVE = !1,
  subOpen = {};
 TC_DRIVE && GOOD.push({
  k: "drive",
  label: "Worth the Drive",
  icon: "car",
  param: "drive"
 });
 var _obgNoop, DATES = [{
   k: "all",
   label: "Any date"
  }, {
   k: "today",
   label: "Today"
  }, {
   k: "tonight",
   label: "Tonight"
  }, {
   k: "week",
   label: "This Week"
  }, {
   k: "weekend",
   label: "This Weekend"
  }, {
   k: "month",
   label: "This Month"
  }, {
   k: "custom",
   label: "Pick a Date"
  }],
  CHIPS0 = [{
   k: "today",
   label: "Today",
   icon: "sun"
  }, {
   k: "weekend",
   label: "This Weekend",
   icon: "cal"
  }, {
   k: "music",
   label: "Live Music",
   icon: "music"
  }, {
   k: "foodwine",
   label: "Food + Drink",
   icon: "fork"
  }, {
   k: "outdoors",
   label: "Outdoors",
   icon: "leaf"
  }, {
   k: "free",
   label: "Free",
   icon: "tag"
  }, {
   k: "dog",
   label: "Dog Friendly",
   icon: "paw"
  }, {
   k: "weekly",
   label: "Show everything",
   icon: "list"
  }, {
   k: "picks",
   label: "OB Picks",
   icon: "star"
  },{k:"night",label:"Music + Nightlife",icon:"music"},{k:"wing",label:"Wingman Mode",icon:"heart"}],
  V4 = window.OB_GUIDE_LAYOUT !== "classic",
  CHIPS = CHIPS0;
 V4 && (DATES = DATES.filter(function(d) {
  return d.k !== "tonight"
 })), V4 && (CHIPS = [{
  k: "picks",
  label: "OB Picks",
  icon: "star"
 },{k:"night",label:"Music + Nightlife",icon:"music"},{k:"wing",label:"Wingman Mode",icon:"heart"}, {k: "happy", label: "Happy Hour", icon: "glass"}, {k: "outdoors", label: "Outdoors", icon: "leaf"}, {
  k: "free",
  label: "Free",
  icon: "tag"
 }, {
  k: "dog",
  label: "Dog Friendly",
  icon: "paw"
 }]), TC_DRIVE && CHIPS.push({
  k: "drive",
  label: "Worth the Drive",
  icon: "car"
 });
 var TAG = {
   Concert: ["Live Music", "violet"],
   "Happy Hour": ["Happy Hour", "orange"],
   "Food + Drink": ["Food + Drink", "rose"],
   Market: ["Market", "green"],
   "Art Market": ["Art", "violet"],
   Festival: ["Festival", "amber"],
   Comedy: ["Comedy", "indigo"],
   Karaoke: ["Karaoke", "indigo"],
   Trivia: ["Trivia", "blue"],
   Wildlife: ["Wildlife", "green"],
   "Fitness + Outdoors": ["Outdoors", "green"],
   "Space + Stargazing": ["Space", "navy"],
   Sports: ["Sports", "blue"],
   Film: ["Film", "slate"],
   "Theater + Performing Arts": ["Theater", "violet"],
   Games: ["Games", "blue"],
   Dance: ["Dance", "fuchsia"],
   Nightlife: ["Nightlife", "indigo"],
   "DIY + Workshops": ["DIY + Workshops", "fuchsia"]
  },
  CDN = "https://cdn.shopify.com/s/files/1/0928/5068/4179/files/",
  PHOTO = {
   farmers: CDN + "ob-tie-dye-san-diego-events-farmers-market.webp?v=1789844996",
   obFarmers: CDN + "ob-tie-dye-san-diego-events-ocean-beach-farmers-market_40292f00-3ac4-4b7d-a720-0376c82e922e.webp?v=1789667607",
   pb: CDN + "ob-tie-dye-pacific-beach-fest-crowd.webp?v=1789665538",
   adams: CDN + "ob-tie-dye-adams-avenue-street-fair.webp?v=1789665548",
   made: CDN + "ob-tie-dye-san-diego-made-market-display.webp?v=1789665559",
   general: CDN + "ob-tie-dye-vending-customer-shopping.webp?v=1789665530",
   concert: CDN + "ob-tie-dye-san-diego-events-live-music-concert-crowd.webp?v=1789672481",
   foodWine: CDN + "ob-tie-dye-san-diego-events-food-and-wine.webp?v=1789839840",
   space: CDN + "ob-tie-dye-san-diego-events-space-night-sky-celestial-moon.webp?v=1789840136",
   art: CDN + "ob-tie-dye-san-diego-events-art.webp?v=1789840767",
   diy: CDN + "ob-tie-dye-san-diego-events-diy-workshop.jpg?v=1790444890",
   surf: CDN + "ob-tie-dye-san-diego-events-surf.webp?v=1789841638",
   padres: CDN + "ob-tie-dye-san-diego-events-padres-baseball-game.webp?v=1789841939",
   oktoberfest: CDN + "ob-tie-dye-san-diego-events-oktoberfest.webp?v=1789844762",
   yoga: CDN + "ob-tie-dye-san-diego-events-yoga.webp?v=1789920684",
   wildlife: CDN + "ob-tie-dye-san-diego-events-wildlife-birding.webp?v=1789920757",
   bayfest: CDN + "ob-tie-dye-san-diego-events-mission-bayfest.webp?v=1789675618",
   festival: CDN + "ob-tie-dye-socal-events-festival.webp?v=1789919350",
   film: CDN + "ob-tie-dye-san-diego-event-guide-film-movies.webp?v=1789928095",
   karaoke: CDN + "ob-tie-dye-san-diego-event-guide-karaoke.webp?v=1790010133",
   trivia: CDN + "ob-tie-dye-san-diego-events-trivia.webp?v=1789920808",
   fitness: CDN + "ob-tie-dye-socal-events-fitness.webp?v=1789919363",
   market: CDN + "ob-tie-dye-socal-events-market.webp?v=1789919368",
   run: CDN + "ob-tie-dye-san-diego-event-guide-run-club.webp?v=1789928637",
   harp: CDN + "ob-tie-dye-san-diego-events-the-harp-ocean-beach-logo.webp?v=1790010403",
   aquarius: CDN + "ob-tie-dye-san-diego-events-aquarius-bar-and-grille.jpg?v=1790006127",
   stickFigure: CDN + "ob-tie-dye-san-diego-events-stick-figure.jpg?v=1790027791",
   annieLederman: CDN + "ob-tie-dye-san-diego-events-comedy-annie-lederman.webp?v=1790029136",
   happy: CDN + "ob-tie-dye-san-diego-events-happy-hour-sunset-drink.webp?v=1789674281",
   dog: CDN + "ob-tie-dye-hand-dyed-dog-hoodie-pink-sophie.jpg?v=1770050844",
   comedy: CDN + "ob-tie-dye-san-diego-events-comedy-show.webp?v=1789673768"
  },
  BOOTH_PHOTOS = [PHOTO.general, PHOTO.pb, PHOTO.adams, PHOTO.made],
  GEO = {
   "ocean beach": [32.7496, -117.247],
   "pacific beach": [32.798, -117.24],
   "point loma": [32.7222, -117.2297],
   "liberty station": [32.74, -117.213],
   "shelter island": [32.7115, -117.229],
   "harbor island": [32.7245, -117.196],
   "mission bay": [32.778, -117.228],
   "bay park": [32.781, -117.202],
   "midway district": [32.753, -117.205],
   "little italy": [32.725, -117.169],
   gaslamp: [32.711, -117.16],
   downtown: [32.7157, -117.1611],
   "east village": [32.712, -117.152],
   embarcadero: [32.716, -117.174],
   "seaport village": [32.709, -117.171],
   "balboa park": [32.731, -117.146],
   "barrio logan": [32.697, -117.145],
   "golden hill": [32.719, -117.135],
   "south park": [32.724, -117.129],
   "north park": [32.748, -117.13],
   hillcrest: [32.748, -117.164],
   "university heights": [32.752, -117.144],
   "normal heights": [32.763, -117.115],
   "mission hills": [32.752, -117.181],
   "mission valley": [32.77, -117.15],
   "la jolla": [32.842, -117.274],
   coronado: [32.6859, -117.1831],
   "sunset cliffs": [32.724, -117.255],
   "college area": [32.77, -117.07],
   "la mesa": [32.7678, -117.0231],
   "chula vista": [32.6401, -117.0842],
   miramar: [32.89, -117.14],
   "carmel mountain ranch": [32.986, -117.08],
   bonsall: [33.2889, -117.2256],
   "cardiff-by-the-sea": [33.017, -117.28],
   cardiff: [33.017, -117.28],
   carlsbad: [33.1581, -117.3506],
   "carmel valley": [32.95, -117.23],
   "del mar": [32.9595, -117.2653],
   encinitas: [33.0369, -117.292],
   escondido: [33.1192, -117.0864],
   oceanside: [33.1959, -117.3795],
   "solana beach": [32.9912, -117.2711],
   vista: [33.2, -117.2425],
   anaheim: [33.8366, -117.9143],
   brea: [33.9167, -117.9001],
   "costa mesa": [33.6411, -117.9187],
   "dana point": [33.4672, -117.6981],
   "huntington beach": [33.6595, -117.9988],
   irvine: [33.6846, -117.8265],
   "laguna beach": [33.5427, -117.7854],
   "laguna niguel": [33.5225, -117.7076],
   "mission viejo": [33.6, -117.672],
   "newport beach": [33.6189, -117.9298],
   "san clemente": [33.427, -117.612],
   "downtown los angeles": [34.0407, -118.2468],
   hollywood: [34.0928, -118.3287],
   "long beach": [33.7701, -118.1937],
   "los angeles": [34.0522, -118.2437],
   venice: [33.985, -118.4695],
   "big bear lake": [34.2439, -116.9114],
   idyllwild: [33.74, -116.7189],
   "palm desert": [33.7222, -116.3745],
   pioneertown: [34.1567, -116.4964],
   "joshua tree": [34.1347, -116.3131],
   "joshua tree area": [34.1347, -116.3131],
   "twentynine palms": [34.1356, -116.0542],
   "morongo valley": [34.0469, -116.5808],
   "el cajon": [32.7948, -116.9625],
   santee: [32.8384, -116.9739],
   lakeside: [32.8573, -116.9222],
   alpine: [32.8351, -116.7664],
   "flinn springs": [32.8531, -116.8578],
   campo: [32.6064, -116.4689],
   "lake murray": [32.7858, -117.0373],
   "mission trails": [32.8327, -117.0496],
   rolando: [32.7581, -117.0628],
   "city heights": [32.7478, -117.0992],
   bonita: [32.6578, -117.03],
   "national city": [32.6781, -117.0992],
   "imperial beach": [32.5839, -117.1131],
   "kearny mesa": [32.8337, -117.1392],
   "linda vista": [32.7856, -117.1672],
   "mira mesa": [32.9156, -117.1439],
   "scripps ranch": [32.9095, -117.1075],
   "rancho pe\xF1asquitos": [32.9595, -117.1253],
   "rancho bernardo": [33.0167, -117.0781],
   "university city": [32.8634, -117.2141],
   "torrey pines": [32.9307, -117.26],
   "mission beach": [32.7707, -117.2521],
   "gaslamp quarter": [32.711, -117.16],
   "bankers hill": [32.7339, -117.1636],
   poway: [32.9628, -117.0359],
   ramona: [33.0417, -116.8681],
   julian: [33.0787, -116.6019],
   "santa ysabel / julian": [33.1103, -116.6739],
   "palomar mountain": [33.3225, -116.8764],
   "valley center": [33.2184, -117.0342],
   fallbrook: [33.3764, -117.2512],
   "san marcos": [33.1434, -117.1661],
   "rancho santa fe": [33.0203, -117.2028],
   "carlsbad village": [33.1605, -117.35],
   "downtown encinitas": [33.0461, -117.2932],
   tustin: [33.7458, -117.8262],
   "santa ana": [33.7455, -117.8677],
   orange: [33.7879, -117.8531],
   "garden grove": [33.7743, -117.938],
   "buena park": [33.8675, -117.9981],
   fullerton: [33.8704, -117.9242],
   "yorba linda": [33.8886, -117.8131],
   encino: [34.1592, -118.5012],
   pasadena: [34.1478, -118.1445],
   "santa monica": [34.0195, -118.4912],
   "west hollywood": [34.09, -118.3617],
   "north hollywood": [34.187, -118.3813],
   hawthorne: [33.9164, -118.3526],
   arcadia: [34.1397, -118.0353],
   duarte: [34.1395, -117.9773],
   "playa vista": [33.9722, -118.427],
   perris: [33.7825, -117.2286],
   "palm springs": [33.8303, -116.5453],
   "san bernardino": [34.1083, -117.2898],
   temecula: [33.4936, -117.1484],
   "santa barbara": [34.4208, -119.6982]
  },
  LV_GROUPS = [
   ["The Strip", ["The Strip", "Stadium District", "West of Strip / AREA15", "East of Strip / Paradise"]],
   ["Downtown + Arts District", ["Downtown / Fremont", "Arts District", "Springs Preserve", "Historic Westside", "Westside / Charleston"]],
   ["Summerlin + Northwest", ["Summerlin", "Northwest / Centennial Hills"]],
   ["Southwest", ["Southwest / Enterprise"]],
   ["Henderson", ["Henderson", "Green Valley"]],
   ["UNLV + East Side", ["UNLV / University District", "Fruit Loop", "East Las Vegas", "Southeast / Airport"]],
   ["Chinatown + Spring Valley", ["Chinatown / Spring Mountain", "Spring Valley"]],
   ["North Las Vegas", ["North Las Vegas"]],
   ["Red Rock + Day Trips", ["Red Rock / Outdoors", "Boulder City", "Lake Las Vegas", "Goodsprings", "Mesquite"]]
  ],
  LV_GROUP_OF = {},
  LV_GROUP_NAMES = LV_GROUPS.map(function(g) {
   return g[0]
  });
 LV_GROUPS.forEach(function(g) {
  g[1].forEach(function(h) {
   LV_GROUP_OF[h.toLowerCase()] = g[0]
  })
 });
 var LV_LINK_SLUGS = {
   strip: "The Strip",
   downtown: "Downtown + Arts District",
   chinatown: "Chinatown + Spring Valley",
   "red-rock-canyon": "Red Rock + Day Trips",
   summerlin: "Summerlin + Northwest"
  },
  VGEO = {
   "the strip": [36.1147, -115.1728],
   "downtown + arts district": [36.164, -115.145],
   "summerlin + northwest": [36.17, -115.32],
   southwest: [36.04, -115.242],
   henderson: [36.032, -114.982],
   "unlv + east side": [36.108, -115.13],
   "chinatown + spring valley": [36.123, -115.215],
   "north las vegas": [36.1989, -115.1175],
   "red rock + day trips": [36.135, -115.427]
  },
  CLT_GROUPS = [
   ["Uptown", ["Uptown", "Music Factory", "First Ward", "Second Ward", "Third Ward", "Fourth Ward", "Gateway District"]],
   ["South End + Dilworth", ["South End", "Dilworth", "LoSo", "Wilmore", "Sedgefield"]],
   ["NoDa + Plaza Midwood", ["NoDa", "Plaza Midwood", "Optimist Park", "Villa Heights", "Belmont", "Commonwealth"]],
   ["Midtown + Elizabeth", ["Midtown", "East Charlotte", "Elizabeth", "Cherry", "Myers Park", "Eastover"]],
   ["Camp North End + West", ["Camp North End", "West Charlotte", "West End", "Wesley Heights", "FreeMoreWest", "Airport / West"]],
   ["SouthPark + South Charlotte", ["SouthPark", "Cotswold", "Montford", "Ballantyne", "Pineville", "Matthews", "Mint Hill", "Steele Creek"]],
   ["Lake Norman", ["Cornelius", "Davidson", "Huntersville", "Mooresville", "Lake Norman"]],
   ["University + Concord", ["University City", "Concord", "Kannapolis"]],
   ["Whitewater + Day Trips", ["Whitewater Center", "Belmont NC", "Mount Holly", "Gastonia", "Fort Mill", "Rock Hill", "Fort Mill / Rock Hill", "McAdenville", "Lake Wylie", "Day Trip"]]
  ],
  CGEO = {
   uptown: [35.2271, -80.8431],
   "south end + dilworth": [35.209, -80.858],
   "noda + plaza midwood": [35.235, -80.805],
   "midtown + elizabeth": [35.211, -80.827],
   "camp north end + west": [35.244, -80.853],
   "southpark + south charlotte": [35.152, -80.829],
   "lake norman": [35.489, -80.86],
   "university + concord": [35.33, -80.69],
   "whitewater + day trips": [35.273, -81.004]
  },
  TC_GROUPS = [
   ["Downtown Minneapolis + North Loop", ["Downtown Minneapolis", "North Loop", "Mill District", "Loring Park", "Warehouse District"]],
   ["Northeast + North", ["Northeast", "Northeast Minneapolis", "North Minneapolis"]],
   ["Uptown + Lakes", ["Uptown", "Lyn-Lake", "Linden Hills", "Lake Harriet", "Bde Maka Ska", "Eat Street", "Kingfield"]],
   ["South Minneapolis", ["Powderhorn", "Longfellow", "Seward", "Minnehaha", "Nokomis"]],
   ["U of M + Cedar-Riverside", ["Cedar-Riverside", "Dinkytown", "Stadium Village"]],
   ["Downtown St. Paul + Lowertown", ["Downtown St. Paul", "Lowertown", "West Seventh"]],
   ["St. Paul Neighborhoods", ["Cathedral Hill", "Grand Avenue", "Highland Park", "Midway", "Como", "Frogtown", "St. Anthony Park", "Payne-Phalen", "West Side"]],
   ["Suburbs + Mall of America", ["Bloomington", "Edina", "Richfield", "Roseville", "St. Louis Park", "Golden Valley", "Shakopee", "Chanhassen", "Eagan", "Maplewood", "Burnsville", "Minnetonka", "Anoka", "Plymouth", "Brooklyn Park", "White Bear Lake", "Prior Lake", "Fridley", "Apple Valley", "Columbia Heights", "Falcon Heights"]],
   ["St. Croix Valley + Western Wisconsin", ["Somerset", "New Richmond", "Star Prairie", "Hudson", "North Hudson", "River Falls", "Prescott", "Ellsworth", "Hammond", "Roberts", "Baldwin", "Woodville", "Deer Park", "Glenwood City", "Spring Valley", "Osceola", "Dresser", "St. Croix Falls", "Taylors Falls", "Amery", "Balsam Lake", "Luck", "Grantsburg", "Stillwater", "Bayport", "Afton", "Lake Elmo", "Marine on St. Croix", "Scandia", "Shafer", "Center City", "Lindstrom", "Chisago City", "St. Croix Valley"]],
   ["Day Trips", ["Duluth", "Day Trip", "Red Wing", "Welch", "Frontenac", "Lake City", "Wabasha", "Pepin", "Stockholm", "Alma", "Maiden Rock", "Menomonie", "Eau Claire", "Chippewa Falls", "Northfield", "Cannon Falls", "Hastings", "Faribault", "Hinckley", "St. Cloud", "Stacy", "Mankato"]]
  ],
  TGEO = {
   "downtown minneapolis + north loop": [44.98, -93.27],
   "northeast + north": [45.001, -93.255],
   "uptown + lakes": [44.948, -93.298],
   "south minneapolis": [44.932, -93.232],
   "u of m + cedar-riverside": [44.974, -93.233],
   "downtown st. paul + lowertown": [44.948, -93.09],
   "st. paul neighborhoods": [44.94, -93.15],
   "suburbs + mall of america": [44.855, -93.242],
   "st. croix valley + western wisconsin": [45.075, -92.72],
   "day trips": [44.56, -92.53]
  },
  DEN_GROUPS = [
   ["Downtown + LoDo", ["Downtown Denver", "LoDo", "Union Station", "Ballpark", "Golden Triangle", "Auraria"]],
   ["RiNo + Five Points", ["RiNo", "Five Points", "Globeville / Elyria-Swansea"]],
   ["LoHi + Highlands", ["LoHi", "Highland", "Sunnyside", "Berkeley", "Tennyson", "Sloan's Lake", "Jefferson Park"]],
   ["Capitol Hill + City Park", ["Capitol Hill", "Uptown", "City Park", "Cheesman Park", "Congress Park", "East Colfax", "Park Hill", "Central Park"]],
   ["South Denver + Wash Park", ["Cherry Creek", "Washington Park", "Platt Park", "South Broadway", "Baker", "Overland", "Santa Fe Arts District", "Lincoln Park"]],
   ["Suburbs", ["Englewood", "Littleton", "Lakewood", "Arvada", "Wheat Ridge", "Westminster", "Broomfield", "Thornton", "Commerce City", "Aurora", "Greenwood Village", "Centennial", "Lone Tree", "Castle Rock"]],
   ["Red Rocks + Foothills", ["Morrison", "Golden"]],
   ["Boulder + Fort Collins", ["Boulder", "Louisville", "Fort Collins"]],
   ["Mountains + Day Trips", ["Mountain Day Trip"]]
  ],
  DGEO = {
   "downtown + lodo": [39.75, -104.999],
   "rino + five points": [39.764, -104.981],
   "lohi + highlands": [39.762, -105.02],
   "capitol hill + city park": [39.736, -104.96],
   "south denver + wash park": [39.7, -104.975],
   suburbs: [39.615, -104.89],
   "red rocks + foothills": [39.665, -105.205],
   "boulder + fort collins": [40.015, -105.27],
   "mountains + day trips": [39.742, -105.513]
  },
  XG0_GROUPS = [
   ["Waikiki + Diamond Head", ["Waikiki", "Kapahulu", "Diamond Head"]],
   ["Downtown + Chinatown", ["Downtown Honolulu", "Chinatown"]],
   ["Kakaako + Ala Moana", ["Kakaako", "Ala Moana"]],
   ["Kaimuki + Manoa", ["Kaimuki", "Manoa", "Moiliili", "McCully", "Kahala"]],
   ["Windward + East Side", ["Hawaii Kai", "Kailua", "Kaneohe", "Waimanalo"]],
   ["North Shore", ["Haleiwa", "North Shore", "Laie"]],
   ["Central + West Oahu", ["Kalihi", "Aiea", "Pearl City", "Pearl Harbor", "Waipahu", "Mililani", "Kapolei", "Ko Olina", "Waianae"]]
  ],
  XG0_GEO = {
   "waikiki + diamond head": [21.2793, -157.8293],
   "downtown + chinatown": [21.3105, -157.8607],
   "kakaako + ala moana": [21.296, -157.859],
   "kaimuki + manoa": [21.29, -157.81],
   "windward + east side": [21.397, -157.739],
   "north shore": [21.593, -158.103],
   "central + west oahu": [21.36, -157.98]
  },
  XG1_GROUPS = [
   ["Downtown + National Mall", ["Downtown DC", "Penn Quarter", "Chinatown", "National Mall", "Foggy Bottom"]],
   ["Wharf + Navy Yard", ["The Wharf", "Southwest Waterfront", "Navy Yard", "Capitol Riverfront", "Anacostia"]],
   ["Capitol Hill + H Street", ["Capitol Hill", "Eastern Market", "H Street", "NoMa", "Union Market", "Brookland"]],
   ["U Street + Shaw", ["U Street", "Shaw", "Logan Circle", "14th Street"]],
   ["Adams Morgan + Columbia Heights", ["Adams Morgan", "Columbia Heights", "Petworth"]],
   ["Dupont + Georgetown", ["Dupont Circle", "Georgetown", "West End"]],
   ["Upper Northwest", ["Woodley Park", "Cleveland Park", "Tenleytown"]],
   ["Maryland Suburbs", ["Silver Spring", "Bethesda", "College Park", "Hyattsville", "National Harbor", "Landover", "Columbia MD"]],
   ["Virginia Suburbs", ["Arlington", "Alexandria", "Tysons", "Vienna", "Fairfax", "Bristow", "Falls Church"]]
  ],
  XG1_GEO = {
   "downtown + national mall": [38.899, -77.026],
   "wharf + navy yard": [38.877, -77.009],
   "capitol hill + h street": [38.89, -76.995],
   "u street + shaw": [38.917, -77.03],
   "adams morgan + columbia heights": [38.926, -77.033],
   "dupont + georgetown": [38.908, -77.055],
   "upper northwest": [38.94, -77.06],
   "maryland suburbs": [38.99, -76.95],
   "virginia suburbs": [38.88, -77.15]
  },
  XG2_GROUPS = [
   ["Downtown", ["Downtown Salt Lake", "The Gateway"]],
   ["Granary + Central City", ["Granary District", "Ballpark", "Central City"]],
   ["Sugar House + 9th and 9th", ["Sugar House", "9th and 9th", "Liberty Wells"]],
   ["Avenues + University", ["Marmalade", "Capitol Hill", "The Avenues", "University of Utah"]],
   ["Suburbs", ["South Salt Lake", "West Valley City", "Murray", "Sandy", "Draper", "West Jordan", "South Jordan", "Taylorsville", "Lehi", "Ogden", "Layton", "Provo", "Orem"]],
   ["Park City + Mountains", ["Park City", "Cottonwood Canyons", "Mountain Day Trip"]]
  ],
  XG2_GEO = {
   downtown: [40.765, -111.891],
   "granary + central city": [40.748, -111.9],
   "sugar house + 9th and 9th": [40.723, -111.859],
   "avenues + university": [40.772, -111.85],
   suburbs: [40.64, -111.92],
   "park city + mountains": [40.6461, -111.498]
  },
  XG3_GROUPS = [
   ["Downtown + Pearl", ["Downtown Portland", "Old Town", "Pearl District", "Waterfront"]],
   ["Northwest", ["Northwest", "Slabtown", "Forest Park"]],
   ["Inner Eastside", ["Central Eastside", "Buckman", "Lloyd District", "Rose Quarter", "Kerns"]],
   ["Southeast", ["Hawthorne", "Belmont", "Division", "Sellwood", "Woodstock", "Montavilla", "Foster-Powell"]],
   ["North + Northeast", ["Mississippi", "Alberta", "Williams", "Kenton", "St. Johns", "Hollywood", "Irvington"]],
   ["Suburbs", ["Beaverton", "Hillsboro", "Lake Oswego", "Gresham", "Tigard", "Troutdale", "Vancouver WA", "Ridgefield WA"]],
   ["Gorge, Mountain + Coast", ["Columbia River Gorge", "Hood River", "Mt. Hood", "Oregon Coast", "Willamette Valley"]]
  ],
  XG3_GEO = {
   "downtown + pearl": [45.519, -122.679],
   northwest: [45.53, -122.698],
   "inner eastside": [45.52, -122.658],
   southeast: [45.498, -122.63],
   "north + northeast": [45.555, -122.665],
   suburbs: [45.49, -122.8],
   "gorge, mountain + coast": [45.55, -122]
  },
  XG4_GROUPS = [
   ["Downtown + Midtown", ["Phoenix / Downtown", "Downtown Phoenix", "Phoenix / Central", "Phoenix", "Phoenix / Encanto", "Phoenix / South Mountain", "Roosevelt Row", "Grand Avenue", "Melrose District", "Midtown Phoenix", "Phoenix / Midtown", "Phoenix / Warehouse District"]],
   ["Arcadia + Papago", ["Phoenix / East Phoenix", "Phoenix / Papago Park", "Phoenix / Arcadia", "Arcadia", "Biltmore", "Phoenix / Biltmore", "Papago Park"]],
   ["Tempe", ["Tempe", "Downtown Tempe", "Tempe / ASU", "Tempe Town Lake"]],
   ["Scottsdale", ["Scottsdale", "Scottsdale / Salt River", "Old Town Scottsdale", "Scottsdale / Old Town", "North Scottsdale", "Paradise Valley", "Fountain Hills", "Salt River"]],
   ["Mesa, Chandler + Gilbert", ["Mesa / Downtown", "Downtown Mesa", "Mesa", "Chandler", "Downtown Chandler", "Gilbert", "Queen Creek", "Apache Junction"]],
   ["West Valley", ["Glendale", "Westgate / Glendale", "Phoenix / West Phoenix", "Peoria", "Goodyear", "Avondale", "Surprise", "Litchfield Park", "Tolleson"]],
   ["North Valley + Desert", ["Anthem", "Carefree", "Cave Creek", "Wickenburg", "North Phoenix", "Desert Ridge", "Phoenix / North Phoenix", "Phoenix / Desert Ridge"]],
   ["Tucson road trip", ["Tucson / Downtown", "Tucson", "Tucson / Catalina Foothills", "Tucson / West Tucson", "Tucson / Saguaro East", "Tucson / Saguaro West", "Tucson / University", "Oracle", "Picacho", "Green Valley", "Elgin / Sonoita", "Bisbee", "Tubac", "Tombstone"]],
   ["Sedona + Flagstaff road trip", ["Flagstaff / Downtown", "Flagstaff", "Downtown Flagstaff", "Sedona", "Jerome", "Cottonwood", "Grand Canyon", "Prescott", "Williams"]]
  ],
  XG4_GEO = {
   "downtown + midtown": [33.452, -112.074],
   "arcadia + papago": [33.47, -111.97],
   tempe: [33.4255, -111.94],
   scottsdale: [33.4942, -111.9261],
   "mesa, chandler + gilbert": [33.36, -111.83],
   "west valley": [33.5387, -112.186],
   "north valley + desert": [33.8, -112],
   "tucson road trip": [32.2226, -110.9747],
   "sedona + flagstaff road trip": [34.8697, -111.761]
  },
  XG6_GROUPS = [
   ["Mill Ave + Downtown", ["Downtown Tempe", "Mill Avenue"]],
   ["ASU", ["Tempe / ASU"]],
   ["Tempe Town Lake", ["Tempe Town Lake"]],
   ["Around Tempe", ["Tempe", "South Tempe", "North Tempe"]],
   ["Papago + Salt River", ["Near Tempe / Papago Park", "Near Tempe / Salt River"]],
   ["Nearby East Valley", ["Near Tempe / Mesa", "Near Tempe / Scottsdale", "Near Tempe / Chandler + Gilbert", "Near Tempe / Phoenix"]]
  ],
  XG6_GEO = {
   "mill ave + downtown": [33.4255, -111.94],
   asu: [33.4242, -111.9281],
   "tempe town lake": [33.4325, -111.9395],
   "around tempe": [33.38, -111.93],
   "papago + salt river": [33.46, -111.95],
   "nearby east valley": [33.42, -111.83]
  },
  /* Nov 1 2026: St. Pete + Tampa Bay (sheet tab "St. Pete + Tampa Bay", region "St. Pete") */
  XG7_GROUPS = [
   ["Downtown St. Pete", ["Downtown St. Pete", "Grand Central / EDGE", "Warehouse Arts District", "Old Northeast", "St. Pete (other)"]],
   ["Gulfport", ["Gulfport"]],
   ["St. Pete Beaches", ["St. Pete Beach", "Pass-a-Grille", "Treasure Island", "Madeira Beach", "Indian Rocks Beach", "Fort De Soto"]],
   ["Clearwater + Dunedin", ["Clearwater", "Clearwater Beach", "Dunedin", "Safety Harbor", "Largo", "Tarpon Springs", "Palm Harbor"]],
   ["Tampa", ["Downtown Tampa", "Ybor City", "Channel District", "Tampa Riverwalk", "Tampa Heights", "Seminole Heights", "Hyde Park / SoHo", "Westshore", "Tampa (other)"]],
   ["Day trips", ["Sarasota", "Bradenton", "Anna Maria Island", "Crystal River", "Lakeland"]]
  ],
  XG7_GEO = {
   "downtown st. pete": [27.7716, -82.6386],
   gulfport: [27.7484, -82.7034],
   "st. pete beaches": [27.7253, -82.7412],
   "clearwater + dunedin": [27.9892, -82.7896],
   tampa: [27.9506, -82.4572],
   "day trips": [27.3364, -82.5307]
  },
  XG5_GROUPS = [
   ["Shibuya, Harajuku + Shimokita", ["Shibuya", "Yoyogi / Harajuku", "Harajuku", "Aoyama / Omotesando", "Aoyama / Omotesando / Tokyo", "Omotesando / Tokyo", "Ebisu", "Komaba / Meguro", "Shimokitazawa", "Daikanyama", "Nakameguro", "Sangenjaya", "Komazawa", "Kinuta / Setagaya", "Setagaya", "Meguro"]],
   ["Shinjuku + West Side", ["Shinjuku", "Shinjuku / Tokyo", "Kabukicho / Shinjuku", "Shin-Okubo / Shinjuku", "Shinjuku / Shin-Okubo", "Nakano", "Koenji", "Higashi-Koenji", "Kichijoji", "Ogikubo", "Asagaya", "Golden Gai / Shinjuku"]],
   ["Roppongi + Minato", ["Roppongi", "Akasaka / Roppongi", "Takanawa", "Shibakoen / Minato", "Azabu-Juban", "Azabudai", "Shinagawa", "Haneda / Ota", "Toranomon"]],
   ["Ginza, Marunouchi + Tsukiji", ["Yurakucho / Marunouchi", "Hibiya / Marunouchi", "Tokyo Station / Marunouchi", "Ginza / Higashi-Ginza", "Ginza", "Nihonbashi / Ginza", "Nihonbashi", "Tsukiji / Shiodome", "Tsukiji", "Takebashi / Kitanomaru"]],
   ["Ueno, Asakusa + East", ["Ueno", "Yushima / Ueno", "Asakusa", "Ryogoku", "Mukojima", "Kiyosumi-Shirakawa", "Yanaka", "Nippori", "Kuramae", "Oshiage / Skytree", "Arakawa / Tokyo", "Edogawa / Tokyo", "Higashi-Ojima / Edogawa", "Shin-Koiwa / Katsushika", "Komagome / Bunkyo"]],
   ["Akihabara, Ikebukuro + North", ["Akihabara", "Kanda / Jimbocho", "Jimbocho", "Bunkyo / Suidobashi", "Bunkyo / Suidobashi / Tokyo", "Koishikawa / Bunkyo", "Kagurazaka", "Ikebukuro", "Ikebukuro / Tokyo", "Akatsuka / Itabashi", "Hikarigaoka / Nerima"]],
   ["Odaiba + Bay", ["Odaiba", "Harumi / Odaiba", "Ariake", "Shin-Toyosu", "Toyosu", "Odaiba / Marunouchi"]],
   ["West Tokyo + Mountains", ["Chofu", "Fuchu", "Hachioji", "Mt. Takao / Hachioji", "Tachikawa", "Inagi / Yomiuriland", "Higashikurume / Tama", "Higashimurayama / Tama", "Kunitachi / Tama", "Musashimurayama / Tama", "Nishitokyo / Tama", "Okutama / Lake Okutama", "Mitaka"]],
   ["Hakone", ["Hakone", "Hakone-Yumoto", "Gora / Hakone", "Lake Ashi / Hakone", "Owakudani / Hakone", "Sengokuhara / Hakone", "Odawara"]],
   ["Kyoto + Nara", ["Arashiyama / Kyoto", "Fushimi / Momoyama", "Higashiyama", "Higashiyama / Kyoto", "Higashiyama / Tofukuji", "Kamigyo / Imperial Palace", "Kamigy\u014D", "Kamishichiken / Kyoto", "Keihoku / Rural Kyoto", "Kitano / Kamigyo", "Kiyomizu / Higashiyama", "Kurama / Kibune", "Kyotanabe / South Kyoto", "Kyoto", "Kyoto Station", "Kyoto Station / Gojo", "Kyoto Station / Kyoto", "Nakagyo / Nijo Castle", "Okazaki", "Okazaki / Heian Shrine", "Okazaki / Higashiyama", "Sakyo / Kyoto", "Shimogyo / Umekoji", "Shugakuin / Sakyo", "Uzmasa / Kyoto", "Yamashina", "Yawata / South Kyoto", "Gion / Kyoto", "Fushimi Inari / Kyoto", "Nara", "Nara Park / Nara"]],
   ["Osaka", ["Central Osaka / Osaka", "Kaizuka / Senshu", "Konohana / Sakurajima", "Nakanoshima / Osaka", "Noda / Fukushima", "Osaka Castle / Chuo", "Shinsaibashi / Osaka", "Suita / Expo Park", "Umeda to Namba / Osaka", "Yodoyabashi / Honmachi", "Namba / Osaka", "Dotonbori / Osaka", "Umeda / Osaka", "Shinsekai / Osaka", "Tennoji / Osaka", "Osaka"]],
   ["Side trips", ["Minato Mirai", "Minato Mirai / Yokohama", "Yokohama", "Kamakura", "Sasashima / Nakamura", "Nagoya", "Arimatsu / Nagoya", "Sapporo", "Hakata / Fukuoka", "Minami-Nagareyama", "Nikko", "Kawagoe"]]
  ],
  XG5_GEO = {
   "shibuya, harajuku + shimokita": [35.662, 139.7],
   "shinjuku + west side": [35.6938, 139.68],
   "roppongi + minato": [35.6627, 139.731],
   "ginza, marunouchi + tsukiji": [35.675, 139.765],
   "ueno, asakusa + east": [35.711, 139.79],
   "akihabara, ikebukuro + north": [35.71, 139.74],
   "odaiba + bay": [35.627, 139.775],
   "west tokyo + mountains": [35.656, 139.339],
   hakone: [35.2324, 139.1069],
   "kyoto + nara": [35.0116, 135.7681],
   osaka: [34.6937, 135.5023],
   "side trips": [35.4437, 139.638]
  };

 function destOf(groups, geo, slugs) {
  var of = {}, names = groups.map(function(g) {
   return g[0]
  });
  return groups.forEach(function(g) {
   g[1].forEach(function(h) {
    of [h.toLowerCase()] = g[0]
   })
  }), {
   groups: groups,
   names: names,
   of: of,
   geo: geo,
   slugs: slugs || {}
  }
 }
 var DESTS = {
  "Las Vegas": destOf(LV_GROUPS, VGEO, LV_LINK_SLUGS),
  Charlotte: destOf(CLT_GROUPS, CGEO, {
   "south-end": "South End + Dilworth",
   noda: "NoDa + Plaza Midwood",
   "plaza-midwood": "NoDa + Plaza Midwood",
   southpark: "SouthPark + South Charlotte",
   whitewater: "Whitewater + Day Trips"
  }),
  "Twin Cities": destOf(TC_GROUPS, TGEO, {
   "north-loop": "Downtown Minneapolis + North Loop",
   northeast: "Northeast + North",
   uptown: "Uptown + Lakes",
   lowertown: "Downtown St. Paul + Lowertown",
   "mall-of-america": "Suburbs + Mall of America",
   stillwater: "St. Croix Valley + Western Wisconsin",
   "st-croix": "St. Croix Valley + Western Wisconsin",
   "st-croix-valley": "St. Croix Valley + Western Wisconsin",
   "western-wisconsin": "St. Croix Valley + Western Wisconsin",
   "stillwater-day-trips": "Day Trips",
   "day-trips": "Day Trips"
  }),
  Denver: destOf(DEN_GROUPS, DGEO, {
   lodo: "Downtown + LoDo",
   rino: "RiNo + Five Points",
   lohi: "LoHi + Highlands",
   "capitol-hill": "Capitol Hill + City Park",
   "wash-park": "South Denver + Wash Park",
   "red-rocks": "Red Rocks + Foothills",
   boulder: "Boulder + Fort Collins"
  }),
  Honolulu: destOf(XG0_GROUPS, XG0_GEO, {
   waikiki: "Waikiki + Diamond Head",
   chinatown: "Downtown + Chinatown",
   kakaako: "Kakaako + Ala Moana",
   kailua: "Windward + East Side",
   "north-shore": "North Shore"
  }),
  "Washington DC": destOf(XG1_GROUPS, XG1_GEO, {
   "the-wharf": "Wharf + Navy Yard",
   "navy-yard": "Wharf + Navy Yard",
   "u-street": "U Street + Shaw",
   shaw: "U Street + Shaw",
   georgetown: "Dupont + Georgetown",
   "capitol-hill": "Capitol Hill + H Street"
  }),
  "Salt Lake City": destOf(XG2_GROUPS, XG2_GEO, {
   "sugar-house": "Sugar House + 9th and 9th",
   "park-city": "Park City + Mountains",
   granary: "Granary + Central City"
  }),
  Portland: destOf(XG3_GROUPS, XG3_GEO, {
   pearl: "Downtown + Pearl",
   "pearl-district": "Downtown + Pearl",
   mississippi: "North + Northeast",
   alberta: "North + Northeast",
   hawthorne: "Southeast",
   division: "Southeast"
  }),
  Tempe: destOf(XG6_GROUPS, XG6_GEO, {
   downtown: "Mill Ave + Downtown",
   "mill-ave": "Mill Ave + Downtown",
   asu: "ASU",
   "town-lake": "Tempe Town Lake",
   papago: "Papago + Salt River"
  }),
  Phoenix: destOf(XG4_GROUPS, XG4_GEO, {
   downtown: "Downtown + Midtown",
   "roosevelt-row": "Downtown + Midtown",
   "old-town": "Scottsdale",
   tempe: "Tempe",
   mesa: "Mesa, Chandler + Gilbert",
   tucson: "Tucson road trip",
   sedona: "Sedona + Flagstaff road trip",
   flagstaff: "Sedona + Flagstaff road trip"
  }),
  Tokyo: destOf(XG5_GROUPS, XG5_GEO, {
   shibuya: "Shibuya, Harajuku + Shimokita",
   harajuku: "Shibuya, Harajuku + Shimokita",
   shinjuku: "Shinjuku + West Side",
   koenji: "Shinjuku + West Side",
   asakusa: "Ueno, Asakusa + East",
   ginza: "Ginza, Marunouchi + Tsukiji",
   hakone: "Hakone",
   kyoto: "Kyoto + Nara",
   osaka: "Osaka"
  }),
  "St. Pete": destOf(XG7_GROUPS, XG7_GEO, {
   downtown: "Downtown St. Pete",
   "grand-central": "Downtown St. Pete",
   edge: "Downtown St. Pete",
   gulfport: "Gulfport",
   beaches: "St. Pete Beaches",
   "st-pete-beach": "St. Pete Beaches",
   clearwater: "Clearwater + Dunedin",
   dunedin: "Clearwater + Dunedin",
   tampa: "Tampa",
   ybor: "Tampa"
  })
 };

 function hoodPt(o) {
  var d = DESTS[o.region];
  return d ? d.geo[norm(o.hk)] : GEO[norm(o.hood)]
 }
 var SOCAL_AREAS = {
   "San Diego": ["Central + Coastal", "North County Coastal", "North County Inland", "East County", "South Bay"],
   "Los Angeles": ["Downtown + Central LA", "Westside", "Hollywood", "Valley", "Northeast LA", "South Bay", "Long Beach", "San Gabriel Valley"],
   "Orange County": ["North OC", "Central OC", "Coastal OC", "South OC"],
   "Palm Springs + Joshua Tree": ["Coachella Valley", "High Desert"],
   "Inland Empire": ["Riverside", "San Bernardino", "Temecula Valley", "Southwest Riverside County"]
  },
  SOCAL_AREA_GEO = {
   "San Diego": {
    "central + coastal": [32.75, -117.21],
    "north county coastal": [33.1, -117.3],
    "north county inland": [33.12, -117.08],
    "east county": [32.8, -116.96],
    "south bay": [32.62, -117.06]
   },
   "Los Angeles": {
    "downtown + central la": [34.05, -118.27],
    westside: [34.02, -118.46],
    hollywood: [34.1, -118.33],
    valley: [34.17, -118.43],
    "northeast la": [34.11, -118.22],
    "south bay": [33.86, -118.37],
    "long beach": [33.77, -118.19],
    "san gabriel valley": [34.15, -118.11]
   },
   "Orange County": {
    "north oc": [33.85, -117.9],
    "central oc": [33.7, -117.84],
    "coastal oc": [33.62, -117.93],
    "south oc": [33.47, -117.67]
   },
   "Palm Springs + Joshua Tree": {
    "coachella valley": [33.78, -116.43],
    "high desert": [34.13, -116.31]
   },
   "Inland Empire": {
    riverside: [33.95, -117.4],
    "san bernardino": [34.11, -117.29],
    "temecula valley": [33.52, -117.15],
    "southwest riverside county": [33.68, -117.29]
   }
  };

 function socalDest(D, items) {
  var map2 = window.OB_SOCAL_HOOD_AREA || {},
   by = {},
   order = (SOCAL_AREAS[D] || []).slice();
  items.forEach(function(o) {
   var h = String(o.hood || "").trim(),
    a = map2[h.toLowerCase()];
   !h || !a || (by[a] || (by[a] = []), by[a].indexOf(h) < 0 && by[a].push(h))
  }), Object.keys(by).sort().forEach(function(a) {
   order.indexOf(a) < 0 && order.push(a)
  });
  var groups = order.filter(function(a) {
    return by[a]
   }).map(function(a) {
    return [a, by[a]]
   }),
   slugs = {};
  return groups.forEach(function(g) {
   slugs[slug(g[0])] = g[0]
  }), destOf(groups, SOCAL_AREA_GEO[D] || {}, slugs)
 }
 var REGION_GEO = {
   Phoenix: [33.4484, -112.074],
   Tempe: [33.4255, -111.94],
   Tokyo: [35.6762, 139.6503],
   "St. Pete": [27.7676, -82.6403],
   Honolulu: [21.3069, -157.8583],
   "Washington DC": [38.9072, -77.0369],
   "Salt Lake City": [40.7608, -111.891],
   Portland: [45.5152, -122.6784],
   Denver: [39.7392, -104.9903],
   "Twin Cities": [44.964, -93.18],
   "Las Vegas": [36.1699, -115.1398],
   Charlotte: [35.2271, -80.8431],
   "San Diego": [32.7157, -117.1611],
   "North County": [33.08, -117.28],
   "Orange County": [33.62, -117.85],
   "Los Angeles / Long Beach": [34.0522, -118.2437],
   "Inland / Desert": [33.83, -116.55],
   "Santa Barbara / Central Coast": [34.4208, -119.6982],
   "Los Angeles": [34.0522, -118.2437],
   "Palm Springs + Joshua Tree": [33.83, -116.55],
   "Inland Empire": [33.95, -117.4]
  },
  $ = function(s, r) {
   return (r || ROOT).querySelector(s)
  },
  $$ = function(s, r) {
   return Array.prototype.slice.call((r || ROOT).querySelectorAll(s))
  };

 function esc(s) {
  return String(s == null ? "" : s).replace(/[&<>"']/g, function(m) {
   return {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
   } [m]
  })
 }

 function norm(s) {
  return String(s || "").toLowerCase().replace(/[’‘]/g, "'").replace(/[“”]/g, "").replace(/\s+/g, " ").trim()
 }

 function slug(s) {
  return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")
 }

 function truthy(v) {
  return v === !0 || /^(yes|true|1)$/i.test(String(v || "").trim())
 }

 function hash(s) {
  for (var h = 0, i = 0; i < s.length; i++) h = h * 31 + s.charCodeAt(i) >>> 0;
  return h
 }
 var fDay = new Intl.DateTimeFormat("en-CA", {
   timeZone: TZ,
   year: "numeric",
   month: "2-digit",
   day: "2-digit"
  }),
  fTime = new Intl.DateTimeFormat("en-US", {
   timeZone: TZ,
   hour: "numeric",
   minute: "2-digit"
  }),
  fHour = new Intl.DateTimeFormat("en-US", {
   timeZone: TZ,
   hour: "numeric",
   hourCycle: "h23"
  }),
  DK = {},
  HK = {};

 function dayKey(ms) {
  var h = Math.floor(ms / 36e5),
   v = DK[h];
  return v === void 0 && (v = DK[h] = fDay.format(new Date(ms))), v
 }

 function addDays(key, n) {
  var a = key.split("-").map(Number),
   x = new Date(Date.UTC(a[0], a[1] - 1, a[2] + n, 12));
  return x.toISOString().slice(0, 10)
 }

 function keyDate(key) {
  var a = key.split("-").map(Number);
  return new Date(Date.UTC(a[0], a[1] - 1, a[2], 12))
 }

 function dow(key) {
  return keyDate(key).getUTCDay()
 }
 var WD = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  MO = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

 function mdLabel(key) {
  var d = keyDate(key);
  return MO[d.getUTCMonth()] + " " + d.getUTCDate()
 }

 function timeLabel(ms) {
  return fTime.format(new Date(ms)).replace(":00 ", " ").replace(" AM", "am").replace(" PM", "pm")
 }

 function hourOf(ms) {
  var h = Math.floor(ms / 36e5),
   v = HK[h];
  return v === void 0 && (v = HK[h] = +fHour.format(new Date(ms))), v
 }

 function todayKey() {
  return dayKey(Date.now())
 }
 var ICONS = {
  car: '<path d="M5 16.5V12l1.6-4.3A2 2 0 0 1 8.5 6.4h7a2 2 0 0 1 1.9 1.3L19 12v4.5"/><path d="M4 12h16v4.5H4z"/><circle cx="7.5" cy="18" r="1.5"/><circle cx="16.5" cy="18" r="1.5"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
  pin: '<path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>',
  moon: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>',
  cal: '<rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/>',
  music: '<path d="M9 18V5l11-2v13"/><circle cx="6.5" cy="18" r="2.5"/><circle cx="17.5" cy="16" r="2.5"/>',
  fork: '<path d="M7 3v8a2 2 0 0 0 2 2v8M5 3v5M9 3v5M16 21V3c2.5 1.5 3.5 4 3.5 7s-1.5 4-3.5 4"/>',
  glass: '<path d="M6 4h12l-6 8zM12 12v7M8 20h8"/>',
  leaf: '<path d="M5 19c0-8 5-14 15-15-1 10-7 15-15 15zM5 19l7-7"/>',
  tag: '<path d="M3 12V4h8l9 9-8 8z"/><circle cx="7.5" cy="8.5" r="1.3"/>',
  paw: '<circle cx="5.5" cy="10.5" r="1.9"/><circle cx="9.2" cy="5.8" r="1.9"/><circle cx="14.8" cy="5.8" r="1.9"/><circle cx="18.5" cy="10.5" r="1.9"/><path d="M12 12.2c-2.7 0-5.3 3.1-5.3 5.5 0 1.6 1.2 2.3 2.6 2.3 1.1 0 1.8-.6 2.7-.6s1.6.6 2.7.6c1.4 0 2.6-.7 2.6-2.3 0-2.4-2.6-5.5-5.3-5.5z"/>',
  heart: '<path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.4a4.3 4.3 0 0 1 7.5 2.4C19.5 15.4 12 20 12 20z"/>',
  smile: '<circle cx="12" cy="12" r="8.5"/><path d="M8.5 14a4 4 0 0 0 7 0M9 9.5h.01M15 9.5h.01"/>',
  bag: '<path d="M5 8h14l-1.2 12H6.2zM9 8V6.5a3 3 0 0 1 6 0V8"/>',
  bolt: '<path d="M13 3 5 13.5h6L10 21l8-10.5h-6z"/>',
  star: '<path d="m12 3 2.8 5.8 6.2.9-4.5 4.4 1 6.3L12 17.5 6.5 20.4l1-6.3L3 9.7l6.2-.9z"/>',
  tent: '<path d="M3 20 12 4l9 16zM12 4v16M8.5 20 12 13l3.5 7"/>',
  palette: '<path d="M12 3a9 9 0 1 0 0 18c1.5 0 2-1 2-2s-1-1.5-1-2.5 1-1.5 2-1.5h2a4 4 0 0 0 4-4c0-4.4-4-8-9-8z"/><circle cx="7.5" cy="11" r="1"/><circle cx="10" cy="7" r="1"/><circle cx="15" cy="7.5" r="1"/>',
  mic: '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21"/>',
  dice: '<rect x="4" y="4" width="16" height="16" rx="3"/><circle cx="9" cy="9" r="1"/><circle cx="15" cy="15" r="1"/><circle cx="15" cy="9" r="1"/><circle cx="9" cy="15" r="1"/>',
  ball: '<circle cx="12" cy="12" r="8.5"/><path d="M5 7c3 2 4 5 4 10M19 7c-3 2-4 5-4 10"/>',
  list: '<path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01"/>',
  map: '<path d="m3 6 6-2 6 2 6-2v14l-6 2-6-2-6 2zM9 4v14M15 6v14"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M4.6 4.6l1.4 1.4M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4"/>',
  clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
  chev: '<path d="m6 9 6 6 6-6"/>',
  x: '<path d="M6 6l12 12M18 6 6 18"/>',
  sliders: '<path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>',
  arrow: '<path d="M7 17 17 7M9 7h8v8"/>',
  scissors: '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
  ticket: '<path d="M4 7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a2 2 0 0 0 0 4v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a2 2 0 0 0 0-4z"/><path d="M14 6v2M14 11v2M14 16v2"/>'
 };

 function icon(n, cls) {
  return '<svg class="obg-i' + (cls ? " " + cls : "") + '" viewBox="0 0 24 24" aria-hidden="true">' + (ICONS[n] || "") + "</svg>"
 }

 function regionOf(i) {
  var ex = String(i.region || "").trim(),
   e = norm(ex);
  if (REGIONS.indexOf(ex) > -1) return ex;
  if (/^(san diego|central san diego|east county|south bay|south county)$/.test(e)) return "San Diego";
  if (e === "north county") return "North County";
  if (/^(south orange county|south oc|orange county)$/.test(e)) return "Orange County";
  if (/^(los angeles|los angeles long beach|los angeles \/ long beach)$/.test(e)) return "Los Angeles / Long Beach";
  if (/^(inland empire|inland \/ desert|palm desert \/ coachella valley|coachella valley|palm springs)$/.test(e)) return "Inland / Desert";
  if (/santa barbara/.test(e)) return "Santa Barbara / Central Coast";
  if (/^(las vegas|vegas|henderson|north las vegas|summerlin)$/.test(e)) return "Las Vegas";
  if (/^(charlotte|charlotte nc|charlotte, nc|clt)$/.test(e)) return "Charlotte";
  if (/^(twin cities|minneapolis|st\.? paul|saint paul|minneapolis \/ st\.? paul|minneapolis-st\.? paul|msp)$/.test(e)) return "Twin Cities";
  if (/^(denver|denver, co|denver co|den|denver metro)$/.test(e)) return "Denver";
  if (/^(honolulu|honolulu, hi|oahu|hnl)$/.test(e)) return "Honolulu";
  if (/^(washington dc|washington, dc|washington d\.?c\.?|dc|d\.c\.)$/.test(e)) return "Washington DC";
  if (/^(salt lake city|salt lake|slc|salt lake city, ut)$/.test(e)) return "Salt Lake City";
  if (/^(portland|portland, or|pdx|portland oregon)$/.test(e)) return "Portland";
  if (/^(tempe|tempe, az)$/.test(e)) return "Tempe";
  if (/^(phoenix|phoenix, az|phx|arizona|phoenix metro|valley of the sun)$/.test(e)) return "Phoenix";
  if (/^(tokyo|tokyo, japan|tyo|japan)$/.test(e)) return "Tokyo";
  if (/^(st\.? pete|st\.? petersburg|saint petersburg|st\.? pete \+ tampa bay|tampa bay|tampa|clearwater)$/.test(e)) return "St. Pete";
  var g = GEO[norm(i.hood)];
  if (g) {
   if (g[0] > 34.3) return g[1] < -119 ? "Santa Barbara / Central Coast" : "Inland / Desert";
   if (g[1] > -117.2 && g[0] > 33.4) return "Inland / Desert";
   if (g[0] > 33.75) return "Los Angeles / Long Beach";
   if (g[0] > 33.38) return "Orange County";
   if (g[0] > 32.94) return "North County"
  }
  return "San Diego"
 }

 function detailFor(i) {
  var d = String(i.desc || "").replace(/(?:^|\n)\s*(?:image|image url)\s*:\s*https?:\/\/\S+/ig, "").trim();
  if (d) return d;
  if (window.OB_GUIDE_DETAIL_FOR && !DESTS[regionOf(i)]) try {
   return window.OB_GUIDE_DETAIL_FOR(i.title, i.cat)
  } catch (_) {}
  return ""
 }

 function imageMarker(i) {
  var m = String(i.desc || "").match(/(?:^|\n)\s*(?:image|image url)\s*:\s*(https?:\/\/[^\s<>]+)/i);
  return m ? m[1] : ""
 }

 function isFarmers(t) {
  return /\bfarmers? market\b|\bfarmer s market\b/.test(t) || t.indexOf("ocean beach community open market") !== -1 || t.indexOf("la jolla open aire") !== -1
 }

 function isObFarmers(t) {
  return /\b(ob|ocean beach) farmers market\b|ocean beach community open market/.test(t)
 }

 function isMusicFest(tagText) {
  return /(^|,|\s)music festival($|,|\s)/i.test(tagText)
 }

 function isSurf(i, t, all, tags) {
  return /\bsurfing\b|\bsurf competition\b|\bsurf culture\b|\bpara surfing\b|\bscholastic surfing\b|\bcollege surfing\b/.test(tags) || i.cat === "Sports" && /\bsurf(?:ing)?\b|\bnssa\b|\bwsa\b|\busa surfing\b|\bscholastic surf series\b/.test(all) ? !0 : /\bsurf (?:lounge )?festival\b|\bsurf championships?\b|\bsurf competition\b|\bsurf contest\b|\bcalifornia surf museum\b|\bsurf film\b|\bsurfilm\b/.test(all)
 }

 function hasTag(tags, rx) {
  return (tags || []).some(function(t) {
   return rx.test(String(t))
  })
 }

 function isDogEvent(i, t) {
  if (hasTag(i.tags, /^\s*dog[\s-]*events?\s*$/i)) return !0;
  var name = t.replace(/\bdog[\s-]*friendly\b/g, "").replace(/\bhot[\s-]*dogs?\b/g, "");
  return /\b(?:dogs?|doggies|doggy|pupp(?:y|ies)|pups?|pooch(?:es)?|canine|corgis?|dachshunds?|barktoberfest|dogtoberfest|woofstock|fur[\s-]*ball|yappy[\s-]*hour|howl[\s-]*o[\s-]*ween|paws?[\s-]*(?:for|in)|bark[\s-]*(?:for|in|at)|strut[\s-]*your[\s-]*mutt|walk[\s-]*for[\s-]*animals|pet[\s-]*(?:expo|fest(?:ival)?|fair|parade|costume|adoption|rescue|a[\s-]*palooza)|adopt[\s-]*a[\s-]*pet)\b/.test(name)
 }

 function photoFor(i) {
  if (i._photo !== void 0) return i._photo;
  var t = i._t,
   s = i._all,
   p = "",
   marked = i.image || imageMarker(i) || (window.OB_GUIDE_EVENT_IMAGES || {})[t];
  return marked ? p = marked : /\bannie lederman\b/.test(t) ? p = PHOTO.annieLederman : /\bstick figure\b/.test(t) ? p = PHOTO.stickFigure : isDogEvent(i, t) ? p = PHOTO.dog : i._booth ? p = isObFarmers(t) ? PHOTO.obFarmers : /\bpalm springs pride\b/.test(t) ? BOOTH_PHOTOS[0] : /pacific beachfest|beachfest/.test(t) ? BOOTH_PHOTOS[1] : /adams avenue/.test(t) ? BOOTH_PHOTOS[2] : /san diego made/.test(t) ? BOOTH_PHOTOS[3] : BOOTH_PHOTOS[hash(t) % BOOTH_PHOTOS.length] : /\bthe harp\b/.test(norm(i.place)) && (!i.hood || /\bocean beach\b/.test(norm(i.hood))) ? p = PHOTO.harp : /\baquarius(?:\s+bar)?(?:\s*(?:&|and)\s*grill(?:e)?)?\b/.test(t + " " + norm(i.place)) ? p = PHOTO.aquarius : i.cat === "DIY + Workshops" ? p = PHOTO.diy : /\b(run club|running club|run crew|fun run|5k|10k|half marathon|marathon)\b/.test(t) ? p = PHOTO.run : isObFarmers(t) ? p = PHOTO.obFarmers : isFarmers(t) ? p = PHOTO.farmers : /pacific beachfest|beachfest/.test(t) ? p = PHOTO.pb : /adams avenue/.test(t) ? p = PHOTO.adams : /san diego made/.test(t) ? p = PHOTO.made : /mission bayfest|bayfestsd/.test(t + " " + norm(i.url)) ? p = PHOTO.bayfest : i.cat === "Sports" && /\bpadres\b/.test(s) ? p = PHOTO.padres : isSurf(i, t, s, i._tags) ? p = PHOTO.surf : /\b(?:oktober|october)\s*fest\b|\bcraftober\s*fest\b/.test(t) ? p = PHOTO.oktoberfest : i.cat === "Food + Drink" || /food\s*(?:&|\+|and)\s*wine|wine\s*(?:&|\+|and)\s*food|art\s*(?:&|\+|and)\s*wine|wine\s*(?:&|\+|and)\s*art|\btaste of\b|\brestaurant week\b/.test(t) ? p = PHOTO.foodWine : i.cat === "Space + Stargazing" || /\brocket launch\b|\blaunch viewing\b|\bspacex\b|\bstargazing\b|\bmeteor shower\b|\btelescope\b|\bastronomy\b|\bcelestial\b|\bstar party\b|\bmoon viewing\b|\bmoonlight (?:paddle|kayak|hike|walk|sail|cruise)\b|\bfull moon\b|\bsupermoon\b|\blunar eclipse\b/.test(t) ? p = PHOTO.space : /\byoga\b/.test(s) ? p = PHOTO.yoga : i.cat === "Wildlife" || /\bbirding\b|\bbirdwatch(?:ing)?\b|\bbird walk\b|\bwildlife\b|\bnature walk\b/.test(s) ? p = PHOTO.wildlife : i.cat === "Film" ? p = PHOTO.film : i.cat === "Art Market" && i._cats && i._cats.market || /\bart walk\b|\bart crawl\b|\bart fair\b|\bart faire\b|\bart market\b|\bartist market\b|\barts festival\b|\bart festival\b|\bplein air\b/.test(s) ? p = PHOTO.art : /\bfilm festival\b|\bdocumentary\b|\bmovie\b|\bscreening\b/.test(s) ? p = PHOTO.film : i.cat === "Karaoke" || /\bkaraoke\b/.test(t) ? p = PHOTO.karaoke : i.cat === "Trivia" || /\btrivia\b/.test(t) ? p = PHOTO.trivia : i.cat === "Fitness + Outdoors" ? p = PHOTO.fitness : i.cat === "Market" ? p = PHOTO.market : i.cat === "Festival" ? p = PHOTO.festival : /\bpalm springs pride\b/.test(t) ? p = PHOTO.general : i.cat === "Concert" ? p = PHOTO.concert : i.cat === "Happy Hour" ? p = PHOTO.happy : i.cat === "Comedy" && (p = PHOTO.comedy), i._photo = p, p
 }

 function sized(u, w) {
  return u ? /cdn\.shopify\.com|\/cdn\/shop\//.test(u) ? u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w : u : ""
 }

 function linkFor(i) {
  var u = String(i.url || "").trim();
  if ((!u || u === "#") && !DESTS[regionOf(i)]) try {
   window.OB_GUIDE_EVENT_LINKS && window.OB_GUIDE_EVENT_LINKS.linkFor && (u = window.OB_GUIDE_EVENT_LINKS.linkFor(i.title) || "")
  } catch (_) {}
  return u || ""
 }
 var UTM = {
   utm_source: "obtiedye.com",
   utm_medium: "referral",
   utm_campaign: "socal_event_guide"
  },
  SHOP_URL = "/collections/all-products-1";

 function tracked(u, where) {
  if (!u) return u;
  try {
   var x = new URL(u, location.href);
   if (!/^https?:$/.test(x.protocol)) return u;
   var h = x.hostname.toLowerCase();
   if (h === "obtiedye.com" || /\.obtiedye\.com$/.test(h) || h === location.hostname || /\.ics$/i.test(x.pathname)) return u;
   var has = !1;
   return x.searchParams.forEach(function(v, k) {
    /^utm_/i.test(k) && (has = !0)
   }), has ? u : (Object.keys(UTM).forEach(function(k) {
    x.searchParams.set(k, UTM[k])
   }), where && x.searchParams.set("utm_content", where), x.toString())
  } catch (_) {
   return u
  }
 }
 var FREE_RX = /\bfree (admission|entry|events?|shows?|concerts?|festival|community|street|outdoor|family|beach|to attend|to the public|and open|with rsvp|with registration)\b|\ba free\b|\badmission is free\b|\bno cover\b|\b(is|it's|always) free\b|^free\b/i,
  WELL_RX = /\b(yoga|sound ?baths?|sound healing|sound journey|gong|meditat\w*|breath ?work|reiki|tai chi|qigong|pilates|mindful\w*|wellness|restorative|nidra|forest bathing)\b/,
  RUNCLUB_RX = /\b(run club|running club|run crew|group run|social run|november project|front runners)\b/,
  RACE_RX = /\b(marathon|half[- ]?marathon|5k|10k|8k|12k|15k|half|fun run|turkey trot|trot|triathlon|duathlon|aquathlon|race|races|relay|ultra|obstacle|mud run|color run|ragnar|runfest|run fest|running festival|\d+(?:\.\d+)? ?milers?|\d+ ?mile run|trail run|gran fondo|century ride)\b/,
  NATURE_MORE_RX = /\b(volunteer|clean ?up|cleanup|habitat|native plants?|garden tour|trail work|restoration|raking|weeding|ranger|mushroom|wildflower)\b/;

 function activeKind(o) {
  var t = o._t,
   all = o._t + " " + o._tags;
  return WELL_RX.test(all) ? "wellness" : RUNCLUB_RX.test(all) ? "workouts" : RACE_RX.test(t) || /\b(marathon|half marathon|race|5k|10k|triathlon)\b/.test(o._tags) ? "races" : NATURE_RX.test(o._all) || NATURE_MORE_RX.test(all) ? "nature" : "workouts"
 }
 var OUT_RX = /\b(outdoors?|open air|beach|beaches|park|pier|trails?|hikes?|hiking|gardens?|lake|bay|harbou?r|amphitheat\w*|shell|plaza|street fair|farmers market|patio|rooftop|stadium|ballpark|field|canyon|mountain|desert|river|zoo|botanic\w*|preserve|campground|boardwalk|waterfront|meadow|ranch|vineyard|lawn|courtyard|block party|tide ?pools?|kayak\w*|surf\w*|paddle\w*|bike ride|ride|stargazing|meteor|night sky|whale|birding|bird walk)\b/,
  INDOOR_RX = /\b(museum|theat(?:er|re)|planetarium|dome|hall|ballroom|arena|club|lounge|studio|library|gallery|bar|pub|brewery|taproom|cinema|church|hotel|casino|cafe|restaurant|kitchen|bookstore|improv)\b/;

 function isOutside(o, act) {
  var c = o.cat,
   txt = o._t + " " + o._tags,
   pl = o._pl;
  return /\b(indoor|indoors)\b/.test(txt) ? !1 : c === "Wildlife" || c === "Space + Stargazing" || act === "races" || act === "nature" ? !INDOOR_RX.test(pl) || /\b(outdoor|garden|trail|walk|hike)\b/.test(txt) : /\b(outdoors?|open air|patio|rooftop|lawn|courtyard|on the beach|beach)\b/.test(txt) ? !0 : INDOOR_RX.test(pl) ? !1 : OUT_RX.test(pl + " " + txt)
 }
 var DANCE_RX = /\b(salsa|bachata|merengue|cumbia|kizomba|swing danc\w*|lindy|west coast swing|line danc\w*|two[- ]step|tango|milonga|contra danc\w*|square danc\w*|ballroom danc\w*|dance (?:party|night|social|class|classes|lesson|lessons)|silent disco|latin night|disco night|80s night|emo nite)\b/,
  DANCE_SHOW_RX = /\b(ballet|nutcracker|dance company|dance theat(?:er|re)|recital|presentations?|showcase|performance|choreograph\w*)\b/,
  GAME_RX = /\b(bingo|game night|board games?|mah ?-?jongg?|mahj|chess|catan|cribbage|euchre|pinball|cornhole|meat raffle|puzzle)\b/,
  NATURE_RX = /\b(hikes?|hiking|nature walks?|tide ?pools?|tidepooling|birding|bird walks?|whale watch(?:ing)?|guided walks?|trail walks?|garden walks?|botanic(?:al)?)\b/,
  VENUE_GENERIC = {
   bar: 1,
   pub: 1,
   grill: 1,
   grille: 1,
   brewing: 1,
   brewery: 1,
   brewhouse: 1,
   co: 1,
   company: 1,
   taproom: 1,
   tap: 1,
   room: 1,
   tasting: 1,
   restaurant: 1,
   kitchen: 1,
   lounge: 1,
   cocktail: 1,
   cocktails: 1,
   and: 1,
   the: 1
  },
  HOOD_SHORT = {
   "ocean beach": "ob",
   "pacific beach": "pb",
   "north park": "np",
   "point loma": "pl"
  };

 function keyText(s) {
  return norm(s).replace(/&/g, " and ").replace(/['’]/g, "").replace(/[^a-z0-9]+/g, " ").replace(/^the /, "").trim()
 }

 function venueCore(place, hood) {
  var v = " " + keyText(place) + " ",
   h = keyText(hood);
  h && (v = v.split(" " + h + " ").join(" "), HOOD_SHORT[h] && (v = v.split(" " + HOOD_SHORT[h] + " ").join(" ")));
  var w = v.trim().split(" ").filter(function(x) {
   return x && !VENUE_GENERIC[x]
  });
  return w.join(" ") || keyText(place)
 }
 var NOT_A_VENUE = /^(tbd|tba|tbc|various|multiple|online|virtual|see |location|venue|address|private|secret)/;

 function venueId(o) {
  if (!o) return "";
  if (o._vid !== void 0) return o._vid;
  var k = keyText(o.place),
   w = k.split(" ").filter(function(x) {
    return x && !VENUE_GENERIC[x]
   }).join(" ") || k;
  return o._vid = !k || NOT_A_VENUE.test(k) ? "" : slug(w) + "--" + slug(o.region || "")
 }
 var PREP_CACHE = {},
  SHARED = ["_act", "_out", "region", "_t", "_tags", "_all", "_booth", "_pick", "_dog", "_dogEvent", "_kids", "_free", "_cats", "_pl", "_tk", "_vc", "_weekly", "_radar", "_low", "_drive", "_night", "_eve", "_nt", "_gn"];

 function prep(raw) {
  var i = raw && raw.__obRaw ? raw.__obRaw : raw;
  if (!i || !i.title || !i.start) return null;
  var s = Date.parse(i.start);
  if (isNaN(s)) return null;
  var e = i.end ? Date.parse(i.end) : NaN,
   tagsArr = Array.isArray(i.tags) ? i.tags : i.tags ? String(i.tags).split(",") : [],
   o = {
    src: i,
    key: i.key || "",
    title: String(i.title),
    cat: i.cat || "",
    place: i.place || "",
    hood: i.hood || i.neighborhood || "",
    url: linkFor(i),
    desc: i.desc || "",
    image: i.image || "",
    pick_note: i.pick_note || "",
    all_day: !!i.all_day,
    tags: tagsArr,
    s: s,
    e: isNaN(e) ? s + 6 * 36e5 : e,
    hasEnd: !isNaN(e)
   },
   sig = [o.title, o.desc, tagsArr.join(""), o.cat, i.region || "", o.hood, o.place, i.here, i.starred, i.priority || ""].join("");
  o._sig = sig;
  var hit = PREP_CACHE[sig];
  if (hit) {
   for (var si = 0; si < SHARED.length; si++) o[SHARED[si]] = hit[SHARED[si]];
   return finishPrep(o), o
  }
  o.region = regionOf(i), o._t = norm(o.title), o._tags = norm(tagsArr.join(" ")), o._all = norm([o.title, o.desc, tagsArr.join(" ")].join(" ")), o._pl = norm(o.place), o._tk = keyText(o.title), o._vc = venueCore(o.place, o.hood), o._booth = truthy(i.here) || /ob tie dye|obtiedye|tie[- ]?dye booth/.test(o._t), o._pick = truthy(i.starred), o._dog = hasTag(tagsArr, /^\s*dog[\s-]*friendly\s*$/i), o._dogEvent = hasTag(tagsArr, /^\s*dog[\s-]*events?\s*$/i), o._kids = hasTag(tagsArr, /^\s*(family|families|kids|family[\s-]*friendly|kid[\s-]*friendly|all[\s-]*ages)\s*$/i), o._free = hasTag(tagsArr, /^\s*free\s*$/i) || /\bfree\b/.test(o._t) || FREE_RX.test(o.desc), o._weekly = !!i.weekly && !o._pick && !o._booth, o._drive = hasTag(tagsArr, /^\s*worth[\s-]+the[\s-]+drive\s*$/i);
  var pr = String(i.priority || "").trim().toLowerCase();
  o._low = !o._pick && !o._booth && (pr === "low" || hasTag(tagsArr, /^\s*low(\s+priority)?\s*$/i)), o._high = pr === "high" || pr === "top", o._radar = !o._pick && !o._low && (pr === "radar" || hasTag(tagsArr, /^\s*(on\s+our\s+)?radar\s*$/i));
  var c = o.cat,
   mf = isMusicFest(tagsArr.join(",")),
   act = c === "Fitness + Outdoors" ? activeKind(o) : "";
  o._act = act, o._out = isOutside(o, act), o._cats = {
   art: c === "Art Market",
   diy: c === "DIY + Workshops",
   film: c === "Film",
   theater: c === "Theater + Performing Arts" || c === "Dance" && DANCE_SHOW_RX.test(o._t),
   dance: c === "Dance" && !DANCE_SHOW_RX.test(o._t) || c === "Nightlife" || DANCE_RX.test(o._t),
   comedy: c === "Comedy",
   dogevent: o._dogEvent,
   kids: o._kids,
   fest: c === "Festival" || mf,
   food: c === "Food + Drink" || /\bfood\s+(?:and\s+|\+\s*|&\s*)?wine\b|\bwine\s+(?:and\s+)?food\b|\btaste of\b|\bwine tasting\b|\bwine festival\b/.test(o._all),
   happy: c === "Happy Hour",
   music: c === "Concert" || mf,
   market: c === "Market" || c === "Art Market" && (/\b(?:market|fair|faire|bazaar)\b/.test(o._t) || /\bshow(?: and)? sale\b/.test(o._t) || hasTag(tagsArr, /^\s*(?:art market|holiday market|market|makers|shopping|handmade|craft fair)\s*$/i) || /\b(?:vendors?|selling|handmade goods|shopping)\b/i.test(o.desc)),
   games: c === "Trivia" || c === "Karaoke" || c === "Games" || GAME_RX.test(o._t),
   races: act === "races",
   workouts: act === "workouts",
   wellness: act === "wellness" || c !== "Concert" && WELL_RX.test(o._t + " " + o._tags),
   nature: c === "Wildlife" || c === "Space + Stargazing" || act === "nature",
   sports: c === "Sports"
  };
  nightPrep(o, tagsArr);
  for (var keep = {}, sj = 0; sj < SHARED.length; sj++) keep[SHARED[sj]] = o[SHARED[sj]];
  return PREP_CACHE[sig] = keep, finishPrep(o), o
 }

 function finishPrep(o) {
  o.sd = dayKey(o.s), o.ed = o.hasEnd ? dayKey(o.e - 1e3) : o.sd, o.ed < o.sd && (o.ed = o.sd), o._dk = o.cat === "Trivia" || o.cat === "Karaoke" ? "tk|" + o.cat + "|" + o._vc + "|" + o.s : o._tk + "|" + o.sd + "|" + o._vc + "|" + o.s
 }
 var STOP = {
   a: 1,
   an: 1,
   the: 1,
   and: 1,
   or: 1,
   of: 1,
   in: 1,
   at: 1,
   on: 1,
   to: 1,
   for: 1,
   with: 1,
   near: 1,
   me: 1,
   my: 1,
   some: 1,
   any: 1,
   event: 1,
   events: 1,
   thing: 1,
   things: 1,
   do: 1,
   happening: 1,
   going: 1,
   whats: 1,
   what: 1,
   where: 1,
   is: 1,
   are: 1,
   sd: 1,
   show: 1,
   shows: 1
  },
  SYN = {
   dog: ["dog", "pupp", "pups", "doggy", "doggie", "canine", "pooch"],
   kid: ["kid", "famil", "child", "allage"],
   child: ["kid", "famil", "child", "allage"],
   children: ["kid", "famil", "child", "allage"],
   beer: ["beer", "brew", "taproom", "ipa"],
   brew: ["brew", "beer", "taproom"],
   brewery: ["brew", "beer", "taproom"],
   wine: ["wine", "winer", "vineyard"],
   winery: ["winer", "wine", "vineyard"],
   movie: ["movie", "film", "cinema", "screening"],
   film: ["film", "movie", "cinema", "screening"],
   cinema: ["cinema", "film", "movie", "screening"],
   theater: ["theater", "theatre", "musical", "broadway"],
   theatre: ["theater", "theatre", "musical", "broadway"],
   play: ["play", "theater", "theatre", "musical"],
   concert: ["concert", "music", "band", "gig"],
   gig: ["gig", "concert", "music", "band"],
   comedy: ["comed", "standup"],
   comedian: ["comed", "standup"],
   standup: ["standup", "comed"],
   hike: ["hik", "trail"],
   trail: ["trail", "hik"],
   run: ["run", "5k", "10k", "race", "marathon"],
   race: ["race", "run", "5k", "10k", "marathon"],
   bike: ["bike", "bicycl", "cycling"],
   gallery: ["galler", "art"],
   galleri: ["galler", "art"],
   halloween: ["halloween", "spook", "haunt", "costume"],
   pride: ["pride", "lgbt", "queer", "drag"],
   trivia: ["trivia", "quiz"],
   quiz: ["quiz", "trivia"],
   bbq: ["bbq", "barbecue", "barbeque"],
   barbecue: ["bbq", "barbecue", "barbeque"],
   dance: ["danc"],
   dancing: ["danc"],
   market: ["market", "bazaar", "swap"],
   tiedye: ["tiedye", "shibori", "reversedye", "icedye"],
   icedye: ["icedye", "tiedye"],
   paint: ["paint", "watercolor", "acrylic"],
   pottery: ["pottery", "ceramic"],
   potter: ["pottery", "ceramic"],
   ceramic: ["ceramic", "pottery"],
   jewelry: ["jewel", "bead"],
   woodwork: ["woodwork"],
   knit: ["knit", "crochet", "yarn"],
   knitt: ["knit", "crochet", "yarn"],
   crochet: ["crochet", "knit", "yarn"],
   class: ["class", "workshop", "lesson"],
   workshop: ["workshop", "class", "lesson"],
   mak: ["mak", "diy", "workshop", "class"]
  };
 ["pup", "puppy", "doggy", "doggie", "canine", "pooch"].forEach(function(k) {
  SYN[k] = SYN.dog
 });

 function stem(w) {
  return w.length > 4 && /ies$/.test(w) ? w.slice(0, -3) + "y" : w.length > 4 && /(ches|shes|xes|sses)$/.test(w) ? w.slice(0, -2) : w.length > 3 && /s$/.test(w) && !/(ss|us|is)$/.test(w) ? w.slice(0, -1) : w.length > 5 && /ing$/.test(w) ? w.slice(0, -3) : w
 }

 function tokens(text, joinPairs) {
  var out = [],
   prev = "";
  return norm(text).replace(/['’]/g, "").split(/\s+/).forEach(function(word) {
   var parts = word.split(/[^a-z0-9]+/).filter(Boolean);
   parts.length && (parts.forEach(function(p) {
    out.push(p);
    var s = stem(p);
    s !== p && out.push(s)
   }), parts.length > 1 && out.push(parts.join("")), joinPairs && (prev && out.push(prev + parts[0]), prev = parts[parts.length - 1]))
  }), out
 }
 var SI_CACHE = {};

 function searchIndex(o) {
  if (o._si) return o._si;
  if (o._sig && SI_CACHE[o._sig]) return o._si = SI_CACHE[o._sig];
  var al = [];
  o.hood === "Ocean Beach" && al.push("ob"), o.hood === "Pacific Beach" && al.push("pb"), o.hood === "North Park" && al.push("np"), o.hood === "Point Loma" && al.push("pl");
  var catWords = o.cat === "Art Market" ? o._cats.market ? "art market" : "art gallery galleries exhibit exhibition" : o.cat === "DIY + Workshops" ? "diy workshop workshops class classes craft hands on make" : o.cat,
   strong = [o.title, o.place, o.hood, catWords, (TAG[o.cat] || [""])[0], o.region, o.tags.join(", "), al.join(" "), o._free ? "free" : "", o._dog ? "dog friendly" : "", o._dogEvent ? "dog event" : "", o._kids ? "family friendly kids" : ""],
   s = [];
  strong.forEach(function(f) {
   f && (s = s.concat(tokens(f, !0)))
  });
  var w = tokens(detailFor(o), !1);
  return o._si = {
   s: " " + s.join(" ") + " ",
   w: " " + w.join(" ") + " "
  }, o._sig && (SI_CACHE[o._sig] = o._si), o._si
 }
 var VOCAB = null;

 function vocab() {
  if (VOCAB) return VOCAB;
  var counts = {},
   uses = new Map;
  return ITEMS.forEach(function(o) {
   var si = searchIndex(o);
   uses.set(si, (uses.get(si) || 0) + 1)
  }), uses.forEach(function(n, si) {
   (si.s + si.w).split(" ").forEach(function(t) {
    t.length > 2 && (counts[t] = (counts[t] || 0) + n)
   })
  }), VOCAB = {
   counts: counts,
   list: Object.keys(counts),
   str: " " + Object.keys(counts).join(" ") + " "
  }, VOCAB
 }

 function editDist(a, b, max) {
  if (Math.abs(a.length - b.length) > max) return max + 1;
  var prev = [],
   cur, i, j;
  for (j = 0; j <= b.length; j++) prev[j] = j;
  for (i = 1; i <= a.length; i++) {
   cur = [i];
   var rowMin = i;
   for (j = 1; j <= b.length; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)), cur[j] < rowMin && (rowMin = cur[j]);
   if (rowMin > max) return max + 1;
   prev = cur
  }
  return prev[b.length]
 }

 function closeWords(w) {
  var V = vocab(),
   max = w.length >= 7 ? 2 : 1,
   best = [];
  return V.list.forEach(function(t) {
   if (!(t.length < 3)) {
    var d = editDist(w, t, max);
    d <= max && best.push([d, -V.counts[t], t])
   }
  }), best.sort(function(a, b) {
   return a[0] - b[0] || a[1] - b[1]
  }), best.slice(0, 2).map(function(x) {
   return x[2]
  })
 }
 var qCache = {
  q: null,
  r: null
 };

 function parseQuery(q) {
  if (qCache.q === q) return qCache.r;
  var s = " " + norm(q).replace(/['’]/g, "") + " ",
   when = "",
   fixes = [];
  s = s.replace(/\bhh\b/g, " happy hour ").replace(/\btie[\s-]*dye[a-z]*\b/g, " tiedye ").replace(/\bice[\s-]*dye[a-z]*\b/g, " icedye ").replace(/\bstand[\s-]+up\b/g, " standup ").replace(/\bthis weekend\b/g, " weekend "), s = s.replace(/\b(tonight|today|tomorrow|weekend)\b/g, function(m) {
   return when = when || m, " "
  });
  var terms = [];
  s.split(/[^a-z0-9]+/).forEach(function(w) {
   if (!(!w || STOP[w])) {
    var st = stem(w),
     alts = (SYN[st] || SYN[w] || []).slice();
    if (alts.indexOf(st) === -1 && alts.unshift(st), w.length <= 2) {
     terms.push({
      alts: alts,
      exact: !0
     });
     return
    }
    if (st.length >= 4 && !SYN[st] && !SYN[w]) {
     var V = vocab();
     if (!alts.some(function(a) {
       return V.str.indexOf(" " + a) > -1
      })) {
      var near = closeWords(st);
      near.length && (alts = alts.concat(near), fixes.push([w, near[0]]))
     }
    }
    terms.push({
     alts: alts,
     exact: !1
    })
   }
  });
  var r = {
   terms: terms,
   when: when,
   fixes: fixes
  };
  return qCache = {
   q: q,
   r: r
  }, r
 }

 function termIn(str, t) {
  return t.alts.some(function(a) {
   return str.indexOf(" " + a + (t.exact ? " " : "")) > -1
  })
 }
 var CHIP_REGIONS = window.OB_GUIDE_CHIP_REGIONS || ["all", "San Diego", "North County", "Orange County", "Inland / Desert", "Los Angeles / Long Beach", "Santa Barbara / Central Coast"],
  preSearch = null,
  lastQuery = null,
  LV_PAGE = !1,
  DEST = "",
  ITEMS = [],
  HOODS = {},
  state = defaults(),
  areaTouched = !1,
  limit = PAGE,
  lastList = [],
  calMonth = null,
  map = null,
  mapLayer = null,
  leafletLoading = !1;

 function defaults() {
  return {
   q: "",
   cats: [],
   when: "all",
   from: "",
   to: "",
   open: !1,
   picks: !1,
   free: !1,
   dog: !1,
   kids: !1, night: !1, wing: !1, nw: !1, nt: [], gn: [],
   weekly: "",
   region: DEFAULT_REGION,
   hoods: [],
   view: "list",
   venue: "",
   venueName: "",
   dist: "",
   outside: !1,
   drive: !1
  }
 }

 function goodOn() {
  return GOOD.filter(function(g) {
   return state[g.k]
  })
 }

 function groupState(g) {
  var ks = leavesOf(g.k),
   n = ks.filter(function(x) {
    return state.cats.indexOf(x) > -1
   }).length;
  return n === 0 ? "off" : n === ks.length ? "on" : "some"
 }

 function catUnits() {
  var out = [];
  return GROUPS.forEach(function(g) {
   var st = groupState(g);
   st === "on" ? out.push({
    k: g.k,
    label: g.label,
    keys: leavesOf(g.k)
   }) : st === "some" && g.subs.forEach(function(s) {
    state.cats.indexOf(s.k) > -1 && out.push({
     k: s.k,
     label: s.label,
     keys: [s.k]
    })
   })
  }), out
 }

 function allCatsOn() {
  return state.cats.length === CAT_KEYS.length
 }

 function offUnits() {
  var out = [];
  return GROUPS.forEach(function(g) {
   var st = groupState(g);
   st === "off" ? out.push(g.label) : st === "some" && g.subs.forEach(function(sb) {
    state.cats.indexOf(sb.k) === -1 && out.push(sb.label)
   })
  }), out
 }

 function mostlyAll() {
  return state.cats.length > CAT_KEYS.length / 2
 }

 function compactCats() {
  return allCatsOn() ? ["all"] : catUnits().map(function(u) {
   return u.k
  })
 }

 function addCats(list, keys) {
  (keys || []).forEach(function(k) {
   (CAT_ALIASES[k] || [k]).forEach(function(x) {
    CAT_KEYS.indexOf(x) > -1 && list.indexOf(x) === -1 && list.push(x)
   })
  })
 }

 function readUrl() {
  var p;
  try {
   p = new URL(location.href).searchParams
  } catch (_) {
   return
  }
  var q = p.get("q") || p.get("search");
  q && (state.q = q); nightReadUrl(p);
  var cats = [];
  addCats(cats, (p.get("categories") || "").split(","));
  var legacyMap = {
   music: "music",
   concert: "music",
   happy: "happy",
   foodwine: "foodwine",
   wine: "foodwine",
   food: "food",
   outdoors: "outdoors",
   active: "active",
   fitness: "active",
   nature: "nature",
   wildlife: "nature",
   space: "nature",
   sports: "sports",
   games: "games",
   trivia: "games",
   karaoke: "games",
   mahjong: "games",
   bingo: "games",
   dance: "dance",
   nightlife: "dance",
   markets: "markets",
   market: "market",
   festival: "fest",
   fest: "fest",
   arts: "arts",
   art: "art",
   diy: "diy",
   workshop: "diy",
   workshops: "diy",
   film: "film",
   theater: "theater",
   performing: "theater",
   comedy: "comedy",
   dogs: "dogevent",
   dogevent: "dogevent",
   kids: "kids",
   family: "kids"
  };
  ["guide", "category"].forEach(function(k) {
   var v2 = p.get(k);
   v2 && legacyMap[v2] && addCats(cats, [legacyMap[v2]])
  }), state.cats = CAT_KEYS.filter(function(k) {
   return cats.indexOf(k) > -1
  });
  var when = p.get("when") || "";
  when === "7days" && (when = "week"), V4 && when === "tonight" && (when = "today");
  var g = p.get("guide");
  (g === "today" || g === "week") && (when = g), g === "picks" && (state.picks = !0), DATES.some(function(d) {
   return d.k === when
  }) && (state.when = when);
  var from = p.get("from"),
   to = p.get("to");
  /^\d{4}-\d{2}-\d{2}$/.test(from || "") && (state.from = from), /^\d{4}-\d{2}-\d{2}$/.test(to || "") && (state.to = to), (state.from || state.to) && state.when === "all" && (state.when = "custom"), p.get("open") === "1" && (state.open = !0), p.get("picks") === "1" && (state.picks = !0);
  var wk = p.get("weekly");
  wk === "only" ? state.weekly = "only" : (wk === "1" || wk === "all") && (state.weekly = "all"), GOOD.forEach(function(x) {
   p.get(x.param) === "1" && (state[x.k] = !0)
  }), p.get("kids") === "1" && state.cats.indexOf("kids") === -1 && (state.cats.push("kids"), state.cats = CAT_KEYS.filter(function(k) {
   return state.cats.indexOf(k) > -1
  })), (p.get("dogevents") === "1" || p.get("dogs") === "1") && (state.cats.indexOf("dogevent") === -1 && state.cats.push("dogevent"), state.cats = CAT_KEYS.filter(function(k) {
   return state.cats.indexOf(k) > -1
  }));
  var region = p.get("region"),
   area = p.get("area"),
   hood = p.get("neighborhood");
  if (region) {
   var r = REGIONS.filter(function(x) {
    return slug(x) === region
   })[0];
   region === "all" ? (state.region = "all", areaTouched = !0) : r && (state.region = r, areaTouched = !0)
  }
  if (area && !region) {
   var ra = REGIONS.filter(function(x) {
    return slug(x) === slug(area)
   })[0];
   ra ? (state.region = ra, areaTouched = !0) : hood = hood || slug(area)
  }
  hood && hood !== "none" && (state._hoodSlugs = hood.split(","), areaTouched = !0), state.q && (preSearch = {
   region: DEFAULT_REGION,
   hoods: [],
   touched: !1
  }, !region && !area && !(hood && hood !== "none") && (state.region = "all"));
  var v = p.get("mode") || p.get("guide_view");
  v === "month" && (v = "calendar"), (v === "calendar" || v === "map") && (state.view = v), V4 && (when === "tonight" && (state.when = "today"), p.get("when") || p.get("from") || p.get("to") || g === "today" || g === "week" ? dateTouched = !0 : state.q ? searchWidened = !0 : state.picks || (state.when = "today"));
  var ds = p.get("distance");
  ds && DISTS.some(function(d) {
   return d[0] === ds
  }) && (state.dist = ds), state.cats.length === 1 && state.cats[0] === "races" && !p.get("when") && !p.get("from") && !p.get("to") && (state.when = "all");
  var vn = p.get("venue");
  vn && /^[a-z0-9-]+$/.test(vn) && (state.venue = vn, !p.get("when") && !p.get("from") && !p.get("to") && (state.when = "all"), dateTouched = !0)
 }

 function writeUrl() {
  try {
   var u = new URL(location.href),
    p = u.searchParams;
   ["q", "search", "categories", "guide", "category", "when", "from", "to", "open", "picks", "free", "dog", "dogevents", "dogs", "kids", "weekly", "region", "area", "neighborhood", "mode", "guide_view", "venue", "distance", "night", "wingman", "type", "style"].forEach(function(k) {
    p.delete(k)
   }), state.q && p.set("q", state.q), state.cats.length && p.set("categories", compactCats().join(","));
   var dfltWhen = V4 && !state.q && !state.picks && !state.venue ? "today" : "all";
   state.when !== dfltWhen && p.set("when", state.when), state.when === "custom" && (state.from && p.set("from", state.from), state.to && p.set("to", state.to)), state.open && p.set("open", "1"), state.picks && p.set("picks", "1"), state.weekly && p.set("weekly", state.weekly === "only" ? "only" : "1"), GOOD.forEach(function(x) {
    state[x.k] && p.set(x.param, "1")
   }), (state.q ? state.region !== "all" || areaTouched : areaTouched && state.region !== DEFAULT_REGION) && p.set("region", state.region === "all" ? "all" : slug(state.region)), state.hoods.length && p.set("neighborhood", state.hoods.map(slug).join(",")), state.view !== "list" && p.set("mode", state.view), state.venue && p.set("venue", state.venue), state.dist && p.set("distance", state.dist);
   nightWriteUrl(p);
   var qs = p.toString();
   history.replaceState(history.state, "", u.pathname + (qs ? "?" + qs : "") + u.hash)
  } catch (_) {}
 }

 function weekendRange(t) {
  var d = dow(t),
   fri = d === 6 ? addDays(t, -1) : d === 0 ? addDays(t, -2) : addDays(t, (5 - d + 7) % 7);
  return [fri, addDays(fri, 2)]
 }

 function monthEnd(t) {
  var a = t.split("-").map(Number),
   x = new Date(Date.UTC(a[0], a[1], 0, 12));
  return x.toISOString().slice(0, 10)
 }

 function locationOk(o) {
  return state.region === "all" ? !0 : o.region !== state.region ? !1 : !state.hoods.length || state.hoods.indexOf(o.hk) > -1
 }

 function dateOk(o, t, now, dw) {
  if (o.ed < t) return !1;
  var when = dw ? dw.when : state.when,
   from = dw ? dw.from : state.from,
   to = dw ? dw.to : state.to;
  switch (when) {
   case "today":
    return o.sd <= t;
   case "tonight":
    return o.sd > t || o.all_day && !noTimeShow(o) ? !1 : o.sd < t || o.ed > t || hourOf(o.s) >= 16 || hourOf(o.e) >= 17;
   case "week":
    return o.sd < addDays(t, 7);
   case "weekend":
    var w = weekendRange(t);
    return o.ed >= w[0] && o.sd <= w[1];
   case "month":
    return o.sd <= monthEnd(t);
   case "custom":
    return !(from && o.ed < from || to && o.sd > to)
  }
  return !0
 }

 function openNow(o, t, now) {
  return o.cat === "Happy Hour" && o.hasEnd && o.sd === t && now >= o.s && now < o.e
 }

 function dogOk(o) {
  return !state.dog || o._dog
 }

 function filtered(opts) {
  opts = opts || {};
  var now = Date.now(),
   t = todayKey(),
   seen = {},
   out = [],
   weak = [],
   pq = state.q ? parseQuery(state.q) : {
    terms: [],
    when: ""
   },
   terms = pq.terms,
   dw = null,
   weeklyOn = V4 || !!state.weekly || !!state.q || !!state.venue || state.cats.some(function(k2) {
    return k2 === "happy" || k2 === "games"
   }),
   allOn = state.weekly === "all" || !!state.q || !!state.venue;
  lastQuery = pq, pq.when && state.when === "all" && (dw = pq.when === "tomorrow" ? {
   when: "custom",
   from: addDays(t, 1),
   to: addDays(t, 1)
  } : {
   when: pq.when,
   from: "",
   to: ""
  });
  for (var n = 0; n < ITEMS.length; n++) {
   var o = ITEMS[n];
   if (!(o.e < now) && !(state.venue && venueId(o) !== state.venue) && !(state.picks && !o._pick) && !(V4 && state.saved && !isSaved(o))) {
    if (o._weekly) {
     if (!weeklyOn) continue
    } else if (state.weekly === "only") continue;
    if (!(o._low && !allOn) && !(state.free && !o._free) && !(state.outside && !o._out) && !(state.drive && !o._drive) && nightOk(o) && !(state.dist && !distOk(o)) && !(state.kids && !o._kids) && dogOk(o) && !(state.cats.length && !state.cats.some(function(k2) {
      return o._cats[k2]
     })) && !(!opts.ignoreLocation && !state.venue && !locationOk(o)) && !(!opts.ignoreDate && !dateOk(o, t, now, dw)) && !(state.open && !openNow(o, t, now))) {
     var isWeak = !1;
     if (terms.length) {
      for (var si = searchIndex(o), ok = !0, ti = 0; ti < terms.length; ti++) {
       var tm = terms[ti];
       if (!termIn(si.s, tm)) {
        if (!tm.exact && termIn(si.w, tm)) {
         isWeak = !0;
         continue
        }
        ok = !1;
        break
       }
      }
      if (!ok) continue
     }
     var k = o._dk;
     seen[k] || (seen[k] = 1, (isWeak ? weak : out).push(o))
    }
   }
  }
  return out = ongoingLater(out, t), weak.length ? out.concat(ongoingLater(weak, t)) : out
 }

 function ongoingLater(list, t) {
  var cont = [],
   rest = [],
   i;
  for (i = 0; i < list.length; i++)(list[i].sd < t ? cont : rest).push(list[i]);
  if (!cont.length) return list;
  for (var at = 0; at < rest.length && rest[at].sd <= t;) at++;
  return rest.slice(0, at).concat(cont, rest.slice(at))
 }

 function runNoTime(o) {
  return o.all_day && o.ed > o.sd && (o.cat === "Theater + Performing Arts" || o.cat === "Film" || o.cat === "Concert" || o.cat === "Comedy")
 }

 function noTimeShow(o) {
  return o.all_day && o.ed === o.sd && (o.cat === "Concert" || o.cat === "Comedy" || o.cat === "Theater + Performing Arts" || o.cat === "Film")
 }

 function whenBits(o) {
  if (o._series) return {
   dow: "Every",
   md: o._series,
   time: o.all_day ? "All day" : timeLabel(o.s),
   thru: "",
   series: !0
  };
  var t = todayKey(),
   d = o.sd < t ? t : o.sd,
   dd = keyDate(d),
   dayName = d === t ? "Today" : d === addDays(t, 1) ? "Tomorrow" : WD[dd.getUTCDay()];
  if (o.sd < t) return {
   dow: "On now",
   md: o.ed > t ? "thru " + mdLabel(o.ed) : "Ends today",
   time: "",
   thru: "",
   ongoing: !0
  };
  var time = noTimeShow(o) ? "Time TBA" : runNoTime(o) ? "Times vary" : o.all_day ? "All day" : timeLabel(o.s),
   thru = o.ed > d && (o.all_day || o.ed > addDays(d, 1)) ? "thru " + mdLabel(o.ed) : "";
  return {
   dow: dayName,
   md: mdLabel(d),
   time: time,
   thru: thru
  }
 }

 function tagsFor(o, max) {
  var out = [],
   tg = TAG[o.cat];
  return o._booth && out.push('<span class="obg-tag obg-t-brand">OB Tie Dye booth</span>'), tg && out.push('<span class="obg-tag obg-t-' + tg[1] + '">' + esc(o._act ? catLabelOf(o) : tg[0]) + "</span>"), o._dogEvent && out.push('<span class="obg-tag obg-t-dogevent">' + icon("heart") + "Dog Event</span>"), o._dog && out.push('<span class="obg-tag obg-t-dog">' + icon("paw") + "Dog Friendly</span>"), o._free && out.push('<span class="obg-tag obg-t-teal">Free</span>'), out.slice(0, max || 3).join("")
 }

 function fallbackPhoto(o) {
  var c = Object.create(o);
  return c.image = "", c._photo = void 0, photoFor(c)
 }

 function thumb(o, w) {
  var p = photoFor(o),
   fb = o.image ? fallbackPhoto(o) : "";
  return p ? '<span class="obg-thumb"><img src="' + esc(sized(p, w || 240)) + '"' + (fb && fb !== p ? ' data-fb="' + esc(sized(fb, w || 240)) + '"' : "") + ' data-ic="' + esc(catIcon(o)) + '" data-cc="' + esc(TAG[o.cat] ? TAG[o.cat][1] : "slate") + '" alt="" loading="lazy" decoding="async" width="112" height="112"></span>' : '<span class="obg-thumb obg-thumb-icon obg-c-' + (TAG[o.cat] ? TAG[o.cat][1] : "slate") + '">' + icon(catIcon(o)) + "</span>"
 }

 function catIcon(o) {
  var c = o.cat;
  return c === "Concert" ? "music" : c === "Happy Hour" ? "glass" : c === "Food + Drink" ? "fork" : c === "Karaoke" || c === "Comedy" ? "mic" : c === "Trivia" ? "dice" : c === "Sports" ? "ball" : /Wildlife|Fitness/.test(c) ? "leaf" : c === "Space + Stargazing" ? "moon" : c === "DIY + Workshops" ? "scissors" : c === "Film" || c === "Art Market" ? "palette" : c === "Theater + Performing Arts" ? "ticket" : "tent"
 }
 var TC_MILES = {
  "somerset": 35,
  "new richmond": 43,
  "star prairie": 47,
  "hudson": 28,
  "north hudson": 29,
  "river falls": 38,
  "prescott": 32,
  "ellsworth": 50,
  "hammond": 45,
  "roberts": 38,
  "baldwin": 48,
  "woodville": 52,
  "osceola": 47,
  "dresser": 56,
  "st. croix falls": 52,
  "taylors falls": 51,
  "amery": 62,
  "balsam lake": 66,
  "luck": 71,
  "grantsburg": 79,
  "stillwater": 26,
  "bayport": 27,
  "afton": 29,
  "lake elmo": 23,
  "marine on st. croix": 38,
  "scandia": 38,
  "shafer": 46,
  "center city": 43,
  "lindstrom": 41,
  "chisago city": 38,
  "spring valley": 60,
  "deer park": 53,
  "glenwood city": 64,
  "red wing": 55,
  "lake city": 72,
  "wabasha": 86,
  "pepin": 77,
  "stockholm": 70,
  "alma": 93,
  "maiden rock": 64,
  "menomonie": 70,
  "eau claire": 93,
  "chippewa falls": 100,
  "northfield": 44,
  "hinckley": 81,
  "cannon falls": 41,
  "hastings": 30,
  "faribault": 50,
  "st. cloud": 66,
  "duluth": 154,
  "welch": 46,
  "frontenac": 65,
  "stacy": 37,
  "mankato": 81
 };

 function tcMiles(o) {
  var m = o && o.region === "Twin Cities" ? TC_MILES[norm(o.hood)] : 0;
  return m || 0
 }

 function venueParts(o) {
  var parts = [],
   seen = {};
  [o.place, o.hood].forEach(function(x) {
   var k = norm(x);
   k && !seen[k] && (seen[k] = 1, parts.push(x))
  });
  var mi = tcMiles(o);
  mi && parts.push(mi + " mi from Mpls");
  return {
   base: parts.join(" \xB7 "),
   region: state.region === "all" && !seen[norm(o.region)] ? o.region : ""
  }
 }

 function venueText(o) {
  var v = venueParts(o);
  return [v.base, v.region].filter(Boolean).join(" \xB7 ")
 }

 function venueHtml(o) {
  var v = venueParts(o);
  return !v.base && !v.region ? "" : '<span class="obg-venue">' + icon("pin") + (v.base ? "<span>" + esc(v.base) + "</span>" : "") + (v.region ? '<span class="obg-venue-reg">' + (v.base ? " \xB7 " : "") + esc(v.region) + "</span>" : "") + "</span>"
 }

 function row(o, i) {
  var w = whenBits(o),
   href = o.url,
   desc = o._pick && o.pick_note ? o.pick_note : detailFor(o),
   tag = href ? "a" : "div",
   attrs = href ? ' href="' + esc(tracked(href, "list")) + '" target="_blank" rel="noopener"' : "";
  return "<" + tag + ' class="obg-row' + (o._pick ? " is-pick" : "") + (o._booth ? " is-booth" : "") + '" data-ev="' + i + '"' + attrs + ">" + thumb(o) + '<span class="obg-when' + (w.ongoing ? " is-ongoing" : "") + '"><b>' + esc(w.dow) + "</b><strong>" + esc(w.md) + "</strong><em>" + esc(w.time) + "</em>" + (w.thru ? "<small>" + esc(w.thru) + "</small>" : "") + '</span><span class="obg-info"><span class="obg-title-line"><span class="obg-title">' + esc(o.title) + "</span>" + (o._pick ? '<span class="obg-pick">' + icon("star") + "OB Pick</span>" : "") + '</span><span class="obg-mwhen">' + (w.series ? esc("Every " + w.md + " \xB7 " + w.time) : w.ongoing ? esc(w.dow + " \xB7 " + w.md) : esc(w.dow + ", " + w.md + " \xB7 " + w.time) + (w.thru ? " \xB7 " + esc(w.thru) : "")) + "</span>" + venueHtml(o) + (desc ? '<span class="obg-desc">' + esc(desc) + "</span>" : "") + '<span class="obg-tags">' + tagsFor(o, 3) + "</span>" + (o._booth ? '<span class="obg-shop-link" role="link" tabindex="0" data-shop="list">Can\u2019t make it? Shop the pieces online ' + icon("arrow") + "</span>" : "") + "</span>" + (href ? '<span class="obg-go" aria-hidden="true">' + icon("arrow") + "</span>" : "") + "</" + tag + ">"
 }

 function renderList(list) {
  var box2 = $("#obgList"),
   more = $("#obgMoreWrap");
  if (!list.length) {
   var acts = [];
   if (state.region !== "all") {
    var wide = filtered({
     ignoreLocation: !0
    }).length;
    wide && acts.push('<button type="button" class="obg-btn obg-btn-solid" data-rchip="all">See ' + wide.toLocaleString() + " across " + ALL_PLACE + "</button>")
   }(state.when !== "all" || state.open) && acts.push('<button type="button" class="obg-btn" data-remove="' + (state.open ? "open" : "when") + '">Any date</button>'), acts.push('<button type="button" class="obg-btn" data-reset>Clear filters</button>'), box2.innerHTML = '<div class="obg-empty"><strong>Nothing fits that combo yet.</strong><span>' + (state.q ? "Try a different word, or widen the area and dates." : "Try widening the dates or the area.") + '</span><div class="obg-empty-acts">' + acts.join("") + "</div></div>", more.hidden = !0;
   return
  }
  box2.innerHTML = list.slice(0, limit).map(row).join(""), more.hidden = list.length <= limit;
  var mb = $("#obgMore");
  mb && (mb.textContent = "Show more events (" + (list.length - limit).toLocaleString() + " left)")
 }

 function renderMarkets() {
  var now = Date.now(),
   seen = {},
   list = ITEMS.filter(function(o) {
    return !o._booth || o.e < now || seen[o._t] ? !1 : (seen[o._t] = 1, !0)
   }).slice(0, 3),
   sec = $("#obgMarkets");
  if (sec) {
   if (!list.length) {
    sec.hidden = !0;
    return
   }
   sec.hidden = !1;
   var hp = $(".obg-sec-head p", sec);
   hp && !hp.querySelector("[data-shop]") && (hp.innerHTML = 'Come say hi and shop in person, or <a class="obg-shop-inline" href="' + SHOP_URL + '" data-shop="markets_strip">shop online</a>.'), $("#obgMarketsRow").innerHTML = list.map(function(o) {
    var w = whenBits(o),
     href = o.url,
     tag = href ? "a" : "div",
     attrs = href ? ' href="' + esc(tracked(href, "ob_markets")) + '" target="_blank" rel="noopener"' : "";
    return "<" + tag + ' class="obg-mkt"' + attrs + ">" + thumb(o, 320) + '<span class="obg-mkt-info"><span class="obg-mkt-date">' + esc(w.dow + " \xB7 " + w.md + (w.thru ? " \u2013 " + w.thru.replace("thru ", "") : "")) + '</span><span class="obg-mkt-title">' + esc(o.title) + '</span><span class="obg-mkt-meta">' + esc([o.all_day ? "" : timeLabel(o.s) + (o.hasEnd ? "\u2013" + timeLabel(o.e) : ""), o.place || o.hood].filter(Boolean).join(" \xB7 ")) + "</span></span></" + tag + ">"
   }).join("")
  }
 }

 function byTime(a) {
  return a.slice().sort(function(x, y) {
   return x.s - y.s
  })
 }

 function rankInDay(a, b) {
  return b._pick - a._pick || (a.cat === "Happy Hour") - (b.cat === "Happy Hour") || a.s - b.s
 }

 function renderCalendar(list) {
  var box2 = $("#obgCal"),
   t = todayKey();
  if (!calMonth) {
   var base = state.when === "custom" && state.from ? state.from : t;
   calMonth = base.slice(0, 7)
  }
  var y = +calMonth.slice(0, 4),
   m = +calMonth.slice(5, 7) - 1,
   first = new Date(Date.UTC(y, m, 1, 12)),
   startKey = addDays(first.toISOString().slice(0, 10), -first.getUTCDay()),
   byDay = {};
  list.forEach(function(o) {
   for (var d = o.sd < t ? t : o.sd, last = o.ed > addDays(d, 6) ? addDays(d, 6) : o.ed, k2 = d; k2 <= last; k2 = addDays(k2, 1))(byDay[k2] || (byDay[k2] = [])).push(o)
  });
  for (var cells = "", agenda = "", n = 0; n < 42; n++) {
   var k = addDays(startKey, n),
    inMonth = +k.slice(5, 7) - 1 === m,
    arr = (byDay[k] || []).slice().sort(function(a, b) {
     return (a.sd < k) - (b.sd < k) || rankInDay(a, b)
    }),
    uniq = [],
    seenT = {},
    regsN = 0,
    seenR = {};
   /* Oct 25 2026: weekly regulars get their own "+N regulars" line instead of padding the day's count */
   arr.forEach(function(o) {
    if (o._weekly) {
     regsN++;
     return
    }
    seenT[o._t] || (seenT[o._t] = 1, uniq.push(o))
   }), cells += '<div class="obg-day' + (inMonth ? "" : " is-out") + (k === t ? " is-today" : "") + (k < t ? " is-past" : "") + '"><span class="obg-dnum">' + +k.slice(8) + "</span>" + dayOrder(uniq.slice(0, 3), k).map(function(o) {
    return calItem(o, !1, k)
   }).join("") + (uniq.length > 3 ? '<button type="button" class="obg-day-more" data-day="' + k + '">+' + (uniq.length - 3) + " more</button>" : "") + (regsN ? '<button type="button" class="obg-day-more obg-day-regs" data-day="' + k + '">+' + regsN + " regular" + (regsN === 1 ? "" : "s") + "</button>" : "") + "</div>", inMonth && k >= t && (uniq.length || regsN) && (agenda += '<div class="obg-ag-day"><div class="obg-ag-head">' + esc((k === t ? "Today" : WD[dow(k)]) + ", " + mdLabel(k)) + "<span>" + uniq.length + "</span></div>" + dayOrder(uniq.slice(0, 5), k).map(function(o) {
    return calItem(o, !0, k)
   }).join("") + (uniq.length > 5 ? '<button type="button" class="obg-day-more" data-day="' + k + '">See all ' + uniq.length + "</button>" : "") + (regsN ? '<button type="button" class="obg-day-more obg-day-regs" data-day="' + k + '">+ ' + regsN + " weekly regular" + (regsN === 1 ? "" : "s") + " (happy hours, trivia and more)</button>" : "") + "</div>")
  }
  var mLabel = MONTHS[m] + " " + y,
   canPrev = calMonth > t.slice(0, 7);
  box2.innerHTML = '<div class="obg-cal-bar"><button type="button" class="obg-cal-nav" data-mo="-1" ' + (canPrev ? "" : "disabled") + ' aria-label="Previous month">\u2039</button><strong>' + mLabel + '</strong><button type="button" class="obg-cal-nav" data-mo="1" aria-label="Next month">\u203A</button></div><div class="obg-cal-grid"><div class="obg-dow">Sun</div><div class="obg-dow">Mon</div><div class="obg-dow">Tue</div><div class="obg-dow">Wed</div><div class="obg-dow">Thu</div><div class="obg-dow">Fri</div><div class="obg-dow">Sat</div>' + cells + '</div><div class="obg-agenda">' + (agenda || '<p class="obg-cal-empty">No matching events left this month.</p>') + "</div>"
 }

 function dayOrder(a, k) {
  var s = [],
   c = [];
  return a.forEach(function(o) {
   (o.sd < k ? c : s).push(o)
  }), byTime(s).concat(byTime(c))
 }

 function calItem(o, full, k) {
  var cont = k && o.sd < k,
   label = (o.all_day || cont ? "" : timeLabel(o.s) + " ") + o.title,
   href = o.url,
   inner = full ? '<span class="obg-ag-time' + (cont ? " is-ongoing" : "") + '">' + esc(cont ? "Ongoing" : noTimeShow(o) ? "Time TBA" : o.all_day ? "All day" : timeLabel(o.s)) + '</span><span class="obg-ag-body"><b>' + (o._pick ? "\u2605 " : "") + esc(o.title) + "</b><small>" + esc(venueText(o)) + "</small></span>" : (o._pick ? "\u2605 " : "") + esc(label),
   cls = full ? "obg-ag-item" : "obg-cal-ev obg-c-" + (TAG[o.cat] ? TAG[o.cat][1] : "slate") + (o._pick ? " is-pick" : "");
  return href ? '<a class="' + cls + '" href="' + esc(tracked(href, "calendar")) + '" target="_blank" rel="noopener" title="' + esc(o.title) + '">' + inner + "</a>" : '<span class="' + cls + '">' + inner + "</span>"
 }

 function loadLeaflet(cb) {
  if (window.L) return cb();
  if (!leafletLoading) {
   leafletLoading = !0;
   var css = document.createElement("link");
   css.rel = "stylesheet", css.href = "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css", document.head.appendChild(css);
   var s = document.createElement("script");
   s.src = "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js", s.async = !0, s.onload = function() {
    leafletLoading = !1, cb()
   }, s.onerror = function() {
    leafletLoading = !1;
    var el = $("#obgMap");
    el && (el.innerHTML = '<div class="obg-map-msg">The map didn\u2019t load this time. Switch views and back to try again.</div>')
   }, document.head.appendChild(s)
  }
 }

 function mapGroups(list) {
  var t = todayKey(),
   cap = state.when === "all" ? addDays(t, 30) : null,
   groups = {},
   order = [];
  return list.forEach(function(o) {
   if (!(cap && o.sd > cap)) {
    var key = hoodPt(o) ? o.region + "|" + norm(o.hk) : "@" + o.region,
     g = groups[key];
    g || (g = groups[key] = {
     name: hoodPt(o) ? o.hk : o.region,
     pt: hoodPt(o) || REGION_GEO[o.region] || REGION_GEO["San Diego"],
     items: [],
     titles: {},
     pick: !1,
     hood: hoodPt(o) ? o.hk : "",
     region: o.region
    }, order.push(key)), o._pick && (g.pick = !0);
    var tt = g.titles[o._t];
    tt ? tt.n++ : (tt = g.titles[o._t] = {
     o: o,
     n: 1
    }, g.items.push(tt))
   }
  }), order.map(function(k) {
   var g = groups[k];
   return g.items.sort(function(a, b) {
    return rankInDay(a.o, b.o)
   }), g.count = g.items.reduce(function(s, x) {
    return s + x.n
   }, 0), g
  })
 }

 function renderMap(list) {
  var wrap = $("#obgMapWrap"),
   el = $("#obgMap"),
   note = $("#obgMapNote");
  note.textContent = (state.when === "all" ? "Showing the next 30 days. " : "") + "Pins mark neighborhoods, not exact venues. Gold pins include an OB Pick. Tap one to see what\u2019s on.", loadLeaflet(function() {
   if (state.view === "map") {
    var L = window.L,
     groups = mapGroups(lastList);
    map || (el.innerHTML = "", map = L.map(el, {
     scrollWheelZoom: !1,
     zoomControl: !0,
     attributionControl: !0
    }), L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
     maxZoom: 18,
     attribution: "&copy; OpenStreetMap contributors"
    }).addTo(map), mapLayer = L.layerGroup().addTo(map)), mapLayer.clearLayers();
    var pts = [],
     total = 0,
     covered = 0;
    groups.forEach(function(g) {
     total += g.count
    }), groups.slice().sort(function(a, b) {
     return b.count - a.count
    }).forEach(function(g) {
     (covered < total * .85 || pts.length < 2) && (pts.push(g.pt), covered += g.count)
    }), groups.forEach(function(g) {
     var size = g.count > 99 ? 34 : g.count > 9 ? 30 : 26,
      ic = L.divIcon({
       className: "obg-pin-wrap",
       html: '<span class="obg-pin' + (g.pick ? " is-pick" : "") + '" style="width:' + size + "px;height:" + size + 'px">' + (g.count > 999 ? "999+" : g.count) + "</span>",
       iconSize: [size, size],
       iconAnchor: [size / 2, size / 2]
      }),
      rows = g.items.slice(0, 6).map(function(x) {
       var o = x.o,
        w = whenBits(o),
        line = w.ongoing ? w.dow + " \xB7 " + w.md : (x.n > 1 ? x.n + " dates, next " : "") + w.dow + " " + w.md + " \xB7 " + w.time,
        ttl = (o._pick ? "\u2605 " : "") + esc(o.title);
       return '<div class="obg-pop-row">' + thumb(o, 160) + "<span>" + (o.url ? '<a href="' + esc(tracked(o.url, "map")) + '" target="_blank" rel="noopener">' + ttl + "</a>" : "<b>" + ttl + "</b>") + "<small>" + esc(line) + "</small></span></div>"
      }).join(""),
      extra = g.items.length > 6 ? '<button type="button" class="obg-pop-more" data-hood="' + esc(g.hood) + '" data-region="' + esc(g.region) + '">See all ' + g.items.length + " in the list</button>" : "";
     L.marker(g.pt, {
      icon: ic,
      title: g.name,
      zIndexOffset: g.count
     }).addTo(mapLayer).bindPopup('<div class="obg-pop"><div class="obg-pop-head">' + esc(g.name) + "<span>" + g.count + " event" + (g.count === 1 ? "" : "s") + "</span></div>" + rows + extra + "</div>", {
      maxWidth: 300,
      minWidth: 240,
      autoPanPadding: [20, 20]
     })
    }), setTimeout(function() {
     map.invalidateSize(), pts.length > 1 ? map.fitBounds(pts, {
      padding: [40, 40],
      maxZoom: 13
     }) : pts.length ? map.setView(pts[0], 13) : map.setView(REGION_GEO[state.region] || REGION_GEO[DEFAULT_REGION] || REGION_GEO["San Diego"], 11)
    }, 30)
   }
  })
 }

 function optHtml(type, name, value, label, checked, extra) {
  return '<label class="obg-opt"><input type="' + type + '" name="' + name + '" value="' + esc(value) + '"' + (checked ? " checked" : "") + '><span class="obg-opt-ui"></span><span class="obg-opt-label">' + (extra || "") + esc(label) + "</span></label>"
 }

 function buildSidebar() {
  var counts = {};
  ITEMS.forEach(function(o) {
   counts[o.region] = 1
  });
  var regions = REGIONS.filter(function(r) {
   return counts[r]
  });
  $("#obgRegions").innerHTML = optHtml("radio", "obg-region", "all", ALL_LABEL, state.region === "all") + regions.map(function(r) {
   return optHtml("radio", "obg-region", r, r, state.region === r)
  }).join("");
  var hs = $("#obgHeroRegion");
  hs && (LV_PAGE ? hs.innerHTML = '<option value="' + esc(DEST) + '">' + esc(ALL_LABEL) + "</option>" + (HOODS[DEST] || []).map(function(h) {
   return '<option value="hood:' + esc(h) + '">' + esc(h) + "</option>"
  }).join("") + '<option value="multi" hidden disabled></option>' : hs.innerHTML = '<option value="all">' + esc(ALL_LABEL) + "</option>" + regions.map(function(r) {
   return '<option value="' + esc(r) + '">' + esc(r) + "</option>"
  }).join("")), $("#obgCats").innerHTML = '<div class="obg-subhead obg-subhead-first">What\u2019s happening</div><div class="obg-allrow">' + optHtml("checkbox", "obg-allcats", "all", "Select all", allCatsOn()) + "</div>" + GROUPS.map(function(g) {
   return g.subs ? '<div class="obg-catrow">' + optHtml("checkbox", "obg-grp", g.k, g.label, groupState(g) === "on", icon(g.icon, "obg-opt-ic")) + '<button type="button" class="obg-subbtn" data-subtoggle="' + g.k + '" aria-expanded="false" aria-label="Show ' + esc(g.label) + ' options">' + icon("chev") + '</button></div><div class="obg-subopts" data-subs="' + g.k + '" hidden>' + g.subs.map(function(s) {
    return optHtml("checkbox", "obg-cat", s.k, s.label, state.cats.indexOf(s.k) > -1)
   }).join("") + "</div>" : optHtml("checkbox", "obg-cat", g.k, g.label, state.cats.indexOf(g.k) > -1, icon(g.icon, "obg-opt-ic"))
  }).join("") + '<div class="obg-subhead">Good for</div>' + GOOD.map(function(g) {
   return optHtml("checkbox", "obg-good", g.k, g.label, state[g.k], icon(g.icon, "obg-opt-ic"))
  }).join(""), $("#obgDates").innerHTML = DATES.map(function(d) {
   return optHtml("radio", "obg-when", d.k, d.label, state.when === d.k)
  }).join(""), $("#obgChips").innerHTML = CHIPS.map(function(c) {
   return '<button type="button" class="obg-chip' + (c.k === "picks" ? " obg-chip-pick" : "") + '" data-chip="' + c.k + '" aria-pressed="false">' + icon(c.icon) + "<span>" + esc(c.label) + "</span></button>"
  }).join("") + (V4 ? '<button type="button" class="obg-chip obg-chip-more" data-open="all">' + icon("sliders") + "<span>More filters</span></button>" : ""), buildHoods()
 }

 function buildHoods() {
  var wrap = $("#obgHoodsWrap");
  if (state.region === "all") {
   wrap.hidden = !0;
   return
  }
  var list = HOODS[state.region] || [];
  wrap.hidden = !list.length, $("#obgHoods").innerHTML = list.map(function(h) {
   return optHtml("checkbox", "obg-hood", h, h, state.hoods.indexOf(h) > -1)
  }).join("")
 }

  /* ---- Night Out filters (Oct 25 2026): Nightlife + Music chip, Wingman Mode, type + music-style drill-downs,
  *      live counts on chips, too-narrow warning with undo. Leans toward including events. ---- */
 var NIGHT_TYPES = [{k: "small", label: "Bars + Small Venues"}, {k: "big", label: "Big Shows"}, {k: "fest", label: "Music Fests"}, {k: "comedy", label: "Comedy"}, {k: "games", label: "Karaoke + Trivia"}, {k: "costume", label: "Costume Parties"}],
  NIGHT_GENRES = [{k: "reggae", label: "Reggae / Ska"}, {k: "rock", label: "Rock / Indie"}, {k: "punk", label: "Punk / Metal"}, {k: "jam", label: "Jam / Dead"}, {k: "hiphop", label: "Hip-Hop / R&B"}, {k: "edm", label: "EDM / Dance"}, {k: "pop", label: "Pop"}, {k: "country", label: "Country / Folk"}, {k: "latin", label: "Latin"}, {k: "jazz", label: "Jazz / Blues"}],
  NX = {
   kidTag: /^(kids?|kids \+ family|family|families|family friendly|kid friendly|toddlers?|children)$/,
   kidTitle: /\b(kids?|toddlers?|storytime|story time|children'?s|family (day|fun|night|festival|movie|halloween)|trick[- ]or[- ]treat\w*|pumpkin patch|petting zoo|sensory)\b/,
   dogTitle: /\b(dogs?|pups?|puppy|puppies|pets?|yappy|doggie|doggy|canines?|adoption)\b/,
   dogOk: /\b(hot dogs?|salty dog|dog haus|three dog night|pet shop boys|snoop|dogtown|dog town|black dog|dirty dogs?|top dog)\b/,
   musicTag: /^(live music|concert|music|dj|jam|band|reggae scene)$/,
   musicTitle: /\b(live music|live band|concert|dj|djs|tour|band|orchestra|symphony|quartet|trio|unplugged|acoustic)\b/,
   comedy: /\b(comedy|comedian|comedians|stand-?up|improv|roast)\b/,
   mic: /\b(open mic|open-mic|karaoke|jam session|jam night|blues jam|songwriters? (night|showcase|round|in the round)|poetry slam|spoken word)\b/,
   trivia: /\b(trivia|bingo|quiz|game night)\b/,
   bar: /\b(bar|pub|tavern|saloon|lounge|taproom|tap room|tasting room|brewing|brewery|brewhouse|brewpub|cantina|nightclub|club|distillery|winery|beer garden|biergarten|speakeasy|casino|cocktail|taphouse|ale house|alehouse|beer co|beer company|beer works|wine bar|wine co|ciderhouse|cidery)\b/,
   over21: /(^|\W)21\s*(\+|and over|& over|and up)/,
   latin: /\b(salsa (night|dancing|dance|social|lesson|lessons|class)|salsa|bachata|merengue|cumbia (night|party)|kizomba|zouk|tango|milonga|swing danc\w*|lindy\s?hop|lindy|west coast swing|line danc\w*|two[- ]step|ballroom danc\w*|country danc\w*|latin night|latin dance|noche latina|contra|contra danc\w*|square danc\w*|folk ?danc\w*|english country|ceili|barn dance|scottish country|balfolk|zydeco|cajun dance|polka)\b/,
   latinDesc: /\b(salsa (night|dancing|dance|social|lessons?|class)|bachata|kizomba|swing danc\w*|line danc\w*|two[- ]step|tango lessons?|dance lessons?)\b/,
   dj: /\b(dj|djs|d\.j\.|club night|rave|edm|house music|techno|dance party|silent disco|disco night|disco party|80s night|90s night|2000s night|emo nite|throwback night|day party|pool party|day club|dayclub|afterparty|after party|after-party|b2b|bass|booty|dance night|block party)\b/,
   djTag: /^(dj|electronic|edm|house|techno|dance|disco)$/,
   costume: /\b(costumes?|masquerade|halloween (party|bash|ball|night|bar crawl|crawl|costume)|monster ball|zombie (crawl|walk|party)|haunted (bar|pub) crawl|ugly sweater|themed? (party|night)|white party|neon|glow party|blacklight|toga|dress[- ]up|y2k|80s night|90s night|2000s night|d[ií]a de (los )?muertos (party|celebration|night|bash)|day of the dead (party|celebration)|scream|fright night|hunter's moon)\b/,
   party: /\b(party|bash|ball|night|crawl|takeover|social|mixer)\b/,
   big: /(arena|amphithea|stadium|ballpark|bowl\b|rady shell|humphreys|pechanga|viejas|sycuan|harrah|valley view|jamul|belly up|music box|observatory|house of blues|soma\b|soundwave|sound wave|civic theat|balboa theat|copley|open air theat|petco|snapdragon|frontwave|greek theat|palladium|wiltern|the novo|youtube theat|kia forum|\bforum\b|crypto|intuit dome|sofi|honda center|pacific amphithea|toyota|acrisure|fox theat|fox performing|glass house|belasco|shrine|orpheum|mayan|el rey|troubadour|fonda|teragram|regent|catch one|the sound|grove of anaheim|the observatory|chain reaction|garden amp|yaamava|morongo|agua caliente|fantasy springs|spotlight 29|pappy|coachella|stagecoach|empire polo)/,
   local: /(the harp|holding company|casbah|soda bar|whistle stop|kensington club|til[- ]two|pour house|winston|black cat|brick by brick|tower bar|space bar|merrow|bancroft|hideaway|rabbit hole|pal joey|u-31|nate's|coffee|cafe|café|tiki|dive)/,
   tour: /\b(tour|anniversary|farewell|world tour|live in concert)\b/,
   theaterOk: /\b(drag|burlesque|cabaret|variety show|after dark|late night|21\+|rocky horror|immersive|speakeasy)\b/,
   foodOk: /\b(beer|wine|cocktails?|spirits|tequila|mezcal|whiskey|brew|oktoberfest|block party|night market|party|bar crawl|pub crawl|sip)\b/,
   festOk: /\b(beer|wine|tequila|mezcal|block party|street party|oktoberfest|pride|halloween|d[ií]a de|music|concert|night|after dark|rave|reggae|jazz|blues|rock|hip hop|edm|lights?)\b/
  },
  GENRE_RX = {
   reggae: /\b(reggae|ska|rocksteady|dancehall|dub|roots reggae|lovers rock|eli[- ]mac|cruz roots|lowtide|iration|rebelution|slightly stoopid|stick figure|tribal seeds|common kings|fortunate youth|pepper|sublime|dirty heads|expanders|hirie|through the roots|mike love|kash'?d out|arise roots|bumpin uglies|collie buddz|soja|steel pulse|elovaters|ballyhoo|kolohe kai|j boog|katastro|marley|toots|barrington levy|pato banton|maxi priest|ub40|long beach dub|the green|hot rain|natural vibrations|seedless|new kingston|e\.n young|keznamdi|pacific dub|irie|roots rock)\b/,
   jam: /\b(jam band|jamband|jamgrass|psychedelic|psych rock|psych|grateful dead|deadhead|dead & company|phish|umphrey|papadosio|perpetual groove|disco biscuits|sts9|pigeons playing ping pong|goose|widespread panic|string cheese|twiddle|spafford|the floozies|jam session)\b/,
   funk: /\b(funk|funky|soul|motown|neo[- ]soul|northern soul|rhythm and blues|brass band|funk hunters|saxsquatch|break science)\b/,
   electronic: /\b(electronic|edm|house music|deep house|tech house|afro ?house|techno|trance|dubstep|drum (and|&|n) bass|dnb|bass music|disco|nu[- ]disco|synthwave|electro|rave|club night|boiler room)\b|^house$|\| house\b/,
   hiphop: /\b(hip[- ]?hop|rap|rapper|r&b|r ?n ?b|rnb|tupac|2pac|biggie|notorious b|dr\.? dre|snoop|outkast|wu-tang clan|trap music|boom bap|emcee|talib kweli|wu[- ]?tang|chali 2na)\b/,
   rock: /\b(rock|indie|alt[- ]rock|alternative|garage|grunge|shoegaze|surf rock|stoner|britpop|new wave|goth|post[- ]punk|yacht rock|classic rock|prog|aerosmith|kiss|led zeppelin|zeppelin|pink floyd|floyd|beatles|queen|journey|eagles|fleetwood mac|tom petty|ac\/dc|acdc|van halen|bon jovi|def leppard|guns n.? roses|nirvana|pearl jam|foo fighters|chili peppers|the doors|rolling stones|springsteen|zz top|lynyrd skynyrd|creedence|ccr|santana|oingo boingo|the cure|depeche mode|smiths|u2|rush|heart|boston|cheap trick|stone temple pilots|soundgarden|alice in chains|weezer|incubus)\b/,
   punk: /\b(punk|skacore|hardcore|emo|pop[- ]punk|screamo|elder emo|emo nite|warped|oi|metal|heavy metal|thrash|doom|death metal|metalcore|misfits|ramones|bad brains|green day|blink[- ]?182|social distortion|bad religion|offspring|black sabbath|metallica|iron maiden|slayer|megadeth|judas priest|ozzy|motorhead|danzig|the bronx|voodoo glow skulls|rocket from the crypt)\b/,
   jazz: /\b(jazz|blues|big band|bebop|swing band|dixieland|fusion|soul jazz|organ trio)\b/,
   country: /\b(johnny cash|garth brooks|dolly parton|willie nelson|george strait|shania|luke combs|morgan wallen|zach bryan|country|bluegrass|americana|honky[- ]tonk|folk|outlaw|country western|alt[- ]country|singer[- ]songwriter|two[- ]step|line danc\w*)\b/,
   pop: /\b(pop|indie pop|synth[- ]?pop|electropop|top 40|abba|madonna|michael jackson|prince|whitney|britney|mariah|elton john|bee gees|lady gaga|beyonce|dua lipa|harry styles|olivia rodrigo|ariana|bruno mars|backstreet|nsync|spice girls|cher|boy band|girl group|k[- ]?pop|j[- ]?pop|disco pop|taylor swift|sabrina carpenter|chappell roan)\b/,
   latin: /\b(latin|latino|latina|cumbia|salsa|reggaet[oó]n|banda|norte[nñ]o|mariachi|bachata|corridos?|tejano|merengue|bolero|son jarocho|rancheras?|tropical|bossa nova|samba|afro[- ]cuban|afrobeats?|tango|flamenco|brazilian|world music|highlife|soca|calypso)\b/,
   tribute: /\b(tribute|tributes|cover band|covers|the music of|music of|salute to|plays the hits|former members|celebrating the music|re-?imagined|grateful dead|dead set|dead night|deadhead|dead & company|dead and company|jerry garcia|jgb|grateful)\b/,
   classical: /\b(classical|symphony|orchestra|chamber music|string quartet|philharmonic|opera|candlelight|baroque|mozart|beethoven|bach|vivaldi|chopin)\b/
  };
 var WING_VET = {regions: /^(San\ Diego|North\ County|Los\ Angeles\ \/\ Long\ Beach|Los\ Angeles|Orange\ County|Inland\ \/\ Desert|Inland\ Empire|Palm\ Springs\ \+\ Joshua\ Tree|Las\ Vegas|Phoenix|Tempe|Arizona|Denver|Salt\ Lake\ City|Portland|Twin\ Cities|Charlotte|Washington\ DC|Honolulu|Tokyo|St\.\ Pete)$/, yes: /^(oh\ pool\ bar\ \+\ cabanas\ at\ hotel\ valley\ ho,\ 6850\ e\ main\ st|maya\ day\ \+\ night,\ 7333\ e\ indian\ plaza,\ scottsdale|culinary\ dropout\ at\ the\ yard,\ 149\ s\ farmer\ ave|dierks\ bentley's\ whiskey\ row,\ 323\ n\ gilbert\ rd|hard\ rock\ hotel\ san\ diego\ \/\ float\ rooftop|marquee\ dayclub\ dome\ at\ the\ cosmopolitan|24\ oxford\ at\ virgin\ hotels\ las\ vegas|marquee\ dayclub\ at\ the\ cosmopolitan|petra's\ bar,\ 1919\ commonwealth\ ave|ace\ hotel\ palm\ springs\ —\ main\ pool|the\ chandelier,\ the\ cosmopolitan|cervantes'\ masterpiece\ ballroom|humphreys\ concerts\ by\ the\ bay|the\ rady\ shell\ at\ jacobs\ park|stk\ steakhouse\ salt\ lake\ city|hb\ social\ club\ \-\ crossroads|the\ fillmore\ silver\ spring|ophelia's\ electric\ soapbox|belly\ up,\ 143\ s\ cedros\ ave|the\ observatory\ north\ park|house\ of\ blues\ las\ vegas|reframe\ studios\ outdoors|house\ of\ blues\ san\ diego|the\ fillmore\ minneapolis|punch\ bowl\ social\ denver|the\ midlands\ beer\ garden|bottled\ blonde\ las\ vegas|jack\ rose\ dining\ saloon|w\ scottsdale\ —\ wet\ deck|brooklyn\ bowl\ las\ vegas|waterfront\ bar\ \&\ grill|the\ district\ nightclub|the\ fillmore\ charlotte|the\ pub\ and\ the\ people|social\ tap\ scottsdale|dilworth\ tasting\ room|cervantes'\ other\ side|the\ commonwealth\ room|hakkasan\ at\ mgm\ grand|w\ scottsdale\ wet\ deck|neighborhood\ theatre|sealegs\ at\ the\ beach|winston's\ beach\ club|songbyrd\ music\ house|the\ moroccan\ lounge|golden\ road\ brewing|jax\ fish\ house\ lodo|fillmore\ auditorium|the\ rose\ honky\ tonk|clubasia,\ 1f\ lounge|winstons\ beach\ club|mississippi\ studios|the\ hermosa\ saloon|yard\ house\ waikiki|pappy\ \&\ harriet's|teragram\ ballroom|crescent\ ballroom|lulu's\ winegarden|encore\ beach\ club|the\ green\ pig\ pub|the\ fonda\ theatre|marquee\ nightclub|everson\ royce\ bar|whiskey\ warehouse|patrick\ molloy's|mission\ ballroom|the\ roxy\ theatre|pacific\ electric|visulite\ theatre|bluebird\ theater|metro\ music\ hall|crystal\ ballroom|park\ on\ fremont|reframe\ studios|wonder\ ballroom|the\ underground|the\ three\ clubs|the\ cruise\ room|rumfire\ waikiki|omnia\ nightclub|marquee\ dayclub|sound\ nightclub|lighthouse\ cafe|marquee\ theatre|american\ bonded|belly\ up\ tavern|the\ bellwether|uptown\ theater|amos'\ southend|bottled\ blonde|regent\ theatre|zouk\ nightclub|duke's\ waikiki|el\ rey\ theatre|the\ waterfront|rialto\ theatre|house\ of\ blues|gothic\ theatre|the\ green\ room|tao\ nightclub|jupiter\ hotel|the\ spotlight|woody's\ wharf|we\ all\ scream|broken\ shaker|the\ ordinarie|wunder\ garten|ogden\ theatre|liv\ las\ vegas|desert\ 5\ spot|madam's\ organ|fonda\ theatre|the\ van\ buren|ace\ eat\ serve|bigfoot\ lodge|the\ republik|wasted\ grain|star\ theater|gold\ diggers|the\ wayfarer|lost\ \&\ found|first\ avenue|urban\ lounge|xs\ nightclub|the\ griffin|rock'n\ fish|union\ stage|the\ admiral|service\ bar|petra's\ bar|snug\ harbor|sky\ waikiki|hinano\ cafe|nolita\ hall|the\ wiltern|herbs\ \&\ rye|mozambique|the\ casbah|kingfisher|the\ anthem|interurban|black\ jack|the\ virgil|fahrenheit|lodge\ room|valley\ bar|stk\ denver|discopussy|brit's\ pub|radio\ room|troubadour|barley\ mac|fine\ line|ink\ n\ ivy|townhouse|soundwell|music\ box|black\ cat|turf\ club|winston’s|24\ oxford|9:30\ club|the\ depot|tiki\ tnt|the\ brig|hey\ love|belly\ up|echoplex|the\ echo|nextdoor|petra's|rontoms|zebulon|level\ 8|berlin|el\ cid|linger|takoda|calico|joule|perch|womb|mesa|mizu)$/, maybe: /^(yokohama\ red\ brick\ warehouse\ event\ plaza\ and\ red\ brick\ park|yoyogi\ park\ events\ square,\ outdoor\ stage\ \&\ keyaki\ avenue|local\ craft\ beer\ pub\ arca\-archa,\ caption\ by\ hyatt\ namba|skysill\ rooftop\ lounge,\ the\ westin\ tempe,\ 11\ e\ 7th\ st|fantasy\ springs\ resort\ casino\ \-\ special\ events\ center|mortgage\ matchup\ center\ \(formerly\ footprint\ center\)|university\ sports\ grill,\ 740\ s\ mill\ ave\ \(check\-in\)|outside\ casey\ moore's\ oyster\ house,\ 850\ s\ ash\ ave|hundred\ mile\ brewing\ company,\ 690\ n\ scottsdale\ rd|hilton\ waikiki\ beach\ resort\ \&\ spa\ grand\ ballroom|cal\ coast\ credit\ union\ open\ air\ theatre\ at\ sdsu|thirsty\ lion\ gastropub\ \&\ grill,\ santan\ village|mcmenamins\ edgefield\ \(edgefield\ amphitheater\)|arcadia\ tavern,\ 3950\ e\ indian\ school\ rd\ \#150|pearl\ concert\ theater\ at\ palms\ casino\ resort|bel\-aire\ backyard\ at\ durango\ casino\ \&\ resort|boondocks\ patio\ \&\ grill,\ 1024\ e\ broadway\ rd|the\ concert\ lounge\ \-\ romano's\ mission\ grove|cathedral\ city\ festival\ lawn\ \&\ amphitheater|mcmenamins\ edgefield\ \(edgefield\ ballroom\)|charlotte\ metro\ credit\ union\ amphitheatre|monkey\ pants\ bar\ \&\ grill,\ 3223\ s\ mill\ ave|alibi\ rooftop\ lounge,\ 108\ e\ university\ dr|yoyogi\ park\ events\ square\ \&\ outdoor\ stage|yokohama\ red\ brick\ warehouse\ event\ plaza|allegra\ rooftop\ pool\ \&\ bar\ at\ the\ remi\.|voodoo\ room\ at\ house\ of\ blues\ san\ diego|the\ dock\ at\ the\ historic\ sears\ building|peppermill\ restaurant\ \&\ fireside\ lounge|playground\ rooftop,\ 278\ e\.\ congress\ st\.|mcmenamins\ edgefield\ \(blackberry\ hall\)|sideline\ stage\ \-\ morongo\ casino\ resort|the\ theater\ at\ virgin\ hotels\ las\ vegas|north\ island\ credit\ union\ amphitheatre|carbon\ beach\ club\ at\ malibu\ beach\ inn|old\ world\ village,\ 7561\ center\ avenue|ace\ hotel\ palm\ springs\ —\ commune\ pool|constellation\ room\ at\ the\ observatory|the\ underground\ \(below\ nile\ theater\)|kona\ grill,\ 2224\ e\ williams\ field\ rd|iw\ live\ at\ indian\ wells\ resort\ hotel|amigo\ room\ at\ ace\ hotel\ palm\ springs|utah\ first\ credit\ union\ amphitheatre|swell\ pool\ \&\ bar,\ ʻalohilani\ resort|the\ vig,\ 1744\ s\ val\ vista\ dr\ \#5\-101|house\ of\ blues\ anaheim\ \-\ the\ parish|flight\ club\ las\ vegas,\ the\ venetian|the\ lobby\ cocktail\ lounge\ \&\ kitchen|carlos\ mexican\ restaurant\ \+\ cantina|house\ of\ blues\ anaheim\ \-\ music\ hall|the\ sound,\ 2260\ jimmy\ durante\ blvd|pedal\ haus\ brewery,\ 730\ s\ mill\ ave|the\ white\ rabbit,\ 207\ n\ gilbert\ rd|highball\ bar\ umeda\ rakutenchi\ 1923|bleaulive\ theater\ at\ fontainebleau|kelsey's\ at\ pechanga\ resort\ casino|round\ bar,\ the\ resort\ at\ summerlin|ruby's\ nightclub,\ downtown\ oxnard|bleaulive\ theater\ –\ fontainebleau|talking\ stick\ resort\ amphitheatre|hb\ social\ club\ \-\ slack\ key\ lounge|four\ peaks\ brewing\ 8th\ street\ pub|bitter\ \&\ twisted\ cocktail\ parlour|queen\ mary\ waterfront\ events\ park|four\ peaks\ brewing,\ 1340\ e\ 8th\ st|mill\ avenue\ and\ centerpoint\ plaza|fat\ tuesday,\ 680\ s\ mill\ ave\ \#106|beauty\ \&\ essex,\ the\ cosmopolitan|waikiki\ brewing\ company\ kaka'ako|k\ o'donnell's\ sports\ bar\ \&\ grill|ghostbar\ rooftop\ lounge\ –\ palms|station\ craft\ brewery\ \+\ kitchen|the\ holding\ company\ –\ 1st\ floor|u\.s\.\ national\ whitewater\ center|414\ pub\ \&\ pizza,\ 414\ s\ mill\ ave|skyla\ credit\ union\ amphitheatre|south\ coast\ winery\ resort\ \&\ spa|toca\ madera,\ shops\ at\ crystals|riverside\ municipal\ auditorium|gallagher\ square\ at\ petco\ park|meow\ wolf\ convergence\ station|the\ cosmopolitan\ of\ las\ vegas|los\ angeles\ memorial\ coliseum|hennessey's\ tavern\ dana\ point|fantasy\ springs\ resort\ casino|shrine\ auditorium\ \&\ expo\ hall|cardiff\ beach\ bar\ at\ tower\ 13|luxe\ restaurant\ \&\ martini\ bar|neighborhood\ theatre\ tap\ room|pkwy\ tavern\ \-\ all\ 7\ locations|pkwy\ tavern\ at\ tivoli\ village|the\ olde\ mecklenburg\ brewery|sevilla\ nightclub\ costa\ mesa|stanley's\ northeast\ bar\ room|melvyn's\ \/\ casablanca\ lounge|right\ proper\ brewing\ taproom|campground\ at\ larimer\ lounge|kona\ brewing\ hawai'i\ kai\ pub|lucky\ bar\ at\ red\ rock\ resort|the\ majestic\ ventura\ theater|fiddler's\ green\ amphitheatre|miyashita\ park\ rooftop\ lawn|cien\ agaves\ tacos\ \&\ tequila|c\.a\.s\.a\.\ tempe,\ 15\ e\ 6th\ st|ph\ live\ at\ planet\ hollywood|treehouse\ at\ larimer\ lounge|pedal\ haus\ brewery\ chandler|show\ bar\ at\ revolution\ hall|reelworks\ and\ tracks\ denver|surly\ brewing\ co\.\ beer\ hall|permanent\ records\ roadhouse|cathedral\ city\ amphitheater|morongo\ casino\ resort\ \&\ spa|james\ ballentine\ uptown\ vfw|hula's\ modern\ tiki\ old\ town|pedal\ haus\ brewery\ phoenix|clancy's\ pub\ pizza\ \&\ grill|ventura\ county\ fairgrounds|texas\ lil's\ mesquite\ grill|hotel\ congress\ plaza\ stage|veterans\ memorial\ coliseum|hollywood\ forever\ cemetery|swell\ at\ 'alohilani\ resort|casey\ moore's\ oyster\ house|merriweather\ post\ pavilion|ivan'z\ house\ at\ mozambique|a\ bar\ named\ sue\ \(highland\)|the\ point\ restaurant\ \&\ bar|tom\ moffatt\ waikiki\ shell|backstage\ bar\ \&\ billiards|quartyard,\ 1301\ market\ st|fremont\ street\ experience|al's\ den\ at\ crystal\ hotel|mr\.\ smith's\ of\ georgetown|big\ bear\ lake\ oktoberfest|yoyogi\ park\ keyaki\ avenue|arizona\ financial\ theatre|hide\-a\-while\ bar\ \&\ lounge|pioneer\ courthouse\ square|taverna\ costera\ –\ rooftop|nava\ rooftop\ bar\ \&\ lounge|hi\-wire\ brewing\ charlotte|therapy,\ 518\ e\ fremont\ st|molly\ malone's\ irish\ pub|monkey\ pants\ bar\ \&\ grill|pedal\ haus\ brewery\ tempe|resident\ culture\ brewing|maui\ brewing\ co\.\ waikiki|ramona\ bowl\ amphitheatre|the\ irish\ rover\ \(denver\)|craig\ ranch\ amphitheater|goodbeer\ faucets\ shibuya|pearl\ dive\ oyster\ palace|pechanga\ arena\ san\ diego|humphreys\ backstage\ live|lanikai\ brewing\ company|knuckleheads\ sports\ bar|mortgage\ matchup\ center|bank\ of\ america\ stadium|blue\ coyote\ bar\ \&\ grill|fontainebleau\ las\ vegas|the\ wonderland\ ballroom|a\ bar\ named\ sue\ \(state\)|the\ local\ pacific\ beach|pedal\ haus\ brewery\ mesa|santa\ monica\ brew\ works|rooftop\ 262\ bar\ \&\ grill|maui\ brewing\ co\.\ kailua|common\ market\ south\ end|suffolk\ punch\ south\ end|waikiki\ brewing\ company|long\ beach\ amphitheater|barcelona\ wine\ bar\ rino|modist\ brewing\ company|the\ sand\ dollar\ lounge|schoolyard\ beer\ garden|honolulu\ museum\ of\ art|fulton\ brewing\ taproom|dodger\ stadium\ grounds|mgm\ grand\ garden\ arena|red\ rocks\ amphitheatre|el\ jefe\ desert\ cantina|hurricanes\ bar\ \&\ grill|miyashita\ park\ rooftop|pearl\ street\ warehouse|dolby\ live\ at\ park\ mgm|amsterdam\ bar\ and\ hall|house\ of\ blues\ anaheim|atomic\ cowboy\ \(colfax\)|tonga\ hut\ palm\ springs|agave\ caliente\ terraza|la\ state\ historic\ park|jax\ fish\ house\ boulder|maui\ sugar\ mill\ saloon|the\ union\ event\ center|palm\ springs\ surf\ club|the\ brickyard\ downtown|theater\ of\ the\ clouds|morrissey's\ irish\ pub|emmett's\ public\ house|cascades\ amphitheater|beer\ lab\ hi\ beretania|kirwan's\ on\ the\ wharf|public\ house\ temecula|the\ vermont\ hollywood|pinstripes\ georgetown|hofbräuhaus\ las\ vegas|the\ surly\ goat\ encino|hideout\ at\ the\ laylow|the\ sunset\ restaurant|pearl\ concert\ theater|mango\ tango\ nightclub|ace\ hotel\ \&\ swim\ club|edgewater\ beer\ garden|truliant\ amphitheater|junction\ food\ \&\ drink|redwood\ bar\ and\ grill|prost\ brewing\ company|ireland's\ four\ courts|yucca\ tap\ room\ lounge|boathouse\ on\ the\ bay|tommy\ bahama\ waikiki|birdsong\ brewing\ co\.|the\ oriental\ theater|desert\ diamond\ arena|viejas\ arena\ at\ sdsu|machete\ cherry\ creek|wooden\ robot\ brewery|hotel\ congress\ plaza|mavericks\ beach\ club|linger\ longer\ lounge|boatyard\ lake\ norman|tortoise\ rock\ casino|michelob\ ultra\ arena|mon\ takanawa\ box1000|mcmenamins\ edgefield|denver\ union\ station|the\ continental\ club|shinsaibashi\ sunhall|thomas\ \&\ mack\ center|shibuya\ club\ quattro|noda\ brewing\ company|old\ world\ biergarten|amsterdam\ bar\ \&\ hall|hollywood\ palladium|sugar\ creek\ brewing|old\ town\ scottsdale|loulou\ santa\ monica|ace\ mission\ studios|portland\ city\ grill|palms\ casino\ resort|33\ taps\ silver\ lake|kalaveras\ fullerton|chart\ house\ waikiki|barnoa\ wine\ company|bohemian\ biergarten|ace\*mission\ studios|the\ holding\ company|redwood\ bar\ \&\ grill|mon\ takanawa\ box300|paddy's\ bar\ \&\ grill|duo\ music\ exchange|fox\ theater\ pomona|modist\ brewing\ co\.|walters\ sports\ bar|tiki's\ grill\ \&\ bar|helmsman\ ale\ house|yogibo\ meta\ valley|the\ liberty\ tavern|zepp\ osaka\ bayside|mickey's\ irish\ pub|the\ fox\ and\ hounds|heist\ brewery\ noda|joshua\ tree\ saloon|thunderbird\ lounge|double\ down\ saloon|las\ vegas\ ballpark|umeda\ club\ quattro|hennessey's\ tavern|fergusons\ downtown|denver\ milk\ market|ventura\ music\ hall|bojangles\ coliseum|downtown\ riverside|gaslamp\ long\ beach|white\ eagle\ saloon|capital\ one\ arena|q's\ billiard\ club|the\ local\ on\ 50th|old\ town\ temecula|mission\ navy\ yard|wild\ goose\ tavern|patsy's\ irish\ pub|allegiant\ stadium|the\ stage\ at\ zouk|poplar\ street\ pub|mesa\ amphitheatre|bauhaus\ brew\ labs|cafe\ brass\ monkey|summit\ music\ hall|brewdog\ las\ vegas|old\ world\ village|the\ auld\ dubliner|velvet\ elk\ lounge|surly\ brewing\ co\.|punch\ bowl\ social|hollywood\ forever|killer\ yacht\ club|the\ culver\ hotel|law's\ restaurant|culinary\ dropout|shrine\ expo\ hall|goosetown\ tavern|empire\ polo\ club|the\ rebel\ lounge|the\ catwalk\ club|birdsong\ brewing|the\ sleepy\ whale|roseland\ theater|horseshoe\ lounge|the\ hidden\ house|avalon\ hollywood|the\ roost\ lounge|the\ cat\ \&\ fiddle|tempe\ beach\ park|the\ shout!\ house|courthaus\ social|tiny\ pony\ tavern|brew'd\ craft\ pub|devil's\ hideaway|k\-arena\ yokohama|crypto\.com\ arena|beer\ club\ popeye|long\ beach\ arena|barney's\ beanery|santa\ anita\ park|whistle\ stop\ bar|the\ pharmacy\ pdx|lost\ lake\ lounge|the\ usual\ place|utepils\ brewing|jiffy\ lube\ live|phoenix\ raceway|the\ glass\ house|the\ copper\ room|bootlegger\ tiki|boulder\ theater|shanghai'd\ room|blaisdell\ arena|the\ village\ inn|spectrum\ center|torrance\ tavern|the\ grass\ skirt|the\ bamboo\ club|the\ venice\ west|exposition\ park|revolution\ hall|tailgate\ tavern|varsity\ theater|rialto\ poolroom|marquis\ theater|the\ golden\ tiki|willie's\ lounge|hi\-wire\ brewing|belasco\ theater|barcoa\ agaveria|the\ observatory|gallivan\ center|the\ walnut\ room|hollywood\ bowl|the\ viper\ room|back\ stage\ bar|soma\ mainstage|nationals\ park|last\ exit\ live|inbound\ brewco|inkwell\ tavern|howard\ theatre|downtown\ tempe|whisky\ a\ go\-go|piper\ down\ pub|tavern\ on\ main|bigs\ fullerton|the\ state\ room|hotel\ congress|t\-mobile\ arena|the\ front\ yard|red\ dog\ saloon|walter\ studios|spotify\ o\-east|710\ beach\ club|maverik\ center|ringlers\ annex|yucca\ tap\ room|soma\ sidestage|socore\ factory|stk\ steakhouse|the\ meadowlark|whisky\ a\ go\ go|acrisure\ arena|mission\ dupont|larimer\ lounge|proper\ brewing|aloha\ beer\ co\.|time\ nightclub|the\ hot\ chick|pb\ shore\ club|the\ paramount|durty\ nelly's|shinjuku\ loft|wyman's\ no\.\ 5|the\ black\ cat|ye\ rustic\ inn|the\ wine\ loft|neil's\ lounge|club\ congress|mayan\ theatre|the\ duck\ dive|mullett\ arena|stk\ charlotte|vesper\ lounge|globe\ theatre|aggie\ theatre|greek\ theatre|tavern\ \&\ pool|the\ tropicale|h\.h\.\ cotton's|the\ salt\ line|the\ queen\ vic|pub\ rock\ live|hello\ darling|target\ center|shibuya\ www\ x|osaka\-jo\ hall|the\ atlantis|the\ dustland|boardwalk\ 11|off\ the\ wall|sofi\ stadium|mutt\ lynch's|deck\ waikiki|ringlers\ pub|the\ haymaker|polaris\ hall|biergartenla|the\ airliner|firehouse\ pb|the\ goodfoot|nile\ theater|7th\ st\ entry|club\ tee\ gee|coyote\ joe's|circus\ osaka|the\ harp\ inn|honda\ center|bao\ tennyson|toyota\ arena|cafe\ sevilla|zepp\ sapporo|tom\ bergin's|sunbar\ tempe|truist\ field|delta\ center|the\ red\ barn|viejas\ arena|washington's|the\ cabooze|intuit\ dome|shibuya\ www|fox\ theatre|kilby\ court|vox\ kitchen|bar\ charley|zepp\ haneda|the\ complex|bmo\ stadium|side\ street|moda\ center|zepp\ nagoya|dirty\ habit|hibiya\ park|exchange\ la|hudson\ hill|namba\ hatch|más\ o\ menos|alex's\ bar|no\ fun\ bar|garden\ amp|space\ room|the\ cellar|little\ joy|las\ brisas|tokyo\ dome|hotel\ zoso|academy\ la|oddfellows|ball\ arena|globe\ hall|urbanguild|zepp\ namba|la\ cuevita|los\ globos|handle\ bar|kyoto\ muse|the\ state|catch\ one|kia\ forum|taku\ taku|chinatown|echostage|red\ derby|the\ fable|union\ pub|monty\ bar|the\ sound|brat\ haus|dots\ cafe|myth\ live|191\ toole|quartyard|substance|swan\ dive|r\ lounge|331\ club|waterbar|pie\ shop|the\ ford|the\ harp|glasspar|agua\ 301|al's\ den|the\ nest|the\ cave|icehouse|holocene|the\ mint|del\ rey|conpass|bullard|hanny's|dante's|hi\-dive|chi\ chi|sphere|area15|armory|lowboy|bigcat|soma|1720|oak|dc9)$/, no: /^(cygnet\ theatre,\ joan\ and\ irwin\ jacobs\ performing\ arts\ center|melrose\ trading\ post,\ fairfax\ high\ school,\ 7850\ melrose\ ave|margaret\ gisolo\ dance\ theatre\ and\ nelson\ fine\ arts\ center|california\ center\ for\ the\ arts,\ escondido,\ center\ theater|japanese\ cultural\ center\ of\ hawaiʻi,\ generations\ ballroom|hall\ of\ flame\ museum\ of\ firefighting,\ 6101\ e\ van\ buren\ st|national\ museum\ of\ african\ american\ history\ and\ culture|california\ center\ for\ the\ arts,\ escondido,\ concert\ hall|tokyo\ international\ forum\ ground\ plaza\ \&\ lobby\ gallery|sunshine\ city\ exhibition\ hall\ a,\ world\ import\ mart\ 4f|treasure\ island\ resort\ \&\ casino,\ island\ event\ center|phipps\ center\ for\ the\ arts,\ john\ h\.\ potter\ theater|ikeda\ theater,\ mesa\ arts\ center,\ 1\ e\ main\ st,\ mesa|winehaven\ winery\ \&\ vineyard,\ 10020\ deer\ garden\ ln|university\ of\ electro\-communications\ chofu\ campus|tokyo\ university\ of\ foreign\ studies,\ fuchu\ campus|crooners\ supper\ club,\ the\ belvedere\ at\ crooners|evelyn\ smith\ music\ theatre,\ asu\ music\ building|the\ old\ globe,\ sheryl\ and\ harvey\ white\ theatre|center\ theater,\ california\ center\ for\ the\ arts|uncommon\ loon\ brewing\ company,\ 10825\ lake\ blvd|lazy\ dog\ restaurant\ \&\ bar\ \-\ downtown\ summerlin|phipps\ center\ for\ the\ arts,\ black\ box\ theater|honolulu\ central\ seventh\-day\ adventist\ church|the\ old\ globe,\ lowell\ davies\ festival\ theatre|studio\ loft\ at\ the\ ellie\ caulkins\ opera\ house|desert\ botanical\ garden,\ 1201\ n\.\ galvin\ pkwy\.|sunshine\ city\ cultural\ hall\ exhibition\ hall\ d|the\ historic\ auditorium,\ 210\ n\ washington\ st|tivoli\ quad\ \/\ auraria\ campus\ \(viewing\ areas\)|concert\ hall,\ california\ center\ for\ the\ arts|natural\ history\ museum\ of\ los\ angeles\ county|hang\ 10\ bar\ \&\ grill\ at\ hilton\ waikiki\ beach|gila\ river\ hotels\ \&\ casinos\ wild\ horse\ pass|margaret\ gisolo\ dance\ theatre,\ bulldog\ hall|kaimuki\ high\ school\ performing\ arts\ center|expo\ '70\ commemorative\ park\ festival\ plaza|shaka's\ at\ hilton\ garden\ inn\ waikiki\ beach|red\ rock\ canyon\ national\ conservation\ area|mcmenamins\ edgefield\ \(winery\ tasting\ room\)|the\ san\ diego\ museum\ of\ art,\ 1450\ el\ prado|casa\ romantica\ cultural\ center\ and\ gardens|crooners\ supper\ club,\ main\ stage\ showroom|la\ jolla\ playhouse,\ mandell\ weiss\ theatre|scottsdale\ center\ for\ the\ performing\ arts|california\ center\ for\ the\ arts,\ escondido|tempe\ center\ for\ the\ arts\ \(lakeside\ room\)|caesars\ republic\ scottsdale\ –\ hotel\ lobby|live\ at\ the\ loft\ \-\ pechanga\ resort\ casino|highway\ inn\ kakaako\ \(salt\ at\ our\ kakaako\)|improv\ collective\ at\ starlight\ theater\ oc|spotlight\ showroom\ at\ spotlight\ 29\ casino|marunouchi\ building\ hall\ \(marubiru\ hall\)|king's\ highway\ at\ ace\ hotel\ palm\ springs|willow\ river\ saloon\ \/\ carbone's\ pizzeria|hitotsubashi\ university\ kunitachi\ campus|mccallum\ theatre\ for\ the\ performing\ arts|crooners\ supper\ club,\ dunsmore\ jazz\ room|chairman's\ lounge\ at\ spotlight\ 29\ casino|criss\ angel\ theater\ at\ planet\ hollywood|musical\ instrument\ museum\ music\ theater|tracy\ aviary\ nature\ center\ at\ pia\ okwai|l\.b\.l\.e\.\ lounge\ at\ hilton\ waikiki\ beach|asu\ music\ building,\ katzin\ concert\ hall|barfly\ at\ alamo\ drafthouse\ sloan's\ lake|tempe\ eats\ food\ hall,\ 85\ e\ southern\ ave|bishop\ museum,\ castle\ memorial\ building|murray's\ restaurant\ and\ cocktail\ lounge|richard\ dingle\ american\ legion\ post\ 98|charlotte\ comedy\ theater\ \(vapa\ center\)|walter\ e\.\ washington\ convention\ center|tokyo\ midtown\ hibiya\ \/\ hibiya\ district|tokyo\ photographic\ art\ museum\ 2f\ lobby|sunshine\ city\ fountain\ plaza\ \(alpa\ b1\)|sam's\ christmas\ village,\ 710\ spring\ st|laurel\ brasserie\ \&\ bar\ \(grand\ america\)|delirious\ comedy\ club\ at\ silver\ sevens|expo\ '70\ commemorative\ park\ east\ plaza|sunshine\ city\ world\ import\ mart\ hall\ a|tokyo\ international\ forum\ ground\ plaza|national\ museum\ of\ the\ american\ indian|bank\ of\ america\ performing\ arts\ center|the\ theatre\ at\ resorts\ world\ las\ vegas|newman\ center\ for\ the\ performing\ arts|alexis\ park\ resort\ \-\ pegasus\ showroom|mesa\ cemetery,\ 1212\ n\ center\ st,\ mesa|denver\ center\ for\ the\ performing\ arts|sunshine\ city\ exhibition\ halls\ a\ \&\ b|kani\ ka\ pila\ grille\ \(outrigger\ reef\)|helen\ bonfils\ theatre\ complex\ \(dcpa\)|dave\ \&\ buster's\ at\ tempe\ marketplace|copa\ room\ at\ tuscany\ suites\ \&\ casino|clarice\ smith\ performing\ arts\ center|billboard\ live\ tokyo\ \(tokyo\ midtown\)|postino\ east,\ 302\ n\ gilbert\ rd\ \#102|united\ nations\ university\ courtyard|mystic\ lake\ casino,\ mystic\ showroom|chrome\ showroom\ at\ santa\ fe\ station|portland\ center\ stage\ at\ the\ armory|symbol\ promenade\ park\ central\ plaza|fire\ on\ the\ mountain\ \(n\ interstate\)|outrigger\ reef\ waikiki\ beach\ resort|railgiants\ train\ museum\ at\ fairplex|national\ museum\ of\ american\ history|university\ of\ tokyo\ komaba\ i\ campus|mesa\ arts\ center,\ 1\ e\ main\ st,\ mesa|kennedy\ school\ courtyard\ restaurant|tapa\ bar\ at\ hilton\ hawaiian\ village|mon\ takanawa,\ takanawa\ gateway\ city|patricia\ reser\ center\ for\ the\ arts|hilton\ hawaiian\ village\ beachfront|laugh\ camp\ comedy\ club\ at\ camp\ bar|dynasty\ typewriter\ at\ the\ hayworth|the\ century\ room\ at\ hotel\ congress|rachel\ m\.\ schlesinger\ concert\ hall|coffman\ memorial\ union,\ great\ hall|masonic\ lodge\ at\ hollywood\ forever|aloha\ dance\ sport,\ 350\ ward\ avenue|portland\ art\ museum,\ mark\ building|rose\ wagner\ performing\ arts\ center|westgate\ las\ vegas\ resort\ \&\ casino|big\ guys\ bbq\ roadhouse,\ 1237\ wi\-35|royal\ hawaiian\ center,\ royal\ grove|miller\ hall,\ world\ forestry\ center|national\ museum\ of\ natural\ history|snakes\ \&\ lattes\ tempe,\ 20\ w\ 6th\ st|the\ hangar\ at\ long\ beach\ exchange|hank's\ oyster\ bar\ \(dupont\ circle\)|wells\ fargo\ playhouse\ at\ imaginon|mccoll\ family\ theatre\ at\ imaginon|fire\ on\ the\ mountain\ \(e\ burnside\)|academy\ museum\ of\ motion\ pictures|melancholy\ wine\ \&\ cocktail\ lounge|gaslight\ music\ hall\ of\ oro\ valley|the\ living\ desert\ zoo\ and\ gardens|autry\ museum\ of\ the\ american\ west|mediterranean\ exploration\ company|loo\ theatre,\ chaminade\ university|smorgasburg\ los\ angeles,\ row\ dtla|mid\-valley\ performing\ arts\ center|denver\ museum\ of\ nature\ \&\ science|tsurutontan\ udon\ noodle\ brasserie|heritage\ museum\ of\ orange\ county|house\ without\ a\ key\ \(halekulani\)|the\ show\ at\ agua\ caliente\ casino|mesa\ arts\ center\ \(ikeda\ theater\)|the\ mabel\ tainter,\ 205\ main\ st\ e|tokyo\ international\ forum\ hall\ c|tokyo\ international\ forum\ hall\ a|disney\ california\ adventure\ park|arthur\ o\.\ haukland\ vfw\ post\ 1350|uptown\ tavern\ \/\ rich's\ san\ diego|encore\ theater\ at\ wynn\ las\ vegas|ucr\ arts\ building\ studio\ theatre|san\ diego\ natural\ history\ museum|saxe\ theater\ at\ planet\ hollywood|denver\ beer\ co\.\ olde\ town\ arvada|museums\ \&\ galleries\ across\ tokyo|simi\ valley\ cultural\ arts\ center|asu\ music\ building,\ recital\ hall|maracas\ mexican\ cantina\ \&\ grill|the\ railhead\ at\ boulder\ station|otori\ shrine\ \&\ chokokuji\ temple|mckinley\ high\ school\ auditorium|evelyn\ smith\ music\ theatre,\ asu|kamishichiken\ kaburenjo\ theatre|the\ copa\ room\ at\ the\ bootlegger|bloomington\ center\ for\ the\ arts|sunshine\ city\ exhibition\ hall\ d|this\ is\ the\ place\ heritage\ park|rocks\ lounge\ at\ red\ rock\ resort|the\ chelsea\ at\ the\ cosmopolitan|smithsonian\ american\ art\ museum|the\ colosseum\ at\ caesars\ palace|columbus\ adult\ education\ center|belmont\ park,\ 3146\ mission\ blvd|kaimuki\ performing\ arts\ center|segerstrom\ center\ for\ the\ arts|shinjuku\ gyoen\ national\ garden|phoenix\ zoo,\ 455\ n\ galvin\ pkwy|alohilani\ resort\ waikiki\ beach|fire\ on\ the\ mountain\ \(ne\ 57th\)|the\ united\ theater\ on\ broadway|yucaipa\ performing\ arts\ center|osaka\ city\ central\ public\ hall|the\ cheesecake\ factory\ arcadia|the\ music\ center\ at\ strathmore|natural\ history\ museum\ of\ utah|national\ museum\ of\ african\ art|blaisdell\ center\ hawaii\ suites|nevada\ state\ museum,\ las\ vegas|pet\ supplies\ plus,\ yorba\ linda|blind\ dog\ restaurant\ \&\ raw\ bar|salt\ at\ our\ kakaako\ \(the\ barn\)|garner\ galleria\ theatre\ \(dcpa\)|neal\ s\.\ blaisdell\ concert\ hall|samadhi\ hawaii\ \(330\ cooke\ st\.\)|salt\ at\ our\ kakaʻako,\ the\ barn|the\ comedy\ club\ at\ duckworth's|asu\ organ\ hall,\ music\ building|sea\ life\ park,\ beach\ boy\ lānai|hank's\ oyster\ bar\ \(the\ wharf\)|gallery\ aamo,\ tokyo\ dome\ city|agua\ caliente\ cultural\ museum|bechtler\ museum\ of\ modern\ art|mancini's\ char\ house\ \&\ lounge|lake\ elsinore\ diamond\ stadium|v\ theater\ at\ planet\ hollywood|teleferic\ barcelona\ brentwood|arlene\ schnitzer\ concert\ hall|ark\ karajan\ square,\ ark\ hills|todaiji\ hawaii\ bekkaku\ honzan|wiseguys\ comedy\ –\ town\ square|north\ coast\ repertory\ theatre|newport\ beach\ central\ library|tivoli\ quad\ at\ auraria\ campus|denver\ beer\ co\.\ south\ downing|wiseguys\ comedy\ \(the\ gateway\)|daniel\ stowe\ botanical\ garden|moreland\ presbyterian\ church|bishop\ museum,\ hawaiian\ hall|everett\ mcclay\ vfw\ post\ 1296|san\ bernardino\ county\ museum|chandler\ center\ for\ the\ arts|national\ museum\ of\ asian\ art|palm\ springs\ cultural\ center|first\ street\ pool\ \&\ billiard|38\ degrees\ ale\ house\ \&\ grill|pearl\ harbor\ aviation\ museum|mohri\ garden,\ roppongi\ hills|discovery\ cube\ orange\ county|bob\ baker\ marionette\ theatre|las\ vegas\ convention\ center|the\ old\ globe,\ shiley\ stage|nocturne\ jazz\ \&\ supper\ club|tabernacle\ on\ temple\ square|hawaii's\ plantation\ village|wiseguys\ comedy\ town\ square|myron's\ at\ the\ smith\ center|san\ diego\ automotive\ museum|bugsy's\ cabaret\ at\ flamingo|the\ hook\ and\ ladder\ theater|mission\ san\ juan\ capistrano|first\ congregational\ church|komazawa\ olympic\ park\ plaza|president\ lincoln's\ cottage|lutheran\ church\ of\ honolulu|artemus\ w\.\ ham\ concert\ hall|market\ city\ shopping\ center|cherry\ cricket\ cherry\ creek|pam\ cut's\ tomorrow\ theater|balla\ italian\ soul,\ sahara|legoland\ california\ resort|anacostia\ community\ museum|casa\ oliver\ hotel\ \&\ resort|laugh\ factory\ at\ horseshoe|smorgasburg\ la\ at\ row\ dtla|long\ beach\ terrace\ theater|palm\ springs\ downtown\ park|world\ trade\ center\ theatre|minneapolis\ mah\ jongg\ club|soboba\ resort\ event\ center|grand\ cube\ osaka\ main\ hall|fox\ performing\ arts\ center|vip\ nightclub\ \&\ restaurant|colorado\ convention\ center|jimmy\ kimmel's\ comedy\ club|brad\ garrett's\ comedy\ club|m\.\ james\ gleason\ boat\ ramp|libby\ gardner\ concert\ hall|laguna\ niguel\ parade\ route|plaza\ theatre\ palm\ springs|ellie\ caulkins\ opera\ house|100\ sails\ restaurant\ \&\ bar|folger\ shakespeare\ library|joshua\ tree\ retreat\ center|koishikawa\ korakuen\ garden|mountain\ sun\ pub\ \&\ brewery|yurakucho\ marui\ 8f\ space5|the\ cedar\ cultural\ center|tempe\ center\ for\ the\ arts|the\ green\ room\ on\ ventura|forest\ lake\ vfw\ post\ 4210|artists\ repertory\ theatre|tapestry\ folkdance\ center|yomiuriland\ \&\ hana\ biyori|worldbeat\ cultural\ center|ocean\ prime\ beverly\ hills|shinjuku\ gyoen\ greenhouse|dave\ \&\ buster's\ ala\ moana|stillwater\ public\ library|craig\ ranch\ regional\ park|san\ diego\ zoo\ safari\ park|hawaiʻi\ convention\ center|namja\ town,\ sunshine\ city|the\ firehouse\ joshua\ tree|mcmenamins\ kennedy\ school|shimokitazawa\ basementbar|comedy\ corner\ underground|the\ comedy\ store\ la\ jolla|the\ canyon\ \-\ agoura\ hills|linda\ ronstadt\ music\ hall|cherry\ cricket\ \(ballpark\)|smithsonian\ national\ zoo|wagyu\ shokudo\ waigaya\[s\]|the\ ebell\ of\ los\ angeles|san\ diego\ history\ center|wonderlove\ food\ cart\ pod|66\ plaza,\ roppongi\ hills|ponderosa\ lounge\ \&\ grill|jj\ collins\ memorial\ park|pioneer\ memorial\ theatre|roppongi\ keyakizaka\-dori|stoney's\ rockin'\ country|utah\ museum\ of\ fine\ arts|singleton\ theatre\ \(dcpa\)|gloria\ molina\ grand\ park|herberger\ theater\ center|tokyo\ skytree\ tembo\ deck|walt\ disney\ concert\ hall|phantom\ projects\ theatre|dancing\ dragonfly\ winery|blue\ moon\ tavern\ \&\ grill|national\ western\ complex|kennedy\ school\ gymnasium|cain\ center\ for\ the\ arts|revolution\ stage\ company|salt\ lake\ acting\ company|beer\ lab\ hi\ puck's\ alley|honmachi\ sakaba\ fukuriki|ōkubo\ park\ special\ venue|the\ american\ comedy\ co\.|gmu\ center\ for\ the\ arts|purple\ room\ supper\ club|crystal\ city\ sports\ pub|desert\ botanical\ garden|s\.\ dillon\ ripley\ center|hard\ rock\ cafe\ honolulu|regent\ street\ black\ box|koenji\ shopping\ streets|dented\ brick\ distillery|the\ grand\ america\ hotel|kyoto\ kanze\ noh\ theater|san\ diego\ civic\ theatre|yushima\ tenmangu\ shrine|breakside\ brewery\ dekum|discovery\ place\ science|palm\ springs\ art\ museum|hapa\ sushi\ cherry\ creek|kilstrom\ theatre\ \(dcpa\)|four\ mile\ historic\ park|green\ street\ restaurant|sports\ page\ bar\ \&\ grill|tommy\ bahama\ marlin\ bar|port\ of\ camas\-washougal|american\ legion\ post\ 39|st\.\ johns\ theater\ \&\ pub|hopkins\ brewing\ company|oyster\ bar\ south\ jordan|palm\ springs\ air\ museum|cherry\ cricket\ downtown|yomiuriland\ fureai\ lawn|life\ of\ pie\ \(williams\)|oc\ fair\ \&\ event\ center|blaisdell\ concert\ hall|ʻiolani\ palace\ grounds|boettcher\ concert\ hall|edina\ community\ center|st\.\ helens\ public\ dock|national\ postal\ museum|curious\ comedy\ theater|the\ pico\ union\ project|wood\ ranch\ bbq\ \&\ grill|old\ st\.\ francis\ school|denver\ botanic\ gardens|lamb's\ players\ theatre|heritage\ square\ museum|the\ fitzgerald\ theater|ura\ namba\ sakana\ ebisu|kaimuki\ public\ library|kitano\ tenmangu\ shrine|bunkamura\ orchard\ hall|irvine\ barclay\ theatre|lewis\ family\ playhouse|golden\ nugget\ showroom|sesame\ place\ san\ diego|harvey\ b\.\ gantt\ center|mandell\ weiss\ theatre|south\ coast\ repertory|takanawa\ gateway\ city|stand\ up\ live\ phoenix|lawry's\ the\ prime\ rib|clyfford\ still\ museum|lan\ su\ chinese\ garden|matchbox\ barracks\ row|barrio\ queen\ old\ town|denver\ beer\ co\.\ lowry|dar\ constitution\ hall|comedy\ works\ downtown|the\ comedy\ loft\ of\ dc|wally's\ desert\ turtle|blue\ note\ los\ angeles|komazawa\ olympic\ park|ted\ mann\ concert\ hall|petersen\ house\ museum|kiwanis\ park\ and\ lake|royal\ hawaiian\ center|westin\ edina\ galleria|snakes\ \&\ lattes\ tempe|life\ of\ pie\ \(nw\ 23rd\)|mix\ up\ on\ the\ hilltop|clyde's\ of\ georgetown|503\ distilling\ lounge|higashi\-koenji\ 20000v|soboba\ cabaret\ lounge|ucb\ theatre\ franklin|highway\ inn\ kaka'ako|denver\ comedy\ lounge|diversionary\ theatre|south\ point\ showroom|hunters\ palm\ springs|salt\ at\ our\ kakaʻako|kyu\-furukawa\ gardens|p\.f\.\ chang's\ waikiki|mint\ museum\ randolph|thunder\ burger\ \&\ bar|largo\ at\ the\ coronet|tempe\ history\ museum|gertie's\ salon\ \&\ bar|hamarikyu\ asahi\ hall|diamond\ head\ theatre|billboard\ live\ osaka|the\ venetian\ theatre|marunouchi\ naka\-dori|2220\ arts\ \+\ archives|the\ minneapolis\ club|ne\ moose\ bar\ \&\ grill|town\ hall\ provisions|mccabe's\ guitar\ shop|alberta\ rose\ theatre|comedy\ cellar\ at\ rio|benihana\ santa\ anita|dudley\ riggs\ theatre|the\ carolina\ theatre|manoa\ valley\ theatre|stoney's\ north\ forty|flex\ cocktail\ lounge|jazzyblu\ supper\ club|kiyomizu\-dera\ temple|papa\ haydn\ northwest|queen\ kapiolani\ park|buck\ \&\ rider\ phoenix|the\ gaslight\ theatre|ala\ moana\ beach\ park|the\ granada\ theatre|cornelius\ town\ hall|diesel,\ a\ bookstore|the\ parkway\ theater|shin\-okubo\ earthdom|house\ of\ comedy\ moa|new\ deal\ distillery|ordway\ concert\ hall|kiwanis\ park,\ tempe|social\ dance\ studio|honolulu\ burger\ co\.|namba\ grand\ kagetsu|wolf\ theatre\ \(dcpa\)|big\ bear\ alpine\ zoo|nellie's\ sports\ bar|casino\ san\ clemente|legoland\ california|portland\ art\ museum|hale\ centre\ theatre|jo\ bar\ \(papa\ haydn\)|winningstad\ theatre|armored\ cow\ brewing|route\ 65\ pub\ \&\ grub|merriman's\ honolulu|the\ hog\ wallow\ pub|thanksgiving\ point|koko\ marina\ center|helium\ comedy\ club|the\ enchanted\ barn|in\ sheeps\ clothing|kumu\ kahua\ theatre|lion's\ lair\ lounge|ucla\ nimoy\ theater|vibrato\ grill\ jazz|the\ comedy\ chateau|hama\-rikyu\ gardens|mint\ museum\ uptown|knott's\ berry\ farm|victoria\ ward\ park|koami\-jinja\ shrine|midosuji\ boulevard|tim\ ho\ wan\ waikiki|the\ swanee\ theatre|spangalang\ brewery|stage\ door\ theater|seaworld\ san\ diego|alberta\ street\ pub|catalina\ jazz\ club|comedy\ works\ south|the\ milestone\ club|tokyo\ prince\ hotel|fox\ tucson\ theatre|the\ ecology\ center|pasadena\ playhouse|dynasty\ typewriter|mama\ mia\ trattoria|swallow\ hill\ music|lifehouse\ theater|paramount\ theatre|laguna\ art\ museum|grant\ street\ pier|denver\ art\ museum|uahi\ island\ grill|mim\ music\ theater|theatre\ charlotte|the\ hamilton\ live|lisner\ auditorium|riverplace\ marina|granville\ moore's|mississippi\ pizza|roppongi\ district|arlington\ theatre|wet'n'wild\ hawaii|keller\ auditorium|starlight\ on\ 22nd|uss\ midway\ museum|nine\ mile\ brewing|jack\ london\ revue|kabuki\-za\ theatre|disneyland\ resort|smitty's\ taphouse|pearlridge\ center|ucb\ theatre\ annex|southpark\ seafood|orange\ county\ zoo|pioneertown\ motel|celebrity\ theatre|dana\ point\ harbor|piranha\ nightclub|civic\ center\ park|walker\ art\ center|lowry\ beer\ garden|noi\ thai\ cuisine|assembly\ brewing|descanso\ gardens|open\ eye\ theatre|geffen\ playhouse|the\ smith\ center|sisyphus\ brewing|mesa\ arts\ center|the\ baked\ potato|sidetrack\ saloon|springs\ preserve|yaamava'\ theater|ovens\ auditorium|mccallum\ theatre|pechanga\ theater|ala\ moana\ center|blaisdell\ center|pantages\ theatre|egyptian\ theatre|hirshhorn\ museum|laguna\ playhouse|kickstand\ comedy|orleans\ showroom|rich's\ san\ diego|byu\ concert\ hall|blue\ note\ hawaii|wiseguys\ gateway|the\ evening\ muse|hapa\ sushi\ lodo|orpheum\ theatre|holiday\ theater|brunish\ theatre|bowles\ burritos|renwick\ gallery|kalakaua\ avenue|nakano\ moonstep|schooner\ tavern|pershing\ square|bamboo\ sushi\ nw|ka\ makana\ aliʻi|live\ house\ nano|bamboo\ sushi\ ne|gibroni's\ pizza|capitol\ theatre|thornton\ winery|lincoln\ theatre|bamboo\ sushi\ se|los\ angeles\ zoo|benihana\ encino|redfish\ waikiki|tokyo\ dome\ city|the\ coach\ house|rikugien\ garden|barley\ mill\ pub|booth\ playhouse|peacock\ theater|the\ neon\ museum|bluewater\ grill|moonshine\ beach|coastal\ kitchen|sheldon\ theatre|hanazono\ shrine|bamboo\ sushi\ sw|sgc\ hall\ ariake|blue\ note\ tokyo|the\ template\ ob|acme\ comedy\ co\.|mission\ theater|the\ comedy\ zone|orpheum\ theater|guard\ and\ grace|osaka\ city\ hall|aladdin\ theater|browning\ center|kennedy\ theatre|newmark\ theatre|meldrum\ theatre|harrah's\ casino|the\ spare\ room|the\ huntington|balboa\ theatre|kennedy\ school|caesars\ palace|woolly\ mammoth|wiseguys\ ogden|palace\ theatre|kingsbury\ hall|elitch\ gardens|santan\ gardens|greater\ trumps|wild\ corgi\ pub|eccles\ theater|abravanel\ hall|ʻiolani\ palace|the\ old\ church|redcat\ theater|lobero\ theatre|studio\ theatre|capitol\ modern|halton\ theater|knight\ theater|bellco\ theatre|chance\ theater|kabeltop\ games|orchestra\ hall|hawaii\ theatre|ontario\ improv|roxy's\ cabaret|warner\ theatre|ford's\ theatre|the\ mob\ museum|sensoji\ temple|dolby\ theatre|middle\ c\ jazz|grammy\ museum|tam\ o'shanter|san\ diego\ zoo|klein\ theatre|53\ by\ the\ sea|kaiser\ grille|the\ rib\ joint|union\ station|arvada\ center|festival\ hall|atomic\ museum|bishop\ museum|optimist\ hall|irvine\ improv|temple\ square|stand\ up\ live|zojoji\ temple|loft\/plus\ one|krazy\ kooters|sticky\ wicket|symphony\ hall|alberta\ abbey|corona\ improv|schnepf\ farms|bowers\ museum|waimea\ valley|buell\ theatre|state\ theatre|broadway\ pub|ward\ village|crudo\ e\ nudo|the\ oaks\ pub|jake's\ grill|getty\ center|heard\ museum|the\ hamilton|vegas\ lounge|wang\ chung's|belmont\ park|ucb\ franklin|belk\ theater|tempe\ improv|fogo\ de\ chao|honolulu\ zoo|okazaki\ park|koenji\ cave|blues\ alley|logan\ lodge|uchi\ denver|phoenix\ zoo|number\ nine|yomiuriland|boozehounds|leluia\ hall|asu\ gammage|smoke\ house|jammin\ java|cotton\ club|tommy's\ pub|brea\ improv|the\ sardine|harman\ hall|ccbc\ resort|arena\ stage|commissary|tavernetta|honey\ salt|fiola\ mare|denver\ zoo|etown\ hall|oregon\ zoo|hal's\ cafe|the\ mix\ up|halekulani|jacqueline|taco\ guild|clarklewis|chapel\ pub|the\ soraya|the\ noorda|bar\ à\ vin|the\ broad|carowinds|stage\ red|dc\ improv|steuben's|menagerie|notoriety|kbxtreme|camp\ bar|the\ sink|hau\ tree|jr's\ bar|1029\ bar|barbette|wave808|maestro|et\ al\.|palate|dakota|kachka|redcat|dazzle|quadz|largo|rioja|umoca|omsi)$/};

 /* Concert venues checked Oct 25 2026 (Google + Reddit crowd reports, Jamie's Chrome). 2 = social room, any evening;
    1 = fine on Fri/Sat nights only (show-dependent, mixed ages); -1 = never (older 50+, teen/all-ages, arena-size, or poor crowd reports).
    Concert venues not listed here no longer count on their own in SoCal + Twin Cities (music fests and "Wingman" tags still do). */
 var WS_MUSIC = [
  [/\bbelly up\b/, 2], [/\bwinstons\b/, 2], [/\bholding company\b/, 2], [/\bthe casbah\b/, 2], [/^the harp\b/, 2], [/\bel cid\b/, 2],
  [/\bgaslamp\b.*long beach|^gaslamp long beach/, 2], [/\bturf club\b/, 2], [/\bthe wayfarer\b/, 2], [/\bpappy (&|and) harriets\b/, 2],
  [/\bmusic box\b/, 1], [/\bobservatory north park\b/, 1], [/^the sound\b/, 1], [/\bhouse of blues san diego\b/, 1],
  [/^the echo\b/, 1], [/\bechoplex\b/, 1], [/\bmoroccan lounge\b/, 1], [/\bteragram\b/, 1], [/\bthe bellwether\b/, 1], [/\blodge room\b/, 1],
  [/\bpacific electric\b/, 1], [/\bthe wiltern\b/, 1], [/\bhollywood palladium\b/, 1], [/\bzebulon\b/, 1], [/\bgold diggers\b/, 1], [/\breframe studios\b/, 1],
  [/\bfine line\b/, 1], [/\bfirst avenue\b/, 1], [/\b7th st(reet)? entry\b/, 1], [/\bfillmore minneapolis\b/, 1], [/^icehouse\b/, 1], [/\bcabooze\b/, 1], [/^the green room\b/, 1],
  [/\bconstellation room\b/, 1], [/^the observatory\b(?! north park)/, 1], [/\btime nightclub\b/, 1], [/\bconcert lounge\b/, 1],
  [/\bhumphreys\b/, -1], [/^soma\b/, -1], [/^armory\b|\bthe armory\b/, -1], [/\bhouse of blues anaheim\b/, -1], [/\bthe glass house\b/, -1], [/^berlin\b/, -1]
 ];
 /* Oct 26 2026: concert venues for the destination guides, rated the same way (2 any evening, 1 Fri/Sat nights only,
    -1 never). From the Oct 26 research pass; seated halls, jazz supper clubs, arenas, amphitheaters and all-ages
    rooms are -1. Venues not listed don't count on their own. Matched only within that guide's region. */
 var WS_MUSIC_DEST = {
  "Las Vegas": [[/^(the )?bleaulive theater at fontainebleau\b/, -1], [/^(the )?theater at virgin hotels las vegas\b/, 1], [/^(the )?theatre at resorts world las vegas\b/, -1], [/^(the )?encore theater at wynn las vegas\b/, -1], [/^(the )?colosseum at caesars palace\b/, -1], [/^(the )?ph live at planet hollywood\b/, -1], [/^(the )?myrons at the smith center\b/, -1], [/^(the )?house of blues las vegas\b/, 1], [/^(the )?brooklyn bowl las vegas\b/, -1], [/^(the )?golden nugget showroom\b/, -1], [/^(the )?mgm grand garden arena\b/, -1], [/^(the )?dolby live at park mgm\b/, -1], [/^(the )?hakkasan at mgm grand\b/, -1], [/^(the )?pearl concert theater\b/, -1], [/^(the )?sand dollar lounge\b/, 2], [/^(the )?double down saloon\b/, 1], [/^(the )?marquee nightclub\b/, -1], [/^(the )?piranha nightclub\b/, 1], [/^(the )?venetian theatre\b/, -1], [/^(the )?omnia nightclub\b/, -1], [/^(the )?marquee dayclub\b/, -1], [/^(the )?zouk nightclub\b/, -1], [/^(the )?liv las vegas\b/, -1], [/^(the )?tao nightclub\b/, -1], [/^(the )?we all scream\b/, 1], [/^(the )?xs nightclub\b/, -1], [/^(the )?swan dive\b/, 1], [/^(the )?griffin\b/, 1], [/^(the )?sphere\b/, -1], [/^(the )?area15\b/, 1]],
  "Charlotte": [[/^(the )?charlotte metro credit union amphitheatre\b/, -1], [/^(the )?skyla credit union amphitheatre\b/, -1], [/^(the )?neighborhood theatre tap room\b/, 1], [/^(the )?cain center for the arts\b/, -1], [/^(the )?truliant amphitheater\b/, -1], [/^(the )?neighborhood theatre\b/, 1], [/^(the )?boatyard lake norman\b/, 2], [/^(the )?fillmore charlotte\b/, 1], [/^(the )?bojangles coliseum\b/, -1], [/^(the )?ovens auditorium\b/, -1], [/^(the )?visulite theatre\b/, 1], [/^(the )?spectrum center\b/, -1], [/^(the )?knight theater\b/, -1], [/^(the )?swanee theatre\b/, -1], [/^(the )?milestone club\b/, 1], [/^(the )?middle c jazz\b/, -1], [/^(the )?amos southend\b/, 1], [/^(the )?evening muse\b/, -1], [/^(the )?belk theater\b/, -1], [/^(the )?underground\b/, 1], [/^(the )?snug harbor\b/, 2], [/^(the )?coyote joes\b/, -1], [/^(the )?petras\b/, 2]],
  "Denver": [[/^(the )?cervantes masterpiece ballroom\b/, 1], [/^(the )?meow wolf convergence station\b/, -1], [/^(the )?nocturne jazz & supper club\b/, -1], [/^(the )?ophelias electric soapbox\b/, 1], [/^(the )?boettcher concert hall\b/, -1], [/^(the )?red rocks amphitheatre\b/, -1], [/^(the )?cervantes other side\b/, 1], [/^(the )?fillmore auditorium\b/, 1], [/^(the )?swallow hill music\b/, -1], [/^(the )?summit music hall\b/, -1], [/^(the )?paramount theatre\b/, -1], [/^(the )?velvet elk lounge\b/, 2], [/^(the )?bluebird theater\b/, 1], [/^(the )?mission ballroom\b/, 1], [/^(the )?lost lake lounge\b/, 1], [/^(the )?marquis theater\b/, -1], [/^(the )?boulder theater\b/, 1], [/^(the )?gothic theatre\b/, 1], [/^(the )?larimer lounge\b/, 1], [/^(the )?ogden theatre\b/, 1], [/^(the )?aggie theatre\b/, 1], [/^(the )?fox theatre\b/, 1], [/^(the )?washingtons\b/, 1], [/^(the )?globe hall\b/, 1], [/^(the )?ball arena\b/, -1], [/^(the )?etown hall\b/, -1], [/^(the )?hi-dive\b/, 1], [/^(the )?dazzle\b/, -1]],
  "Honolulu": [[/^(the )?tom moffatt waikiki shell\b/, -1], [/^(the )?blaisdell concert hall\b/, -1], [/^(the )?royal hawaiian center\b/, -1], [/^(the )?house without a key\b/, -1], [/^(the )?blue note hawaii\b/, -1], [/^(the )?blaisdell arena\b/, -1], [/^(the )?hawaii theatre\b/, -1], [/^(the )?dukes waikiki\b/, -1], [/^(the )?republik\b/, 1], [/^(the )?nextdoor\b/, 1]],
  "Washington DC": [[/^(the )?music center at strathmore\b/, -1], [/^(the )?merriweather post pavilion\b/, -1], [/^(the )?pearl street warehouse\b/, 1], [/^(the )?fillmore silver spring\b/, 1], [/^(the )?songbyrd music house\b/, 1], [/^(the )?lisner auditorium\b/, -1], [/^(the )?capital one arena\b/, -1], [/^(the )?lincoln theatre\b/, -1], [/^(the )?jiffy lube live\b/, -1], [/^(the )?howard theatre\b/, 1], [/^(the )?warner theatre\b/, -1], [/^(the )?hamilton live\b/, -1], [/^(the )?blues alley\b/, -1], [/^(the )?jammin java\b/, -1], [/^(the )?union stage\b/, 1], [/^(the )?9:30 club\b/, -1], [/^(the )?echostage\b/, -1], [/^(the )?black cat\b/, -1], [/^(the )?atlantis\b/, 1], [/^(the )?pie shop\b/, 1], [/^(the )?anthem\b/, 1], [/^(the )?dc9\b/, -1]],
  "Salt Lake City": [[/^(the )?utah first credit union amphitheatre\b/, -1], [/^(the )?rose wagner performing arts center\b/, -1], [/^(the )?union event center\b/, -1], [/^(the )?commonwealth room\b/, 1], [/^(the )?metro music hall\b/, 1], [/^(the )?egyptian theatre\b/, -1], [/^(the )?abravanel hall\b/, -1], [/^(the )?eccles theater\b/, -1], [/^(the )?maverik center\b/, -1], [/^(the )?kingsbury hall\b/, -1], [/^(the )?urban lounge\b/, 2], [/^(the )?delta center\b/, -1], [/^(the )?kilby court\b/, -1], [/^(the )?state room\b/, 1], [/^(the )?soundwell\b/, 1], [/^(the )?complex\b/, -1], [/^(the )?depot\b/, 1]],
  "Portland": [[/^(the )?arlene schnitzer concert hall\b/, -1], [/^(the )?show bar at revolution hall\b/, 2], [/^(the )?veterans memorial coliseum\b/, -1], [/^(the )?alberta rose theatre\b/, -1], [/^(the )?mcmenamins edgefield\b/, -1], [/^(the )?mississippi studios\b/, 2], [/^(the )?white eagle saloon\b/, 1], [/^(the )?jack london revue\b/, -1], [/^(the )?keller auditorium\b/, -1], [/^(the )?crystal ballroom\b/, 1], [/^(the )?roseland theater\b/, 1], [/^(the )?aladdin theater\b/, -1], [/^(the )?revolution hall\b/, 1], [/^(the )?wonder ballroom\b/, 1], [/^(the )?mission theater\b/, -1], [/^(the )?doug fir lounge\b/, 1], [/^(the )?polaris hall\b/, 1], [/^(the )?star theater\b/, 1], [/^(the )?moda center\b/, -1], [/^(the )?holocene\b/, 2], [/^(the )?als den\b/, 1]],
  "Phoenix": [[/^(the )?scottsdale center for the performing arts\b/, -1], [/^(the )?century room at hotel congress\b/, -1], [/^(the )?chandler center for the arts\b/, -1], [/^(the )?arizona financial theatre\b/, -1], [/^(the )?linda ronstadt music hall\b/, -1], [/^(the )?tempe center for the arts\b/, -1], [/^(the )?desert diamond arena\b/, -1], [/^(the )?fox tucson theatre\b/, -1], [/^(the )?crescent ballroom\b/, 2], [/^(the )?mim music theater\b/, -1], [/^(the )?celebrity theatre\b/, -1], [/^(the )?mesa arts center\b/, -1], [/^(the )?marquee theatre\b/, 1], [/^(the )?orpheum theater\b/, -1], [/^(the )?yucca tap room\b/, 2], [/^(the )?rialto theatre\b/, 1], [/^(the )?walter studios\b/, 1], [/^(the )?last exit live\b/, 1], [/^(the )?club congress\b/, 1], [/^(the )?symphony hall\b/, -1], [/^(the )?rebel lounge\b/, 1], [/^(the )?nile theater\b/, -1], [/^(the )?underground\b/, -1], [/^(the )?valley bar\b/, 2], [/^(the )?van buren\b/, 1], [/^(the )?191 toole\b/, 1]],
  "Tokyo": [[/^(the )?tokyo international forum hall a\b/, -1], [/^(the )?shimokitazawa basementbar\b/, 1], [/^(the )?billboard live tokyo\b/, -1], [/^(the )?shibuya club quattro\b/, 1], [/^(the )?hamarikyu asahi hall\b/, -1], [/^(the )?shinsaibashi sunhall\b/, 1], [/^(the )?umeda club quattro\b/, 1], [/^(the )?blue note tokyo\b/, -1], [/^(the )?nakano moonstep\b/, 1], [/^(the )?spotify o-east\b/, -1], [/^(the )?shibuya www x\b/, -1], [/^(the )?shinjuku loft\b/, 1], [/^(the )?cotton club\b/, -1], [/^(the )?shibuya www\b/, 1], [/^(the )?tokyo dome\b/, -1], [/^(the )?urbanguild\b/, 1], [/^(the )?kyoto muse\b/, 1], [/^(the )?bigcat\b/, 1]],
 };
 WS_MUSIC_DEST.Arizona = WS_MUSIC_DEST.Tempe = WS_MUSIC_DEST.Phoenix; WS_MUSIC_DEST.Japan = WS_MUSIC_DEST.Tokyo;
 var WS_KIT = null;
 function wsKit() {
  if (WS_KIT) return WS_KIT;
  var raw = window.OB_WING_SPOTS || [], list = [];
  raw.forEach(function(s) {
   var rx = null;
   if (s.m && !s.verify) try { rx = new RegExp(s.m) } catch (e) { rx = null }
   list.push({n: s.n, v: s.v, d: s.d, regions: s.regions || [], rx: rx})
  });
  WS_KIT = {
   list: list,
   cover: /^(Twin Cities|San Diego|North County|Orange County|Los Angeles|Los Angeles \/ Long Beach|Inland Empire|Inland \/ Desert|Palm Springs \+ Joshua Tree|Las Vegas|Charlotte|Denver|Honolulu|Washington DC|Salt Lake City|Portland|Phoenix|Arizona|Tempe|Tokyo|Japan|St\. Pete)$/,
   singles: /\b(speed[- ]?dating|pitch[- ]?a[- ]?friend|matchmak\w*|singles (night|nights|event|events|mixer|social|party|trivia|pickleball|meetup|meet-up|happy hour|mingle|bowling|game night|hike|run|dance|travel trivia)|for singles|singles,? ages|singles \d\d|\d\d\s?(-|–|to)\s?\d\d singles|dating (event|game|night)|lock (and|&) key party)\b/,
   notSingles: /\b(single malt|tennis|singles (title|final|finals|match|tournament|draw|bracket|chart|charts|league)|pickleball (singles|tournament|league))\b/,
   musicRate: function(v, reg) {
    var L = WS_MUSIC_DEST[reg] || WS_MUSIC;
    for (var i = 0; i < L.length; i++) if (L[i][0].test(v)) return L[i][1];
    return 0
   },
   social: /\b(block party|street party|pool party|day party|bar crawl|pub crawl|beer (fest|festival)|brewfest|wine (fest|festival|walk)|oktoberfest|mixer|silent disco|halloween (party|bash)|costume party)\b/
  };
  return WS_KIT
 }
 function nightPrep(o, tagsArr) {
  var T = String(o.title || "").toLowerCase(),
   D = String(o.desc || "").toLowerCase(),
   tl = (tagsArr || []).map(function(x) {
    return String(x || "").trim().toLowerCase()
   }),
   G = tl.join(" | "),
   P = (String(o.place || "") + " " + String(o.hood || "")).toLowerCase(),
   c = o.cat || "",
   tg = function(rx) {
    return tl.some(function(x) {
     return rx.test(x)
    })
   },
   h = hourOf(o.s),
   he = o.hasEnd ? hourOf(o.e) : -1,
   evening = !o.all_day && (h >= 16 || h < 4) || he >= 19 || /\b(night|nite|after dark|late night|tonight|evening|pm)\b/.test(T),
   isMusic = c === "Concert" || c === "Nightlife" || c === "Dance" || tg(NX.musicTag) || NX.musicTitle.test(T) || c === "Festival" && (/music|concert|reggae|jazz|rock|blues|edm|hip hop/.test(T + " " + G)),
   isComedy = c === "Comedy" || tg(/stand-?up|comedy/) || NX.comedy.test(T),
   isMic = c === "Karaoke" || tg(/^(karaoke|open mic|jam)$/) || NX.mic.test(T) || NX.mic.test(D.slice(0, 240)),
   isTrivia = c === "Trivia" || c === "Games" || NX.trivia.test(T),
   barish = NX.bar.test(P) || NX.bar.test(G) || NX.over21.test(T + " " + D + " " + G) || tg(/^21\+$/),
   kidsy = NX.kidTitle.test(T) || (tg(NX.kidTag) || o._kids) && !(isMusic && evening) && !barish,
   mfest = /music fest|music festival|\bfest\b.*\b(music|reggae|rock|jazz|blues|edm|punk|country|hip hop)|(music|reggae|rock|jazz|blues|edm|punk|country|hip hop).*\bfest/.test(T) || tg(/^(music festival|music fest)$/),
   familyPlace = /\b(zoo|seaworld|sea world|disney|disneyland|legoland|aquarium|pumpkin|harvest|farm|hay ?rides?|corn maze|knott|six flags|safari park)\b/.test(T + " " + P),
   dogsy = (o._dogEvent || NX.dogTitle.test(T) && !NX.dogOk.test(T)) && !isMusic,
   clue = isMusic || isComedy || isMic || isTrivia || barish || tg(/^(nightlife|21\+|dj|dance|bachelorette|date night|live music|concert|party|halloween)$/) || NX.dj.test(T) || NX.latin.test(T),
   ok = !1;
  if (c === "Concert" || c === "Nightlife" || c === "Dance" || c === "Karaoke" || c === "Comedy") ok = !0;
  else if (c === "Trivia" || c === "Games") ok = evening || barish;
  else if (c === "Festival") ok = isMusic || tg(/^(live music|nightlife|21\+|concert)$/) || evening || NX.festOk.test(T);
  else if (c === "Theater + Performing Arts") ok = NX.theaterOk.test(T + " " + G) || isComedy || isMic;
  else if (c === "Food + Drink") ok = (evening || barish) && NX.foodOk.test(T + " " + G);
  else if (c === "Art Market" || c === "DIY + Workshops" || c === "Film") ok = evening && (barish || NX.party.test(T) || tg(/^(nightlife|21\+|date night)$/));
  else if (c === "Market") ok = /night market|after dark|moonlight/.test(T);
  else if (c === "Happy Hour" || c === "Wildlife" || c === "Space + Stargazing" || c === "Sports" || c === "Fitness + Outdoors") ok = !1;
  else ok = clue && evening;
  var danceNight = !isTrivia && (NX.latin.test(T) || NX.latinDesc.test(D.slice(0, 300)) && (barish || evening || /^(Dance|Nightlife|Concert|Food \+ Drink)$/.test(c)));
  danceNight && (ok = !0);
  ok && (kidsy || dogsy || familyPlace && c !== "Concert") && (ok = !1), ok && !o.all_day && !evening && !isMusic && !isComedy && (ok = !1);
  /* Oct 25 2026: Music Fests drill-down. Sheet tag "Music Festival" always counts; otherwise festival names, or a genre + "fest" in the title, or a concert billed as a fest. Food, beer, holiday, pride, parade and cultural fairs stay out. */
  var MF_NOT = /\b(oktoberfest|beer|brew\w*|wine|food|tamale|chili|film|book|literary|comedy|kite|lantern|balloon|harvest|fall|winter\w*|holiday|christmas|lights|trees|pride|santa|pumpkin|tractor|renaissance|earth\w*|street fair|parade|veterans|ice cream|pow wow|cultural|filipino|day of the dead|choreography|ballet|poe\w*|festive)\b|d[ií]a de (los )?muertos/,
   MF_GEN = "(music|musical|reggae|ska|dub|jazz|blues|rock|punk|metal|emo|edm|electronic|house|techno|bass|country|folk|bluegrass|americana|roots|hip[- ]?hop|rap|r&b|soul|funk|latin|salsa|mariachi|cumbia|reggaeton|gospel|indie|surf|songwriters?|guitar|ukulele|jam|psych|tribute|cover bands?|new wave|goth|dj|rave)",
   MF_TITLE = new RegExp("\\b" + MF_GEN + "\\b[\\w'\\s&/+-]{0,25}\\b(fest|festival|fes)\\b|\\b(fest|festival)\\b[\\w'\\s&/+-]{0,25}\\b" + MF_GEN + "\\b"),
   MF_KNOWN = /\b(coachella(?! valley)|stagecoach|darker waves|wonderfront|crssd fest\w*|kaaboo|cali vibes|ohana fest\w*|just like heaven|sick new world|lightning in a bottle|hard summer|beyond wonderland|day n vegas|desert daze|lovers (&|and) friends|cruel world|holo holo|totally tubular|slackfest|faux fest|hoco420fest)\b/,
   mfx = tg(/^(music festival|music fest|music fests)$/) || !tg(/^not a music fest$/) && !MF_NOT.test(T) && c !== "Sports" && (
    (c === "Festival" || c === "Concert" || c === "Nightlife") && (MF_KNOWN.test(T) || c === "Festival" && /\binsomniac\b/.test(T)) ||
    MF_TITLE.test(T) && !kidsy ||
    (c === "Concert" || c === "Nightlife" || c === "Dance") && /(\w+fest\b|\bfest\b|\bfestival\b)/.test(T) ||
    c === "Festival" && !kidsy && tg(/^(edm|rave)$/) ||
    c === "Festival" && !kidsy && tg(/^(edm|live music|concert)$/) && /\b(lineup|line-up|headlin\w*|stages|djs|bands)\b/.test(D.slice(0, 300)));
  mfx && !dogsy && (ok = !0);
  var nt = [],
   gn = [];
  if (ok) {
   var TG = T + " " + G;
   (c === "Nightlife" || NX.dj.test(TG) || tg(NX.djTag) || c === "Dance" && !NX.latin.test(TG)) && nt.push("dj"), (NX.latin.test(TG) || danceNight) && nt.push("latin"), isComedy && nt.push("comedy"), isMic && nt.push("mic"), (NX.costume.test(T) || NX.costume.test(D.slice(0, 300)) && NX.party.test(T) || tg(/^halloween$/) && NX.party.test(T)) && nt.push("costume");
   var concerty = c === "Concert" || c === "Festival" && isMusic || tg(/^(live music|concert)$/) || (isMusic && !isComedy && !isMic && nt.indexOf("dj") < 0 && nt.indexOf("latin") < 0);
   if (concerty) {
    var localV = barish || NX.local.test(P) || tg(/^(local|local favorite|reggae scene|free|jam)$/),
     bigV = NX.big.test(P) || c === "Festival" && mfest || NX.tour.test(T) && !localV;
    c === "Festival" && !bigV && !localV || nt.push(bigV && !(localV && !NX.big.test(P)) ? "big" : "local")
   }
   if (isMusic && !(isMic && c === "Karaoke") || nt.indexOf("dj") > -1 || nt.indexOf("latin") > -1) {
    var GT = T + " | " + G,
     DD = D.slice(0, 400);
    for (var gk in GENRE_RX) {
     var rx = GENRE_RX[gk],
      hit = rx.test(GT);
     !hit && gk !== "rock" && gk !== "tribute" && gk !== "hiphop" && gk !== "pop" && gk !== "jam" && (hit = rx.test(DD)), !hit && gk === "rock" && (hit = /\b(rock band|rock and roll|rock 'n' roll|rock n roll|indie rock|alt-rock|classic rock|hard rock|garage rock|surf rock|indie)\b/.test(DD)), !hit && gk === "jam" && (hit = /\b(jam band|psychedelic|grateful dead|phish)\b/.test(DD)), !hit && gk === "pop" && (hit = /\b(pop star|pop singer|indie pop|synth-?pop|r&b singer)\b/.test(DD)), !hit && gk === "hiphop" && (hit = /\b(hip[- ]?hop|r&b|rnb|neo[- ]soul|rapper)\b/.test(DD)), !hit && gk === "tribute" && (hit = /\b(tribute band|tribute to|cover band|covers band|plays the music of|grateful dead)\b/.test(DD)), hit && gn.push(gk)
    }
    gn.length || !(isMusic || nt.indexOf("dj") > -1 || nt.indexOf("latin") > -1) || gn.push("other"), gn.indexOf("reggae") > -1 && /\bdub\b/.test(GT + DD) && !/reggae|ska|roots/.test(GT + DD) && gn.indexOf("electronic") > -1 && gn.splice(gn.indexOf("reggae"), 1)
   }
  }
  var GMAP = {reggae: "reggae", rock: "rock", punk: "punk", jam: "jam", hiphop: "hiphop", funk: "hiphop", electronic: "edm", pop: "pop", country: "country", latin: "latin", jazz: "jazz"},
   gpub = [];
  gn.forEach(function(g) {
   GMAP[g] && gpub.indexOf(GMAP[g]) < 0 && gpub.push(GMAP[g])
  });
  var addG = function(g) {
   gpub.indexOf(g) < 0 && gpub.push(g)
  };
  nt.indexOf("dj") > -1 && addG("edm"), /\b(salsa|bachata|merengue|cumbia|kizomba|zouk|tango|milonga|latin night|latin dance|noche latina)\b/.test(T + " " + G) && addG("latin"), /\b(line danc\w*|two[- ]step|country danc\w*|contra|square danc\w*|folk ?danc\w*|barn dance|english country|ceili|zydeco|cajun)\b/.test(T + " " + G + " " + D.slice(0, 200)) && addG("country"), /\b(swing danc\w*|lindy\s?hop|lindy|west coast swing|big band)\b/.test(T + " " + G) && addG("jazz");
  var vibe = [];
  ok && isTrivia && nt.push("trivia"), (nt.indexOf("dj") > -1 && !(nt.indexOf("latin") > -1 && !/\b(dj|edm|house|techno|rave|club night|electronic)\b/.test(T)) || gn.indexOf("electronic") > -1 && nt.indexOf("latin") < 0) && vibe.push("dance"), nt.indexOf("latin") > -1 && vibe.push("partner"), nt.indexOf("local") > -1 && vibe.push("small"), nt.indexOf("big") > -1 && vibe.push("big"), nt.indexOf("comedy") > -1 && vibe.push("comedy"), (nt.indexOf("trivia") > -1 || nt.indexOf("mic") > -1 && /karaoke|open[- ]mic|poetry|spoken word|songwriter/.test(T + " " + G + " " + c.toLowerCase())) && vibe.push("games"), nt.indexOf("costume") > -1 && vibe.push("costume"), ok && mfx && !dogsy && vibe.push("fest");
  var TGP = T + " | " + G,
   quiet = /\b(lecture|talks?|book (signing|reading|club)|reading|workshops?|class|classes|lessons?|storytime|museum|exhibit|exhibition|gallery|symphony|orchestra|philharmonic|opera|ballet|recital|chamber|string quartet|meditation|sound bath|yoga|webinar|dinner show|seminar|meeting|vigil|memorial|worship|mass|candlelight|film screening|screening|open mic|poetry)\b/.test(T) || /^(Theater \+ Performing Arts|DIY \+ Workshops|Film|Art Market|Wildlife|Space \+ Stargazing|Market)$/.test(c) && !/\b(party|after dark|21\+|rooftop|night market)\b/.test(TGP),
   social = /\b(party|parties|bash|block party|street (fair|party|festival)|day party|pool party|rooftop|beach club|bar crawl|pub crawl|crawl|beer (fest|festival|garden)|brewfest|wine (fest|festival|walk)|tequila|mezcal|oktoberfest|pride|mixer|singles|speed dating|takeover|rave|silent disco|club night|nightclub|carnival|parade|watch party|tailgate|game day|run club|bachelorette|costume|nye|new year'?s)\b/.test(TGP),
   dow = new Date(o.s).getDay(),
   seated = /(theat(re|er)\b|theatre|copley|mccallum|symphony|performing arts|\bjai\b|playhouse|auditorium|church|library)/.test(P),
   communityPlace = /(folk ?dance|dance (center|centre|studio|hall|academy|school)|community center|community centre|rec(reation)? center|senior center|\bgrange\b|\bymca\b|church|temple|synagogue|library|legion|vfw|elks lodge)/.test(P),
   bookish = /\b(book(s|store|seller|sellers|shop)?|bookshop|library|museum|gallery|planetarium)\b/.test(P) || /\b(books?|novel|author|authors|signing|book launch|book release|acotar|fantasy book|reading|poetry|knitting|crochet|book club)\b/.test(T + " " + D.slice(0, 200)),
   wingOk = !kidsy && !dogsy && !familyPlace && !quiet && !communityPlace && !bookish && vibe.indexOf("partner") < 0 && !/\b(line danc\w*|two[- ]step|salsa|bachata|swing danc\w*|contra)\b/.test(TGP) && !/\b(contra|square danc\w*|folk ?danc\w*|english country|ceili|lessons?|class|classes|beginner)\b/.test(T) && !/\blibrary\b/.test(P) && !(isComedy && !social) && !(isTrivia && !social && !NX.costume.test(T)),
   wing = wingOk && (vibe.indexOf("dance") > -1 || vibe.indexOf("costume") > -1 || c === "Nightlife" || c === "Happy Hour" || c === "Festival" && (isMusic || social || /\b(festival|fest|street|block|fair|fiesta|celebration|muertos|oktoberfest|tasting)\b/.test(T) && !/\b(car show|lawn program|ofrenda|exhibit|expo|book)\b/.test(T)) || c === "Karaoke" || social || tg(/^(21\+|nightlife|bachelorette|dj|dance|lgbtq\+|craft beer|brewery|cocktails)$/) || vibe.indexOf("small") > -1 && barish && (evening || dow === 0 || dow === 6) || vibe.indexOf("big") > -1 && !seated && !/^(jazz|classical|jazz,classical)$/.test(gn.join(",")) || c === "Sports" && (NX.big.test(P) || /\b(watch party|tailgate|game day)\b/.test(TGP)) || c === "Food + Drink" && /\b(beer|wine|cocktails?|tequila|brew|spirits)\b/.test(TGP));
  nt = vibe;
  if (wingOk && WING_VET && WING_VET.regions.test(String(o.region || o.src && o.src.region || ""))) {
   var vk = String(o.place || "").toLowerCase(),
    vv = WING_VET.yes.test(vk) ? 2 : WING_VET.maybe.test(vk) ? 1 : WING_VET.no.test(vk) ? -1 : 0,
    bigSocial = /\b(block party|street (fair|party|festival)|pool party|day party|bar crawl|pub crawl|beer (fest|festival)|brewfest|wine (fest|festival)|oktoberfest|pride|halloween (party|bash)|costume party|rave|music festival|music fest)\b/.test(TGP) && !NX.local.test(P);
   wing = vv === 2 || vv === 1 && (dow === 5 || dow === 6) && (h >= 19 || h < 3) || vv === 0 && bigSocial
  }
  var wsReg = String(o.region || o.src && o.src.region || ""), wsK = wsKit();
  if (wsK.cover.test(wsReg)) {
   var wsP = P.replace(/['’]/g, ""), wsHit = null;
   for (var wi = 0; wi < wsK.list.length; wi++) {
    var sp = wsK.list[wi];
    if (sp.rx && sp.regions.indexOf(wsReg) > -1 && sp.rx.test(wsP)) { wsHit = sp; break }
   }
   var wsText = T + " " + D.slice(0, 300),
    wsSingles = wsK.singles.test(wsText) && !wsK.notSingles.test(wsText),
    wsSocial = wsK.social.test(TGP) && !NX.local.test(P),
    wsNight = !o.all_day && (h >= 15 || h < 3),
    wsOk = wingOk || isTrivia && !kidsy && !dogsy && !familyPlace && !communityPlace && !bookish && !quiet,
    wsDow = h < 3 ? (dow + 6) % 7 : dow,
    wsDay = wsHit && wsHit.d ? wsHit.d.indexOf(wsDow) > -1 : !0,
    wsGone = !!(wsHit && wsHit.v === "excluded");
   var wvv = wsK.musicRate(wsP, wsReg),
    wsAllAges = /\b(all ages|all-ages|family|kids|children|teens?|youth|students?|school|marching|choirs?|honor band|band festival)\b/.test(TGP + " " + D.slice(0, 200)),
    wsMusic = wingOk && !seated && !wsAllAges && (mfx && !kidsy || isMusic && !/^(jazz|classical|jazz,classical)$/.test(gn.join(",")) && (wvv === 2 && wsNight || wvv === 1 && (wsDow === 5 || wsDow === 6) && (h >= 19 || h < 3))),
    wsDayOk = /\b(pool party|day party|bar crawl|pub crawl|beer (fest|festival)|brewfest|wine (fest|festival|walk)|oktoberfest)\b/.test(TGP);
   wsSocial = wsSocial && !wsAllAges && (wsDayOk || wsNight && h >= 17 || h < 3 || tg(/^(21\+|nightlife)$/));
   wing = !wsGone && (wingOk && (wsSingles || wsSocial) || wsMusic || wsOk && !!wsHit && (wsHit.v === "top" || wsHit.v === "strong") && wsNight && wsDay && !seated);
   !wsGone && tg(/^wingman( mode)?$/) && !(wsHit && wsHit.v === "nights" && wsHit.d && !wsDay) && (wing = !0);
   o._wsVenue = wsHit ? wsHit.n : "";
  } else tg(/^wingman( mode)?$/) && (wing = !0);
  tg(/^(no wingman|wingman exclude)$/) && (wing = !1);
  o._wing = !!wing, o._night = ok, o._eve = ok && (!o.all_day && (h >= 17 || h < 4) || /\b(night|nite|after dark|late night|evening)\b/.test(T) || he >= 21 && h >= 12), o._nt = nt, o._gn = gpub
 }

 var nightGenreOpen = !1,
  nightHist = [],
  nightTimer = 0,
  nightBooted = !1,
  NIGHT_CSS = '#obg .obg-chip{min-height:40px}#obg .obg-ct{display:inline-block;min-width:1.7em;margin-left:6px;padding:1px 7px;border-radius:999px;background:rgba(0,0,0,.09);font-size:12px;font-weight:700;line-height:1.55;text-align:center;font-variant-numeric:tabular-nums}#obg .obg-chip[aria-pressed="true"] .obg-ct{background:rgba(255,255,255,.3)}#obg .obg-chip-zero{opacity:.4;cursor:not-allowed}#obg .obg-night{margin:8px 0 4px;padding:8px 10px;border-radius:12px;background:rgba(120,120,120,.07);border:1px solid rgba(120,120,120,.18)}#obg .obg-night[hidden]{display:none}#obg .obg-night-row{display:flex;flex-wrap:wrap;gap:6px;align-items:center}#obg .obg-night-row[hidden]{display:none}#obg .obg-night-genres{margin-top:8px;padding-top:8px;border-top:1px solid rgba(120,120,120,.18)}#obg .obg-night .obg-chip{min-height:34px;padding-top:4px;padding-bottom:4px;font-size:14px}#obg .obg-night .obg-chip[hidden]{display:none}#obg .obg-night-more{min-height:34px;padding:4px 10px;border:0;background:none;font:inherit;font-size:14px;font-weight:600;color:inherit;text-decoration:underline;cursor:pointer;white-space:nowrap}@media (max-width:899px){#obg .obg-night-row{flex-wrap:nowrap;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none}#obg .obg-night-row::-webkit-scrollbar{display:none}#obg .obg-night-row>*{flex:0 0 auto}}#obg .obg-narrow{display:flex;flex-wrap:wrap;align-items:center;gap:8px 12px;margin:10px 0;padding:12px 14px;border-radius:12px;background:#fff4d6;color:#4d3a00;border:1px solid #efd388;font-size:15px}#obg .obg-narrow[hidden]{display:none}#obg .obg-narrow b{font-weight:700}#obg .obg-narrow-acts{display:flex;flex-wrap:wrap;gap:8px}#obg .obg-narrow button{min-height:36px;padding:6px 14px;border-radius:999px;border:1px solid #c9a646;background:#fff;color:#4d3a00;font:inherit;font-size:14px;font-weight:600;cursor:pointer}#obg .obg-narrow button.is-main{background:#4d3a00;border-color:#4d3a00;color:#fff}';

 function nightActive() {
  return !!(state.night || state.wing || state.nt && state.nt.length || state.gn && state.gn.length)
 }

 function nightOk(o) {
  if (!nightActive()) return !0;
  if (state.wing && !o._wing) return !1;
  if ((state.night || state.nt.length || state.gn.length) && !o._night) return !1;
  if (state.nt.length && !state.nt.some(function(k) {
    return o._nt.indexOf(k) > -1
   })) return !1;
  return !(state.gn.length && !state.gn.some(function(k) {
   return o._gn.indexOf(k) > -1
  }))
 }

 function nightChipOn(k) {
  return k === "night" ? !!state.night : k === "wing" ? !!state.wing : k.indexOf("nt:") === 0 ? state.nt.indexOf(k.slice(3)) > -1 : k.indexOf("gn:") === 0 ? state.gn.indexOf(k.slice(3)) > -1 : null
 }

 function nightToggleList(list, v) {
  var i = list.indexOf(v);
  return i > -1 ? list.splice(i, 1) : list.push(v), list
 }

 function nightApply(k) {
  if (k === "night") return state.night ? (state.night = !1, state.nt = [], state.gn = []) : state.night = !0, !0;
  if (k === "wing") return state.wing = !state.wing, !0;
  if (k.indexOf("nt:") === 0) return state.night = !0, state.nt = nightToggleList(state.nt.slice(), k.slice(3)), !0;
  if (k.indexOf("gn:") === 0) return state.night = !0, state.gn = nightToggleList(state.gn.slice(), k.slice(3)), !0;
  return !1
 }

 function chipApplyStd(k) {
  if (k === "today" || k === "tonight" || k === "weekend") state.when = state.when === k ? "all" : k, state.from = "", state.to = "", state.open = !1;
  else if (k === "free") state.free = !state.free;
  else if (k === "dog") state.dog = !state.dog;
  else if (k === "outside") state.outside = !state.outside;
  else if (k === "drive") state.drive = !state.drive;
  else if (k === "picks") state.picks = !state.picks;
  else if (k === "weekly") state.weekly = state.weekly ? "" : "all";
  else {
   var ks = leavesOf(k),
    all = ks.every(function(x) {
     return state.cats.indexOf(x) > -1
    });
   allCatsOn() ? state.cats = CAT_KEYS.filter(function(c) {
    return ks.indexOf(c) > -1
   }) : state.cats = all ? state.cats.filter(function(c) {
    return ks.indexOf(c) === -1
   }) : CAT_KEYS.filter(function(c) {
    return ks.indexOf(c) > -1 || state.cats.indexOf(c) > -1
   })
  }
 }

 function cloneState(s) {
  var c = {};
  for (var k in s) c[k] = Array.isArray(s[k]) ? s[k].slice() : s[k];
  return c
 }

 function nightCountList(list) {
  for (var nE = 0, nW = 0, sk = {}, i = 0; i < list.length; i++) {
   var o = list[i];
   if (o._weekly) {
    var kk = o._tk + "|" + o._vc;
    sk[kk] || (sk[kk] = 1, nW++)
   } else nE++
  }
  return {e: nE, w: nW}
 }

 function countWith(fn) {
  var save = state,
   cm = calMonth,
   n = 0;
  state = cloneState(save);
  try {
   fn(), n = nightCountList(filtered())
  } catch (_) {
   n = null
  }
  return state = save, calMonth = cm, n
 }

 function nightClick(k, b) {
  if (b && b.getAttribute("aria-disabled") === "true") return !0;
  if (nightHist.push(cloneState(state)), nightHist.length > 30 && nightHist.shift(), !nightApply(k)) return !1;
  render();
  try {
   tf("quick", k, chipOn(k))
  } catch (_) {}
  return !0
 }

 function nightRemove(r) {
  return r === "night" ? (state.night = !1, state.nt = [], state.gn = [], !0) : r === "wing" ? (state.wing = !1, !0) : r.indexOf("nt:") === 0 ? (state.nt = state.nt.filter(function(x) {
   return x !== r.slice(3)
  }), !0) : r.indexOf("gn:") === 0 ? (state.gn = state.gn.filter(function(x) {
   return x !== r.slice(3)
  }), !0) : !1
 }

 function nightLabel(list, k) {
  for (var i = 0; i < list.length; i++)
   if (list[i].k === k) return list[i].label;
  return k
 }

 function nightPills(pills) {
  state.wing && pills.push(["wing", "Wingman Mode"]), state.night && pills.push(["night", "Music + Nightlife"]), state.nt.forEach(function(k) {
   pills.push(["nt:" + k, nightLabel(NIGHT_TYPES, k)])
  }), state.gn.forEach(function(k) {
   pills.push(["gn:" + k, nightLabel(NIGHT_GENRES, k)])
  })
 }

 function nightActiveCount() {
  return (state.night ? 1 : 0) + (state.wing ? 1 : 0) + state.nt.length + state.gn.length
 }

 function nightValid(list, raw) {
  var keys = list.map(function(x) {
   return x.k
  });
  return String(raw || "").toLowerCase().split(",").map(function(x) {
   return x.trim()
  }).filter(function(x, i, a) {
   return x && keys.indexOf(x) > -1 && a.indexOf(x) === i
  })
 }

 function nightReadUrl(p) {
  p.get("night") === "1" && (state.night = !0), p.get("wingman") === "1" && (state.wing = !0), state.nt = nightValid(NIGHT_TYPES, p.get("type")), state.gn = nightValid(NIGHT_GENRES, p.get("style")), (state.nt.length || state.gn.length) && (state.night = !0)
 }

 function nightWriteUrl(p) {
  state.wing && p.set("wingman", "1"), state.night && p.set("night", "1"), state.nt.length && p.set("type", state.nt.join(",")), state.gn.length && p.set("style", state.gn.join(","))
 }

 function nightChipHtml(k, label) {
  return '<button type="button" class="obg-chip obg-nchip" data-chip="' + k + '" aria-pressed="false"><span>' + esc(label) + '</span><span class="obg-ct" aria-hidden="true"></span></button>'
 }

 function nightBoot() {
  if (!nightBooted) {
   nightBooted = !0;
   var st = document.createElement("style");
   window.addEventListener("click", function(e) {
    e.target && e.target.closest && e.target.closest("#obg #obgActive .obn-clear, #obg .obg-pill-clear") && nightActive() && (state.night = !1, state.wing = !1, state.nt = [], state.gn = [], setTimeout(function() {
     render()
    }, 0))
   }, !0), st.id = "obgNightCss", st.textContent = NIGHT_CSS + (/happy-hours/.test(location.pathname) ? "" : "#obgdFacets{display:none!important}"), document.head.appendChild(st), ROOT.addEventListener("click", function(e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (el) {
     if (el.closest("[data-night-undo]")) {
      if (e.preventDefault(), nightHist.length) {
       state = nightHist.pop(), buildHoods(), render();
       try {
        tf("quick", "undo", !0)
       } catch (_) {}
      }
      return
     }
     if (el.closest("[data-night-genres]")) {
      e.preventDefault(), nightGenreOpen = !nightGenreOpen, nightRender();
      return
     }
     el.closest("[data-night-clear]") && (e.preventDefault(), nightHist.push(cloneState(state)), nightRemove("night"), render())
    }
   })
  }
 }

 function nightRender() {
  nightBoot();
  var chips = $("#obgChips");
  if (chips) {
   var pan = $("#obgNight"),
    anc;
   pan || (pan = document.createElement("div"), pan.id = "obgNight", pan.className = "obg-night", pan.hidden = !0, pan.setAttribute("role", "group"), pan.setAttribute("aria-label", "Narrow down nightlife"), pan.innerHTML = '<div class="obg-night-row" aria-label="Vibe">' + NIGHT_TYPES.map(function(t) {
    return nightChipHtml("nt:" + t.k, t.label)
   }).join("") + '<button type="button" class="obg-night-more" data-night-genres aria-expanded="false">Pick a genre <span aria-hidden="true">\u25BE</span></button></div><div class="obg-night-row obg-night-genres" hidden aria-label="Genre">' + NIGHT_GENRES.map(function(g) {
    return nightChipHtml("gn:" + g.k, g.label)
   }).join("") + "</div>"), anc = chips.closest(".obg-chipbar") || chips, pan.previousElementSibling !== anc && anc.parentNode.insertBefore(pan, anc.nextSibling), pan.hidden = !state.night, state.gn.length && (nightGenreOpen = !0);
   var gr = pan.querySelector(".obg-night-genres"),
    gb = pan.querySelector("[data-night-genres]");
   gr && (gr.hidden = !nightGenreOpen), gb && (gb.setAttribute("aria-expanded", nightGenreOpen ? "true" : "false"), gb.innerHTML = (state.gn.length ? "Genre: " + state.gn.map(function(k) {
    return nightLabel(NIGHT_GENRES, k)
   }).join(", ") : "Pick a genre") + ' <span aria-hidden="true">' + (nightGenreOpen ? "\u25B4" : "\u25BE") + "</span>")
  }
  var nb = $("#obgNarrow"),
   lst = $("#obgList");
  !nb && lst && lst.parentNode && (nb = document.createElement("div"), nb.id = "obgNarrow", nb.className = "obg-narrow", nb.hidden = !0, nb.setAttribute("role", "status"), lst.parentNode.insertBefore(nb, lst));
  var nc = nightCountList(lastList),
   n = nc.e,
   userF = activeCount() - (V4 && state.when === "today" ? 1 : 0) + (state.q ? 1 : 0);
  if (nb) {
   if (n < 5 && userF > 0 && !state.venue) {
    var acts = [];
    nightHist.length && acts.push('<button type="button" class="is-main" data-night-undo>Undo last filter</button>'), V4 && state.when === "today" && acts.push('<button type="button" data-remove="when">Show all dates</button>'), acts.push('<button type="button" data-reset>Clear all filters</button>'), nb.innerHTML = "<span>" + (n === 0 ? "<b>No events match all of these filters" + (nc.w ? "</b> (just " + nc.w + " weekly regular" + (nc.w === 1 ? "" : "s") + ")." : ".</b>") : "<b>Only " + n + (n === 1 ? " event matches" : " events match") + "</b> these filters.") + '</span><span class="obg-narrow-acts">' + acts.join("") + "</span>", nb.hidden = !1
   } else nb.hidden = !0, nb.innerHTML = ""
  }
  clearTimeout(nightTimer), nightTimer = setTimeout(nightCounts, 40)
 }

 function nightCounts() {
  var cur = nightCountList(lastList),
   panOpen = !!state.night;
  $$("[data-chip]").forEach(function(b) {
   var k = b.getAttribute("data-chip");
   if (k && k !== "weekly") {
    var drill = k.indexOf("nt:") === 0 || k.indexOf("gn:") === 0;
    if (!drill || panOpen) {
     var on = chipOn(k),
      n;
     if (drill) {
      var key = k.slice(3);
      n = countWith(function() {
       state.night = !0, k.charAt(0) === "n" ? state.nt = [key] : state.gn = [key]
      })
     } else n = on ? cur : countWith(function() {
      nightApply(k) || chipApplyStd(k)
     });
     if (n) {
      var ct = b.querySelector(".obg-ct"),
       txt = n.e || !n.w ? n.e > 999 ? "999+" : String(n.e) : n.w + " weekly";
      ct || (ct = document.createElement("span"), ct.className = "obg-ct", ct.setAttribute("aria-hidden", "true"), b.appendChild(ct)), ct.textContent = txt;
      var zero = !on && n.e + n.w === 0;
      (k === "nt:costume" || k === "nt:fest") && (b.hidden = zero), b.classList.toggle("obg-chip-zero", zero), zero ? b.setAttribute("aria-disabled", "true") : b.removeAttribute("aria-disabled");
      var lbl = b.querySelector("span:not(.obg-ct)");
      b.setAttribute("aria-label", (lbl ? lbl.textContent : k) + ", " + txt + (txt === "1" ? " event" : /weekly/.test(txt) ? "" : " events"))
     }
    }
   }
  })
 }


 function chipOn(k) {
  var nko = nightChipOn(k);
  if (nko !== null) return nko;
  return k === "today" || k === "tonight" || k === "weekend" ? state.when === k : k === "free" ? state.free : k === "dog" ? state.dog : k === "outside" ? !!state.outside : k === "drive" ? !!state.drive : k === "picks" ? state.picks : k === "weekly" ? !!state.weekly : allCatsOn() ? !1 : leavesOf(k).every(function(x) {
   return state.cats.indexOf(x) > -1
  })
 }

 function catSummary() {
  if (allCatsOn() && !goodOn().length) return "All categories";
  if (mostlyAll() && !allCatsOn() && !goodOn().length) {
   var off = offUnits();
   return off.length === 1 ? "All except " + off[0] : "All except " + off.length
  }
  var labels = catUnits().map(function(u) {
   return u.label
  });
  return goodOn().forEach(function(g) {
   labels.push(g.label)
  }), labels.length ? labels.length === 1 ? labels[0] : labels.length === 2 ? labels.join(", ") : labels.length + " selected" : "All"
 }

 function syncControls() {
  $$('input[name="obg-region"]').forEach(function(x) {
   x.checked = x.value === state.region
  }), $$('input[name="obg-cat"]').forEach(function(x) {
   x.checked = state.cats.indexOf(x.value) > -1
  });
  var ac = $('input[name="obg-allcats"]');
  ac && (ac.checked = allCatsOn(), ac.indeterminate = state.cats.length > 0 && !allCatsOn()), GROUPS.forEach(function(g) {
   if (g.subs) {
    var st = groupState(g),
     x = $('input[name="obg-grp"][value="' + g.k + '"]');
    x && (x.checked = st === "on", x.indeterminate = st === "some"), st === "some" && (subOpen[g.k] = !0);
    var box2 = $('[data-subs="' + g.k + '"]'),
     btn = $('[data-subtoggle="' + g.k + '"]');
    box2 && (box2.hidden = !subOpen[g.k]), btn && btn.setAttribute("aria-expanded", subOpen[g.k] ? "true" : "false")
   }
  }), $$('input[name="obg-good"]').forEach(function(x) {
   x.checked = !!state[x.value]
  }), $$('input[name="obg-when"]').forEach(function(x) {
   x.checked = x.value === state.when
  }), $$('input[name="obg-hood"]').forEach(function(x) {
   x.checked = state.hoods.indexOf(x.value) > -1
  }), $("#obgPicks").checked = state.picks, $("#obgOpen").checked = state.open;
  var range = $("#obgRange");
  range.hidden = state.when !== "custom";
  var t = todayKey(),
   fi = $("#obgFrom"),
   ti = $("#obgTo");
  fi.value = state.from, ti.value = state.to, fi.min = t, ti.min = state.from || t;
  var hs = $("#obgHeroRegion");
  if (hs && LV_PAGE) {
   var mo = hs.querySelector('option[value="multi"]');
   state.hoods.length > 1 ? (mo && (mo.textContent = state.hoods.length + " neighborhoods"), hs.value = "multi") : hs.value = state.hoods.length === 1 ? "hood:" + state.hoods[0] : DEST
  } else hs && (hs.value = state.region);
  var si = $("#obgSearch");
  si && document.activeElement !== si && (si.value = state.q), $(".obg-search-clear").hidden = !state.q, $$("[data-chip]").forEach(function(b) {
   b.setAttribute("aria-pressed", chipOn(b.getAttribute("data-chip")) ? "true" : "false")
  }), $$("[data-view]").forEach(function(b) {
   b.setAttribute("aria-pressed", b.getAttribute("data-view") === state.view ? "true" : "false")
  });
  var areaVal = state.region === "all" ? ALL_LABEL : state.hoods.length ? state.hoods.length === 1 ? state.hoods[0] : state.hoods.length + " neighborhoods" : state.region;
  $('[data-val="area"]').textContent = areaVal, $('[data-val="cats"]').textContent = catSummary();
  var dl = DATES.filter(function(d) {
   return d.k === state.when
  })[0];
  $('[data-val="date"]').textContent = state.open ? "Open now" : state.when === "custom" ? (state.from ? mdLabel(state.from) : "") + (state.to && state.to !== state.from ? " \u2013 " + mdLabel(state.to) : "") : dl ? dl.label : "Any date";
  var n = activeCount(),
   fc = $("#obgFilterCount");
  fc && (fc.textContent = n ? String(n) : ""), ROOT.classList.toggle("has-filters", n > 0)
 }

 function activeCount() {
  return (state.cats.length ? mostlyAll() ? 1 : catUnits().length : 0) + goodOn().length + (state.when !== "all" ? 1 : 0) + (state.open ? 1 : 0) + (state.picks ? 1 : 0) + nightActiveCount() + (areaTouched && (state.region !== DEFAULT_REGION || state.hoods.length) ? 1 : 0)
 }

 function renderActive() {
  var pills = [];
  state.venue && pills.push(["venue", "At " + venueLabel()]), state.q && pills.push(["q", "\u201C" + state.q + "\u201D"]), state.picks && pills.push(["picks", "\u2605 OB Picks"]), state.weekly && pills.push(["weekly", state.weekly === "only" ? "Weekly stuff only" : "Showing everything"]), allCatsOn() ? pills.push(["cat:all", "All categories"]) : mostlyAll() ? pills.push(["cat:all", "All except " + offUnits().join(", ")]) : catUnits().forEach(function(u) {
   pills.push(["cat:" + u.k, u.label])
  }), goodOn().forEach(function(g) {
   pills.push(["good:" + g.k, g.label])
  }), nightPills(pills), state.when !== "all" && !V4 && pills.push(["when", $('[data-val="date"]').textContent || "Dates"]), state.open && pills.push(["open", "Open now"]), state.region !== "all" && !state.venue && pills.push(["region", state.region]), state.venue || state.hoods.forEach(function(h) {
   pills.push(["hood:" + h, h])
  });
  var box2 = $("#obgActive");
  box2.innerHTML = pills.length ? pills.map(function(p) {
   return '<button type="button" class="obg-pill" data-remove="' + esc(p[0]) + '">' + esc(p[1]) + icon("x") + "</button>"
  }).join("") + (pills.length > 0 ? '<button type="button" class="obg-pill-clear" data-reset>Clear all</button>' : "") : "", box2.hidden = !pills.length
 }
 var lastRchip = "";

 function renderRegionChips() {
  var box2 = $("#obgRegionChips");
  if (box2) {
   if (!state.q || DEST) {
    box2.hidden = !0, box2.innerHTML = "", lastRchip = "";
    return
   }
   var counts = {
     all: 0
    },
    rl = filtered({
     ignoreLocation: !0
    });
   if (state.view === "list" && collapseOn() && (rl = collapseWeekly(rl)), rl.forEach(function(o) {
     counts.all++, counts[o.region] = (counts[o.region] || 0) + 1
    }), box2.innerHTML = CHIP_REGIONS.map(function(r) {
     var on = state.region === r,
      n = counts[r] || 0;
     return '<button type="button" class="obg-chip obg-rchip' + (n ? "" : " is-empty") + '" data-rchip="' + esc(r) + '" aria-pressed="' + (on ? "true" : "false") + '"><span>' + esc(r === "all" ? ALL_LABEL : r) + "</span><em>" + n.toLocaleString() + "</em></button>"
    }).join(""), box2.hidden = !1, lastRchip !== state.region) {
    lastRchip = state.region;
    var a = $('.obg-rchip[aria-pressed="true"]', box2);
    a && (a.offsetLeft < box2.scrollLeft || a.offsetLeft + a.offsetWidth > box2.scrollLeft + box2.clientWidth) && (box2.scrollLeft = Math.max(0, a.offsetLeft - 16))
   }
  }
 }

 function setQuery(v) {
  v = String(v || "").trim();
  var was = state.q;
  if (v === was) return render();
  !was && v ? (preSearch = {
   region: state.region,
   hoods: state.hoods.slice(),
   touched: areaTouched
  }, !areaTouched && state.region === DEFAULT_REGION && !state.hoods.length && (state.region = "all")) : was && !v && preSearch && (state.region = preSearch.region, state.hoods = preSearch.hoods, areaTouched = preSearch.touched, preSearch = null), V4 && (!was && v && !dateTouched && state.when === "today" ? (state.when = "all", searchWidened = !0) : was && !v && searchWidened && (state.when = "today", searchWidened = !1)), state.q = v, buildHoods(), render(), trackSearchSoon()
 }

 function headingForQuery() {
  var q = state.q,
   pq = lastQuery || {};
  (pq.fixes || []).forEach(function(f) {
   q = q.replace(new RegExp("\\b" + f[0] + "\\b", "i"), f[1])
  });
  var h = (pq.fixes && pq.fixes.length ? "Showing results for \u201C" : "Results for \u201C") + q + "\u201D";
  return h
 }
 var savedPrev = null,
  V4_ROWS = [],
  regsOpen = {},
  dayOpen = {},
  awAll = !1,
  lastFocus = null,
  dateTouched = !1,
  searchWidened = !1,
  WDL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  CHEV_R = '<svg class="obg-i" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

 function v4Start(t) {
  if (state.when === "custom" && state.from) return state.from > t ? state.from : t;
  if (state.when === "weekend") {
   var w = weekendRange(t);
   return w[0] > t ? w[0] : t
  }
  return t
 }

 function isLongRun(o) {
  return !o._weekly && !o._series && o.ed > addDays(o.sd, 2)
 }

 function regsCatOn() {
  return !allCatsOn() && state.cats.some(function(c) {
   return c === "happy" || c === "games"
  })
 }

 function v4DayLabel(k, t) {
  return k === t ? "Today" : k === addDays(t, 1) ? "Tomorrow" : k < addDays(t, 7) ? WDL[dow(k)] : WD[dow(k)] + ", " + mdLabel(k)
 }

 function dayWord(k, t) {
  var l = v4DayLabel(k, t);
  return l === "Today" || l === "Tomorrow" ? l.toLowerCase() : k < addDays(t, 7) ? "on " + l : "on " + WDL[dow(k)] + ", " + mdLabel(k)
 }

 function dayHead(k, t) {
  var l = v4DayLabel(k, t);
  return l === "Today" || l === "Tomorrow" ? [l, WD[dow(k)] + ", " + mdLabel(k)] : [WDL[dow(k)], mdLabel(k)]
 }

 function nextWeekRange(t) {
  var mon = addDays(t, (8 - dow(t)) % 7 || 7);
  return [mon, addDays(mon, 6)]
 }

 function rangeLabel(a, b) {
  return a.slice(0, 7) === b.slice(0, 7) ? mdLabel(a) + "\u2013" + +b.slice(8) : mdLabel(a) + " \u2013 " + mdLabel(b)
 }

 function v4Time(o, day) {
  return o._series ? o.all_day ? "Weekly" : timeLabel(o.s) : o.sd < day ? "Ongoing" : noTimeShow(o) ? "Time TBA" : runNoTime(o) ? "Times vary" : o.all_day ? "All day" : timeLabel(o.s)
 }
 var PRICE_RX = /\$\s?\d{1,4}(?:\.\d{2})?(?:\s?(?:-|–|to)\s?\$?\d{1,4}(?:\.\d{2})?)?\+?/,
  NO_PRICE_CATS = /^(Happy Hour|Food \+ Drink|Trivia|Karaoke|Market|Art Market)$/;

 function priceOf(o) {
  if (o._free) return "Free";
  if (o._weekly || NO_PRICE_CATS.test(o.cat)) return "";
  var m = String(o.desc || "").match(PRICE_RX);
  return m ? m[0].replace(/\s+/g, "").replace(/to/, "\u2013").replace(/-/, "\u2013") : ""
 }

 function catLabelOf(o) {
  return o._act ? o._act === "races" ? "Race" : o._act === "wellness" ? "Wellness" : o._act === "nature" ? "Outdoors" : "Fitness" : TAG[o.cat] ? TAG[o.cat][0] : o.cat || ""
 }

 function catPill(o) {
  var tg = TAG[o.cat];
  return '<span class="obg-r4-pill obg-p-' + (tg ? tg[1] : "slate") + '">' + esc(catLabelOf(o)) + "</span>"
 }
 var GAMES_RX = /bingo|game night|board games?|karaoke|drag/;

 function regType(o) {
  return o.cat === "Happy Hour" ? "happy" : o.cat === "Karaoke" || GAMES_RX.test(o._t) ? "games" : o.cat === "Trivia" || /trivia|quiz/.test(o._t) ? "trivia" : /open mic/.test(o._t) ? "openmic" : o.cat === "Concert" ? "music" : "other"
 }
 var REG_NAMES = {
  happy: ["happy hour", "happy hours"],
  trivia: ["trivia night", "trivia nights"],
  games: ["karaoke or game night", "karaoke and game nights"],
  openmic: ["open mic", "open mics"],
  music: ["live music night", "live music nights"],
  other: ["other regular", "other regulars"]
 };

 function regSummary(arr) {
  var c = {},
   order = ["happy", "trivia", "games", "openmic", "music", "other"];
  arr.forEach(function(o) {
   var k = regType(o);
   c[k] = (c[k] || 0) + 1
  });
  var parts = order.filter(function(k) {
   return c[k]
  }).map(function(k) {
   return c[k] + " " + REG_NAMES[k][c[k] === 1 ? 0 : 1]
  });
  return parts.length > 1 ? parts.slice(0, -1).join(", ") + " and " + parts[parts.length - 1] : parts[0] || ""
 }

 function seriesKey(o) {
  return o._tk + "|" + o._vc
 }
 var SAVED = {};
 try {
  SAVED = JSON.parse(window.localStorage.getItem("obg_saved") || "{}") || {}
 } catch (_) {
  SAVED = {}
 }
 var HEART = '<svg class="obg-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2z"/></svg>';

 function saveKey(o) {
  return String(o.key || o._tk + "|" + o._vc + "|" + o.sd)
 }

 function isSaved(o) {
  return !!SAVED[saveKey(o)]
 }

 function savedCount() {
  return Object.keys(SAVED).length
 }

 function heartBtn(o) {
  var on = isSaved(o);
  return '<button type="button" class="obg-save' + (on ? " is-on" : "") + '" data-save="' + esc(saveKey(o)) + '" aria-pressed="' + (on ? "true" : "false") + '" aria-label="Save ' + esc(o.title) + '">' + HEART + "</button>"
 }

 function toggleSave(k) {
  SAVED[k] ? delete SAVED[k] : SAVED[k] = Date.now();
  try {
   window.localStorage.setItem("obg_saved", JSON.stringify(SAVED))
  } catch (_) {}
  var on = !!SAVED[k];
  $$(".obg-save").forEach(function(b) {
   b.getAttribute("data-save") === k && (b.classList.toggle("is-on", on), b.setAttribute("aria-pressed", on ? "true" : "false"))
  }), renderSavedChip(), state.saved && render(!0), tf("save", k, on)
 }

 function renderSavedChip() {
  var box2 = $("#obgChips");
  if (box2) {
   var n = savedCount(),
    b = $("[data-saved-chip]", box2);
   if (!b) {
    b = document.createElement("button"), b.type = "button", b.className = "obg-chip obg-chip-saved", b.setAttribute("data-saved-chip", "");
    var mo = $(".obg-chip-more", box2);
    box2.insertBefore(b, mo || null)
   }
   b.style.display = !n && !state.saved ? "none" : "", b.setAttribute("aria-pressed", state.saved ? "true" : "false"), b.innerHTML = HEART + "<span>Saved" + (n ? " (" + n + ")" : "") + "</span>"
  }
 }

 function thumbHtml(o, cls, w) {
  var p = cardPhoto(o);
  return '<span class="' + cls + '">' + (p ? '<img src="' + esc(sized(p, w)) + '" alt="" loading="lazy" decoding="async">' : icon(catIcon(o))) + "</span>"
 }

 function v4Row(o, day) {
  var idx = V4_ROWS.push(o) - 1,
   href = o.url,
   price = priceOf(o),
   thru = o.ed > day && !o._series && !o._weekly ? "thru " + mdLabel(o.ed) : "",
   meta = [venueText(o), o._series ? "Every " + o._series : "", thru].filter(Boolean).join(" \xB7 ");
  return '<div class="obg-r4w"><a class="obg-r4' + (o._pick ? " is-pick" : "") + (o._weekly ? " is-reg" : "") + '" data-r4="' + idx + '" href="' + (href ? esc(tracked(href, "list")) : "#") + '"' + (href ? ' target="_blank" rel="noopener"' : "") + '><span class="obg-r4-time">' + esc(v4Time(o, day)) + '</span><span class="obg-r4-title">' + (o._pick ? '<span class="obg-r4-star" role="img" aria-label="OB Pick" title="OB Pick">\u2605</span> ' : "") + '<span class="obg-title">' + esc(o.title) + '</span></span><span class="obg-r4-meta">' + esc(meta) + '</span><span class="obg-r4-tags">' + (price ? '<span class="obg-r4-price' + (price === "Free" ? " is-free" : "") + '">' + esc(price) + "</span>" : "") + catPill(o) + "</span>" + thumbHtml(o, "obg-r4-thumb", 200) + "</a>" + heartBtn(o) + "</div>"
 }

 function cmpInDay(day) {
  return function(a, b) {
   return (a.sd < day) - (b.sd < day) || a.all_day - b.all_day || a.s - b.s
  }
 }

 function weeklyPageHref() {
  var here = location.pathname.replace(/\/$/, ""),
   a = document.querySelector('a[href$="-happy-hours"],a[href*="-happy-hours?"]'),
   h = a ? a.getAttribute("href") : "";
  return !h && /^\/pages\/events/.test(here) && (h = here === "/pages/events" ? "/pages/events-happy-hours" : here + "-happy-hours"), h && h.split("?")[0].replace(/\/$/, "") !== here ? h : ""
 }
 var SOCAL_STOCK = [PHOTO.festival, PHOTO.wildlife, PHOTO.fitness, PHOTO.surf, PHOTO.farmers, PHOTO.obFarmers, PHOTO.market, PHOTO.art, PHOTO.general].filter(Boolean);

 function cardPhoto(o) {
  var p = photoFor(o);
  return DEST && SOCAL_STOCK.indexOf(p) > -1 ? "" : p
 }

 function allWeekHtml(runs, start, t) {
  if (!runs.length) return "";
  var seen = {},
   u = [];
  runs.forEach(function(o) {
   seen[o._t] || (seen[o._t] = 1, u.push(o))
  }), u.sort(function(a, b) {
   return b._pick - a._pick || (a.ed < b.ed ? -1 : a.ed > b.ed ? 1 : 0)
  });
  var cap = awAll ? u.length : 5,
   single = state.when === "custom" && state.from && state.from === state.to && state.from !== t,
   head = single ? "Also on " + v4DayLabel(start, t) : "Happening All Week";
  return '<section class="obg-railbox obg-allweek" aria-label="' + esc(head) + '"><div class="obg-sec-head"><h3>' + esc(head) + "</h3>" + (u.length > 5 ? '<button type="button" class="obg-sec-all" data-aw-all>' + (awAll ? "Show fewer" : "See all " + u.length + " \u2192") + "</button>" : "") + '</div><div class="obg-cu-list">' + u.slice(0, cap).map(function(o) {
   var idx = V4_ROWS.push(o) - 1,
    href = o.url;
   return '<a class="obg-cu" data-r4="' + idx + '" href="' + (href ? esc(tracked(href, "all_week")) : "#") + '"' + (href ? ' target="_blank" rel="noopener"' : "") + ">" + thumbHtml(o, "obg-cu-img", 160) + '<span class="obg-cu-body"><span class="obg-cu-title">' + (o._pick ? '<span class="obg-r4-star" role="img" aria-label="OB Pick">\u2605</span> ' : "") + esc(o.title) + '</span><span class="obg-cu-venue">' + esc(venueText(o)) + '</span><span class="obg-cu-thru">Thru ' + esc(mdLabel(o.ed)) + "</span></span></a>"
  }).join("") + "</div></section>"
 }
 var WK_T = [
  ["happy", "Happy Hours", "glass"],
  ["trivia", "Trivia Nights", "dice"],
  ["openmic", "Open Mics", "mic"],
  ["music", "Live Music", "music"],
  ["games", "Games + Karaoke", "smile"],
  ["other", "More", "list"]
 ];

 var regPick = "",
  firstRegs = null,
  REG_ORDER = ["happy", "trivia", "games", "openmic", "music", "other"];

 function regCountsOf(arr) {
  var c = {};
  return arr.forEach(function(o) {
   var k = regType(o);
   c[k] = (c[k] || 0) + 1
  }), c
 }

 function capFirst(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s
 }

 /* Oct 25 2026: the open regulars row gets type tabs so 90 happy hours don't bury 9 trivia nights */
 function regsListHtml(g) {
  var c = regCountsOf(g.rg),
   types = REG_ORDER.filter(function(k) {
    return c[k]
   }),
   cur = regPick && c[regPick] ? regPick : "",
   tabs = types.length > 1 ? '<div class="obg-regs-tabs" role="group" aria-label="Filter weekly regulars"><button type="button" class="obg-regs-tab" data-regpick="" aria-pressed="' + (cur ? "false" : "true") + '">All <span>' + g.rg.length + "</span></button>" + types.map(function(k) {
    return '<button type="button" class="obg-regs-tab" data-regpick="' + k + '" aria-pressed="' + (cur === k ? "true" : "false") + '">' + esc(capFirst(REG_NAMES[k][1])) + " <span>" + c[k] + "</span></button>"
   }).join("") + "</div>" : "";
  return tabs + g.rg.filter(function(o) {
   return !cur || regType(o) === cur
  }).map(function(o) {
   return v4Row(o, g.day)
  }).join("")
 }

 function weekRegCounts() {
  var save = {
   cats: state.cats,
   picks: state.picks,
   q: state.q,
   free: state.free,
   kids: state.kids,
   dog: state.dog,
   weekly: state.weekly,
   open: state.open,
   ql: lastQuery
  };
  state.cats = [], state.picks = !1, state.q = "", state.free = !1, state.kids = !1, state.dog = !1, state.weekly = "only", state.open = !1;
  var all = filtered({
   ignoreDate: !0
  });
  state.cats = save.cats, state.picks = save.picks, state.q = save.q, state.free = save.free, state.kids = save.kids, state.dog = save.dog, state.weekly = save.weekly, state.open = save.open, lastQuery = save.ql;
  var c = {},
   seen = {};
  return all.forEach(function(o) {
   if (o._weekly) {
    var k = seriesKey(o);
    if (!seen[k]) {
     seen[k] = 1;
     var ty = regType(o);
     c[ty] = (c[ty] || 0) + 1
    }
   }
  }), c
 }

 function weeklyTilesHtml() {
  if (state.q || state.weekly === "only" || regsCatOn() || state.picks) return "";
  if (firstRegs) {
   var dc = regCountsOf(firstRegs.rg),
    dk = firstRegs.day,
    dt = WK_T.filter(function(x) {
     return dc[x[0]]
    }).map(function(x) {
     return '<button type="button" class="obg-wk-tile" data-wk="' + x[0] + '" data-wkday="' + dk + '"><span class="obg-wk-ic">' + icon(x[2]) + '</span><span class="obg-wk-txt"><b>' + esc(x[1]) + "</b><span>" + dc[x[0]] + "</span></span></button>"
    }).join("");
   if (dt) {
    var wpd = weeklyPageHref();
    return '<section class="obg-railbox obg-wkreg" aria-label="Weekly regulars"><div class="obg-sec-head"><h3>Regulars ' + esc(dayWord(dk, todayKey())) + "</h3>" + (wpd ? '<a class="obg-sec-all" href="' + esc(wpd) + '">See all \u2192</a>' : "") + '</div><div class="obg-wk-grid">' + dt + "</div></section>"
   }
  }
  var c = weekRegCounts(),
   tiles = WK_T.filter(function(x) {
    return c[x[0]]
   }).map(function(x) {
    return '<button type="button" class="obg-wk-tile" data-wk="' + x[0] + '"><span class="obg-wk-ic">' + icon(x[2]) + '</span><span class="obg-wk-txt"><b>' + esc(x[1]) + "</b><span>" + c[x[0]] + "</span></span></button>"
   }).join("");
  if (!tiles) return "";
  var wp = weeklyPageHref();
  return '<section class="obg-railbox obg-wkreg" aria-label="Weekly Regulars"><div class="obg-sec-head"><h3>Weekly Regulars</h3>' + (wp ? '<a class="obg-sec-all" href="' + esc(wp) + '">See all \u2192</a>' : '<button type="button" class="obg-sec-all" data-wk="other">See all \u2192</button>') + '</div><div class="obg-wk-grid">' + tiles + "</div></section>"
 }

 function renderListV4(list) {
  var box2 = $("#obgList"),
   more = $("#obgMoreWrap"),
   t = todayKey();
  V4_ROWS = [], firstRegs = null;
  var rail = $("#obgRail");
  if (!list.length) {
   renderList(list), rail && (rail.innerHTML = weeklyTilesHtml());
   return
  }
  firstRegs = null;
  var start = v4Start(t),
   collapse = !state.q && !state.venue && state.weekly !== "only" && !regsCatOn(),
   runs = [],
   rows = [];
  list.forEach(function(o) {
   isLongRun(o) && !state.picks && !state.q && !state.venue ? runs.push(o) : rows.push(o)
  });
  var groups = [],
   byDay = {};
  rows.forEach(function(o) {
   var d = o.sd < start ? start : o.sd,
    g2 = byDay[d];
   g2 || (g2 = byDay[d] = {
    day: d,
    ev: [],
    rg: []
   }, groups.push(g2)), (o._weekly && collapse ? g2.rg : g2.ev).push(o)
  }), groups.sort(function(a, b) {
   return a.day < b.day ? -1 : a.day > b.day ? 1 : 0
  }), groups.forEach(function(g2) {
   g2.rg.length && (g2.rg.length <= 3 || !g2.ev.length) && (g2.ev = g2.ev.concat(g2.rg), g2.rg = []), g2.ev.sort(cmpInDay(g2.day)), g2.rg.sort(cmpInDay(g2.day))
  });
  for (var cap = groups.length === 1 ? 10 : 6, html = "", used = 0, left = 0, gi = 0; gi < groups.length; gi++) {
   var g = groups[gi];
   if (used >= limit) {
    left += g.ev.length;
    continue
   }
   var open = !!dayOpen[g.day],
    n = g.ev.length,
    evs = open ? g.ev.slice(0, Math.max(limit - used, cap)) : n > cap ? g.ev.slice().sort(function(a, b) {
     return topScore(b) - topScore(a)
    }).slice(0, cap).sort(cmpInDay(g.day)) : g.ev;
   used += evs.length, open && (left += n - evs.length);
   !firstRegs && g.rg.length && (firstRegs = g);
   var showRegs = g.rg.length > 0,
    ro = !!regsOpen[g.day],
    dh = dayHead(g.day, t),
    lbl = dh[0],
    evN = g.ev.filter(function(o) {
     return !o._weekly
    }).length,
    rgN = n - evN + g.rg.length,
    cnt = (evN || !rgN ? evN + " event" + (evN === 1 ? "" : "s") : "") + (rgN ? (evN ? " + " : "") + rgN + " weekly regular" + (rgN === 1 ? "" : "s") : "");
   html += '<section class="obg-dgroup" aria-label="' + esc(lbl + ", " + mdLabel(g.day)) + '"><div class="obg-dhead"><h3>' + esc(lbl) + "<span>" + esc(dh[1]) + '</span></h3><span class="obg-dcount">' + esc(cnt) + "</span>" + (n > cap && !open ? '<button type="button" class="obg-sec-all" data-dayall="' + g.day + '">See all ' + n + " \u2192</button>" : "") + '</div><div class="obg-dlist">' + evs.map(function(o) {
    return v4Row(o, g.day)
   }).join("") + (showRegs ? '<div class="obg-regs' + (ro ? " is-open" : "") + '"><button type="button" class="obg-regs-btn" data-regs="' + g.day + '" aria-expanded="' + (ro ? "true" : "false") + '">' + icon("glass") + "<span><b>Weekly regulars:</b> " + esc(regSummary(g.rg)) + '</span><span class="obg-regs-cta">' + (ro ? "Hide" : "Show") + icon("chev") + "</span></button>" + (ro ? '<div class="obg-regs-list">' + regsListHtml(g) + "</div>" : "") + "</div>" : "") + (n > cap && !open ? '<button type="button" class="obg-dmore" data-dayall="' + g.day + '">See all ' + n + " " + (evN === n ? "events" : evN ? "listings" : "weekly regulars") + " " + esc(dayWord(g.day, t)) + ' <span aria-hidden="true">\u2192</span></button>' : "") + (open && n > cap ? '<button type="button" class="obg-dmore is-less" data-dayall="' + g.day + '">Show fewer</button>' : "") + "</div></section>"
  }
  box2.innerHTML = html, rail && (rail.innerHTML = allWeekHtml(runs, start, t) + weeklyTilesHtml()), more.hidden = left <= 0;
  var mb = $("#obgMore");
  mb && (mb.textContent = "Show more (" + left.toLocaleString() + " left)")
 }

 function dateChipOn(k) {
  var t = todayKey();
  if (k === "today") return state.when === "today" || state.when === "tonight";
  if (k === "weekend") return state.when === "weekend";
  if (k === "nextweek") {
   var nw = nextWeekRange(t);
   return state.when === "custom" && state.from === nw[0] && state.to === nw[1]
  }
  if (k.indexOf("d:") === 0) {
   var d = k.slice(2);
   return state.when === "custom" && state.from === d && state.to === d
  }
  return !1
 }

 function renderDatebar() {
  var nav = $("#obgDatebar");
  if (nav) {
   for (var t = todayKey(), nDays = Math.max(6, (7 - dow(t)) % 7 + 1), wk = weekendRange(t), nw = nextWeekRange(t), items = [
     ["today", "Today", mdLabel(t)]
    ], i = 1; i < nDays; i++) {
    var k = addDays(t, i);
    items.push(["d:" + k, i === 1 ? "Tomorrow" : WDL[dow(k)], mdLabel(k)])
   }
   items.push(["weekend", "This Weekend", rangeLabel(wk[0] < t ? t : wk[0], wk[1])]), items.push(["nextweek", "Next Week", rangeLabel(nw[0], nw[1])]);
   var anyOn = !1,
    html = items.map(function(it) {
     var on = dateChipOn(it[0]);
     return anyOn = anyOn || on, '<button type="button" class="obg-dcard' + (it[0] === "nextweek" ? " is-next" : "") + '" data-date="' + it[0] + '" aria-pressed="' + (on ? "true" : "false") + '"><b>' + esc(it[1]) + (it[0] === "nextweek" ? CHEV_R : "") + "</b><span>" + esc(it[2]) + "</span></button>"
    }).join(""),
    custom = state.when === "custom" && !anyOn,
    lbl = "Pick a date",
    sub = "Any day";
   custom ? (lbl = state.from && state.to && state.from !== state.to ? rangeLabel(state.from, state.to) : v4DayLabel(state.from || t, t), sub = state.from && state.to && state.from !== state.to ? "Your dates" : mdLabel(state.from || t)) : state.when === "week" ? (lbl = "This week", sub = "Next 7 days") : state.when === "month" ? (lbl = "This month", sub = "Through " + mdLabel(monthEnd(t))) : state.when === "all" && (sub = "All dates");
   var pickOn = custom || state.when === "week" || state.when === "month";
   html += '<label class="obg-dcard obg-dpick" aria-pressed="' + (pickOn ? "true" : "false") + '"><b>' + icon("cal") + esc(lbl) + "</b><span>" + esc(sub) + '</span><input type="date" id="obgDatePick" min="' + t + '" value="' + (custom && state.from ? state.from : "") + '" aria-label="Pick a date"></label>', nav.__html !== html && (nav.innerHTML = html, nav.__html = html)
  }
 }

 function setDate(k) {
  var was = dateChipOn(k),
   t = todayKey();
  if (was) state.when = "all", state.from = "", state.to = "";
  else if (k === "today" || k === "weekend") state.when = k, state.from = "", state.to = "";
  else if (k === "nextweek") {
   var nw = nextWeekRange(t);
   state.when = "custom", state.from = nw[0], state.to = nw[1]
  } else k.indexOf("d:") === 0 && (state.when = "custom", state.from = state.to = k.slice(2));
  dateTouched = !0, searchWidened = !1, state.open = !1, calMonth = null, regsOpen = {}, dayOpen = {}, awAll = !1, render(), tf("date_bar", k, !was)
 }
 var PK_ROWS = [];

 function relPill(o, t) {
  var d = o.sd < t ? t : o.sd;
  if (o.sd < t && o.ed > t) return "On now";
  if (d === t) return "Today";
  if (d === addDays(t, 1)) return "Tomorrow";
  var w = weekendRange(t);
  return d >= w[0] && d <= w[1] ? "This Weekend" : d < addDays(t, 7) ? WDL[dow(d)] : mdLabel(d)
 }

 function pickWhen(o, t) {
  if (o.sd < t) return "Now thru " + mdLabel(o.ed);
  var d = WD[dow(o.sd)] + ", " + mdLabel(o.sd);
  return o.ed > addDays(o.sd, 1) ? d + " \u2013 " + mdLabel(o.ed) : d + (noTimeShow(o) || o.all_day ? "" : " \xB7 " + timeLabel(o.s))
 }

 function renderPicksFeat() {
  var sec = $("#obgPicksFeat");
  if (sec) {
   if (state.q || state.picks || state.saved || state.view !== "list") {
    sec.hidden = !0;
    return
   }
   var sv = {
    picks: state.picks,
    cats: state.cats,
    free: state.free,
    dog: state.dog,
    kids: state.kids,
    weekly: state.weekly,
    open: state.open,
    ql: lastQuery
   };
   state.picks = !0, state.cats = [], state.free = !1, state.dog = !1, state.kids = !1, state.weekly = "", state.open = !1;
   var pa = filtered({
    ignoreDate: !0
   });
   state.picks = sv.picks, state.cats = sv.cats, state.free = sv.free, state.dog = sv.dog, state.kids = sv.kids, state.weekly = sv.weekly, state.open = sv.open, lastQuery = sv.ql;
   var pday = state.when === "custom" && state.from && state.from === state.to && state.from > todayKey() ? state.from : "";
   pday && (pa = pa.filter(function(o) {
    return o.ed >= pday
   }), pa = pa.filter(function(o) {
    return o.sd <= pday
   }).concat(pa.filter(function(o) {
    return o.sd > pday
   })));
   var seen = {},
    u = [];
   if (pa.forEach(function(o) {
     var k2 = (o.sd < todayKey() ? "now" : o.sd) + "|" + o._vc;
     !seen[o._t] && !seen[k2] && u.length < 20 && (seen[o._t] = 1, seen[k2] = 1, u.push(o))
    }), !u.length) {
    sec.hidden = !0, sec.innerHTML = "";
    return
   }
   var t = todayKey();
   PK_ROWS = u, sec.hidden = !1, sec.innerHTML = '<div class="obg-sec-head"><h2><span class="obg-pf-star" aria-hidden="true">\u2605</span> OB Picks</h2><button type="button" class="obg-sec-all" data-pk-all>See all OB Picks \u2192</button></div><div class="obg-pf-wrap">' + (u.length > 6 ? '<button type="button" class="obg-pf-nav is-prev" data-pf-nav="-1" aria-label="Previous picks">' + CHEV_R + '</button><button type="button" class="obg-pf-nav" data-pf-nav="1" aria-label="More picks">' + CHEV_R + "</button>" : "") + '<div class="obg-pf-row">' + u.map(function(o, i) {
    var p = cardPhoto(o),
     href = o.url;
    return '<div class="obg-pkw"><a class="obg-pk" data-pk="' + i + '" href="' + (href ? esc(tracked(href, "picks_featured")) : "#") + '"' + (href ? ' target="_blank" rel="noopener"' : "") + '><span class="obg-pk-img">' + (p ? '<img src="' + esc(sized(p, 600)) + '" alt="" loading="' + (i < 4 ? "eager" : "lazy") + '" decoding="async" width="600" height="375">' : '<span class="obg-pk-ic">' + icon(catIcon(o)) + "</span>") + '<span class="obg-pk-badge">' + esc(relPill(o, t)) + '</span></span><span class="obg-pk-body"><span class="obg-pk-title">' + esc(o.title) + '</span><span class="obg-pk-when">' + esc(pickWhen(o, t)) + '</span><span class="obg-pk-venue">' + esc(venueText(o)) + "</span></span></a>" + heartBtn(o) + "</div>"
   }).join("") + "</div></div>"
  }
 }
 var GEO = {
   "San Diego": [32.7157, -117.1611],
   "North County": [33.1581, -117.3506],
   "Orange County": [33.7175, -117.8311],
   "Los Angeles / Long Beach": [34.0522, -118.2437],
   "Inland / Desert": [33.8303, -116.5453],
   "Santa Barbara / Central Coast": [34.4208, -119.6982],
   "Las Vegas": [36.1699, -115.1398],
   Charlotte: [35.2271, -80.8431],
   "Twin Cities": [44.9778, -93.265],
   Denver: [39.7392, -104.9903],
   Honolulu: [21.3069, -157.8583],
   "Washington DC": [38.9072, -77.0369],
   "Salt Lake City": [40.7608, -111.891],
   Portland: [45.5152, -122.6784],
   Phoenix: [33.4484, -112.074],
   Tempe: [33.4255, -111.94],
   Tokyo: [35.6762, 139.6503],
   "St. Pete": [27.7676, -82.6403],
   "Los Angeles": [34.0522, -118.2437],
   "Palm Springs + Joshua Tree": [33.8303, -116.5453],
   "Inland Empire": [33.9533, -117.3962]
  },
  WX = null,
  wxFor = "",
  wxBusy = !1;

 function glanceGeo() {
  var r = DEST || (state.region !== "all" ? state.region : DEFAULT_REGION);
  return [r, GEO[r] || GEO["San Diego"]]
 }

 function loadWeather() {
  var g = glanceGeo(),
   key = g[0] + "|" + todayKey();
  if (!(wxFor === key || wxBusy)) {
   try {
    var c = JSON.parse(window.sessionStorage.getItem("obg_wx") || "null");
    if (c && c.k === key) {
     WX = c.d, wxFor = key;
     return
    }
   } catch (_) {}
   wxBusy = !0;
   var u = "https://api.open-meteo.com/v1/forecast?latitude=" + g[1][0] + "&longitude=" + g[1][1] + "&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_probability_max&temperature_unit=fahrenheit&forecast_days=7&timezone=" + encodeURIComponent(TZ);
   fetch(u).then(function(r) {
    return r.ok ? r.json() : null
   }).then(function(j) {
    if (wxBusy = !1, !(!j || !j.daily)) {
     WX = j.daily, wxFor = key;
     try {
      window.sessionStorage.setItem("obg_wx", JSON.stringify({
       k: key,
       d: WX
      }))
     } catch (_) {}
     renderGlance(), renderHeroWx()
    }
   }).catch(function() {
    wxBusy = !1
   })
  }
 }
 var WXI = {
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
  part: '<path d="M8 3v1.5M3.5 8H5M4.8 4.8l1 1M11.2 4.8l-1 1"/><path d="M5.6 10.5A3 3 0 1 1 11 8"/><path d="M8 19h9.5a3.5 3.5 0 0 0 0-7 5 5 0 0 0-9.6 1A3 3 0 0 0 8 19z"/>',
  cloud: '<path d="M7 19h10.5a4 4 0 0 0 0-8 6 6 0 0 0-11.4 1.5A3.3 3.3 0 0 0 7 19z"/>',
  rain: '<path d="M7 15h10.5a4 4 0 0 0 0-8 6 6 0 0 0-11.4 1.5A3.3 3.3 0 0 0 7 15z"/><path d="M8 18l-1 3M12 18l-1 3M16 18l-1 3"/>',
  snow: '<path d="M7 15h10.5a4 4 0 0 0 0-8 6 6 0 0 0-11.4 1.5A3.3 3.3 0 0 0 7 15z"/><path d="M8 19h.01M12 20h.01M16 19h.01M10 22h.01M14 22h.01"/>',
  storm: '<path d="M7 15h10.5a4 4 0 0 0 0-8 6 6 0 0 0-11.4 1.5A3.3 3.3 0 0 0 7 15z"/><path d="m12 15-2 4h3l-2 4"/>',
  fog: '<path d="M4 9h16M3 13h18M5 17h14"/>'
 };

 function wxKind(c) {
  return c === 0 ? ["sun", "Clear"] : c <= 2 ? ["part", "Partly cloudy"] : c === 3 ? ["cloud", "Cloudy"] : c === 45 || c === 48 ? ["fog", "Fog"] : c >= 95 ? ["storm", "Storms"] : c >= 71 && c <= 77 || c === 85 || c === 86 ? ["snow", "Snow"] : ["rain", "Rain"]
 }

 function wxHtml(t) {
  return !WX || !WX.time ? "" : '<div class="obg-gl-wx" aria-label="Weather this week">' + WX.time.slice(0, 7).map(function(d, i) {
   var k = wxKind(WX.weather_code[i]),
    p = WX.precipitation_probability_max ? WX.precipitation_probability_max[i] : null;
   return '<div class="obg-gl-day' + (d === t ? " is-today" : "") + '" title="' + esc(k[1]) + '"><b>' + esc(d === t ? "Today" : WD[dow(d)]) + '</b><svg class="obg-i obg-wx-' + k[0] + '" viewBox="0 0 24 24" role="img" aria-label="' + esc(k[1]) + '">' + WXI[k[0]] + '</svg><span class="obg-gl-temp">' + Math.round(WX.temperature_2m_max[i]) + "\xB0 <i>" + Math.round(WX.temperature_2m_min[i]) + "\xB0</i></span>" + (p != null && p >= 30 ? '<span class="obg-gl-rain">' + p + "% rain</span>" : "") + "</div>"
  }).join("") + "</div>"
 }
 var SHOWERS = [
  ["01-03", "Quadrantid meteor shower"],
  ["04-22", "Lyrid meteor shower"],
  ["05-05", "Eta Aquariid meteor shower"],
  ["07-29", "Delta Aquariid meteor shower"],
  ["08-12", "Perseid meteor shower"],
  ["10-08", "Draconid meteor shower"],
  ["10-21", "Orionid meteor shower"],
  ["11-17", "Leonid meteor shower"],
  ["12-13", "Geminid meteor shower"],
  ["12-21", "Ursid meteor shower"]
 ];

 function moonAge(k) {
  var ms = keyDate(k).getTime() + 288e5,
   ref = Date.UTC(2e3, 0, 6, 18, 14),
   a = (ms - ref) / 864e5 % 29.530588853;
  return a < 0 ? a + 29.530588853 : a
 }

 function skyNotes(t) {
  for (var out = [], full = null, nw = null, i = 0; i < 7; i++) {
   var k = addDays(t, i),
    a = moonAge(k);
   Math.abs(a - 14.77) < .75 && !full && (full = k), (a < .75 || a > 28.78) && !nw && (nw = k);
   var md = k.slice(5);
   SHOWERS.forEach(function(s) {
    s[0] === md && out.push([k, s[1] + " peak", "Best after midnight, away from city lights", k === t ? "Tonight" : WDL[dow(k)] + " night"])
   })
  }
  return full && out.push([full, "Full moon", "Bright night for moonlit walks, tough for stars", full === t ? "Tonight" : WDL[dow(full)]]), nw && out.push([nw, "New moon", "Darkest skies of the month for stargazing", nw === t ? "Tonight" : WDL[dow(nw)]]), out.sort(function(a2, b) {
   return a2[0] < b[0] ? -1 : 1
  })
 }
 var BIG_VENUE = /amphithe|arena|stadium|field|center|centre|pavilion|fillmore|ogden|mission ballroom|paramount|bowl|coliseum|forum|garden|sphere|dome|hall/;

 function glanceItems(t) {
  for (var end = addDays(t, 6), now = Date.now(), b = {
    sky: [],
    sports: [],
    music: [],
    comedy: [],
    fest: []
   }, seen = {}, n = 0; n < ITEMS.length; n++) {
   var o = ITEMS[n];
   if (!(o.e < now || o.sd > end || o.ed < t || o._weekly || o._low || !locationOk(o))) {
    var k = o.cat === "Space + Stargazing" || o._cats && o._cats.nature ? "sky" : o.cat === "Sports" ? "sports" : o.cat === "Concert" ? "music" : o.cat === "Comedy" ? "comedy" : o.cat === "Festival" ? "fest" : "";
    if (!(!k || k === "fest" && /bingo/.test(o._t))) {
     var dk = k + "|" + o._tk,
      dv = k + "|" + o.sd + "|" + o._vc + "|" + (o.all_day ? "" : o.s);
     seen[dk] || seen[dv] || (seen[dk] = seen[dv] = 1, b[k].push(o))
    }
   }
  }

  function score(o2) {
   return topScore(o2) + (o2.sd < t ? -15 : 0)
  }
  return ["sports", "music", "comedy", "fest"].forEach(function(k2) {
   b[k2].sort(function(x, y) {
    return score(y) - score(x) || x.s - y.s
   })
  }), b.sky.sort(function(x, y) {
   return (y.cat === "Space + Stargazing") - (x.cat === "Space + Stargazing") || score(y) - score(x) || x.s - y.s
  }), b
 }

 function glWhen(o, t) {
  if (o.sd < t) return "Thru " + mdLabel(o.ed);
  var d = o.sd === t ? "Today" : o.sd === addDays(t, 1) ? "Tomorrow" : WDL[dow(o.sd)];
  return d + (noTimeShow(o) || o.all_day ? "" : " \xB7 " + timeLabel(o.s))
 }
 var GL_ROWS = [];

 function glList(arr, t) {
  return arr = arr.slice().sort(function(x, y) {
   return x.s - y.s
  }), arr.map(function(o) {
   var idx = GL_ROWS.push(o) - 1,
    href = o.url;
   return '<a class="obg-gl-item" data-gl="' + idx + '" href="' + (href ? esc(tracked(href, "glance")) : "#") + '"' + (href ? ' target="_blank" rel="noopener"' : "") + '><span class="obg-gl-when">' + esc(glWhen(o, t)) + '</span><span class="obg-gl-title">' + (o._pick ? '<span class="obg-r4-star" role="img" aria-label="OB Pick">\u2605</span> ' : "") + esc(o.title) + '</span><span class="obg-gl-venue">' + esc(o.place || venueText(o)) + "</span></a>"
  }).join("")
 }

 function renderGlance() {
  var sec = $("#obgGlance");
  if (sec) {
   if (state.q || state.picks || state.saved || state.view !== "list") {
    sec.hidden = !0;
    return
   }
   loadWeather(), GL_ROWS = [];
   var t = todayKey(),
    b = glanceItems(t),
    notes = skyNotes(t);
   b.sky.some(function(o) {
    return /meteor|orionid|perseid|geminid|leonid|lyrid|quadrantid|aquariid|draconid|ursid/.test(o._t)
   }) && (notes = notes.filter(function(x) {
    return !/meteor/.test(x[1])
   }));
   var cols = [];
   notes = notes.slice(0, 2);
   var sky = notes.map(function(x) {
    return '<div class="obg-gl-item is-note"><span class="obg-gl-when">' + esc(x[3]) + '</span><span class="obg-gl-title">' + esc(x[1]) + '</span><span class="obg-gl-venue">' + esc(x[2]) + "</span></div>"
   }).join("") + glList(b.sky.slice(0, Math.max(1, 3 - notes.length)), t);
   b.music.length && cols.push(["music", "Live Music", glList(b.music.slice(0, 3), t), "music"]), b.comedy.length && cols.push(["mic", "Comedy", glList(b.comedy.slice(0, 3), t), "comedy"]), b.sports.length && cols.push(["ball", "Sports", glList(b.sports.slice(0, 3), t), "sports"]), b.fest.length && cols.push(["tent", "Festivals", glList(b.fest.slice(0, 3), t), "fest"]), sky && cols.push(["leaf", "Nature", sky, b.sky.length ? "nature" : ""]);
   var wx = "";
   if (!cols.length && !wx) {
    sec.hidden = !0;
    return
   }
   var html = '<div class="obg-sec-head"><div><h2>This Week at a Glance</h2><p>' + esc(rangeLabel(t, addDays(t, 6))) + (glanceGeo()[0] && !DEST ? " \xB7 " + esc(glanceGeo()[0]) : "") + '</p></div></div><div class="obg-gl-card">' + wx + '<div class="obg-gl-cols">' + cols.map(function(c) {
    return '<div class="obg-gl-col"><div class="obg-gl-colhead"><h3>' + icon(c[0]) + esc(c[1]) + "</h3>" + (c[3] ? '<button type="button" class="obg-sec-all" data-gl-all="' + c[3] + '" aria-label="See all upcoming ' + esc(c[1].toLowerCase()) + '">See all \u2192</button>' : "") + "</div>" + c[2] + "</div>"
   }).join("") + "</div></div>";
   sec.innerHTML = html, sec.hidden = !1
  }
 }

 function renderHeroWx() {
  var inner = $(".obg-hero-inner");
  if (inner) {
   loadWeather();
   var box2 = $("#obgHeroWx");
   box2 || (box2 = document.createElement("div"), box2.id = "obgHeroWx", box2.className = "obg-hero-wx", box2.hidden = !0, inner.appendChild(box2));
   var html = wxHtml(todayKey());
   if (!html) {
    box2.hidden = !0;
    return
   }
   html = '<p class="obg-hwx-title">' + icon("sun") + "Weather this week</p>" + html, box2.__html !== html && (box2.innerHTML = html, box2.__html = html), box2.hidden = !1
  }
 }

 function topScore(o) {
  return (o._pick ? 100 : 0) + (o._high ? 60 : 0) + (BIG_VENUE.test(norm(o.place)) ? 20 : 0) + (cardPhoto(o) ? 10 : 0) - (o._weekly ? 50 : 0)
 }
 var SOCAL_LIST = [
   ["", "All of SoCal", "/pages/events?region=all", "/pages/events-happy-hours"],
   ["San Diego", "San Diego", "/pages/events-san-diego", "/pages/events-happy-hours"],
   ["Los Angeles", "Los Angeles", "/pages/events-los-angeles", "/pages/events-happy-hours"],
   ["Orange County", "Orange County", "/pages/events-orange-county", "/pages/events-happy-hours"],
   ["Palm Springs + Joshua Tree", "Palm Springs + Joshua Tree", "/pages/events-palm-springs-joshua-tree", "/pages/events-happy-hours"],
   ["Inland Empire", "Inland Empire", "/pages/events-inland-empire", "/pages/events-happy-hours"]
  ],
  CITY_LIST = [
   ["Charlotte", "Charlotte", "/pages/events-charlotte"],
   ["Denver", "Denver", "/pages/events-denver"],
   ["Honolulu", "Honolulu", "/pages/events-honolulu"],
   ["Las Vegas", "Las Vegas", "/pages/events-las-vegas"],
   ["Twin Cities", "Minneapolis + St. Paul", "/pages/events-minneapolis-st-paul"],
   ["Phoenix", "Phoenix", "/pages/events-phoenix"],
   ["Portland", "Portland", "/pages/events-portland"],
   ["Salt Lake City", "Salt Lake City", "/pages/events-salt-lake-city"],
   ["St. Pete", "St. Pete + Tampa Bay", "/pages/events-st-pete"],
   ["Washington DC", "Washington, DC", "/pages/events-washington-dc"],
   ["Tokyo", "Tokyo", "/pages/events-tokyo"]
  ];

 function renderCitySwitch() {
  var inner = $(".obg-hero-inner");
  if (!(!inner || $("#obgCity"))) {
   var hh = /happy-hours/.test(location.pathname),
    cur = DEST || "",
    opt = function(c) {
     var u = hh ? c[3] || c[2] + "-happy-hours" : c[2];
     return '<option value="' + esc(u) + '"' + (c[0] === cur ? " selected" : "") + ">" + esc(c[1]) + "</option>"
    },
    opts = '<optgroup label="Southern California">' + SOCAL_LIST.map(opt).join("") + '</optgroup><optgroup label="Other destinations">' + CITY_LIST.map(opt).join("") + '</optgroup><option value="/pages/events-destinations">All cities\u2026</option>',
    w = document.createElement("label");
   w.className = "obg-city", w.innerHTML = icon("pin") + '<select id="obgCity" aria-label="Choose a city">' + opts + "</select>" + icon("chev"), inner.insertBefore(w, inner.firstChild), $("#obgCity").addEventListener("change", function(e) {
    var u = e.target.value;
    u && (tf("city_switch", u, !0), location.href = u)
   })
  }
 }

 function fullWhen(o) {
  var t = todayKey();
  if (o._series) return "Every " + o._series + (o.all_day ? "" : " \xB7 " + timeLabel(o.s) + (o.hasEnd ? "\u2013" + timeLabel(o.e) : ""));
  if (o.ed > o.sd && (o.all_day || o.ed > addDays(o.sd, 1))) return (o.sd < t ? "Now" : WD[dow(o.sd)] + ", " + mdLabel(o.sd)) + " \u2013 " + WD[dow(o.ed)] + ", " + mdLabel(o.ed) + (o.all_day ? "" : " \xB7 " + timeLabel(o.s));
  var d = WDL[dow(o.sd)] + ", " + mdLabel(o.sd);
  return noTimeShow(o) ? d + " \xB7 Time TBA" : o.all_day ? d : d + " \xB7 " + timeLabel(o.s) + (o.hasEnd && o.e - o.s < 20 * 36e5 ? "\u2013" + timeLabel(o.e) : "")
 }

 function openSheet(o, from) {
  var sh = $("#obgSheet");
  if (!(!sh || !o)) {
   lastFocus = from || document.activeElement;
   var p = photoFor(o),
    href = o.url,
    price = priceOf(o),
    desc = detailFor(o),
    note = o._pick && o.pick_note ? o.pick_note : "";
   sh.__o = o, $(".obg-sheet-card", sh).innerHTML = '<button type="button" class="obg-sheet-x" data-sheet-close aria-label="Close">' + icon("x") + "</button>" + (p ? '<img class="obg-sheet-img" src="' + esc(sized(p, 900)) + '" alt="" decoding="async">' : "") + '<div class="obg-sheet-body"><p class="obg-sheet-when">' + esc(fullWhen(o)) + '</p><h2 id="obgSheetT">' + esc(o.title) + '</h2><p class="obg-sheet-venue">' + icon("pin") + "<span>" + esc(venueText(o)) + "</span>" + (price ? '<span class="obg-r4-price' + (price === "Free" ? " is-free" : "") + '">' + esc(price) + "</span>" : "") + "</p>" + (o._pick ? '<div class="obg-sheet-pick"><b>\u2605 OB Pick</b><span>' + (note ? esc(note) : "Hand-picked by OB Tie Dye.") + "</span></div>" : "") + (desc ? '<p class="obg-sheet-desc">' + esc(desc) + "</p>" : "") + '<div class="obg-sheet-tags">' + tagsFor(o, 4) + '</div><div class="obg-sheet-acts">' + (href ? '<a class="obg-sheet-go" href="' + esc(tracked(href, "detail")) + '" target="_blank" rel="noopener">' + icon("ticket") + (o._weekly || NO_PRICE_CATS.test(o.cat) ? "See details" : "Tickets + info") + "</a>" : "") + (function() {
    var vid = venueId(o);
    if (!vid || vid === state.venue) return "";
    var vc = venueCount(vid);
    return vc < 2 ? "" : (venueCss(), '<button type="button" class="obg-sheet-share obg-sheet-more" data-venue="' + esc(vid) + '" data-venue-name="' + esc(o.place) + '">' + icon("pin") + "More at " + esc(o.place) + " (" + vc + ")</button>")
   })() + '<button type="button" class="obg-sheet-share" data-sheet-share><svg class="obg-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12"/><path d="m7 8 5-5 5 5"/><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/></svg>Share</button></div><p class="obg-sheet-note">Times and details can change. Check the event page before heading out.</p></div>', sh.hidden = !1, document.documentElement.classList.add("obg-lock");
   var x = $(".obg-sheet-x", sh);
   x && x.focus(), track("select_content", {
    content_type: "event_detail",
    item_id: cut(o.title)
   })
  }
 }

 function closeSheet() {
  var sh = $("#obgSheet");
  if (!(!sh || sh.hidden) && (sh.hidden = !0, document.documentElement.classList.remove("obg-lock"), lastFocus && lastFocus.focus)) try {
   lastFocus.focus()
  } catch (_) {}
 }

 function shareSheet() {
  var sh = $("#obgSheet"),
   o = sh && sh.__o;
  if (!o) return;
  var u = new URL(location.origin + location.pathname),
   d = o.sd < todayKey() ? todayKey() : o.sd;
  u.searchParams.set("q", String(o.title).split(" @ ")[0].replace(/[@:()!?,."\/–—#*|\[\]]/g, " ").replace(/\s+/g, " ").trim()), o._series || (u.searchParams.set("from", d), u.searchParams.set("to", d)), u.searchParams.set("utm_source", "share"), u.searchParams.set("utm_medium", "referral"), u.searchParams.set("utm_campaign", "event_guide_share");
  var data = {
   title: o.title,
   text: o.title + " \xB7 " + fullWhen(o) + "\nFound on the OB Tie Dye " + (window.OB_GUIDE_SHARE_NAME || "SoCal Event Guide"),
   url: u.toString()
  };

  function toastMsg(m) {
   var tt = ROOT.querySelector(".obg-toast");
   tt || (tt = document.createElement("div"), tt.className = "obg-toast", tt.setAttribute("role", "status"), tt.setAttribute("aria-live", "polite"), ROOT.appendChild(tt)), tt.textContent = m, tt.classList.add("is-on"), setTimeout(function() {
    tt.classList.remove("is-on")
   }, 2200)
  }

  function copyIt() {
   navigator.clipboard && window.isSecureContext ? navigator.clipboard.writeText(data.url).then(function() {
    toastMsg("Link copied")
   }, function() {
    window.prompt("Copy this link:", data.url)
   }) : window.prompt("Copy this link:", data.url)
  }
  navigator.share ? navigator.share(data).catch(function(e) {
   e && e.name !== "AbortError" && copyIt()
  }) : copyIt(), track("share", {
   method: "event_detail",
   content_type: "event",
   item_id: cut(o.title)
  })
 }

 function bindV4() {
  ROOT.addEventListener("click", function(e) {
   var el = e.target.closest ? e.target : e.target.parentElement,
    b;
   if (el) {
    if (b = el.closest("[data-save]")) {
     e.preventDefault(), e.stopPropagation(), toggleSave(b.getAttribute("data-save"));
     return
    }
    if (b = el.closest("[data-saved-chip]")) {
     e.preventDefault(), e.stopPropagation(), state.saved ? (state.saved = !1, savedPrev && (state.when = savedPrev.when, state.from = savedPrev.from, state.to = savedPrev.to), savedPrev = null) : (savedPrev = {
      when: state.when,
      from: state.from,
      to: state.to
     }, state.saved = !0, state.when = "all", state.from = "", state.to = ""), tf("saved_chip", "saved", state.saved), render(), scrollToResults();
     return
    }
    if (b = el.closest("[data-pf-nav]")) {
     e.preventDefault(), e.stopPropagation();
     var pr = $(".obg-pf-row");
     pr && pr.scrollBy({
      left: +b.getAttribute("data-pf-nav") * pr.clientWidth * .92,
      behavior: "smooth"
     });
     return
    }
    if (b = el.closest("[data-gl-all]")) {
     e.preventDefault(), e.stopPropagation();
     var gc = b.getAttribute("data-gl-all"),
      gt = todayKey();
     state.cats = [gc], state.weekly = "", state.picks = !1, state.when = "all", state.from = "", state.to = "", state.open = !1, dateTouched = !0, searchWidened = !1, dayOpen = {}, regsOpen = {}, calMonth = null, state.view = "list", tf("glance_all", gc, !0), render(), scrollToResults();
     return
    }
    if ((b = el.closest("[data-gl]")) && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) {
     var go = GL_ROWS[+b.getAttribute("data-gl")];
     go && (e.preventDefault(), e.stopPropagation(), openSheet(go, b));
     return
    }
    if ((b = el.closest("[data-r4],[data-pk]")) && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) {
     var o = b.hasAttribute("data-pk") ? PK_ROWS[+b.getAttribute("data-pk")] : V4_ROWS[+b.getAttribute("data-r4")];
     o && (e.preventDefault(), e.stopPropagation(), openSheet(o, b));
     return
    }
    if ((b = el.closest("[data-sheet-close]")) || el.classList.contains("obg-sheet-bg")) {
     e.preventDefault(), e.stopPropagation(), closeSheet();
     return
    }
    if (el.closest("[data-sheet-share]")) {
     e.preventDefault(), e.stopPropagation(), shareSheet();
     return
    }
    if (b = el.closest("[data-venue]")) {
     e.preventDefault(), e.stopPropagation(), enterVenue(b.getAttribute("data-venue"), b.getAttribute("data-venue-name"));
     return
    }
    if (el.closest("[data-venue-clear]")) {
     e.preventDefault(), e.stopPropagation(), leaveVenue();
     return
    }
    if (el.closest("[data-venue-share]")) {
     e.preventDefault(), e.stopPropagation(), shareVenue();
     return
    }
    if (b = el.closest("[data-dist]")) {
     e.preventDefault(), e.stopPropagation();
     var dv = b.getAttribute("data-dist");
     state.dist = state.dist === dv ? "" : dv, dayOpen = {}, tf("race_distance", dv || "all", !!state.dist), render();
     return
    }
    if (b = el.closest(".obg-sheet-go")) {
     var so = $("#obgSheet").__o;
     so && track("select_content", {
      content_type: "event_link",
      item_id: cut(so.title),
      link_url: cut(so.url || "")
     });
     return
    }
    if (b = el.closest("[data-date]")) {
     e.preventDefault(), e.stopPropagation(), setDate(b.getAttribute("data-date"));
     return
    }
    if (b = el.closest(".obg-dpick")) {
     var di = $("#obgDatePick");
     if (di && di.showPicker && e.target !== di) {
      e.preventDefault();
      try {
       di.showPicker()
      } catch (_) {
       di.focus()
      }
     }
     return
    }
    if (b = el.closest("[data-regpick]")) {
     e.preventDefault(), e.stopPropagation(), regPick = b.getAttribute("data-regpick") || "", render(!0), tf("regulars_type", regPick || "all", !0);
     return
    }
    if (b = el.closest("[data-regs]")) {
     e.preventDefault(), e.stopPropagation();
     var rd = b.getAttribute("data-regs");
     regsOpen[rd] = !regsOpen[rd], render(!0), tf("regulars_day", rd, regsOpen[rd]);
     return
    }
    if (b = el.closest("[data-dayall]")) {
     e.preventDefault(), e.stopPropagation();
     var dd = b.getAttribute("data-dayall");
     if (dayOpen[dd] = !dayOpen[dd], render(!0), !dayOpen[dd]) {
      var gh = $(".obg-dgroup");
      if (gh) {
       var gy = gh.getBoundingClientRect().top;
       gy < 0 && window.scrollTo({
        top: gy + window.scrollY - stickyTop() - 12
       })
      }
     }
     tf("day_all", dd, dayOpen[dd]);
     return
    }
    if (el.closest("[data-pk-all]")) {
     e.preventDefault(), e.stopPropagation(), state.picks = !0, state.when = "all", state.from = "", state.to = "", dateTouched = !0, searchWidened = !1, state.view = "list", tf("picks_all", "all", !0), render(), scrollToResults();
     return
    }
    if (el.closest("[data-aw-all]")) {
     e.preventDefault(), e.stopPropagation(), awAll = !awAll, render(!0);
     return
    }
    if (b = el.closest("[data-wk]")) {
     e.preventDefault(), e.stopPropagation();
     var wk = b.getAttribute("data-wk"),
      wkd = b.getAttribute("data-wkday");
     if (wkd) {
      regPick = wk, regsOpen[wkd] = !0, render(!0), tf("weekly_card", wk, !0);
      var rb = document.querySelector('#obg .obg-regs-btn[data-regs="' + wkd + '"]');
      rb && window.scrollTo({
       top: rb.getBoundingClientRect().top + window.scrollY - stickyTop() - 90,
       behavior: "smooth"
      });
      return
     }
     if (wk === "trivia" || wk === "openmic") {
      var keep = dateTouched,
       keepArea = areaTouched;
      dateTouched = !0, areaTouched = !0;
      var qv = wk === "trivia" ? "trivia" : "open mic",
       sq = $("#obgSearch");
      sq && (sq.value = qv);
      var sc = $(".obg-search-clear");
      /* Oct 25 2026: keep the area the visitor was already in instead of widening to all of SoCal */
      sc && (sc.hidden = !1), tf("weekly_card", wk, !0), setQuery(qv), preSearch && (preSearch.touched = keepArea), areaTouched = keepArea, dateTouched = keep, scrollToResults();
      return
     }
     wk === "happy" ? state.cats = ["happy"] : wk === "games" ? (state.cats = ["games"], state.weekly = "only") : wk === "music" ? (state.cats = ["music"], state.weekly = "only") : (state.cats = CAT_KEYS.slice(), state.weekly = "only"), tf("weekly_card", wk, !0), render(), scrollToResults();
     return
    }
   }
  }, !0), ROOT.addEventListener("change", function(e) {
   e.target && e.target.id === "obgDatePick" && e.target.value && (dateTouched = !0, searchWidened = !1, dayOpen = {}, state.when = "custom", state.from = state.to = e.target.value, state.open = !1, calMonth = null, regsOpen = {}, render(), tf("date_bar", "pick", !0))
  }), document.addEventListener("keydown", function(e) {
   if (e.key === "Escape") {
    var sh = $("#obgSheet");
    sh && !sh.hidden && closeSheet()
   }
  })
 }

 function bootV4() {
  ROOT.classList.add("obg-v4"), renderCitySwitch(), /happy-hours/.test(location.pathname) && ROOT.classList.add("obg-hh"), Array.prototype.forEach.call(document.querySelectorAll("style"), function(s) {
   var x = s.textContent || "";
   x.indexOf('value="games"]') > -1 && x.indexOf("foodwine") > -1 && s.parentNode.removeChild(s)
  });
  var cb = $(".obg-chipbar");
  if (cb && !$("#obgDatebar")) {
   var db = document.createElement("div");
   db.className = "obg-datebar", db.innerHTML = '<nav class="obg-dates" id="obgDatebar" aria-label="Pick a day"></nav>', cb.parentNode.insertBefore(db, cb)
  }
  var lst = $("#obgList"),
   mw = $("#obgMoreWrap");
  if (lst && !$("#obgRail")) {
   var cols = document.createElement("div");
   cols.className = "obg-cols";
   var cm = document.createElement("div");
   cm.className = "obg-colmain", lst.parentNode.insertBefore(cols, lst), cols.appendChild(cm), cm.appendChild(lst), mw && cm.appendChild(mw);
   var rl = document.createElement("aside");
   rl.id = "obgRail", rl.className = "obg-rail", rl.setAttribute("aria-label", "More around town"), cols.appendChild(rl)
  }
  var br = $(".obg-browser");
  if (br && !$("#obgPicksFeat")) {
   var pf = document.createElement("section");
   pf.className = "obg-pfeat", pf.id = "obgPicksFeat", pf.hidden = !0, pf.setAttribute("aria-label", "Featured OB Picks"), br.parentNode.insertBefore(pf, br)
  }
  if (br && !$("#obgGlance")) {
   var gl = document.createElement("section");
   gl.className = "obg-glance", gl.id = "obgGlance", gl.hidden = !0, gl.setAttribute("aria-label", "This week at a glance"), br.parentNode.insertBefore(gl, br)
  }
  var dbar = $(".obg-datebar"),
   cbar = $(".obg-chipbar");
  if (br) {
   var fb = document.createElement("div");
   fb.className = "obg-filterbar", fb.id = "obgFilterbar", br.parentNode.insertBefore(fb, br), dbar && fb.appendChild(dbar), cbar && fb.appendChild(cbar)
  }
  var disc = $(".obl-discover"),
   anchor = $(".obl-morelinks") || $(".obg-note");
  if (disc && anchor && anchor.parentNode) {
   var tail = document.createElement("div");
   tail.className = "obl-discover obl-tail", Array.prototype.slice.call(disc.children).forEach(function(c) {
    if (c.querySelector && c.querySelector(".obl-regions")) {
     c.parentNode.removeChild(c);
     return
    }(c.classList.contains("obl-mod") && !c.classList.contains("obl-picks") || c.classList.contains("obl-areas")) && tail.appendChild(c)
   }), tail.children.length && anchor.parentNode.insertBefore(tail, anchor)
  }
  if (!$("#obgSheet")) {
   var sh = document.createElement("div");
   sh.className = "obg-sheet", sh.id = "obgSheet", sh.hidden = !0, sh.innerHTML = '<div class="obg-sheet-bg" data-sheet-close></div><div class="obg-sheet-card" role="dialog" aria-modal="true" aria-labelledby="obgSheetT"></div>', ROOT.appendChild(sh)
  }
  if (!document.getElementById("obg-v4-css")) {
   var st = document.createElement("style");
   st.id = "obg-v4-css", st.textContent = V4_CSS, document.head.appendChild(st)
  }
  bindV4()
 }
 var V4_CSS = '#obg .obg-regs-tabs{display:flex;gap:8px;overflow-x:auto;padding:12px 14px;border-bottom:1px solid var(--line2);background:#fbf7ef;scrollbar-width:none}#obg .obg-regs-tabs::-webkit-scrollbar{display:none}#obg .obg-regs-tab{flex:0 0 auto;display:inline-flex;align-items:center;gap:6px;padding:7px 12px;border:1px solid var(--line);border-radius:999px;background:#fff;color:var(--navy);font:inherit;font-size:13px;font-weight:600;white-space:nowrap;cursor:pointer}#obg .obg-regs-tab span{color:var(--muted);font-weight:500}#obg .obg-regs-tab[aria-pressed="true"]{background:var(--navy);border-color:var(--navy);color:#fff}#obg .obg-regs-tab[aria-pressed="true"] span{color:#dfe8ef}#obg .obg-day-regs{font-style:italic;opacity:.8}#obg .obg-ag-day .obg-day-regs{display:block;margin-top:4px}#obg.obg-v4{--or:#b4541f;--or-bg:#fbeee5;--or-line:#efcdb6;--gold-ink:#7a5208}#obg.obg-v4 .obg-hero{min-height:360px}#obg.obg-v4 .obg-hero-img{left:auto;width:62%;object-position:center 55%}#obg.obg-v4 .obg-hero:after{background:linear-gradient(90deg,#16324a 0%,#16324a 38%,rgba(22,50,74,.72) 50%,rgba(22,50,74,.12) 72%,rgba(22,50,74,0) 100%)}#obg.obg-v4 .obg-hero-inner{padding:56px 28px 40px}#obg.obg-v4 .obg-kicker{color:#f0a070}#obg.obg-v4 .obg-hero h1{text-shadow:none;max-width:640px}#obg.obg-v4.obg .obg-hero .obg-lede{display:block;max-width:560px;margin-top:12px;color:#dfe8ef;font-size:16.5px;line-height:1.5}#obg.obg-v4 .obg-searchbar{max-width:720px;box-shadow:0 8px 24px rgba(0,0,0,.18)}#obg.obg-v4 .obl-picks,#obg.obg-v4 .obl-quick[aria-label="When"],#obg.obg-v4 .obg-picks-bar{display:none!important}#obg.obg-v4:not(.obg-hh) .obn-bar{display:none!important}#obg.obg-v4:not(.obg-hh) .obl-discover:not(.obl-tail){display:none}#obg.obg-v4 .obl-allhead h2,#obg.obg-v4 .obl-allhead p{display:none}#obg.obg-v4 .obl-allhead{margin:0;padding:0;min-height:0}#obg.obg-v4 .obl-tail{margin-top:24px}#obg .obg-filterbar{margin-top:18px;background:var(--bg);border-top:1px solid var(--line);border-bottom:1px solid var(--line)}#obg .obg-datebar{background:transparent}#obg .obg-dates:after{content:"";flex:0 0 1px}#obg .obg-dates{display:flex;gap:10px;overflow-x:auto;scrollbar-width:none;max-width:1360px;margin:0 auto;padding:16px 28px 14px;-webkit-overflow-scrolling:touch;scroll-padding:0 28px}#obg .obg-dates::-webkit-scrollbar{display:none}#obg .obg-dcard{position:relative;flex:0 0 auto;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;gap:1px;min-width:104px;height:58px;padding:0 16px;border-radius:12px;border:1px solid var(--line);background:#fff;color:var(--navy);text-align:left;white-space:nowrap;cursor:pointer;transition:border-color .15s,background .15s}#obg .obg-dcard b{display:inline-flex;align-items:center;gap:4px;font-size:14.5px;font-weight:700;line-height:1.2}#obg .obg-dcard span{font-size:12.5px;color:var(--muted);line-height:1.2}#obg .obg-dcard .obg-i{width:15px;height:15px}#obg .obg-dcard:hover{border-color:var(--navy)}#obg .obg-dcard[aria-pressed="true"]{background:var(--navy);border-color:var(--navy);color:#fff}#obg .obg-dcard[aria-pressed="true"] span{color:#cfdbe5}#obg .obg-dcard:focus-visible,#obg .obg-dpick:focus-within{outline:2px solid var(--or);outline-offset:2px}#obg .obg-dpick{margin-left:auto}#obg .obg-dpick b .obg-i{margin-right:2px}#obg .obg-dpick input{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0;margin:0}#obg.obg-v4 .obg-chipbar{background:var(--bg);border-bottom:0}#obg.obg-v4 .obg-chips{padding:4px 28px 6px}#obg.obg-v4 .obg-chip-pick{background:var(--or-bg);border-color:var(--or-line);color:var(--or)}#obg.obg-v4 .obg-chip-pick .obg-i{color:var(--or);fill:currentColor}#obg.obg-v4 .obg-chips .obg-chip[aria-pressed="true"]{background:var(--navy);border-color:var(--navy);color:#fff}#obg.obg-v4 .obg-chips .obg-chip-pick[aria-pressed="true"]{background:var(--or);border-color:var(--or);color:#fff}#obg.obg-v4 .obg-chips .obg-chip-pick[aria-pressed="true"] .obg-i{color:#fff}#obg .obg-chip-more{margin-left:auto}#obg .obg-sec-head{display:flex;align-items:flex-end;justify-content:space-between;gap:6px 16px;flex-wrap:wrap;margin-bottom:14px}#obg .obg-sec-head h2,#obg .obg-sec-head h3{margin:0;font-family:var(--display);font-weight:700;font-size:30px;line-height:1.08;color:var(--navy)}#obg .obg-sec-head p{margin-top:2px;font-size:14px;color:var(--muted)}#obg .obg-sec-all{flex:0 0 auto;padding:4px 0;border:0;background:transparent;font-size:14.5px;font-weight:700;color:var(--or);white-space:nowrap}#obg .obg-sec-all:hover{text-decoration:underline;text-underline-offset:3px}#obg .obg-pf-star{color:var(--or)}#obg .obg-pfeat{max-width:1360px;margin:0 auto;padding:22px 28px 6px}#obg .obg-pfeat[hidden]{display:none}#obg .obg-pk{height:100%;display:flex;flex-direction:column;min-width:0;background:#fff;border:1px solid var(--line);border-radius:14px;overflow:hidden;color:var(--ink);transition:box-shadow .15s,transform .15s}#obg .obg-pk:hover{box-shadow:0 8px 20px rgba(22,50,74,.12);transform:translateY(-1px)}#obg .obg-pk:focus-visible{outline:2px solid var(--navy);outline-offset:2px}#obg .obg-pk-img{position:relative;display:block;aspect-ratio:16/10;background:var(--sand);overflow:hidden}#obg .obg-pk-img img{display:block;width:100%;height:100%;object-fit:cover}#obg .obg-pk-ic{display:grid;place-items:center;width:100%;height:100%;color:var(--navy)}#obg .obg-pk-ic .obg-i{width:34px;height:34px}#obg .obg-pk-badge{position:absolute;left:10px;top:10px;padding:4px 9px;border-radius:6px;background:var(--or);color:#fff;letter-spacing:.04em;text-transform:uppercase;font-size:11px!important;font-size:12px;font-weight:700;box-shadow:0 1px 4px rgba(0,0,0,.18)}#obg .obg-pk-body{display:flex;flex-direction:column;gap:4px;padding:12px 14px 14px}#obg .obg-pk-title{font-family:var(--display);font-weight:700;font-size:21px;line-height:1.12;color:var(--navy);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}#obg .obg-pk-when{font-size:13px;font-weight:700;color:var(--or)}#obg .obg-pk-venue{font-size:13px;color:var(--muted);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#obg.obg-v4 .obg-browser{display:block;max-width:1360px;padding:18px 28px 40px}#obg.obg-v4 .obg-toolbar{display:none!important}#obg.obg-v4 .obg-results-head{margin-bottom:6px}#obg.obg-v4:not(.obg-isq) #obgHeading{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}#obg.obg-v4:not(.obg-isq) .obg-count{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}#obg.obg-v4:not(.obg-isq) .obg-results-head{justify-content:flex-end}#obg.obg-v4 .obg-list{background:transparent;border:0;border-radius:0;padding:0}#obg .obg-dgroup{margin:6px 0 30px}#obg .obg-dhead{display:flex;align-items:baseline;justify-content:space-between;gap:12px;padding:0 2px 10px;margin-bottom:12px;border-bottom:1px solid var(--line)}#obg .obg-dhead h3{margin:0;font-family:var(--display);font-weight:700;font-size:30px;line-height:1.05;color:var(--navy)}#obg .obg-dhead h3 span{margin-left:12px;font-family:var(--ui);font-size:15px;font-weight:600;color:var(--muted)}#obg .obg-dcount{font-size:13.5px;color:var(--muted);white-space:nowrap}#obg .obg-dlist{background:#fff;border:1px solid var(--line);border-radius:14px;overflow:hidden}#obg .obg-r4-price{display:inline-block;font-size:12.5px;font-weight:700;color:var(--ink);white-space:nowrap}#obg .obg-r4-price.is-free{color:#1d6b42}#obg .obg-r4-pill{display:inline-block;padding:3px 10px;border-radius:999px;font-size:12px;font-weight:600;line-height:1.35;background:#eef1f3;color:#3e4c55}#obg .obg-p-violet{background:#efeafb;color:#5b3fa0}#obg .obg-p-orange{background:var(--or-bg);color:#9a4518}#obg .obg-p-rose{background:#fcebee;color:#a23a52}#obg .obg-p-green{background:#e7f4ec;color:#1f6b40}#obg .obg-p-amber{background:#fdf1d8;color:#83570b}#obg .obg-p-indigo{background:#e9ecfa;color:#3d4a9c}#obg .obg-p-blue{background:#e5f0fa;color:#215f93}#obg .obg-p-navy{background:#e4ebf1;color:var(--navy)}#obg .obg-p-fuchsia{background:#f9e8f6;color:#8e2f7e}#obg .obg-r4.is-reg .obg-r4-title{font-weight:600}#obg .obg-regs{border-top:1px solid var(--line2);background:#f6f0e4}#obg .obg-dlist>.obg-regs:first-child{border-top:0}#obg .obg-regs-btn{display:flex;align-items:center;gap:12px;width:100%;min-height:52px;padding:12px 18px;border:0;background:transparent;text-align:left;color:var(--navy);font-size:14px;line-height:1.35}#obg .obg-regs-btn b{font-weight:700}#obg .obg-regs-btn:focus-visible{outline:2px solid var(--navy);outline-offset:-2px}#obg .obg-regs-cta{margin-left:auto;display:inline-flex;align-items:center;gap:4px;font-weight:700;white-space:nowrap}#obg .obg-regs-cta .obg-i{width:16px;height:16px;transition:transform .15s}#obg .obg-regs.is-open .obg-regs-cta .obg-i{transform:rotate(180deg)}#obg .obg-regs-list{background:#fff}#obg .obg-dmore{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;min-height:50px;padding:12px 18px;border:0;border-top:1px solid var(--line);background:#fbf8f2;font-size:14.5px;font-weight:700;color:var(--or)}#obg .obg-dmore:hover{background:#f6efe2}#obg .obg-dmore.is-less{color:var(--navy);font-weight:600}#obg .obg-dmore:focus-visible{outline:2px solid var(--navy);outline-offset:-2px}#obg .obg-allweek,#obg .obg-wkreg{margin:8px 0 34px}#obg .obg-wk-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(170px,1fr));gap:12px}#obg .obg-wk-tile{display:flex;flex-direction:column;align-items:flex-start;gap:10px;min-height:104px;padding:14px;background:#fff;border:1px solid var(--line);border-radius:14px;text-align:left;color:var(--navy);transition:border-color .15s}#obg .obg-wk-tile:hover{border-color:var(--navy)}#obg .obg-wk-tile:focus-visible{outline:2px solid var(--navy);outline-offset:2px}#obg .obg-wk-ic{display:grid;place-items:center;width:38px;height:38px;border-radius:10px;background:var(--or-bg);color:var(--or)}#obg .obg-wk-ic .obg-i{width:20px;height:20px}#obg .obg-wk-txt{display:flex;flex-direction:column;gap:1px}#obg .obg-wk-txt b{font-size:15px;font-weight:700;line-height:1.2}#obg .obg-wk-txt span{font-size:13px;color:var(--muted)}#obg .obg-sheet{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center}#obg .obg-sheet[hidden]{display:none}#obg .obg-sheet-bg{position:absolute;top:0;right:0;bottom:0;left:0;background:rgba(9,22,30,.55)}#obg .obg-sheet-card{position:relative;width:100%;max-width:560px;max-height:88vh;overflow:auto;background:#fff;border-radius:18px 18px 0 0;box-shadow:0 -8px 30px rgba(0,0,0,.2);-webkit-overflow-scrolling:touch;overscroll-behavior:contain}#obg .obg-sheet-img{display:block;width:100%;aspect-ratio:16/9;object-fit:cover;background:var(--sand)}#obg .obg-sheet-body{display:flex;flex-direction:column;gap:10px;padding:18px 20px 22px}#obg .obg-sheet-x{position:absolute;top:10px;right:10px;z-index:1;width:40px;height:40px;display:grid;place-items:center;border:0;border-radius:50%;background:rgba(255,255,255,.95);box-shadow:0 1px 4px rgba(0,0,0,.2);color:var(--navy)}#obg .obg-sheet-x:focus-visible{outline:2px solid var(--navy);outline-offset:2px}#obg .obg-sheet-when{font-size:13px;font-weight:700;letter-spacing:.03em;text-transform:uppercase;color:var(--or)}#obg .obg-sheet h2{margin:0;padding-right:36px;font-family:var(--display);font-weight:700;font-size:30px;line-height:1.08;color:var(--navy)}#obg .obg-sheet-img+.obg-sheet-body h2{padding-right:0}#obg .obg-sheet-venue{display:flex;align-items:center;flex-wrap:wrap;gap:6px 10px;font-size:14.5px;color:var(--muted)}#obg .obg-sheet-venue .obg-i{width:16px;height:16px}#obg .obg-sheet-pick{display:flex;flex-direction:column;gap:2px;padding:10px 12px;background:var(--or-bg);border:1px solid var(--or-line);border-radius:10px;font-size:14px;color:var(--ink)}#obg .obg-sheet-pick b{color:var(--or)}#obg .obg-sheet-desc{font-size:15px;line-height:1.55;white-space:pre-line}#obg .obg-sheet-tags{display:flex;flex-wrap:wrap;gap:6px}#obg .obg-sheet-tags:empty{display:none}#obg .obg-sheet-acts{display:flex;flex-wrap:wrap;gap:10px;margin-top:4px}#obg .obg-sheet-go{flex:1 1 200px;display:inline-flex;align-items:center;justify-content:center;gap:8px;height:50px;border-radius:12px;background:var(--navy);color:#fff!important;font-weight:700}#obg .obg-sheet-go:hover{background:#0f2536}#obg .obg-sheet-share{flex:0 0 auto;display:inline-flex;align-items:center;gap:8px;height:50px;padding:0 18px;border:1px solid var(--line);border-radius:12px;background:#fff;font-weight:600;color:var(--navy)}#obg .obg-sheet-note{font-size:12.5px;color:var(--muted)}@media (min-width:700px){#obg .obg-sheet{align-items:center;padding:24px}#obg .obg-sheet-card{border-radius:18px;max-height:86vh}}@media (min-width:900px){#obg.obg-v4 .obg-side{position:fixed;top:0;right:0;bottom:0;left:auto;width:400px;max-width:92vw;height:100vh;max-height:none;z-index:2147482001;display:flex;flex-direction:column;background:#fff;border-radius:0;box-shadow:-12px 0 40px rgba(0,0,0,.2);transform:translateX(105%);transition:transform .25s ease;visibility:hidden}#obg.obg-v4.is-drawer .obg-side{transform:none;visibility:visible}#obg.obg-v4 .obg-side-top{display:flex;align-items:center;justify-content:space-between;padding:18px 22px 12px;border-bottom:1px solid var(--line)}#obg.obg-v4 .obg-side-scroll{flex:1;padding:12px 22px 8px}#obg.obg-v4 .obg-side-foot{flex-direction:row;align-items:center;justify-content:space-between;padding:14px 22px;border-top:1px solid var(--line)}#obg.obg-v4 .obg-backdrop{display:block;position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147482000;background:rgba(9,22,30,.45);opacity:0;pointer-events:none;transition:opacity .2s}#obg.obg-v4.is-drawer .obg-backdrop{opacity:1;pointer-events:auto}#obg.obg-v4 .obg-apply{display:inline-flex;align-items:center;justify-content:center;gap:4px;height:44px;padding:0 20px;border:0;border-radius:999px;background:var(--navy);color:#fff;font-size:15px;font-weight:700}}@media (max-width:1100px){}@media (max-width:899px){#obg.obg-v4 .obg-hero{min-height:0}#obg.obg-v4 .obg-hero-img{width:100%}#obg.obg-v4 .obg-hero:after{background:linear-gradient(180deg,rgba(22,50,74,.55) 0%,rgba(22,50,74,.9) 70%,#16324a 100%)}#obg.obg-v4 .obg-hero-inner{padding:40px 16px 24px}#obg.obg-v4.obg .obg-hero .obg-lede{font-size:14.5px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}#obg .obg-dates{padding:12px 16px 10px;gap:8px;scroll-padding:0 16px}#obg .obg-dcard{min-width:92px;height:52px;padding:0 13px}#obg .obg-dcard b{font-size:14px}#obg .obg-dpick{margin-left:0}#obg.obg-v4 .obg-chips{padding:2px 16px 6px}#obg .obg-chip-more{margin-left:0}#obg .obg-pfeat{padding:18px 16px 4px}#obg .obg-sec-head h2,#obg .obg-sec-head h3,#obg .obg-dhead h3{font-size:26px}#obg.obg-v4 .obg-browser{padding:10px 16px 28px}}@media (max-width:640px){#obg .obg-wk-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}#obg .obg-wk-tile{min-height:0;flex-direction:row;align-items:center;padding:12px}#obg .obg-regs-btn{padding:12px 14px;gap:10px}#obg .obg-dhead h3 span{display:block;margin:2px 0 0;font-size:13.5px}}#obg .obg-pf-wrap{position:relative}#obg .obg-pf-row{display:grid;grid-auto-flow:column;grid-auto-columns:calc((100% - 48px)/4);gap:16px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding:2px 0 6px}#obg .obg-pf-row::-webkit-scrollbar{display:none}#obg .obg-pkw{position:relative;min-width:0;scroll-snap-align:start}#obg .obg-pf-nav{position:absolute;top:calc(50% - 46px);right:-14px;z-index:2;width:44px;height:44px;display:grid;place-items:center;border:1px solid var(--line);border-radius:50%;background:#fff;color:var(--navy);box-shadow:0 4px 14px rgba(0,0,0,.15)}#obg .obg-pf-nav.is-prev{right:auto;left:-14px}#obg .obg-pf-nav.is-prev .obg-i{transform:rotate(180deg)}#obg .obg-save{position:absolute;z-index:1;width:40px;height:40px;display:grid;place-items:center;border:0;border-radius:50%;background:transparent;color:#8b979c;cursor:pointer}#obg .obg-save .obg-i{width:21px;height:21px}#obg .obg-save:hover{color:var(--or)}#obg .obg-save.is-on{color:var(--or)}#obg .obg-save.is-on .obg-i{fill:currentColor}#obg .obg-save:focus-visible{outline:2px solid var(--navy);outline-offset:-2px}#obg .obg-pkw .obg-save{top:8px;right:8px;background:rgba(255,255,255,.94);color:var(--navy);box-shadow:0 1px 5px rgba(0,0,0,.18)}#obg .obg-pkw .obg-save.is-on{color:var(--or)}#obg .obg-chip-saved .obg-i{color:var(--or)}#obg .obg-chip-saved[aria-pressed="true"] .obg-i{color:#fff;fill:currentColor}#obg .obg-cols{display:grid;grid-template-columns:minmax(0,1fr) 340px;gap:28px;align-items:start}#obg .obg-colmain{min-width:0}#obg .obg-rail{display:flex;flex-direction:column;gap:18px;min-width:0}#obg .obg-rail:empty{display:none}#obg[data-mode="calendar"] .obg-rail{display:none}#obg .obg-railbox{margin:0;padding:16px 16px 14px;background:#fff;border:1px solid var(--line);border-radius:14px}#obg .obg-railbox .obg-sec-head{align-items:baseline;margin-bottom:10px}#obg .obg-railbox .obg-sec-head h3{font-size:24px}#obg .obg-railbox .obg-sec-all{font-size:13.5px}#obg .obg-cu-list{display:flex;flex-direction:column}#obg .obg-cu{display:flex;gap:12px;align-items:center;padding:9px 0;border-top:1px solid var(--line2);color:var(--ink)}#obg .obg-cu:first-child{border-top:0;padding-top:2px}#obg .obg-cu:hover .obg-cu-title{text-decoration:underline;text-underline-offset:2px}#obg .obg-cu-img{flex:0 0 58px;width:58px;height:58px;display:grid;place-items:center;border-radius:9px;overflow:hidden;background:var(--sand);color:var(--navy)}#obg .obg-cu-img img{width:100%;height:100%;object-fit:cover;display:block}#obg .obg-cu-body{display:flex;flex-direction:column;gap:1px;min-width:0}#obg .obg-cu-title{font-weight:700;font-size:14px;line-height:1.25;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}#obg .obg-cu-title .obg-r4-star{color:var(--or)}#obg .obg-cu-venue{font-size:12.5px;color:var(--muted);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#obg .obg-cu-thru{font-size:12.5px;font-weight:700;color:var(--or)}#obg .obg-rail .obg-wk-grid{grid-template-columns:1fr 1fr;gap:8px}#obg .obg-rail .obg-wk-tile{flex-direction:row;align-items:center;gap:10px;min-height:0;padding:10px}#obg .obg-rail .obg-wk-ic{width:34px;height:34px;flex:0 0 34px}#obg .obg-rail .obg-wk-txt b{font-size:13.5px}#obg .obg-rail .obg-wk-txt span{font-size:12.5px}#obg .obg-dhead .obg-sec-all{margin-left:16px}#obg .obg-dhead{align-items:center}#obg .obg-dhead h3{flex:1}#obg .obg-r4w{position:relative;border-top:1px solid var(--line2)}#obg .obg-dlist>.obg-r4w:first-child,#obg .obg-regs-list>.obg-r4w:first-child{border-top:0}#obg .obg-regs-list{border-top:1px solid var(--line2)}#obg .obg-r4w>.obg-save{top:50%;right:10px;margin-top:-20px}#obg .obg-r4{text-align:left;display:grid;grid-template-columns:78px minmax(0,1fr) auto 72px;grid-template-areas:"time title tags thumb" "time meta tags thumb";gap:2px 16px;align-items:center;min-height:68px;padding:10px 58px 10px 18px;color:var(--ink)}#obg .obg-r4:hover{background:#fdfaf4}#obg .obg-r4:focus-visible{outline:2px solid var(--navy);outline-offset:-2px}#obg .obg-r4-time{grid-area:time;align-self:center;font-weight:700;font-size:14px;color:var(--or);white-space:nowrap}#obg .obg-r4-title{grid-area:title;align-self:end;min-width:0;font-weight:700;font-size:15.5px;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#obg .obg-r4-title .obg-title{display:inline;margin:0;font:inherit;color:inherit;-webkit-line-clamp:unset;overflow:visible}#obg .obg-r4-star{color:var(--or)}#obg .obg-r4-meta{grid-area:meta;align-self:start;min-width:0;font-size:13.5px;color:var(--muted);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#obg .obg-r4-tags{grid-area:tags;display:flex;align-items:center;justify-content:flex-end;gap:8px;white-space:nowrap}#obg .obg-r4-thumb{grid-area:thumb;width:72px;height:50px;display:grid;place-items:center;border-radius:8px;overflow:hidden;background:var(--sand);color:var(--navy)}#obg .obg-r4-thumb img{width:100%;height:100%;object-fit:cover;display:block}#obg .obg-r4-thumb .obg-i{width:20px;height:20px}@media (max-width:1180px){#obg .obg-cols{grid-template-columns:minmax(0,1fr)}#obg .obg-rail{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:16px;align-items:start}}@media (max-width:899px){#obg .obg-pf-row{grid-auto-columns:72%;gap:12px;margin:0 -16px;padding:2px 16px 6px;scroll-padding:0 16px}#obg .obg-pf-nav{display:none}}@media (max-width:640px){#obg .obg-r4{grid-template-columns:58px minmax(0,1fr) 56px;grid-template-areas:"time title thumb" "time meta thumb" "time tags thumb";gap:2px 10px;min-height:0;padding:12px 46px 12px 14px}#obg .obg-r4-time{align-self:start;padding-top:2px;font-size:13px}#obg .obg-r4-title{white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;font-size:15px}#obg .obg-r4-tags{justify-content:flex-start;padding-top:3px}#obg .obg-r4-thumb{width:56px;height:46px;align-self:start}#obg .obg-r4w>.obg-save{right:4px}#obg .obg-rail{grid-template-columns:minmax(0,1fr)}#obg .obg-dhead .obg-dcount{display:none}}#obg .obg-glance{max-width:1360px;margin:0 auto;padding:22px 28px 4px}#obg .obg-glance[hidden]{display:none}#obg .obg-gl-card{background:#fff;border:1px solid var(--line);border-radius:14px;overflow:hidden}#obg .obg-gl-wx{display:grid;grid-template-columns:repeat(7,minmax(0,1fr));border-bottom:1px solid var(--line);background:#fdfaf4}#obg .obg-gl-day{display:flex;flex-direction:column;align-items:center;gap:4px;padding:12px 6px;border-left:1px solid var(--line2);text-align:center}#obg .obg-gl-day:first-child{border-left:0}#obg .obg-gl-day b{font-size:13px;font-weight:700;color:var(--navy)}#obg .obg-gl-day.is-today{background:#fff}#obg .obg-gl-day.is-today b{color:var(--or)}#obg .obg-gl-day .obg-i{width:26px;height:26px;color:var(--navy)}#obg .obg-gl-day .obg-wx-sun,#obg .obg-gl-day .obg-wx-part{color:#d18a16}#obg .obg-gl-day .obg-wx-rain,#obg .obg-gl-day .obg-wx-storm{color:#2f6f9f}#obg .obg-gl-temp{font-size:14px;font-weight:700;color:var(--ink)}#obg .obg-gl-temp i{font-style:normal;font-weight:500;color:var(--muted)}#obg .obg-gl-rain{font-size:11.5px;color:#2f6f9f;font-weight:600}#obg .obg-gl-cols{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr))}#obg .obg-gl-col{padding:16px 18px 12px;border-left:1px solid var(--line2);min-width:0}#obg .obg-gl-col:first-child{border-left:0}#obg .obg-gl-col h3{display:flex;align-items:center;gap:8px;margin:0 0 8px;font-size:12.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--navy)}#obg .obg-gl-col h3 .obg-i{width:17px;height:17px;color:var(--or)}#obg .obg-gl-item{display:flex;flex-direction:column;gap:1px;padding:8px 0;border-top:1px solid var(--line2);color:var(--ink)}#obg .obg-gl-col h3+.obg-gl-item{border-top:0;padding-top:2px}#obg a.obg-gl-item:hover .obg-gl-title{text-decoration:underline;text-underline-offset:2px}#obg .obg-gl-when{font-size:12px;font-weight:700;color:var(--or)}#obg .obg-gl-title{font-weight:700;font-size:14px;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}#obg .obg-gl-title .obg-r4-star{color:var(--or)}#obg .obg-gl-venue{font-size:12.5px;color:var(--muted);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#obg .obg-rail .obg-wk-grid{grid-template-columns:1fr}#obg .obg-rail .obg-wk-txt{flex:1;flex-direction:row;align-items:center;justify-content:space-between;gap:8px}#obg .obg-rail .obg-wk-txt span{font-weight:700;color:var(--or)}@media (max-width:899px){#obg .obg-glance{padding:18px 16px 4px}#obg .obg-gl-wx{display:flex;overflow-x:auto;scrollbar-width:none}#obg .obg-gl-wx::-webkit-scrollbar{display:none}#obg .obg-gl-day{flex:0 0 74px}#obg .obg-gl-cols{display:grid;grid-template-columns:none;grid-auto-flow:column;grid-auto-columns:82%;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none}#obg .obg-gl-cols::-webkit-scrollbar{display:none}#obg .obg-gl-col{scroll-snap-align:start;padding:14px 16px 10px}}#obg .obg-gl-colhead{display:flex;align-items:baseline;justify-content:space-between;gap:8px;margin-bottom:8px}#obg .obg-gl-colhead h3{margin:0}#obg .obg-gl-colhead .obg-sec-all{font-size:13px;padding:0}#obg .obg-gl-colhead+.obg-gl-item{border-top:0;padding-top:2px}#obg .obg-gl-cols{grid-template-columns:repeat(auto-fit,minmax(210px,1fr))}#obg .obg-gl-day{flex-direction:row;justify-content:center;gap:6px;padding:8px 6px;flex-wrap:nowrap;white-space:nowrap}#obg .obg-gl-day b{font-size:12.5px}#obg .obg-gl-day .obg-i{width:18px;height:18px}#obg .obg-gl-temp{font-size:13px}#obg .obg-gl-rain{font-size:11px}#obg .obg-gl-rain:empty{display:none}@media (max-width:899px){#obg .obg-gl-day{flex:0 0 auto;padding:8px 12px}}#obg .obg-hero-wx{margin-top:16px;max-width:980px}#obg .obg-hero-wx[hidden]{display:none}#obg .obg-hero-wx .obg-gl-wx{display:flex;gap:6px;background:transparent;border:0;overflow-x:auto;scrollbar-width:none}#obg .obg-hero-wx .obg-gl-wx::-webkit-scrollbar{display:none}#obg .obg-hero-wx .obg-gl-day{flex:1 0 auto;padding:7px 10px;border:1px solid rgba(255,255,255,.22);border-radius:10px;background:rgba(9,22,30,.35);gap:6px;color:#fff}#obg .obg-hero-wx .obg-gl-day:first-child{border-left:1px solid rgba(255,255,255,.22)}#obg .obg-hero-wx .obg-gl-day b{color:#fff;font-size:12.5px}#obg .obg-hero-wx .obg-gl-day.is-today{background:rgba(255,255,255,.14)}#obg .obg-hero-wx .obg-gl-day.is-today b{color:#f0a070}#obg .obg-hero-wx .obg-gl-day .obg-i,#obg .obg-hero-wx .obg-gl-day .obg-wx-sun,#obg .obg-hero-wx .obg-gl-day .obg-wx-part,#obg .obg-hero-wx .obg-gl-day .obg-wx-rain,#obg .obg-hero-wx .obg-gl-day .obg-wx-storm{color:#fff;width:17px;height:17px}#obg .obg-hero-wx .obg-gl-day .obg-wx-sun,#obg .obg-hero-wx .obg-gl-day .obg-wx-part{color:#ffd27a}#obg .obg-hero-wx .obg-gl-temp{color:#fff;font-size:13px}#obg .obg-hero-wx .obg-gl-temp i{color:#c9d6e0}#obg .obg-hero-wx .obg-gl-rain{color:#9fd0ff}@media (max-width:899px){#obg .obg-hero-wx{margin:12px -16px 0}#obg .obg-hero-wx .obg-gl-wx{padding:0 16px}#obg .obg-hero-wx .obg-gl-day{flex:0 0 auto}}#obg .obg-hwx-title{display:none}@media (min-width:1000px){#obg.obg-v4 .obg-hero-inner{position:relative}#obg .obg-hero-wx{position:absolute;top:50%;right:28px;transform:translateY(-50%);width:270px;max-width:none;margin:0;padding:14px 16px 10px;border-radius:16px;background:rgba(9,22,30,.55);border:1px solid rgba(255,255,255,.18);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);box-shadow:0 10px 30px rgba(0,0,0,.25)}#obg .obg-hwx-title{display:flex;align-items:center;gap:7px;margin:0 0 6px;font-size:11.5px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#f0a070}#obg .obg-hwx-title .obg-i{width:15px;height:15px}#obg .obg-hero-wx .obg-gl-wx{display:flex;flex-direction:column;gap:0;overflow:visible}#obg .obg-hero-wx .obg-gl-day,#obg .obg-hero-wx .obg-gl-day:first-child{display:grid;grid-template-columns:52px 22px 1fr auto;align-items:center;gap:8px;padding:6px 2px;border:0;border-top:1px solid rgba(255,255,255,.12);border-radius:0;background:transparent;text-align:left}#obg .obg-hero-wx .obg-gl-day:first-child{border-top:0}#obg .obg-hero-wx .obg-gl-day.is-today{background:transparent}#obg .obg-hero-wx .obg-gl-day b{font-size:13.5px}#obg .obg-hero-wx .obg-gl-day .obg-i{width:19px;height:19px}#obg .obg-hero-wx .obg-gl-temp{font-size:14px}#obg .obg-hero-wx .obg-gl-rain{font-size:12px;text-align:right}#obg.obg-v4 .obg-hero h1,#obg.obg-v4 .obg-searchbar{max-width:min(720px,calc(100% - 310px))}}#obg.obg-v4 .obg-kicker{display:none}#obg .obg-city{position:relative;display:inline-flex;align-items:center;gap:6px;height:38px;margin-bottom:14px;padding:0 12px;border:1px solid rgba(255,255,255,.35);border-radius:999px;background:rgba(9,22,30,.35);color:#fff;cursor:pointer}#obg .obg-city:hover{border-color:#fff}#obg .obg-city:focus-within{outline:2px solid #f0a070;outline-offset:2px}#obg .obg-city .obg-i{width:16px;height:16px;flex:0 0 auto}#obg .obg-city .obg-i:first-child{color:#f0a070}#obg .obg-city select{appearance:none;-webkit-appearance:none;border:0;background:transparent;color:#fff;font:inherit;font-size:14px;font-weight:700;letter-spacing:.02em;padding:0 2px;cursor:pointer;outline:0}#obg .obg-city option{color:#16324a;background:#fff;font-weight:600}@media (max-width:899px){#obg .obg-city{height:34px;margin-bottom:10px}}#obg.obg-v4 .obg-pf-row{grid-auto-columns:calc((100% - 60px)/6);gap:12px}#obg.obg-v4 .obg-pk{border-radius:12px}#obg.obg-v4 .obg-pk-body{gap:3px;padding:9px 11px 11px}#obg.obg-v4 .obg-pk-title{font-size:16px;line-height:1.15}#obg.obg-v4 .obg-pk-when,#obg.obg-v4 .obg-pk-venue{font-size:12px}#obg.obg-v4 .obg-pk-badge{left:8px;top:8px;padding:3px 7px;font-size:10px}#obg.obg-v4 .obg-pkw .obg-save{transform:scale(.82);transform-origin:top right}@media (max-width:1199px){#obg.obg-v4 .obg-pf-row{grid-auto-columns:calc((100% - 48px)/5)}}@media (max-width:899px){#obg.obg-v4 .obg-pf-row{grid-auto-columns:44%;gap:10px}#obg.obg-v4 .obg-pk-title{font-size:15px}}';

 function collapseOn() {
  return (!!state.q || !!state.venue) && state.when === "all" && !state.open && !(lastQuery && lastQuery.when)
 }

 function collapseWeekly(list) {
  for (var seen = {}, out = [], i = 0; i < list.length; i++) {
   var o = list[i];
   if (!o._weekly) {
    out.push(o);
    continue
   }
   var k = o._tk + "|" + o._vc + "|" + (o.all_day ? "all" : timeLabel(o.s)),
    d = keyDate(o.sd).getUTCDay(),
    c = seen[k];
   if (c) {
    c._wd[d] = 1;
    continue
   }
   c = Object.create(o), c._wd = {}, c._wd[d] = 1, seen[k] = c, out.push(c)
  }
  return out.forEach(function(c2) {
   if (c2._wd) {
    var days = [1, 2, 3, 4, 5, 6, 0].filter(function(d2) {
     return c2._wd[d2]
    });
    if (days.length < 2) {
     c2._wd = null;
     return
    }
    if (days.length === 7) {
     c2._series = "day";
     return
    }
    if (days.length === 5 && !c2._wd[0] && !c2._wd[6]) {
     c2._series = "weekday";
     return
    }
    for (var parts = [], i2 = 0; i2 < days.length;) {
     for (var j = i2; j + 1 < days.length && (days[j + 1] === days[j] + 1 || days[j] === 6 && days[j + 1] === 0);) j++;
     parts.push(j - i2 >= 2 ? WD[days[i2]] + "\u2013" + WD[days[j]] : days.slice(i2, j + 1).map(function(d2) {
      return WD[d2]
     }).join(" + ")), i2 = j + 1
    }
    c2._series = parts.join(" + ")
   }
  }), out
 }
 var renderQueued = !1,
  DISTS = [
   ["5k", "5K"],
   ["10k", "10K"],
   ["half", "Half"],
   ["full", "Marathon"],
   ["trail", "Trail + Ultra"],
   ["tri", "Tri"]
  ];

 function distOf(o) {
  if (o._dist) return o._dist;
  var d = distIn(o._t);
  return Object.keys(d).length || (d = distIn(norm(o.desc))), o._dist = d
 }

 function distIn(x) {
  var d = {};
  return /\b(5k|5 ?km|3\.1)\b|turkey trot|fun run|color run/.test(x) && (d["5k"] = 1), /\b(10k|10 ?km|8k|12k|15k|\d+ ?milers?)\b/.test(x) && (d["10k"] = 1), /half[- ]?marathon|\bhalf\b|13\.1/.test(x) && (d.half = 1), /marathon/.test(x.replace(/half[- ]?marathon/g, "")) && (d.full = 1), /\btrail\b|\bultra\b|\b50k\b|\b50 ?miler?\b|\bmountain\b/.test(x) && (d.trail = 1), /triathlon|duathlon|aquathlon/.test(x) && (d.tri = 1), d
 }

 function distOk(o) {
  return !!(o._cats && o._cats.races && distOf(o)[state.dist])
 }

 function racesOnly() {
  return state.cats.length === 1 && state.cats[0] === "races"
 }

 function renderDistBar() {
  var bar = $("#obgDistBar");
  if (!bar) {
   var lst = $("#obgList");
   if (!lst || !lst.parentNode) return;
   bar = document.createElement("div"), bar.id = "obgDistBar", bar.className = "obg-distbar", bar.setAttribute("role", "group"), bar.setAttribute("aria-label", "Race distance"), bar.hidden = !0, lst.parentNode.insertBefore(bar, lst)
  }
  if (!racesOnly() || state.view === "calendar") {
   state.dist && !racesOnly() && (state.dist = ""), bar.hidden = !0, bar.innerHTML = "";
   return
  }
  if (!$("#obg-dist-css")) {
   var st = document.createElement("style");
   st.id = "obg-dist-css", st.textContent = '#obg .obg-distbar{display:flex;gap:8px;flex-wrap:wrap;margin:0 0 14px}#obg .obg-distbar[hidden]{display:none}#obg .obg-distbar button{padding:7px 13px;border-radius:999px;border:1px solid #d9cdb8;background:#fff;color:inherit;font:600 13.5px/1.2 Inter,sans-serif;cursor:pointer;white-space:nowrap}#obg .obg-distbar button[aria-pressed="true"]{background:var(--navy,#16324a);border-color:var(--navy,#16324a);color:#fff}#obg .obg-distbar button em{font-style:normal;opacity:.65;margin-left:4px;font-weight:500}', document.head.appendChild(st)
  }
  var save = state.dist,
   counts = {},
   n = 0;
  state.dist = "";
  try {
   filtered().forEach(function(o) {
    if (o._cats.races) {
     n++;
     var d = distOf(o);
     for (var k in d) counts[k] = (counts[k] || 0) + 1
    }
   })
  } finally {
   state.dist = save
  }
  bar.innerHTML = '<button type="button" data-dist="" aria-pressed="' + !state.dist + '">All races<em>' + n + "</em></button>" + DISTS.filter(function(d) {
   return counts[d[0]]
  }).map(function(d) {
   return '<button type="button" data-dist="' + d[0] + '" aria-pressed="' + (state.dist === d[0]) + '">' + esc(d[1]) + "<em>" + counts[d[0]] + "</em></button>"
  }).join(""), bar.hidden = !1
 }
 var venuePrev = null,
  VENUE_CSS_ON = !1;

 function venueSample(id) {
  for (var n = 0; n < ITEMS.length; n++)
   if (venueId(ITEMS[n]) === id) return ITEMS[n];
  return null
 }

 function venueLabel() {
  if (!state.venueName) {
   var o = venueSample(state.venue);
   state.venueName = o ? o.place : state.venue.split("--")[0].replace(/-/g, " ")
  }
  return state.venueName
 }

 function venueDedupe(list) {
  var seen = {},
   out = [];
  return list.forEach(function(o) {
   var k = o._weekly ? "w|" + o._tk + "|" + (o.all_day ? "" : timeLabel(o.s)) : o.key ? "k|" + String(o.key).split("|").slice(0, 4).join("|") : "";
   if (k) {
    if (seen[k]) return;
    seen[k] = 1
   }
   out.push(o)
  }), out
 }

 function venueCount(id) {
  var save = state,
   ql = lastQuery,
   n = 0;
  state = defaults(), state.venue = id, state.when = "all";
  try {
   n = venueDedupe(filtered()).length
  } finally {
   state = save, lastQuery = ql
  }
  return n
 }

 function enterVenue(id, name) {
  if (id) {
   state.venue || (venuePrev = {
    q: state.q,
    cats: state.cats.slice(),
    when: state.when,
    from: state.from,
    to: state.to,
    picks: state.picks,
    free: state.free,
    dog: state.dog,
    kids: state.kids,
    open: state.open,
    weekly: state.weekly,
    saved: state.saved,
    dt: dateTouched,
    sw: searchWidened
   }), state.venue = id, state.venueName = name || "", state.q = "", state.cats = [], state.picks = !1, state.free = !1, state.dog = !1, state.kids = !1, state.open = !1, state.weekly = "", state.saved = !1, state.when = "all", state.from = "", state.to = "", state.view = "list", dateTouched = !0, searchWidened = !1, dayOpen = {}, regsOpen = {}, calMonth = null;
   var sq = $("#obgSearch");
   sq && (sq.value = "");
   var sc = $(".obg-search-clear");
   sc && (sc.hidden = !0), closeSheet(), render(), scrollToVenue(), track("select_content", {
    content_type: "venue",
    item_id: cut(state.venueName || id)
   })
  }
 }

 function leaveVenue() {
  var pv = venuePrev;
  if (venuePrev = null, state.venue = "", state.venueName = "", !pv) {
   resetAll();
   return
  }
  state.q = pv.q, state.cats = pv.cats, state.when = pv.when, state.from = pv.from, state.to = pv.to, state.picks = pv.picks, state.free = pv.free, state.dog = pv.dog, state.kids = pv.kids, state.open = pv.open, state.weekly = pv.weekly, state.saved = pv.saved, dateTouched = pv.dt, searchWidened = pv.sw;
  var sq = $("#obgSearch");
  sq && (sq.value = state.q);
  var sc = $(".obg-search-clear");
  sc && (sc.hidden = !state.q), dayOpen = {}, render(), scrollToResults()
 }

 function scrollToVenue() {
  var m = $("#obgVenueBar");
  if (!m || m.hidden) return scrollToResults();
  var y = m.getBoundingClientRect().top + window.scrollY - stickyTop() - (mqMobile.matches ? 84 : 16);
  window.scrollTo({
   top: Math.max(0, y),
   behavior: "smooth"
  })
 }

 function dropVenue() {
  state.venue = "", state.venueName = "", venuePrev = null
 }

 function venueCss() {
  if (!VENUE_CSS_ON) {
   VENUE_CSS_ON = !0;
   var st = document.createElement("style");
   st.id = "obg-venue-css", st.textContent = "#obg .obg-venuebar{display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin:0 0 14px;padding:14px 16px;border:1px solid #e8dfcf;border-radius:14px;background:#fbf7ef}#obg .obg-venuebar[hidden]{display:none}#obg .obg-venuebar-txt{flex:1 1 220px;min-width:0;display:flex;flex-direction:column;gap:2px}#obg .obg-venuebar-txt small{display:flex;align-items:center;gap:5px;font:600 12px/1.2 Inter,sans-serif;letter-spacing:.06em;text-transform:uppercase;color:var(--or,#b4541f)}#obg .obg-venuebar-txt small .obg-i{width:14px;height:14px}#obg .obg-venuebar-txt b{font:700 28px/1.1 Cormorant,Georgia,serif;color:var(--navy,#16324a);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#obg .obg-venuebar-txt span{font:500 13.5px/1.35 Inter,sans-serif;color:var(--muted,#5f6d74)}#obg.obg-venue-on .obg-results-head .obn-fe-intro{display:none!important}#obg.obg-venue-on .obg-results-head.obn-fe-head .obg-rh-actions{margin-left:auto!important}#obg .obg-venuebar-acts{display:flex;gap:8px;flex-wrap:wrap}#obg .obg-venuebar-acts a,#obg .obg-venuebar-acts button{display:inline-flex;align-items:center;gap:6px;padding:8px 12px;border-radius:999px;border:1px solid #d9cdb8;background:#fff;color:inherit;font:inherit;font-size:.85rem;text-decoration:none;cursor:pointer;white-space:nowrap}#obg .obg-venuebar-acts .obg-i{width:16px;height:16px}#obg .obg-sheet-more{white-space:nowrap}", document.head.appendChild(st)
  }
 }

 function renderVenueBar() {
  var bar = $("#obgVenueBar");
  if (!bar) {
   var lst = $("#obgList");
   if (!lst || !lst.parentNode) return;
   bar = document.createElement("div"), bar.id = "obgVenueBar", bar.className = "obg-venuebar", bar.hidden = !0, lst.parentNode.insertBefore(bar, lst)
  }
  var cl = $("#obgCount");
  if (cl && (cl.style.display = state.venue ? "none" : ""), ROOT.classList.toggle("obg-venue-on", !!state.venue), !state.venue) {
   bar.hidden = !0, bar.innerHTML = "";
   return
  }
  venueCss();
  var o = venueSample(state.venue),
   name = venueLabel(),
   nE = 0,
   nW = 0;
  lastList.forEach(function(x) {
   x._weekly ? nW++ : nE++
  });
  var cnt = (nE || !nW ? nE + " upcoming event" + (nE === 1 ? "" : "s") : "") + (nW ? (nE ? " + " : "") + nW + " weekly regular" + (nW === 1 ? "" : "s") : ""),
   where = o ? [o.hood, o.region].filter(function(x, i, a) {
    return x && a.indexOf(x) === i
   }).join(" \xB7 ") : "",
   mq = o ? [o.place, o.hood, o.region === "all" ? "" : o.region].filter(Boolean).join(", ") : name;
  bar.innerHTML = '<div class="obg-venuebar-txt"><small>' + icon("pin") + "Coming up at</small><b>" + esc(name) + "</b><span>" + esc([where, cnt].filter(Boolean).join(" \xB7 ")) + '</span></div><div class="obg-venuebar-acts"><a href="https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(mq) + '" target="_blank" rel="noopener">' + icon("pin") + 'Map</a><button type="button" data-venue-share>Share</button><button type="button" data-venue-clear>' + icon("x") + "All events</button></div>", bar.hidden = !1
 }

 function shareVenue() {
  var u = new URL(location.origin + location.pathname);
  u.searchParams.set("venue", state.venue), u.searchParams.set("utm_source", "share"), u.searchParams.set("utm_medium", "referral"), u.searchParams.set("utm_campaign", "event_guide_venue");
  var data = {
   title: "Coming up at " + venueLabel(),
   text: "Everything coming up at " + venueLabel() + ", from the OB Tie Dye " + (window.OB_GUIDE_SHARE_NAME || "SoCal Event Guide"),
   url: u.toString()
  };

  function copyIt() {
   navigator.clipboard && window.isSecureContext ? navigator.clipboard.writeText(data.url).catch(function() {
    window.prompt("Copy this link:", data.url)
   }) : window.prompt("Copy this link:", data.url)
  }
  navigator.share ? navigator.share(data).catch(function(e) {
   e && e.name !== "AbortError" && copyIt()
  }) : copyIt(), track("share", {
   method: "venue",
   content_type: "venue",
   item_id: cut(venueLabel())
  })
 }

 function render(keepLimit) {
  keepLimit || (limit = PAGE), V4 && racesOnly() && !dateTouched && state.when === "today" && (state.when = "all"), state.dist && !racesOnly() && (state.dist = ""), lastList = filtered(), state.view === "list" && collapseOn() && (lastList = collapseWeekly(lastList)), state.venue && state.view === "list" && (lastList = venueDedupe(lastList));
  var wh = $("#obgWeeklyHint");
  if (!wh) {
   var lst = $("#obgList");
   lst && lst.parentNode && (wh = document.createElement("a"), wh.id = "obgWeeklyHint", wh.className = "obg-weekly-hint", wh.hidden = !0, lst.parentNode.insertBefore(wh, lst))
  }
  if (wh) {
   var whOn = !!state.q && window.OB_GUIDE_HIDDEN_WEEKLY > 0 && !/happy-hours/.test(location.pathname) && (!lastList.length || /happy|hour|trivia|quiz|karaoke|bingo|drink|beer|brew|wine|cocktail|taco|run club|open mic|weekly/i.test(state.q));
   wh.hidden = !whOn, whOn && (wh.href = location.pathname.replace(/\/$/, "") + "-happy-hours?q=" + encodeURIComponent(state.q), wh.innerHTML = "<span>Happy hours, trivia and other weekly regulars live on their own page.</span><b>Search them for \u201C" + esc(state.q) + "\u201D " + icon("arrow") + "</b>")
  }
  syncControls(), renderActive(), renderRegionChips(); nightRender();
  var n = lastList.length;
  if ($("#obgCount").textContent = n.toLocaleString() + " event" + (n === 1 ? "" : "s") + (state.q ? state.region === "all" ? " across " + ALL_PLACE : " in " + (state.hoods.length === 1 ? state.hoods[0] : state.region) : ""), V4) {
   var nW = 0,
    nE = 0,
    sk = {};
   lastList.forEach(function(o) {
    if (o._weekly) {
     var kk = o._tk + "|" + o._vc;
     sk[kk] || (sk[kk] = 1, nW++)
    } else nE++
   }), $("#obgCount").textContent = (nE || !nW ? nE.toLocaleString() + " event" + (nE === 1 ? "" : "s") : "") + (nW ? (nE ? " + " : "") + nW.toLocaleString() + " weekly regular" + (nW === 1 ? "" : "s") : "") + (state.q ? state.region === "all" ? " across " + ALL_PLACE : " in " + (state.hoods.length === 1 ? state.hoods[0] : state.region) : "")
  }
  var ac = $("#obgApplyCount");
  ac && (ac.textContent = n.toLocaleString());
  var hNoun = state.weekly === "only" ? "Weekly stuff" : "Events";
  renderVenueBar(), renderDistBar(), state.venue ? $("#obgHeading").textContent = "Coming up at " + venueLabel() : $("#obgHeading").textContent = state.q ? headingForQuery() : state.picks && !state.cats.length ? "OB Picks" : state.region === "all" ? hNoun + " across " + ALL_PLACE : hNoun + " in " + (state.hoods.length === 1 ? state.hoods[0] : state.region), ROOT.setAttribute("data-mode", state.view), $("#obgCal").hidden = state.view !== "calendar", $("#obgMapWrap").hidden = state.view !== "map", $("#obgList").hidden = state.view === "calendar", state.view === "calendar" ? ($("#obgMoreWrap").hidden = !0, renderCalendar(lastList)) : (V4 ? renderListV4 : renderList)(lastList), V4 && (ROOT.classList.toggle("obg-isq", !!state.q), renderDatebar(), renderPicksFeat(), renderGlance(), renderHeroWx(), renderSavedChip()), state.view === "map" && renderMap(lastList), writeUrl()
 }

 function schedule() {
  renderQueued || (renderQueued = !0, requestAnimationFrame(function() {
   renderQueued = !1, render()
  }))
 }
 var mqMobile = window.matchMedia("(max-width: 899px)");

 function openGroup(name, open) {
  var g = $('.obg-group[data-group="' + name + '"]');
  if (g) {
   var h = $(".obg-group-head", g);
   g.classList.toggle("is-open", open), h.setAttribute("aria-expanded", open ? "true" : "false")
  }
 }

 function openDrawer(group) {
  ROOT.classList.add("is-drawer"), document.documentElement.classList.add("obg-lock"), $$(".obg-group").forEach(function(g2) {
   openGroup(g2.getAttribute("data-group"), !1)
  });
  var sc = $(".obg-side-scroll");
  if (sc && (sc.scrollTop = 0), group && group !== "all") {
   openGroup(group, !0);
   var g = $('.obg-group[data-group="' + group + '"]');
   sc && g && (sc.scrollTop = Math.max(0, g.offsetTop - sc.offsetTop - 6))
  }
  var side = $("#obgSide");
  side.setAttribute("aria-modal", "true"), side.setAttribute("role", "dialog"), setTimeout(function() {
   var c = $(".obg-side-close");
   c && c.focus()
  }, 60)
 }

 function closeDrawer() {
  if (ROOT.classList.contains("is-drawer")) {
   ROOT.classList.remove("is-drawer"), document.documentElement.classList.remove("obg-lock");
   var side = $("#obgSide");
   side.removeAttribute("aria-modal"), side.removeAttribute("role");
   var top = $(".obg-main");
   if (top) {
    var y = top.getBoundingClientRect().top + window.scrollY - stickyTop() - 8;
    window.scrollY > y && window.scrollTo(0, y)
   }
  }
 }

 function stickyTop() {
  var h = document.querySelector("#header-group header, header.shopify-section");
  if (!h) return 0;
  var cs = getComputedStyle(h);
  if (!/sticky|fixed/.test(cs.position)) return 0;
  var r = h.getBoundingClientRect();
  return r.bottom > 0 ? Math.round(r.bottom) : 0
 }
 var stickyRaf = !1;

 function updateSticky() {
  stickyRaf || (stickyRaf = !0, requestAnimationFrame(function() {
   stickyRaf = !1, ROOT.style.setProperty("--obg-top", stickyTop() + "px")
  }))
 }

 function resetAll() {
  venuePrev = null;
  var v = state.view;
  state = defaults(), state.view = v, V4 && (state.when = "today", dateTouched = !1, searchWidened = !1, dayOpen = {}, regsOpen = {}), areaTouched = !1, preSearch = null, calMonth = null, buildHoods(), render()
 }

 function bind() {
  var searchTimer;
  ROOT.addEventListener("input", function(e) {
   var t = e.target;
   t.id === "obgSearch" && (clearTimeout(searchTimer), $(".obg-search-clear").hidden = !t.value, searchTimer = setTimeout(function() {
    setQuery(t.value)
   }, 140))
  }), ROOT.addEventListener("change", function(e) {
   var t = e.target,
    n = t.name;
   if (n === "obg-region" || t.id === "obgHeroRegion" ? tf("area", t.value.replace(/^hood:/, ""), !0) : n === "obg-hood" ? tf("neighborhood", t.value, t.checked) : n === "obg-cat" || n === "obg-grp" || n === "obg-allcats" ? tf("category", t.value, t.checked) : n === "obg-good" ? tf("good_for", t.value, t.checked) : n === "obg-when" ? tf("date", t.value, !0) : t.id === "obgPicks" ? tf("ob_picks", "on", t.checked) : t.id === "obgOpen" ? tf("open_now", "on", t.checked) : (t.id === "obgFrom" || t.id === "obgTo") && tf("date", "custom", !0), t.id === "obgHeroRegion" && LV_PAGE) {
    dropVenue();
    var hv = t.value;
    state.region = DEST, state.hoods = hv.indexOf("hood:") === 0 ? [hv.slice(5)] : [], areaTouched = !0, buildHoods(), render(), V4 || nudgeToResults();
    return
   }
   if (n === "obg-region" || t.id === "obgHeroRegion") {
    dropVenue(), state.region = t.value, state.hoods = [], areaTouched = !0, buildHoods(), render(), t.id === "obgHeroRegion" && !V4 && nudgeToResults();
    return
   }
   if (n === "obg-hood") return areaTouched = !0, state.hoods = $$('input[name="obg-hood"]:checked').map(function(x) {
    return x.value
   }), render();
   if (n === "obg-allcats") return state.cats = t.checked ? CAT_KEYS.slice() : [], render();
   if (n === "obg-cat") return state.cats = $$('input[name="obg-cat"]:checked').map(function(x) {
    return x.value
   }), render();
   if (n === "obg-grp") {
    var gk = leavesOf(t.value);
    return state.cats = t.checked ? CAT_KEYS.filter(function(c) {
     return gk.indexOf(c) > -1 || state.cats.indexOf(c) > -1
    }) : state.cats.filter(function(c) {
     return gk.indexOf(c) === -1
    }), render()
   }
   if (n === "obg-good") return state[t.value] = t.checked, render();
   if (V4 && (n === "obg-when" || t.id === "obgFrom" || t.id === "obgTo" || t.id === "obgOpen") && (dateTouched = !0, searchWidened = !1), n === "obg-when") return state.when = t.value, t.value !== "custom" ? (state.from = "", state.to = "") : state.from || (state.from = todayKey()), t.value !== "all" && (state.open = !1), calMonth = null, render();
   if (t.id === "obgFrom") return state.from = t.value, state.to && state.to < state.from && (state.to = state.from), state.when = "custom", state.open = !1, calMonth = null, render();
   if (t.id === "obgTo") return state.to = t.value, state.from && state.to < state.from && (state.from = state.to), state.when = "custom", state.open = !1, render();
   if (t.id === "obgPicks") return state.picks = t.checked, render();
   if (t.id === "obgOpen") return state.open = t.checked, state.open && (state.when = "all", state.from = "", state.to = ""), render()
  }), ROOT.addEventListener("click", function(e) {
   var el = e.target.closest ? e.target : e.target.parentElement,
    b;
   if (b = el.closest("[data-shop]")) {
    track("guide_shop_click", {
     placement: b.getAttribute("data-shop")
    }), b.getAttribute("href") || (e.preventDefault(), e.stopPropagation(), location.href = SHOP_URL);
    return
   }
   if ((b = el.closest("a[href]")) && b.target === "_blank" && trackEventClick(b), b = el.closest(".obg-share")) {
    var sr = b.parentNode.querySelector(".obg-title");
    track("share", {
     method: "event_row",
     content_type: "event",
     item_id: cut(sr ? sr.textContent : "")
    })
   } else el.closest("[data-share-page]") && track("share", {
    method: "guide_page",
    content_type: "guide",
    item_id: "event_guide"
   });
   if (b = el.closest("[data-rchip]")) return dropVenue(), tf("area_chip", b.getAttribute("data-rchip"), !0), state.region = b.getAttribute("data-rchip"), state.hoods = [], areaTouched = !0, buildHoods(), render();
   if (b = el.closest("[data-chip]")) {
    var k = b.getAttribute("data-chip");
    if (nightClick(k, b)) return;
    if (k === "today" || k === "tonight" || k === "weekend") state.when = state.when === k ? "all" : k, state.from = "", state.to = "", state.open = !1, calMonth = null;
    else if (k === "free") state.free = !state.free;
    else if (k === "dog") state.dog = !state.dog;
    else if (k === "outside") state.outside = !state.outside;
    else if (k === "drive") state.drive = !state.drive;
    else if (k === "picks") state.picks = !state.picks;
    else if (k === "weekly") state.weekly = state.weekly ? "" : "all";
    else {
     var ks = leavesOf(k),
      all = ks.every(function(x) {
       return state.cats.indexOf(x) > -1
      });
     allCatsOn() ? state.cats = CAT_KEYS.filter(function(c) {
      return ks.indexOf(c) > -1
     }) : state.cats = all ? state.cats.filter(function(c) {
      return ks.indexOf(c) === -1
     }) : CAT_KEYS.filter(function(c) {
      return ks.indexOf(c) > -1 || state.cats.indexOf(c) > -1
     })
    }
    render(), tf("quick", k, chipOn(k)), nudgeToResults();
    return
   }
   if (b = el.closest("[data-subtoggle]")) {
    var sk = b.getAttribute("data-subtoggle");
    subOpen[sk] = !subOpen[sk];
    var sb = $('[data-subs="' + sk + '"]');
    sb && (sb.hidden = !subOpen[sk]), b.setAttribute("aria-expanded", subOpen[sk] ? "true" : "false");
    return
   }
   if ((b = el.closest("[data-view]")) && b.tagName === "BUTTON") {
    var v = b.getAttribute("data-view");
    v !== state.view && (track("guide_view", {
     view: v
    }), state.view = v, render(!0));
    return
   }
   if (b = el.closest(".obg-group-head")) {
    var g = b.closest(".obg-group");
    openGroup(g.getAttribute("data-group"), !g.classList.contains("is-open"));
    return
   }
   if (b = el.closest("[data-open]")) {
    openDrawer(b.getAttribute("data-open"));
    return
   }
   if (el.closest("[data-close]")) {
    closeDrawer();
    return
   }
   if (el.closest("[data-reset]")) {
    resetAll();
    return
   }
   if (b = el.closest("[data-remove]")) {
    var r = b.getAttribute("data-remove");
    if (r === "q") {
     var sq = $("#obgSearch");
     return sq && (sq.value = ""), setQuery("")
    }
    if (r === "venue") {
     leaveVenue();
     return
    }
    if (nightRemove(r)) return render();
    if (r === "picks") state.picks = !1;
    else if (r === "open") state.open = !1;
    else if (r === "weekly") state.weekly = "";
    else if (r === "when") dateTouched = !0, searchWidened = !1, state.when = "all", state.from = "", state.to = "";
    else if (r.indexOf("good:") === 0) state[r.slice(5)] = !1;
    else if (r.indexOf("cat:") === 0) {
     var rk = leavesOf(r.slice(4));
     state.cats = state.cats.filter(function(c) {
      return rk.indexOf(c) === -1
     })
    } else r === "region" ? (state.region = "all", state.hoods = [], areaTouched = !0, buildHoods()) : r.indexOf("hood:") === 0 && (state.hoods = state.hoods.filter(function(h) {
     return h !== r.slice(5)
    }));
    return render()
   }
   if (b = el.closest("[data-hoods]")) return state.hoods = [], areaTouched = !0, render();
   if (el.closest(".obg-search-clear")) {
    clearTimeout(searchTimer);
    var si = $("#obgSearch");
    return si.value = "", si.focus(), setQuery("")
   }
   if (b = el.closest("#obgMore")) {
    limit += PAGE, (V4 ? renderListV4 : renderList)(lastList);
    return
   }
   if (b = el.closest("[data-mo]")) {
    var y = +calMonth.slice(0, 4),
     m = +calMonth.slice(5, 7) - 1 + +b.getAttribute("data-mo"),
     d = new Date(Date.UTC(y, m, 1, 12));
    calMonth = d.toISOString().slice(0, 7), renderCalendar(lastList);
    return
   }
   if (b = el.closest("[data-day]")) {
    var day = b.getAttribute("data-day");
    dateTouched = !0, searchWidened = !1, state.when = "custom", state.from = day, state.to = day, state.open = !1, state.view = "list", render(), scrollToResults();
    return
   }
   if (b = el.closest(".obg-pop-more")) {
    dropVenue();
    var hood = b.getAttribute("data-hood"),
     reg = b.getAttribute("data-region");
    state.region = reg, state.hoods = hood ? [hood] : [], areaTouched = !0, buildHoods(), state.view = "list", render(), scrollToResults();
    return
   }
  }), ROOT.addEventListener("keydown", function(e) {
   if (e.key === "Enter" && e.target.getAttribute && e.target.getAttribute("data-shop") === "list") {
    e.preventDefault(), e.target.click();
    return
   }
   e.target.id === "obgSearch" && e.key === "Enter" && (e.preventDefault(), clearTimeout(searchTimer), setQuery(e.target.value), trackSearchSoon(!0), e.target.blur(), scrollToResults())
  }), document.addEventListener("keydown", function(e) {
   e.key === "Escape" && closeDrawer()
  });
  var searchForm = $(".obg-searchbar");
  searchForm && searchForm.addEventListener("submit", function(e) {
   e.preventDefault()
  }), window.addEventListener("scroll", updateSticky, {
   passive: !0
  }), window.addEventListener("resize", function() {
   updateSticky(), !mqMobile.matches && !V4 && closeDrawer(), map && state.view === "map" && map.invalidateSize()
  });
  var applyMq = function() {
   mqMobile.matches || (openGroup("cats", !0), window.innerHeight >= 880 && openGroup("date", !0))
  };
  mqMobile.addEventListener && mqMobile.addEventListener("change", applyMq), applyMq()
 }

 function cut(s) {
  return String(s || "").replace(/\s+/g, " ").trim().slice(0, 100)
 }

 function track(name, params) {
  try {
   params = params || {}, params.guide_area = state.region === "all" ? ALL_LABEL : state.region, typeof window.gtag == "function" && window.gtag("event", name, params), window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish("ob_guide_" + name, params)
  } catch (_) {}
 }

 function tf(type, value, active) {
  track("guide_filter", {
   filter_type: type,
   filter_value: cut(value),
   filter_on: active ? "on" : "off"
  })
 }
 var searchTrackTimer = null,
  lastTrackedQ = "";

 function trackSearchSoon(now) {
  if (clearTimeout(searchTrackTimer), !state.q) {
   lastTrackedQ = "";
   return
  }
  searchTrackTimer = setTimeout(trackSearch, now ? 0 : 1500)
 }

 function trackSearch() {
  var q = state.q;
  if (!(!q || q === lastTrackedQ)) {
   lastTrackedQ = q;
   var n = lastList.length;
   track("search", {
    search_term: cut(q),
    search_results: n
   }), n || track("guide_search_no_results", {
    search_term: cut(q)
   })
  }
 }

 function trackEventClick(a) {
  var r = a.closest(".obg-row"),
   o = r ? lastList[+r.getAttribute("data-ev")] : null,
   t = a.querySelector(".obg-title"),
   host = "";
  try {
   host = new URL(a.href).hostname.replace(/^www\./, "")
  } catch (_) {}
  track("guide_event_click", {
   event_title: cut(o ? o.title : t ? t.textContent : a.getAttribute("title") || a.textContent),
   event_category: cut(o ? o.cat : ""),
   event_region: cut(o ? o.region : ""),
   list_position: o ? +r.getAttribute("data-ev") + 1 : 0,
   view: state.view,
   link_domain: host
  })
 }

 function nudgeToResults() {
  if (!(!mqMobile.matches || ROOT.classList.contains("is-drawer"))) {
   var m = $(".obg-results-head");
   m && m.getBoundingClientRect().top > window.innerHeight * .6 && scrollToResults()
  }
 }

 function scrollToResults() {
  var m = $(".obg-results-head");
  if (m) {
   var y = m.getBoundingClientRect().top + window.scrollY - stickyTop() - (mqMobile.matches ? 64 : 16);
   window.scrollTo({
    top: y,
    behavior: "smooth"
   })
  }
 }
 var EXTRA_CSS = '#obg .obg-t-dog{gap:4px;background:#f6eee2;color:#7a5230}#obg .obg-t-dogevent{gap:4px;background:#fde8ec;color:#9b2c48}#obg .obg-t-dog .obg-i,#obg .obg-t-dogevent .obg-i{width:12px;height:12px;stroke-width:2}#obg .obg-subhead{margin:14px 0 6px;padding-top:12px;border-top:1px solid rgba(127,127,127,.25);font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;opacity:.7}#obg .obg-subhead-first{margin-top:2px;padding-top:0;border-top:0}#obg .obg-allrow{padding-bottom:4px;margin-bottom:4px;border-bottom:1px dashed var(--line)}#obg .obg-allrow .obg-opt-label{font-weight:600}#obg .obg-catrow{display:flex;align-items:center}#obg .obg-catrow .obg-opt{flex:1 1 auto;margin-right:0}#obg .obg-subbtn{flex:0 0 auto;display:grid;place-items:center;width:30px;height:30px;margin-right:-8px;padding:0;border:0;border-radius:8px;background:none;color:inherit;cursor:pointer;opacity:.65}#obg .obg-subbtn:hover{background:var(--sand);opacity:1}#obg .obg-subbtn .obg-i{width:15px;height:15px;transition:transform .15s}#obg .obg-subbtn[aria-expanded="true"] .obg-i{transform:rotate(180deg)}#obg .obg-subopts{display:flex;flex-direction:column;gap:1px;padding-left:27px}#obg .obg-subopts[hidden]{display:none}#obg .obg-subopts .obg-opt{font-size:13.5px}#obg .obg-opt input:indeterminate+.obg-opt-ui{background:var(--navy);border-color:var(--navy)}#obg .obg-opt input:indeterminate+.obg-opt-ui::after{content:"";width:8px;height:2px;background:#fff;border:0;transform:none}@media (max-width:899px){#obg .obg-t-dog .obg-i,#obg .obg-t-dogevent .obg-i{width:11px;height:11px}}#obg .obg-weekly-hint{display:flex;flex-wrap:wrap;align-items:center;gap:4px 10px;margin:0 0 12px;padding:10px 14px;border:1px solid var(--line,#e6dfd2);border-radius:12px;background:#fff;color:inherit;text-decoration:none;font-size:14px}#obg .obg-weekly-hint[hidden]{display:none}#obg .obg-weekly-hint b{display:inline-flex;align-items:center;gap:4px;color:var(--navy,#1d3557)}#obg .obg-weekly-hint .obg-i{width:16px;height:16px}#obg .obg-rchips{display:flex;flex-wrap:nowrap;gap:8px;overflow-x:auto;margin:0 0 12px;padding:2px 0;scrollbar-width:none;-webkit-overflow-scrolling:touch}#obg .obg-rchips::-webkit-scrollbar{display:none}#obg .obg-rchips[hidden]{display:none}#obg .obg-rchip{height:32px;padding:0 12px;gap:6px;font-size:13px;white-space:nowrap}#obg .obg-rchip em{font-style:normal;font-size:12px;font-weight:600;color:var(--faint)}#obg .obg-rchip[aria-pressed="true"] em{color:rgba(255,255,255,.75)}#obg .obg-rchip.is-empty{color:var(--faint)}#obg .obg-rchip.is-empty[aria-pressed="true"]{color:#fff}#obg .obg-rchip:focus-visible{outline:2px solid var(--navy);outline-offset:2px}#obg .obg-venue span.obg-venue-reg{flex:0 0 auto;overflow:visible}#obg.obg .obg-shop-link{display:inline-flex;align-items:center;gap:4px;margin-top:6px;font-size:13px;font-weight:600;color:var(--coral);text-decoration:underline;text-underline-offset:2px;cursor:pointer}#obg.obg .obg-shop-link .obg-i{width:13px;height:13px}#obg.obg .obg-shop-link:hover,#obg.obg .obg-shop-link:focus-visible{color:var(--navy);outline:none}#obg.obg .obg-shop-inline{color:inherit;font-weight:600;text-decoration:underline;text-underline-offset:2px}#obg.obg .obg-when.is-ongoing b{color:var(--teal)}#obg.obg .obg-when.is-ongoing strong{font-size:15px;line-height:1.2}#obg.obg .obg-ag-time.is-ongoing{color:var(--teal)}#obg.obg .obg-thumb-icon.obg-c-violet{background:linear-gradient(135deg,#6a4fc2,#9b86e0)}#obg.obg .obg-empty-acts{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-top:4px}#obg.obg .obg-empty-acts .obg-btn{margin-top:0}#obg.obg .obg-btn-solid{background:var(--navy);color:#fff}@media (max-width:899px){#obg.obg .obg-hero-inner{padding:16px 16px 12px}#obg.obg .obg-hero h1{font-size:30px}#obg.obg .obg-lede{display:none}#obg.obg .obg-searchbar{margin-top:10px}#obg.obg .obg-chips{padding:8px 16px}#obg.obg .obg-markets{padding-top:10px}#obg.obg .obg-markets .obg-sec-head{margin-bottom:6px}#obg.obg .obg-markets .obg-sec-head h2{font-size:18px}#obg.obg .obg-mkt{padding:6px;gap:10px}#obg.obg .obg-mkt .obg-thumb{width:48px;height:48px;border-radius:7px}#obg.obg .obg-mkt-date{font-size:11px}#obg.obg .obg-mkt-title{font-size:14px;-webkit-line-clamp:1}#obg.obg .obg-mkt-meta{font-size:12px}#obg.obg .obg-picks-bar{padding:7px 12px;margin-bottom:8px}#obg.obg .obg-picks-bar small{display:none}#obg.obg .obg-browser{padding-top:4px}}@media (max-width:899px){#obg .obg-rchips{margin:0 -16px 10px;padding:2px 16px;scroll-padding:0 16px}#obg .obg-rchip{height:30px;padding:0 11px;font-size:12.5px}}',
  WEEKLY_CATS = /^(Happy Hour|Trivia|Karaoke)$/,
  SEASONAL_CATS = /^(Festival|Art Market|Theater \+ Performing Arts|Film|Space \+ Stargazing)$/;

 function weeklyDays(v) {
  var s = " " + String(v || "").toLowerCase() + " ";
  if (/daily|nightly|every ?day|select|weekends?\b|\b(1st|2nd|3rd|4th|first|second|third|fourth|last)\b|\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?\s+\d/.test(s)) return !1;
  var m = s.match(/\b(mon|tue|wed|thu|fri|sat|sun)/g);
  if (!m) return !1;
  var u = {};
  return m.forEach(function(x) {
   u[x] = 1
  }), Object.keys(u).length < 7
 }

 function rowIsWeekly(r) {
  if (WEEKLY_CATS.test(r.cat || "")) return !0;
  if (!truthy(r.recurring) || truthy(r.starred) || truthy(r.here) || SEASONAL_CATS.test(r.cat || "") || !weeklyDays(r.days)) return !1;
  var a = Date.parse(r.start_date),
   b = Date.parse(r.active_through || "");
  return isNaN(b) || isNaN(a) || (b - a) / 864e5 > 70
 }

 function tagWeekly(items) {
  for (var raw = window.OB_GUIDE_RAW_FEED || [], byKey = {}, byPri = {}, r = 0; r < raw.length; r++) {
   var x = raw[r];
   if (!(!x || !x.key)) {
    rowIsWeekly(x) && (byKey[String(x.key)] = 1);
    var pv = x.priority || x.Priority;
    pv && (byPri[String(x.key)] = String(pv))
   }
  }
  for (var n = 0; n < items.length; n++) {
   var it = items[n];
   if (!(!it || it.weekly !== void 0)) {
    var inner = it.__obRaw || it,
     k = String(it.key || inner.key || ""),
     bk = k.replace(/\|\d{4}-\d{2}-\d{2}$/, "");
    it.weekly = inner.weekly = !!(byKey[k] || byKey[bk] || WEEKLY_CATS.test(it.cat || inner.cat || "")), !inner.priority && (byPri[k] || byPri[bk]) && (it.priority = inner.priority = byPri[k] || byPri[bk])
   }
  }
 }
 window.OB_GUIDE_TAG_WEEKLY = tagWeekly;

 function boot() {
  var src = window.OB_GUIDE_ITEMS || [];
  tagWeekly(src);
  for (var n = 0; n < src.length; n++) {
   var o = prep(src[n]);
   o && ITEMS.push(o)
  }
  ITEMS.sort(function(a, b) {
   return a.s - b.s
  }), window.OB_GUIDE_SOCAL_DEST && !DESTS[window.OB_GUIDE_SOCAL_DEST] && (DESTS[window.OB_GUIDE_SOCAL_DEST] = socalDest(window.OB_GUIDE_SOCAL_DEST, ITEMS)), ITEMS.forEach(function(o2) {
   var d = DESTS[o2.region];
   o2.hk = d ? d.of[String(o2.hood).trim().toLowerCase()] || "" : o2.hood
  }), ITEMS.forEach(function(o2) {
   if (o2.hk) {
    var r = HOODS[o2.region] || (HOODS[o2.region] = {});
    r[o2.hk] = 1
   }
  }), Object.keys(HOODS).forEach(function(r) {
   var have = HOODS[r];
   HOODS[r] = DESTS[r] ? DESTS[r].names.filter(function(h) {
    return have[h]
   }) : Object.keys(have).filter(function(h) {
    return !/multiple/i.test(h)
   }).sort()
  });
  var rset = {};
  ITEMS.forEach(function(o2) {
   rset[o2.region] = 1
  });
  var rk = Object.keys(rset);
  if (LV_PAGE = rk.length === 1 && !!DESTS[rk[0]], DEST = LV_PAGE ? rk[0] : "", readUrl(), state._hoodSlugs) {
   var found = [],
    reg = "";
   Object.keys(HOODS).forEach(function(r) {
    HOODS[r].forEach(function(h) {
     state._hoodSlugs.indexOf(slug(h)) > -1 && (found.push(h), reg = reg || r)
    })
   }), Object.keys(DESTS).forEach(function(dn) {
    var D = DESTS[dn];
    HOODS[dn] && state._hoodSlugs.forEach(function(sl) {
     var g = D.slugs[sl];
     g || D.groups.forEach(function(gr) {
      gr[1].forEach(function(h) {
       slug(h) === sl && (g = gr[0])
      })
     }), g && HOODS[dn].indexOf(g) > -1 && found.indexOf(g) < 0 && (found.push(g), reg = reg || dn)
    })
   }), found.length && (state.region = reg, state.hoods = found), delete state._hoodSlugs
  }
  if (!document.getElementById("obg-extra-css")) {
   var st = document.createElement("style");
   st.id = "obg-extra-css", st.textContent = EXTRA_CSS, document.head.appendChild(st)
  }
  if (!$("#obgRegionChips")) {
   var stage = $(".obg-stage");
   if (stage) {
    var rc = document.createElement("div");
    rc.className = "obg-rchips", rc.id = "obgRegionChips", rc.setAttribute("role", "group"), rc.setAttribute("aria-label", "Search area"), rc.hidden = !0, stage.parentNode.insertBefore(rc, stage)
   }
  }
  document.addEventListener("error", function(e) {
   var im = e.target;
   if (!(!im || im.tagName !== "IMG" || !im.closest)) {
    var box2 = im.closest(".obg-thumb");
    if (!(!box2 || !ROOT.contains(box2))) {
     var fb = im.getAttribute("data-fb");
     if (fb) {
      im.removeAttribute("data-fb"), im.src = fb;
      return
     }
     box2.className = "obg-thumb obg-thumb-icon obg-c-" + (im.getAttribute("data-cc") || "slate"), box2.innerHTML = icon(im.getAttribute("data-ic") || "music")
    }
   }
  }, !0), V4 && bootV4(), buildSidebar(), bind(), renderMarkets(), render(), updateSticky();
  var freshnessTimer = setInterval(function() {
   document.hidden || render(!0)
  }, 6e4);

  function refreshOnReturn() {
   document.hidden || render(!0)
  }
  document.addEventListener("visibilitychange", refreshOnReturn), window.addEventListener("pagehide", function() {
   clearInterval(freshnessTimer), document.removeEventListener("visibilitychange", refreshOnReturn)
  }, {
   once: !0
  }), ROOT.classList.add("is-ready");

  function countOf(f) {
   return ITEMS.filter(f).length
  }
  window.OB_GUIDE_V3 = {
   state: function() {
    return JSON.parse(JSON.stringify(state))
   },
   count: function() {
    return lastList.length
   },
   items: function() {
    return ITEMS.length
   },
   dogItems: function() {
    return countOf(function(o2) {
     return o2._dog
    })
   },
   dogEventItems: function() {
    return countOf(function(o2) {
     return o2._dogEvent
    })
   },
   kidsItems: function() {
    return countOf(function(o2) {
     return o2._kids
    })
   }
  }
 }
 try {
  boot()
 } catch (err) {
  ROOT.classList.add("is-ready");
  var box = document.getElementById("obgList");
  box && (box.innerHTML = '<div class="obg-empty"><strong>The guide hit a snag loading.</strong><span>Refresh the page, or check back in a minute.</span></div>'), window.console && console.error("[OB guide]", err)
 }
})();
//# sourceMappingURL=/cdn/shop/t/219/assets/ob-guide-v3.js.map